export type Maybe<T> = T | null
export type InputMaybe<T> = Maybe<T>
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string }
  String: { input: string; output: string }
  Boolean: { input: boolean; output: boolean }
  Int: { input: number; output: number }
  Float: { input: number; output: number }
  Currency: { input: string; output: string }
  Date: { input: string; output: string }
  DateTime: { input: string; output: string }
  DateTimeOffset: { input: string; output: string }
  Decimal: { input: number; output: number }
  Long: { input: number; output: number }
  Milliseconds: { input: number; output: number }
  Seconds: { input: number; output: number }
}

export type Action = CustomAction | LinkAction | { __typename?: '%other' }

export type ActivateDigitalGift = {
  __typename: 'ActivateDigitalGift'
  _?: Maybe<Scalars['Boolean']['output']>
}

export type ActivateRedemptionInput = {
  id: Scalars['ID']['input']
}

export type AddAddressInput = {
  city?: InputMaybe<Scalars['String']['input']>
  country: Scalars['String']['input']
  extraAddressLine?: InputMaybe<Scalars['String']['input']>
  firstName: Scalars['String']['input']
  houseNumber?: InputMaybe<Scalars['String']['input']>
  houseNumberExtension?: InputMaybe<Scalars['String']['input']>
  isMyAddress: Scalars['Boolean']['input']
  lastName: Scalars['String']['input']
  postalCode?: InputMaybe<Scalars['String']['input']>
  state?: InputMaybe<Scalars['String']['input']>
  streetName: Scalars['String']['input']
}

export type AddAddressRequestAddressInput = {
  city?: InputMaybe<Scalars['String']['input']>
  country: Scalars['String']['input']
  extraAddressLine?: InputMaybe<Scalars['String']['input']>
  houseNumber?: InputMaybe<Scalars['String']['input']>
  houseNumberExtension?: InputMaybe<Scalars['String']['input']>
  id: Scalars['String']['input']
  postalCode?: InputMaybe<Scalars['String']['input']>
  state?: InputMaybe<Scalars['String']['input']>
  streetName: Scalars['String']['input']
}

export type AddAddressRequestAddressResult =
  | AddAddressRequestAddressSuccess
  | AddressError
  | AddressRequestNotFoundError
  | AddressRequestProcessedError
  | { __typename?: '%other' }

export type AddAddressRequestAddressSuccess = {
  __typename: 'AddAddressRequestAddressSuccess'
  message: Scalars['String']['output']
}

export type AddAddressResult =
  | AddAddressSuccess
  | AddressError
  | { __typename?: '%other' }

export type AddAddressSuccess = {
  __typename: 'AddAddressSuccess'
  address: ShippingAddress
  addressBook?: Maybe<AddressBook>
}

export type AddAddressesError = Error & {
  __typename: 'AddAddressesError'
  addressErrors: Array<KeyedAddAddressesError>
  message: Scalars['String']['output']
}

export type AddAddressesInput = {
  addresses: Array<AddAddressesItemInput>
}

export type AddAddressesItemInput = {
  city?: InputMaybe<Scalars['String']['input']>
  country: Scalars['String']['input']
  extraAddressLine?: InputMaybe<Scalars['String']['input']>
  firstName: Scalars['String']['input']
  houseNumber?: InputMaybe<Scalars['String']['input']>
  houseNumberExtension?: InputMaybe<Scalars['String']['input']>
  key: Scalars['String']['input']
  lastName: Scalars['String']['input']
  postalCode?: InputMaybe<Scalars['String']['input']>
  state?: InputMaybe<Scalars['String']['input']>
  streetName: Scalars['String']['input']
}

export type AddAddressesResult =
  | AddAddressesError
  | AddAddressesSuccess
  | { __typename?: '%other' }

export type AddAddressesSuccess = {
  __typename: 'AddAddressesSuccess'
  addressBook?: Maybe<AddressBook>
  addresses: Array<ShippingAddress>
}

export type AddCardAndDigitalGiftResult =
  | Basket
  | ConcurrentModificationError
  | ProductNotFoundError
  | { __typename?: '%other' }

export type AddCardAndDigitalGiftToBasketInput = {
  cardSku: Scalars['String']['input']
  designId: Scalars['ID']['input']
  digitalGiftSku: Scalars['String']['input']
}

export type AddCreditsInput = {
  authCode: Scalars['String']['input']
  expiryDate?: InputMaybe<Scalars['String']['input']>
  initialBalance: Scalars['Int']['input']
  reason: Scalars['String']['input']
}

export type AddCreditsResult = {
  __typename: 'AddCreditsResult'
  accounts?: Maybe<Array<Maybe<CreditAccount>>>
  message?: Maybe<Scalars['String']['output']>
  success: Scalars['Boolean']['output']
}

export type AddCustomerAddressInvalidCountry = Error & {
  __typename: 'AddCustomerAddressInvalidCountry'
  message: Scalars['String']['output']
}

export type AddCustomerAddressInvalidError = Error & {
  __typename: 'AddCustomerAddressInvalidError'
  message: Scalars['String']['output']
}

export type AddCustomerAddressResult =
  | AddCustomerAddressInvalidCountry
  | AddCustomerAddressInvalidError
  | ConcurrentModificationError
  | Customer
  | UserInputError
  | { __typename?: '%other' }

export type AddCustomerAddressesInvalidError = Error & {
  __typename: 'AddCustomerAddressesInvalidError'
  addressErrors: Array<KeyedCustomerAddressErrorMessage>
  message: Scalars['String']['output']
}

export type AddCustomerAddressesResult =
  | AddCustomerAddressInvalidError
  | AddCustomerAddressesInvalidError
  | ConcurrentModificationError
  | Customer
  | UserInputError
  | { __typename?: '%other' }

/** Input for adding a design to the customer's basket. */
export type AddDesignToBasketInput = {
  /** List of addon products to include (defaults to []) */
  addons?: InputMaybe<Array<DesignAddonInput>>
  /** ID of the design to add to basket */
  designId: Scalars['ID']['input']
  /** Quantity to add (defaults to 1) */
  quantity?: InputMaybe<Scalars['Int']['input']>
  /** SKU for the specific variant/size of the product */
  sku: Scalars['String']['input']
}

/** Result type for the addDesignToBasket mutation. */
export type AddDesignToBasketResult =
  | DesignAddedToBasket
  | DesignAuthorizationError
  | DesignNotFoundError
  | DesignProductNotFoundError
  | DesignServiceError
  | DesignTemplatesServiceError
  | DesignValidationError
  | { __typename?: '%other' }

export type AddDigitalGiftToBasketInput = {
  id?: InputMaybe<Scalars['ID']['input']>
  parentLineItemId: Scalars['ID']['input']
  sku: Scalars['String']['input']
}

export type AddDigitalGiftToBasketResult =
  | Basket
  | BasketNotFoundError
  | LineItemNotFoundError
  | ProductNotFoundError
  | { __typename?: '%other' }

export type AddMembershipToBasketAction = {
  __typename: 'AddMembershipToBasketAction'
  membershipType: MembershipType
}

export type AddMembershipToBasketInput = {
  discountCode?: InputMaybe<Scalars['String']['input']>
  /** @deprecated No longer necessary */
  id?: InputMaybe<Scalars['ID']['input']>
  membershipType: MembershipType
  /** @deprecated No longer required please remove */
  version?: InputMaybe<Scalars['Long']['input']>
}

export type AddMembershipToBasketResult =
  | Basket
  | ConcurrentModificationError
  | MembershipUnavailableError
  | MembershipVoucherError
  | { __typename?: '%other' }

export type AddMessageStateResult =
  | GroupCardProjectClosedState
  | GroupCardProjectFullState
  | GroupCardProjectOpenAuthenticatedState
  | GroupCardProjectOpenState
  | GroupCardServiceError
  | { __typename?: '%other' }

export type AddMessageStateResultV2 =
  | GroupCardProjectArchivedState
  | GroupCardProjectClosedStateV2
  | GroupCardProjectFullStateV2
  | GroupCardProjectOpenAuthenticatedStateV2
  | GroupCardProjectOpenStateV2
  | GroupCardServiceError
  | { __typename?: '%other' }

export type AddRecipientAddressInput = {
  fields: Array<AddressFieldInput>
  recipient?: InputMaybe<AddRecipientAddressRecipient>
}

export type AddRecipientAddressRecipient = {
  firstName: Scalars['String']['input']
  id: Scalars['String']['input']
  lastName: Scalars['String']['input']
}

export type AddRecipientAddressResult =
  | AddRecipientAddressSuccess
  | AddressError
  | RecipientAddressValidationError
  | { __typename?: '%other' }

export type AddRecipientAddressSuccess = {
  __typename: 'AddRecipientAddressSuccess'
  address: Address
  addresses: AddressList
}

export type AddRecipientInput = {
  allowDuplicate?: InputMaybe<Scalars['Boolean']['input']>
  firstName: Scalars['String']['input']
  lastName: Scalars['String']['input']
  relationship?: InputMaybe<Scalars['String']['input']>
}

export type AddRecipientResult =
  | AddRecipientSuccessResult
  | DuplicateRecipientError
  | RecipientValidationError
  | { __typename?: '%other' }

export type AddRecipientSuccessResult = {
  __typename: 'AddRecipientSuccessResult'
  recipient: Recipient
  recipients: RecipientList
}

export type AddToBasketAndSplitInput = {
  addons?: InputMaybe<Array<AddonInput>>
  quantity: Scalars['Int']['input']
  sku: Scalars['String']['input']
}

export type AddToBasketAndSplitResult =
  | Basket
  | ConcurrentModificationError
  | ProductNotFoundError
  | { __typename?: '%other' }

export enum AddToBasketFlow {
  DIGITAL = 'DIGITAL',
  STANDARD = 'STANDARD',
}

export type AddToBasketInput = {
  addons?: InputMaybe<Array<AddonInput>>
  /** @deprecated No longer in use, please provide designId */
  customisationId?: InputMaybe<Scalars['String']['input']>
  designId?: InputMaybe<Scalars['ID']['input']>
  quantity: Scalars['Int']['input']
  sku: Scalars['String']['input']
  store?: InputMaybe<Store>
}

export type AddToBasketResult =
  | Basket
  | ConcurrentModificationError
  | ProductNotFoundError
  | { __typename?: '%other' }

export type AddToFavouritesList = {
  __typename: 'AddToFavouritesList'
  products: Array<Maybe<Product>>
}

export type AddToMultiBuyListError = Error & {
  __typename: 'AddToMultiBuyListError'
  message: Scalars['String']['output']
}

export type AddToMultiBuyListInput = {
  sku: Scalars['String']['input']
}

export type AddToMultiBuyListLimitReachedError = Error & {
  __typename: 'AddToMultiBuyListLimitReachedError'
  limit: Scalars['Int']['output']
  message: Scalars['String']['output']
}

export type AddToMultiBuyListResult =
  | AddToMultiBuyListError
  | AddToMultiBuyListLimitReachedError
  | AddToMultiBuyListSuccess
  | { __typename?: '%other' }

export type AddToMultiBuyListSuccess = {
  __typename: 'AddToMultiBuyListSuccess'
  multiBuyList: MultiBuyList
}

export type Addon = {
  __typename: 'Addon'
  description: Scalars['String']['output']
  image: Image
  inStock: Scalars['Boolean']['output']
  price: Money
  sku: Scalars['String']['output']
  title: Scalars['String']['output']
}

export type AddonInput = {
  sku: Scalars['String']['input']
}

export type Address = {
  __typename: 'Address'
  city?: Maybe<Scalars['String']['output']>
  country: Scalars['String']['output']
  displayLines: Array<Scalars['String']['output']>
  extraAddressLine?: Maybe<Scalars['String']['output']>
  houseNumber?: Maybe<Scalars['String']['output']>
  houseNumberExtension?: Maybe<Scalars['String']['output']>
  id: Scalars['String']['output']
  isVerified: Scalars['Boolean']['output']
  postcode?: Maybe<Scalars['String']['output']>
  state?: Maybe<Scalars['String']['output']>
  streetName?: Maybe<Scalars['String']['output']>
}

export enum AddressActionType {
  CAN_HAVE_MULTIPLE = 'CAN_HAVE_MULTIPLE',
  COMPLETE = 'COMPLETE',
  REQUIRES_MULTIPLE = 'REQUIRES_MULTIPLE',
  REQUIRES_SINGLE = 'REQUIRES_SINGLE',
}

export type AddressBook = {
  __typename: 'AddressBook'
  addresses: Array<ShippingAddress>
}

export type AddressCountrySchema = AddressSchema & {
  __typename: 'AddressCountrySchema'
  country: Scalars['String']['output']
  fieldGroups: Array<AddressFieldGroup>
}

export type AddressDefaultSchema = AddressSchema & {
  __typename: 'AddressDefaultSchema'
  fieldGroups: Array<AddressFieldGroup>
}

export type AddressError = Error & {
  __typename: 'AddressError'
  message: Scalars['String']['output']
}

export type AddressField = {
  key: Scalars['String']['output']
  label: Scalars['String']['output']
}

export type AddressFieldConstraint = {
  message: Scalars['String']['output']
}

export type AddressFieldGroup = {
  __typename: 'AddressFieldGroup'
  fields: Array<AddressField>
}

export type AddressFieldInput = {
  key: Scalars['String']['input']
  value: Scalars['String']['input']
}

export type AddressFieldOption = {
  __typename: 'AddressFieldOption'
  label: Scalars['String']['output']
  value: Scalars['String']['output']
}

export type AddressInvalidErrors = Errors & {
  __typename: 'AddressInvalidErrors'
  id: Scalars['String']['output']
  messages: Array<Scalars['String']['output']>
}

export type AddressList = {
  __typename: 'AddressList'
  id: Scalars['ID']['output']
  items: Array<Address>
}

export type AddressLookupError = Error & {
  __typename: 'AddressLookupError'
  message: Scalars['String']['output']
}

export type AddressLookupInput = {
  country: Scalars['String']['input']
  houseNumber?: InputMaybe<Scalars['String']['input']>
  houseNumberExtension?: InputMaybe<Scalars['String']['input']>
  postalCode: Scalars['String']['input']
}

export type AddressLookupResult =
  | AddressLookupError
  | AddressLookupSuccess
  | { __typename?: '%other' }

export type AddressLookupSuccess = {
  __typename: 'AddressLookupSuccess'
  addresses: Array<LookupAddress>
}

export type AddressMaxLengthConstraint = AddressFieldConstraint & {
  __typename: 'AddressMaxLengthConstraint'
  max: Scalars['Int']['output']
  message: Scalars['String']['output']
}

export type AddressNotFoundError = Error & {
  __typename: 'AddressNotFoundError'
  message: Scalars['String']['output']
}

export type AddressPatternConstraint = AddressFieldConstraint & {
  __typename: 'AddressPatternConstraint'
  message: Scalars['String']['output']
  regex: Scalars['String']['output']
}

export type AddressRequest = {
  __typename: 'AddressRequest'
  expiryMessage: Scalars['String']['output']
  id: Scalars['String']['output']
  recipientFirstName: Scalars['String']['output']
  recipientLastName: Scalars['String']['output']
  shareableMessage: Scalars['String']['output']
  webUrl: Scalars['String']['output']
}

export type AddressRequestInputError = Error & {
  __typename: 'AddressRequestInputError'
  message: Scalars['String']['output']
}

export type AddressRequestNotFoundError = Error & {
  __typename: 'AddressRequestNotFoundError'
  message: Scalars['String']['output']
}

export type AddressRequestProcessedError = Error & {
  __typename: 'AddressRequestProcessedError'
  message: Scalars['String']['output']
}

export type AddressRequestResult =
  | AddressRequestNotFoundError
  | AddressRequestProcessedError
  | AddressRequestResultSuccess
  | { __typename?: '%other' }

export type AddressRequestResultSuccess = {
  __typename: 'AddressRequestResultSuccess'
  customerFirstName: Scalars['String']['output']
  customerLastName: Scalars['String']['output']
  dateCreated: Scalars['String']['output']
  dateProcessed?: Maybe<Scalars['String']['output']>
  id: Scalars['String']['output']
  recipientFirstName: Scalars['String']['output']
  recipientLastName: Scalars['String']['output']
}

export type AddressRequests = {
  __typename: 'AddressRequests'
  count: Scalars['Int']['output']
  items: Array<AddressRequest>
}

export type AddressRequiredConstraint = AddressFieldConstraint & {
  __typename: 'AddressRequiredConstraint'
  message: Scalars['String']['output']
}

export type AddressSchema = {
  fieldGroups: Array<AddressFieldGroup>
}

export type AddressSchemasResult = {
  __typename: 'AddressSchemasResult'
  countrySchemas: Array<AddressCountrySchema>
  countrySelect: AddressSelectField
  defaultSchema: AddressDefaultSchema
}

export type AddressSelectField = AddressField & {
  __typename: 'AddressSelectField'
  key: Scalars['String']['output']
  label: Scalars['String']['output']
  options: Array<AddressFieldOption>
}

export type AddressTextField = AddressField & {
  __typename: 'AddressTextField'
  constraints?: Maybe<AddressTextFieldConstraints>
  key: Scalars['String']['output']
  label: Scalars['String']['output']
  placeholder?: Maybe<Scalars['String']['output']>
}

export type AddressTextFieldConstraints = {
  __typename: 'AddressTextFieldConstraints'
  maxLength?: Maybe<AddressMaxLengthConstraint>
  pattern?: Maybe<AddressPatternConstraint>
  required?: Maybe<AddressRequiredConstraint>
}

export type AlternativeSearchDepartmentCount = {
  __typename: 'AlternativeSearchDepartmentCount'
  count: Scalars['Int']['output']
  department: DepartmentsEnum
  label: Scalars['String']['output']
}

export enum AmendErrorCode {
  DELIVERY_NOT_FOUND = 'DELIVERY_NOT_FOUND',
  LINE_ITEM_NOT_FOUND = 'LINE_ITEM_NOT_FOUND',
  UNAUTHORIZED = 'UNAUTHORIZED',
  UNEXPECTED_ERROR = 'UNEXPECTED_ERROR',
}

export type AmendResult = {
  message: Scalars['String']['output']
}

export type Announcement = {
  __typename: 'Announcement'
  cta: CTA
  detail: Scalars['String']['output']
  heading: Scalars['String']['output']
  id: Scalars['ID']['output']
  image: ContentImage
  title: Scalars['String']['output']
}

export type AppBanner = {
  __typename: 'AppBanner'
  /** @deprecated rating is depricated. Please use reviews.stars field instead */
  rating: Scalars['Float']['output']
  reviews: AppBannerReviews
  shouldFormat: Scalars['Boolean']['output']
  subtitle: Scalars['String']['output']
  title: Scalars['String']['output']
  /** @deprecated totalRatings is depricated. Please use reviews.count field instead */
  totalRatings: Scalars['String']['output']
  url: Scalars['String']['output']
  voucherCode?: Maybe<Scalars['String']['output']>
}

export type AppBannerReviews = {
  __typename: 'AppBannerReviews'
  count: Scalars['Int']['output']
  stars: Scalars['Float']['output']
}

export type ApplicableFilter =
  | FilterFacet
  | IntegerFilter
  | InvertedToggleFilter
  | ToggleFilter
  | { __typename?: '%other' }

export type AppliedDiscount = {
  __typename: 'AppliedDiscount'
  code: Scalars['String']['output']
  name?: Maybe<Scalars['String']['output']>
}

export type AppliedIntent = {
  __typename: 'AppliedIntent'
  intentId: Scalars['String']['output']
  ordinal?: Maybe<Scalars['String']['output']>
  value: Scalars['String']['output']
}

export type AppliedIntentInput = {
  intentId: Scalars['String']['input']
  ordinal?: InputMaybe<Scalars['String']['input']>
  value: Scalars['String']['input']
}

export type ApplyAutoPromoError = Error & {
  __typename: 'ApplyAutoPromoError'
  message: Scalars['String']['output']
}

export type ApplyAutoPromoInput = {
  autoPromoId: Scalars['ID']['input']
  id: Scalars['ID']['input']
  /** @deprecated No longer required please remove */
  version?: InputMaybe<Scalars['Long']['input']>
}

export type ApplyAutoPromoResult =
  | ApplyAutoPromoError
  | Basket
  | BasketNotFoundError
  | ConcurrentModificationError
  | { __typename?: '%other' }

export type ApplyPromoError = Error & {
  __typename: 'ApplyPromoError'
  message: Scalars['String']['output']
}

export type ApplyPromoInput = {
  id: Scalars['ID']['input']
  promoId: Scalars['ID']['input']
}

export type ApplyPromoResult =
  | ApplyPromoError
  | Basket
  | BasketNotFoundError
  | ConcurrentModificationError
  | { __typename?: '%other' }

export type ApplyPromotionCodeToBusinessProjectResult =
  | BusinessProject
  | BusinessProjectPromotionCodeError
  | InputValidationError
  | { __typename?: '%other' }

export type ApplyRenewalDiscountResponse = {
  __typename: 'ApplyRenewalDiscountResponse'
  success: Scalars['Boolean']['output']
}

export type AssignABTestVariantInput = {
  id: Scalars['ID']['input']
  variant: Scalars['String']['input']
  version: Scalars['Long']['input']
}

export type AssignABTestVariantResult =
  | Basket
  | BasketNotFoundError
  | ConcurrentModificationError
  | { __typename?: '%other' }

export type AssignAddressResult =
  | Basket
  | DeliveryAddressInvalidError
  | DeliveryRestrictedError
  | LineItemNotFoundError
  | { __typename?: '%other' }

export type AssignBasketAddressInput = {
  addressId: Scalars['String']['input']
  id: Scalars['ID']['input']
  /** @deprecated No longer required please remove */
  version?: InputMaybe<Scalars['Long']['input']>
}

export type AssignBasketAddressRecipientInput = {
  addressId: Scalars['ID']['input']
  id: Scalars['ID']['input']
  recipientId: Scalars['ID']['input']
}

export type AssignBasketAddressRecipientResult =
  | Basket
  | { __typename?: '%other' }

export type AssignBasketAddressResult =
  | AddressNotFoundError
  | Basket
  | BasketNotFoundError
  | ConcurrentModificationError
  | DeliveryAddressInvalidError
  | DeliveryRestrictedError
  | { __typename?: '%other' }

export type AssignBasketVoucherError = Error & {
  __typename: 'AssignBasketVoucherError'
  message: Scalars['String']['output']
}

export type AssignBasketVoucherInput = {
  code: Scalars['String']['input']
  id: Scalars['ID']['input']
  /** @deprecated No longer required please remove */
  version?: InputMaybe<Scalars['Long']['input']>
}

export type AssignBasketVoucherResult =
  | AssignBasketVoucherError
  | Basket
  | BasketNotFoundError
  | ConcurrentModificationError
  | { __typename?: '%other' }

export type AssignBillingAddressFailed = Error & {
  __typename: 'AssignBillingAddressFailed'
  message: Scalars['String']['output']
}

export type AssignBillingAddressResult =
  | AssignBillingAddressFailed
  | Customer
  | { __typename?: '%other' }

export type AssignCustomerAddressInput = {
  addressId: Scalars['String']['input']
  basketId: Scalars['ID']['input']
  lineItemIds?: InputMaybe<Array<Scalars['ID']['input']>>
}

export type AssignDeliveryAddressInput = {
  addressId: Scalars['String']['input']
  basketId: Scalars['ID']['input']
  deliveryId: Scalars['ID']['input']
  /** @deprecated No longer required please remove */
  version?: InputMaybe<Scalars['Long']['input']>
}

export type AssignDeliveryAddressResult =
  | AddressNotFoundError
  | Basket
  | BasketNotFoundError
  | ConcurrentModificationError
  | DeliveryAddressInvalidError
  | DeliveryNotFoundError
  | DeliveryRestrictedError
  | { __typename?: '%other' }

export type AssignDeliveryDateInput = {
  date: Scalars['Date']['input']
  deliveryId: Scalars['String']['input']
  id: Scalars['ID']['input']
  /** @deprecated No longer required please remove */
  version?: InputMaybe<Scalars['Long']['input']>
}

export type AssignDeliveryDateResult =
  | Basket
  | BasketEmptyError
  | BasketNotFoundError
  | ConcurrentModificationError
  | DeliveryNotFoundError
  | NoLineItemsExistForDeliveryIdError
  | { __typename?: '%other' }

export type AssignDeliveryGiftNoteError = Error & {
  __typename: 'AssignDeliveryGiftNoteError'
  message: Scalars['String']['output']
}

export type AssignDeliveryGiftNoteInput = {
  deliveryId: Scalars['String']['input']
  giftNote: Scalars['String']['input']
  id: Scalars['ID']['input']
  version: Scalars['Long']['input']
}

export type AssignDeliveryGiftNoteResult =
  | AssignDeliveryGiftNoteError
  | Basket
  | BasketEmptyError
  | BasketNotFoundError
  | ConcurrentModificationError
  | DeliveryNotFoundError
  | NoLineItemsExistForDeliveryIdError
  | UserInputError
  | { __typename?: '%other' }

export type AssignDeliveryMethodAndDateInput = {
  deliveryDate?: InputMaybe<Scalars['Date']['input']>
  deliveryId: Scalars['String']['input']
  deliveryInstructions?: InputMaybe<Scalars['String']['input']>
  deliveryMethodId: Scalars['String']['input']
  deliveryMobile?: InputMaybe<Scalars['String']['input']>
  id: Scalars['ID']['input']
}

export type AssignDeliveryMethodAndDateResult =
  | Basket
  | BasketEmptyError
  | BasketNotFoundError
  | ConcurrentModificationError
  | DeliveryNotFoundError
  | NoLineItemsExistForDeliveryIdError
  | UserInputError
  | { __typename?: '%other' }

export type AssignDeliveryMethodInput = {
  deliveryId: Scalars['String']['input']
  deliveryInstructions?: InputMaybe<Scalars['String']['input']>
  deliveryMethodId: Scalars['String']['input']
  deliveryMobile?: InputMaybe<Scalars['String']['input']>
  id: Scalars['ID']['input']
  /** @deprecated No longer required please remove */
  version?: InputMaybe<Scalars['Long']['input']>
}

export type AssignDeliveryMethodResult =
  | Basket
  | BasketEmptyError
  | BasketNotFoundError
  | ConcurrentModificationError
  | DeliveryNotFoundError
  | NoLineItemsExistForDeliveryIdError
  | UserInputError
  | { __typename?: '%other' }

export type AssignLineItemAddressInput = {
  addressId: Scalars['String']['input']
  id: Scalars['ID']['input']
  lineItemId: Scalars['ID']['input']
  /** @deprecated No longer required please remove */
  version?: InputMaybe<Scalars['Long']['input']>
}

export type AssignLineItemAddressResult =
  | AddressNotFoundError
  | Basket
  | BasketNotFoundError
  | ConcurrentModificationError
  | DeliveryAddressInvalidError
  | DeliveryRestrictedError
  | LineItemNotFoundError
  | { __typename?: '%other' }

export type AssignLineItemEmailAddressInput = {
  email: Scalars['String']['input']
  id: Scalars['ID']['input']
  lineItemId: Scalars['ID']['input']
  name: Scalars['String']['input']
  /** @deprecated No longer required please remove */
  version?: InputMaybe<Scalars['Long']['input']>
}

export type AssignLineItemEmailAddressResult =
  | Basket
  | BasketNotFoundError
  | ConcurrentModificationError
  | DeliveryAddressInvalidError
  | LineItemNotFoundError
  | { __typename?: '%other' }

export type AssignRecipientAddressInput = {
  addressId: Scalars['String']['input']
  basketId: Scalars['ID']['input']
  firstName: Scalars['String']['input']
  lastName: Scalars['String']['input']
  lineItemIds?: InputMaybe<Array<Scalars['ID']['input']>>
  recipientId: Scalars['ID']['input']
}

export enum Audience {
  MOBILE_WEB = 'MOBILE_WEB',
  WEB = 'WEB',
}

export enum AutoCompleteVariant {
  Legacy = 'Legacy',
  V1 = 'V1',
  V2 = 'V2',
}

export type AutoPromo = {
  description: Scalars['String']['output']
  id: Scalars['ID']['output']
  name: Scalars['String']['output']
}

export type AutocompleteAddress = {
  __typename: 'AutocompleteAddress'
  addressFirstLine: Scalars['String']['output']
  city?: Maybe<Scalars['String']['output']>
  country: Scalars['String']['output']
  displayAddress: Scalars['String']['output']
  displayLines: Array<Scalars['String']['output']>
  houseNumber?: Maybe<Scalars['String']['output']>
  houseNumberExtension?: Maybe<Scalars['String']['output']>
  postcode?: Maybe<Scalars['String']['output']>
  state?: Maybe<Scalars['String']['output']>
}

export type AutocompleteAddressError = Error & {
  __typename: 'AutocompleteAddressError'
  message: Scalars['String']['output']
}

export type AutocompleteAddressInput = {
  country: Scalars['String']['input']
  query: Scalars['String']['input']
}

export type AutocompleteAddressResult =
  | AutocompleteAddressError
  | AutocompleteAddressSuccess
  | { __typename?: '%other' }

export type AutocompleteAddressSuccess = {
  __typename: 'AutocompleteAddressSuccess'
  addresses: Array<AutocompleteAddress>
}

export type AvailableDeliveryOptions = {
  __typename: 'AvailableDeliveryOptions'
  availableOptions?: Maybe<Array<DeliveryOption>>
  hasEarlierDates: Scalars['Boolean']['output']
  suggestedOptions?: Maybe<Array<SuggestedDeliveryOption>>
}

export type BackwardPage = {
  cursor?: InputMaybe<Scalars['String']['input']>
  last: Scalars['Int']['input']
}

export type BadRequest = Error & {
  __typename: 'BadRequest'
  message: Scalars['String']['output']
}

/** Basket entity reference (extended from other graph). */
export type Basket = Node &
  Versioned & {
    __typename: 'Basket'
    addressActionType: AddressActionType
    autoPromos?: Maybe<Array<BasketAutoPromo>>
    basketSummary: Array<BasketSummaryItem>
    /** @deprecated Use addressActionType */
    canHaveMultipleAddresses: Scalars['Boolean']['output']
    candidateReminder?: Maybe<CandidateReminder>
    credits: CreditsBreakdown
    /** @deprecated Use `credits{used}`. */
    creditsUsed: Money
    customerId?: Maybe<Scalars['String']['output']>
    deliveryOptions?: Maybe<DeliveryOptions>
    /** Unique identifier for the basket */
    id: Scalars['ID']['output']
    /** @deprecated For internal use only */
    isReadyForCheckout: Scalars['Boolean']['output']
    lineItems: Array<LineItem>
    membership: BasketMembership
    /** @deprecated Use membership.selected field on basket */
    membershipLineItem?: Maybe<MembershipLineItem>
    membershipOffer: BasketMembershipOffer
    multiBuyList?: Maybe<MultiBuyList>
    /** @deprecated For internal use only */
    notReadyForCheckoutReason?: Maybe<Scalars['String']['output']>
    paymentProviders: Array<PaymentProvider>
    /** @deprecated Field was extended and has union type, use personalisedPromotion */
    personalisedPromo?: Maybe<BasketPersonalisedPromo>
    personalisedPromotion?: Maybe<BasketPersonalisedPromotion>
    priceSummary: BasketPriceSummary
    recipientOptions?: Maybe<BasketRecipients>
    recipientsDeliveries?: Maybe<BasketRecipientsDeliveries>
    recommendations: Recommendations
    requiredAge?: Maybe<RequiredAge>
    savedCards: SavedCards
    /** @deprecated Use recipientAddress field on lineItem */
    shippingAddress?: Maybe<ShippingAddress>
    /** @deprecated For internal use only */
    state: BasketState
    /** @deprecated for internal use */
    store: Store
    subTotalIncTax: Money
    totalDiscount?: Maybe<Money>
    totalGrossTaxedPrice?: Maybe<Money>
    totalItemPrice: Money
    totalItems: Scalars['Int']['output']
    totalPrice: Money
    totalShippingPrice: Money
    totalTaxExclusive?: Maybe<Money>
    totalToPay: Money
    upsell?: Maybe<BasketUpsell>
    version: Scalars['Long']['output']
    voucherCode?: Maybe<VoucherCode>
  }

/** Basket entity reference (extended from other graph). */
export type BasketpersonalisedPromoArgs = {
  audience?: InputMaybe<Audience>
}

/** Basket entity reference (extended from other graph). */
export type BasketpersonalisedPromotionArgs = {
  audience?: InputMaybe<Audience>
}

/** Basket entity reference (extended from other graph). */
export type BasketrecommendationsArgs = {
  algorithmId?: InputMaybe<Scalars['String']['input']>
  facets?: InputMaybe<RecommendationFacets>
  isDesignInferenceEnabled?: InputMaybe<Scalars['Boolean']['input']>
  isUserLevelPersonalised?: InputMaybe<Scalars['Boolean']['input']>
}

export type BasketAutoPromo = AutoPromo & {
  __typename: 'BasketAutoPromo'
  description: Scalars['String']['output']
  id: Scalars['ID']['output']
  isApplied: Scalars['Boolean']['output']
  name: Scalars['String']['output']
}

export type BasketEmailRecipientDelivery = Node & {
  __typename: 'BasketEmailRecipientDelivery'
  deliveries: Array<Delivery>
  id: Scalars['ID']['output']
  summary: BasketRecipientDeliveriesSummary
}

export type BasketEmptyError = Error & {
  __typename: 'BasketEmptyError'
  message: Scalars['String']['output']
}

export type BasketMembership = {
  __typename: 'BasketMembership'
  /** @deprecated Please use membershipOffer.offer instead */
  offer?: Maybe<MembershipFiveCardsOffer>
  /** @deprecated Please use membershipOffer.recommended instead */
  recommended?: Maybe<MembershipRecommendation>
  selected?: Maybe<MembershipLineItem>
  totalDiscount?: Maybe<Money>
}

export type BasketMembershipOffer = {
  __typename: 'BasketMembershipOffer'
  offer?: Maybe<MembershipFiveCardsOffer>
  recommended?: Maybe<MembershipRecommendation>
}

export type BasketNotFoundError = Error & {
  __typename: 'BasketNotFoundError'
  message: Scalars['String']['output']
}

export type BasketOrderedError = Error & {
  __typename: 'BasketOrderedError'
  message: Scalars['String']['output']
}

export type BasketPersonalisedPromo = BasketPersonalisedPromoBase & {
  __typename: 'BasketPersonalisedPromo'
  description: Scalars['String']['output']
  exclusionsMessage?: Maybe<Scalars['String']['output']>
  id: Scalars['ID']['output']
  isApplied: Scalars['Boolean']['output']
  message?: Maybe<Scalars['String']['output']>
  metadata?: Maybe<BasketPersonalisedPromoMetadata>
  name: Scalars['String']['output']
  stateErrorMessage?: Maybe<Scalars['String']['output']>
}

export type BasketPersonalisedPromoBase = {
  description: Scalars['String']['output']
  exclusionsMessage?: Maybe<Scalars['String']['output']>
  id: Scalars['ID']['output']
  isApplied: Scalars['Boolean']['output']
  message?: Maybe<Scalars['String']['output']>
  metadata?: Maybe<BasketPersonalisedPromoMetadata>
  name: Scalars['String']['output']
  stateErrorMessage?: Maybe<Scalars['String']['output']>
}

export type BasketPersonalisedPromoMetadata = {
  __typename: 'BasketPersonalisedPromoMetadata'
  seeding?: Maybe<Scalars['Boolean']['output']>
}

export type BasketPersonalisedPromoNoOffer = {
  __typename: 'BasketPersonalisedPromoNoOffer'
  metadata?: Maybe<BasketPersonalisedPromoMetadata>
  reason?: Maybe<Scalars['String']['output']>
}

export type BasketPersonalisedPromoUpsell = BasketPersonalisedPromoBase & {
  __typename: 'BasketPersonalisedPromoUpsell'
  description: Scalars['String']['output']
  exclusionsMessage?: Maybe<Scalars['String']['output']>
  id: Scalars['ID']['output']
  isApplied: Scalars['Boolean']['output']
  message?: Maybe<Scalars['String']['output']>
  metadata?: Maybe<BasketPersonalisedPromoMetadata>
  name: Scalars['String']['output']
  stateErrorMessage?: Maybe<Scalars['String']['output']>
}

export type BasketPersonalisedPromotion =
  | BasketPersonalisedPromo
  | BasketPersonalisedPromoNoOffer
  | BasketPersonalisedPromoUpsell
  | { __typename?: '%other' }

export type BasketPhysicalRecipientDelivery = Node & {
  __typename: 'BasketPhysicalRecipientDelivery'
  deliveries: Array<Delivery>
  id: Scalars['ID']['output']
  packagingOptions?: Maybe<BasketRecipientDeliveriesPackagingOptions>
  summary: BasketRecipientDeliveriesSummary
}

export type BasketPriceSummary = {
  __typename: 'BasketPriceSummary'
  all: Array<BasketSummaryPrices>
  items: Array<BasketSummaryItems>
  membership?: Maybe<Money>
  postage?: Maybe<Money>
  salesTax?: Maybe<Money>
  totalDiscount?: Maybe<Money>
  totalItemsCost?: Maybe<Money>
}

export type BasketRecipient = {
  __typename: 'BasketRecipient'
  isMe?: Maybe<Scalars['Boolean']['output']>
  lineItems: Array<LineItem>
  name?: Maybe<Scalars['String']['output']>
}

export type BasketRecipientDeliveries =
  | BasketEmailRecipientDelivery
  | BasketPhysicalRecipientDelivery
  | { __typename?: '%other' }

export type BasketRecipientDeliveriesPackagingOptions = {
  __typename: 'BasketRecipientDeliveriesPackagingOptions'
  items: Array<BasketRecipientDeliveryPackagingOption>
  packagingMessage?: Maybe<Scalars['String']['output']>
  selected?: Maybe<BasketRecipientDeliveryPackagingOptionType>
}

export type BasketRecipientDeliveriesSummary = {
  __typename: 'BasketRecipientDeliveriesSummary'
  deliveriesInfo: Array<Scalars['String']['output']>
  formattedAddress: Scalars['String']['output']
  groupTitle: Scalars['String']['output']
  title: Scalars['String']['output']
}

export type BasketRecipientDeliveryPackagingOption = {
  __typename: 'BasketRecipientDeliveryPackagingOption'
  description: Scalars['String']['output']
  title: Scalars['String']['output']
  type: BasketRecipientDeliveryPackagingOptionType
}

export enum BasketRecipientDeliveryPackagingOptionType {
  TO_CUSTOMER = 'TO_CUSTOMER',
  TO_RECIPIENT = 'TO_RECIPIENT',
}

export type BasketRecipients = {
  __typename: 'BasketRecipients'
  recipients: Array<BasketRecipient>
}

export type BasketRecipientsDeliveries = {
  __typename: 'BasketRecipientsDeliveries'
  count: Scalars['Int']['output']
  isComplete: Scalars['Boolean']['output']
  items: Array<BasketRecipientDeliveries>
}

export enum BasketState {
  ACTIVE = 'ACTIVE',
  ORDERED = 'ORDERED',
}

export type BasketSummaryBenefit = {
  __typename: 'BasketSummaryBenefit'
  priceDisplay: Scalars['String']['output']
  title: Scalars['String']['output']
}

export type BasketSummaryBenefitItem = BasketSummaryPriceItem & {
  __typename: 'BasketSummaryBenefitItem'
  priceDisplay?: Maybe<Scalars['String']['output']>
  title: Scalars['String']['output']
}

export type BasketSummaryCost = {
  __typename: 'BasketSummaryCost'
  discountedPriceDisplay?: Maybe<Scalars['String']['output']>
  originalPriceDisplay: Scalars['String']['output']
  title: Scalars['String']['output']
}

export type BasketSummaryCostItem = BasketSummaryPriceItem & {
  __typename: 'BasketSummaryCostItem'
  priceDisplay?: Maybe<Scalars['String']['output']>
  title: Scalars['String']['output']
}

export type BasketSummaryItem = {
  __typename: 'BasketSummaryItem'
  title: Scalars['String']['output']
  total: Money
}

export type BasketSummaryItems =
  | BasketSummaryBenefit
  | BasketSummaryCost
  | { __typename?: '%other' }

export type BasketSummaryPriceItem = {
  priceDisplay?: Maybe<Scalars['String']['output']>
  title: Scalars['String']['output']
}

export type BasketSummaryPrices =
  | BasketSummaryBenefitItem
  | BasketSummaryCostItem
  | { __typename?: '%other' }

export type BasketUpsell = {
  __typename: 'BasketUpsell'
  content?: Maybe<MembershipUpsellContent>
  intrusive?: Maybe<MembershipUpsellIntrusive>
  productVariants: Array<UpsellProductVariant>
}

export type BasketValidatedResult = {
  __typename: 'BasketValidatedResult'
  basket: Basket
  /** @deprecated Will be removed in an upcoming release */
  invalidDeliveryMethod?: Maybe<InvalidDeliveryMethod>
  /** @deprecated Will be removed in an upcoming release */
  invalidVoucherMessage?: Maybe<Scalars['String']['output']>
  validations: Array<BasketValidationResult>
}

export type BasketValidation = {
  isBlocking: Scalars['Boolean']['output']
  message: Scalars['String']['output']
  title: Scalars['String']['output']
}

export type BasketValidationResult =
  | DeliveryValidation
  | PromoValidation
  | StockValidation
  | VoucherValidation
  | { __typename?: '%other' }

export type BillingAddress = {
  __typename: 'BillingAddress'
  addressFirstLine?: Maybe<Scalars['String']['output']>
  city?: Maybe<Scalars['String']['output']>
  country: Scalars['String']['output']
  firstName: Scalars['String']['output']
  id: Scalars['String']['output']
  lastName: Scalars['String']['output']
  postalCode?: Maybe<Scalars['String']['output']>
  state?: Maybe<Scalars['String']['output']>
  /** @deprecated Use addressFirstLine */
  streetName?: Maybe<Scalars['String']['output']>
}

export type BlogPostListItem = {
  __typename: 'BlogPostListItem'
  image: ContentImage
  subtitle: Scalars['String']['output']
  title: Scalars['String']['output']
  url: Scalars['String']['output']
}

export type BlogPostRelatedArticle = {
  __typename: 'BlogPostRelatedArticle'
  cta: CTA
  image: ContentImage
  title: Scalars['String']['output']
}

export type Breadcrumb = {
  __typename: 'Breadcrumb'
  title: Scalars['String']['output']
  url: Scalars['String']['output']
}

export enum BrowserPlatform {
  Desktop = 'Desktop',
  Mobile = 'Mobile',
}

export type Business = {
  __typename: 'Business'
  businessCredits?: Maybe<BusinessCredits>
  businessProject?: Maybe<BusinessProjectResponse>
  hasBusinessEmail: Scalars['Boolean']['output']
}

export type BusinessAddress = {
  addressFirstLine: Scalars['String']['input']
  city: Scalars['String']['input']
  country: Scalars['String']['input']
  firstName: Scalars['String']['input']
  lastName: Scalars['String']['input']
  postcode: Scalars['String']['input']
}

export type BusinessAvailableSubstitution = {
  __typename: 'BusinessAvailableSubstitution'
  key: BusinessSubstitution
  placeholder: Scalars['String']['output']
}

export type BusinessCardCustomisation = {
  __typename: 'BusinessCardCustomisation'
  to: BusinessCardTo
}

export type BusinessCardCustomisationInput = {
  nameFormat: BusinessNameFormat
}

export type BusinessCardDesign = {
  __typename: 'BusinessCardDesign'
  designId?: Maybe<Scalars['String']['output']>
  productKey: Scalars['String']['output']
  sku: Scalars['String']['output']
}

export type BusinessCardProductAndDesignInput = {
  designId: Scalars['String']['input']
  productKey: Scalars['String']['input']
  sku: Scalars['String']['input']
  source?: InputMaybe<Scalars['String']['input']>
}

export type BusinessCardTo = {
  __typename: 'BusinessCardTo'
  nameFormat: BusinessNameFormat
}

export type BusinessCredits = {
  __typename: 'BusinessCredits'
  balance: Scalars['Long']['output']
}

export type BusinessDeliveryOptions = {
  __typename: 'BusinessDeliveryOptions'
  nextAvailableBusinessDate: Scalars['Date']['output']
  unavailableBusinessDates: Array<Scalars['Date']['output']>
}

export type BusinessDetails = {
  __typename: 'BusinessDetails'
  billingAddress?: Maybe<BillingAddress>
  companyName?: Maybe<Scalars['String']['output']>
}

export type BusinessGiftInput = {
  productKey: Scalars['String']['input']
  sku: Scalars['String']['input']
}

export enum BusinessNameFormat {
  FIRST = 'FIRST',
  FULL = 'FULL',
  NONE = 'NONE',
}

export type BusinessOrder = {
  __typename: 'BusinessOrder'
  card: BusinessOrderCard
  createdOn: Scalars['Date']['output']
  earliestDeliveryDate?: Maybe<Scalars['Date']['output']>
  gift?: Maybe<Product>
  hasReceipt: Scalars['Boolean']['output']
  id: Scalars['ID']['output']
  price: BusinessOrderPrice
  recipientCount: Scalars['Long']['output']
  recipients: Array<BusinessOrderRecipient>
  status: BusinessOrderStatus
  substitutions: BusinessSubstitutions
}

export type BusinessOrderAddress = {
  __typename: 'BusinessOrderAddress'
  addressLine1: Scalars['String']['output']
  city: Scalars['String']['output']
  country: Scalars['String']['output']
  postcode: Scalars['String']['output']
}

export type BusinessOrderCard = {
  __typename: 'BusinessOrderCard'
  designId: Scalars['String']['output']
  productKey: Scalars['String']['output']
  sku: Scalars['String']['output']
}

export type BusinessOrderDelivery = {
  __typename: 'BusinessOrderDelivery'
  deliveryMethod: BusinessOrderDeliveryMethod
  deliveryOption: BusinessOrderDeliveryOption
  id: Scalars['String']['output']
  tracking?: Maybe<BusinessOrderDeliveryTracking>
}

export type BusinessOrderDeliveryMethod = {
  __typename: 'BusinessOrderDeliveryMethod'
  id: Scalars['String']['output']
  name: Scalars['String']['output']
}

export type BusinessOrderDeliveryOption = {
  __typename: 'BusinessOrderDeliveryOption'
  deliveryDate: Scalars['Date']['output']
  despatchDate: Scalars['Date']['output']
}

export type BusinessOrderDeliveryTracking = {
  __typename: 'BusinessOrderDeliveryTracking'
  reference: Scalars['String']['output']
  url: Scalars['String']['output']
}

export type BusinessOrderInput = {
  id: Scalars['ID']['input']
}

export type BusinessOrderNotFoundError = Error & {
  __typename: 'BusinessOrderNotFoundError'
  message: Scalars['String']['output']
}

export type BusinessOrderPrice = {
  __typename: 'BusinessOrderPrice'
  itemisation: BusinessOrderPriceItemisation
  total: BusinessOrderPriceTotal
}

export type BusinessOrderPriceItemisation = {
  __typename: 'BusinessOrderPriceItemisation'
  card: Money
  cardCredits: Scalars['Long']['output']
  gift?: Maybe<Money>
  shipping: Money
}

export type BusinessOrderPriceTotal = {
  __typename: 'BusinessOrderPriceTotal'
  amount: Money
  items: Scalars['Long']['output']
  shipping: Money
}

export type BusinessOrderRecipient = {
  __typename: 'BusinessOrderRecipient'
  address: BusinessOrderAddress
  delivery?: Maybe<BusinessOrderDelivery>
  firstName: Scalars['String']['output']
  id: Scalars['String']['output']
  lastName: Scalars['String']['output']
  status: BusinessOrderRecipientStatus
}

export enum BusinessOrderRecipientStatus {
  DELIVERED = 'DELIVERED',
  DESPATCHED = 'DESPATCHED',
  FAILED = 'FAILED',
  PACKED = 'PACKED',
  PROCESSING = 'PROCESSING',
  UNKNOWN = 'UNKNOWN',
}

export type BusinessOrderResponse =
  | BusinessOrder
  | BusinessOrderNotFoundError
  | { __typename?: '%other' }

export enum BusinessOrderStatus {
  COMPLETED = 'COMPLETED',
  PROCESSING = 'PROCESSING',
  UNKNOWN = 'UNKNOWN',
}

export type BusinessOrdersConnection = {
  __typename: 'BusinessOrdersConnection'
  edges: Array<BusinessOrdersEdge>
  pageInfo: PageInfo
}

export type BusinessOrdersConnectionInput = {
  backwardPage?: InputMaybe<BackwardPage>
  canReorder?: InputMaybe<Scalars['Boolean']['input']>
  forwardPage?: InputMaybe<ForwardPage>
}

export type BusinessOrdersEdge = {
  __typename: 'BusinessOrdersEdge'
  cursor: Scalars['String']['output']
  node: BusinessOrder
}

export type BusinessPreviewSubstitution = {
  __typename: 'BusinessPreviewSubstitution'
  placeholder: Scalars['String']['output']
  value: Scalars['String']['output']
}

export type BusinessPrice = {
  __typename: 'BusinessPrice'
  card?: Maybe<Money>
  delivery?: Maybe<Money>
  gift?: Maybe<Money>
}

export type BusinessPriceDetail = {
  __typename: 'BusinessPriceDetail'
  fullPrice: Money
  price: Money
  promotionalMessage?: Maybe<Scalars['String']['output']>
}

export type BusinessPricing = {
  __typename: 'BusinessPricing'
  card?: Maybe<BusinessPriceDetail>
  delivery?: Maybe<BusinessPriceDetail>
  gift?: Maybe<BusinessPriceDetail>
  total: BusinessPricingTotal
}

export type BusinessPricingTotal = {
  __typename: 'BusinessPricingTotal'
  cardCreditsQuantity?: Maybe<Scalars['Int']['output']>
  cardNonCreditsQuantity?: Maybe<Scalars['Int']['output']>
  price: Money
}

export type BusinessProductImage = {
  __typename: 'BusinessProductImage'
  dimensions: BusinessProductImageDimensions
  url: Scalars['String']['output']
}

export type BusinessProductImageDimensions = {
  __typename: 'BusinessProductImageDimensions'
  h: Scalars['Long']['output']
  w: Scalars['Long']['output']
}

export type BusinessProductVariant = {
  __typename: 'BusinessProductVariant'
  images: Array<BusinessProductImage>
  price: Money
  productKey: Scalars['String']['output']
  sku: Scalars['String']['output']
}

export type BusinessProductVariantInput = {
  productKey: Scalars['String']['input']
  sku: Scalars['String']['input']
}

export type BusinessProductVariantNotFoundError = Error & {
  __typename: 'BusinessProductVariantNotFoundError'
  message: Scalars['String']['output']
}

export type BusinessProductVariantResponse =
  | BusinessProductVariant
  | BusinessProductVariantNotFoundError
  | { __typename?: '%other' }

export type BusinessProject = {
  __typename: 'BusinessProject'
  cardCustomisation?: Maybe<BusinessCardCustomisation>
  cardDesign?: Maybe<BusinessCardDesign>
  gift?: Maybe<BusinessProjectGift>
  id: Scalars['ID']['output']
  keywords?: Maybe<Array<Scalars['String']['output']>>
  price?: Maybe<BusinessPrice>
  pricing?: Maybe<BusinessPricing>
  promotionCode?: Maybe<BusinessProjectPromotionCode>
  recipients: Array<BusinessRecipient>
  sendToSelf?: Maybe<BusinessProjectSendToSelf>
  substitutions?: Maybe<BusinessSubstitutions>
}

export type BusinessProjectAddress = {
  __typename: 'BusinessProjectAddress'
  addressLine1: Scalars['String']['output']
  city: Scalars['String']['output']
  country: Scalars['String']['output']
  postcode: Scalars['String']['output']
}

export type BusinessProjectAddressInput = {
  addressLine1: Scalars['String']['input']
  city: Scalars['String']['input']
  country: Scalars['String']['input']
  postcode: Scalars['String']['input']
}

export type BusinessProjectGift = {
  __typename: 'BusinessProjectGift'
  product: Product
  sku: Scalars['String']['output']
}

export type BusinessProjectKeywordInput = {
  keyword: Scalars['String']['input']
}

export type BusinessProjectPromotionCode = {
  __typename: 'BusinessProjectPromotionCode'
  code: Scalars['String']['output']
}

export type BusinessProjectPromotionCodeError = Error & {
  __typename: 'BusinessProjectPromotionCodeError'
  message: Scalars['String']['output']
}

export type BusinessProjectPromotionCodeInput = {
  code: Scalars['String']['input']
}

export type BusinessProjectResponse =
  | BusinessProject
  | InputValidationError
  | { __typename?: '%other' }

export type BusinessProjectSendToSelf = {
  __typename: 'BusinessProjectSendToSelf'
  address: BusinessProjectAddress
  deliveryDate: Scalars['Date']['output']
  firstName: Scalars['String']['output']
  lastName: Scalars['String']['output']
}

export type BusinessProjectSendToSelfInput = {
  address: BusinessProjectAddressInput
  deliveryDate: Scalars['Date']['input']
  firstName: Scalars['String']['input']
  lastName: Scalars['String']['input']
}

export type BusinessRecipient = {
  __typename: 'BusinessRecipient'
  address: BusinessProjectAddress
  anniversaryYear?: Maybe<Scalars['Long']['output']>
  deliveryDate?: Maybe<Scalars['Date']['output']>
  firstName: Scalars['String']['output']
  id: Scalars['String']['output']
  lastName: Scalars['String']['output']
}

export type BusinessRecipientInput = {
  addressLine1: Scalars['String']['input']
  anniversaryYear?: InputMaybe<Scalars['Long']['input']>
  city: Scalars['String']['input']
  country: Scalars['String']['input']
  deliveryDate?: InputMaybe<Scalars['Date']['input']>
  firstName: Scalars['String']['input']
  lastName: Scalars['String']['input']
  postcode: Scalars['String']['input']
}

export enum BusinessSubstitution {
  FIRST_NAME = 'FIRST_NAME',
  NAME = 'NAME',
  YEAR = 'YEAR',
}

export type BusinessSubstitutions = {
  __typename: 'BusinessSubstitutions'
  available: Array<BusinessAvailableSubstitution>
  preview: Array<BusinessPreviewSubstitution>
  previews: Array<Array<BusinessPreviewSubstitution>>
}

export type CTA = {
  __typename: 'CTA'
  action: CTAAction
  /** @deprecated Use action */
  shouldFormat?: Maybe<Scalars['Boolean']['output']>
  title: Scalars['String']['output']
  /** @deprecated Use action */
  url: Scalars['String']['output']
}

export type CTAAction =
  | AddMembershipToBasketAction
  | LinkAction
  | { __typename?: '%other' }

export enum CacheControlScope {
  PRIVATE = 'PRIVATE',
  PUBLIC = 'PUBLIC',
}

export type CandidateOccasion = {
  __typename: 'CandidateOccasion'
  day: Scalars['Int']['output']
  month: Scalars['Int']['output']
  type: Occasion
}

export type CandidateReminder = {
  __typename: 'CandidateReminder'
  occasion: CandidateOccasion
  recipient?: Maybe<Recipient>
}

export type Capabilities = {
  __typename: 'Capabilities'
  /** @deprecated Use DesignScene.availableCustomisations instead */
  video: Scalars['Boolean']['output']
}

export type CategoryListEdge = {
  __typename: 'CategoryListEdge'
  cursor: Scalars['String']['output']
  node: CategoryListRecommendation
}

export type CategoryListEdges = {
  __typename: 'CategoryListEdges'
  edges: Array<CategoryListEdge>
  pageInfo: CategoryListPageInfo
  totalCount: Scalars['Int']['output']
}

export type CategoryListInvalidCursorError = Error & {
  __typename: 'CategoryListInvalidCursorError'
  message: Scalars['String']['output']
}

export type CategoryListPageInfo = {
  __typename: 'CategoryListPageInfo'
  endCursor?: Maybe<Scalars['String']['output']>
  hasNextPage: Scalars['Boolean']['output']
  hasPreviousPage: Scalars['Boolean']['output']
  startCursor?: Maybe<Scalars['String']['output']>
}

export type CategoryListRecommendation = {
  description?: Maybe<Scalars['String']['output']>
  name: Scalars['String']['output']
}

export type CategoryListResult =
  | CategoryListEdges
  | CategoryListInvalidCursorError
  | { __typename?: '%other' }

export type CheckoutBusinessProjectResponse =
  | CheckoutBusinessProjectResult
  | InputValidationError
  | { __typename?: '%other' }

export type CheckoutBusinessProjectResult = {
  __typename: 'CheckoutBusinessProjectResult'
  paymentSessionId: Scalars['String']['output']
}

export type CloneSharedReminderResult =
  | BadRequest
  | CreatedReminder
  | ReminderNotFound
  | { __typename?: '%other' }

export type Color = {
  __typename: 'Color'
  id: Scalars['ID']['output']
  name: Scalars['String']['output']
  value: Scalars['String']['output']
}

export type ColorEdge = {
  __typename: 'ColorEdge'
  cursor: Scalars['ID']['output']
  node: Color
}

export type ColorEdges = {
  __typename: 'ColorEdges'
  edges: Array<ColorEdge>
  pageInfo: DesignCustomisationPageInfo
  totalCount: Scalars['Int']['output']
}

/** Input for filtering colors by set IDs. */
export type ColorsFilterInput = {
  /** List of color set IDs to filter by */
  colorSetIds: Array<Scalars['ID']['input']>
}

export type ColorsResult =
  | ColorEdges
  | DesignInvalidCursorError
  | DesignServiceError
  | { __typename?: '%other' }

export enum ColumnWidthVariant {
  EqualWidth = 'EqualWidth',
  LeftWider = 'LeftWider',
  RightWider = 'RightWider',
}

export enum CompleteAmendErrorCode {
  NOT_ELIGIBLE = 'NOT_ELIGIBLE',
  NOT_FOUND = 'NOT_FOUND',
  UNAUTHORIZED = 'UNAUTHORIZED',
  UNEXPECTED_ERROR = 'UNEXPECTED_ERROR',
}

export type CompleteAmendFailure = CompleteAmendResult & {
  __typename: 'CompleteAmendFailure'
  errorCode: CompleteAmendErrorCode
  message: Scalars['String']['output']
}

export type CompleteAmendResult = {
  message: Scalars['String']['output']
}

export type CompleteAmendSuccess = CompleteAmendResult & {
  __typename: 'CompleteAmendSuccess'
  deliveryId: Scalars['String']['output']
  lineItemId: Scalars['String']['output']
  message: Scalars['String']['output']
}

export type CompleteDesignAmendmentInput = {
  lineItemId: Scalars['ID']['input']
  originalDeliveryId: Scalars['ID']['input']
}

export type ConcurrentModificationError = Error & {
  __typename: 'ConcurrentModificationError'
  message: Scalars['String']['output']
}

export enum ConsentPosition {
  OPTED_IN = 'OPTED_IN',
  OPTED_OUT = 'OPTED_OUT',
}

export type ContactPreference = {
  __typename: 'ContactPreference'
  status: ContactStatus
  type: ContactPreferenceType
}

export type ContactPreferenceInput = {
  status: ContactStatus
  type: ContactPreferenceType
}

export enum ContactPreferenceType {
  DELIVERY_UPDATES_SMS = 'DELIVERY_UPDATES_SMS',
  DELIVERY_UPDATES_WHATSAPP = 'DELIVERY_UPDATES_WHATSAPP',
  FATHERS_DAY = 'FATHERS_DAY',
  FATHERS_DAY_SMS = 'FATHERS_DAY_SMS',
  FATHERS_DAY_WHATSAPP = 'FATHERS_DAY_WHATSAPP',
  GENERAL_MARKETING = 'GENERAL_MARKETING',
  GENERAL_MARKETING_SMS = 'GENERAL_MARKETING_SMS',
  GENERAL_MARKETING_WHATSAPP = 'GENERAL_MARKETING_WHATSAPP',
  GROUP_CARDS = 'GROUP_CARDS',
  MEMBERSHIPS = 'MEMBERSHIPS',
  MEMBERSHIPS_SMS = 'MEMBERSHIPS_SMS',
  MEMBERSHIPS_WHATSAPP = 'MEMBERSHIPS_WHATSAPP',
  /** @deprecated Use MEMBERSHIPS */
  MOONPIG_PLUS = 'MOONPIG_PLUS',
  MOTHERS_DAY = 'MOTHERS_DAY',
  MOTHERS_DAY_SMS = 'MOTHERS_DAY_SMS',
  MOTHERS_DAY_WHATSAPP = 'MOTHERS_DAY_WHATSAPP',
  REMINDERS_SMS = 'REMINDERS_SMS',
  REMINDERS_WHATSAPP = 'REMINDERS_WHATSAPP',
  SERVICE_UPDATES_SMS = 'SERVICE_UPDATES_SMS',
  SERVICE_UPDATES_WHATSAPP = 'SERVICE_UPDATES_WHATSAPP',
}

export type ContactPreferences = Node & {
  __typename: 'ContactPreferences'
  id: Scalars['ID']['output']
  marketingReviewEligible: Scalars['Boolean']['output']
  preferences: Array<ContactPreference>
  source?: Maybe<ContactSource>
}

export enum ContactSource {
  App = 'App',
  AppCheckout = 'AppCheckout',
  CustomerServices = 'CustomerServices',
  EmailUnsubscribe = 'EmailUnsubscribe',
  GroupCardsSignUp = 'GroupCardsSignUp',
  LandingPage = 'LandingPage',
  MembershipStarted = 'MembershipStarted',
  Migration = 'Migration',
  MyAccountPage = 'MyAccountPage',
  ProspectEmailRegister = 'ProspectEmailRegister',
  RemindersInflowPage = 'RemindersInflowPage',
  WebCheckout = 'WebCheckout',
  WebRegister = 'WebRegister',
}

export enum ContactStatus {
  NOT_ASKED = 'NOT_ASKED',
  OPTED_IN = 'OPTED_IN',
  OPTED_OUT = 'OPTED_OUT',
}

export type Content = {
  __typename: 'Content'
  headerLogo?: Maybe<HeaderLogo>
}

export type ContentDepartment = {
  __typename: 'ContentDepartment'
  dispatchCutOff: ContentDepartmentDispatchCutOff
  id: Scalars['ID']['output']
  longDeliveryInfo: Scalars['String']['output']
  promotionBanner?: Maybe<Scalars['String']['output']>
  shortDeliveryInfo: Scalars['String']['output']
  subdepartments: Array<ContentDepartment>
}

export type ContentDepartmentDispatchCutOff = {
  __typename: 'ContentDepartmentDispatchCutOff'
  weekdays: CutOff
  weekendsAndBankHolidays: CutOff
}

export type ContentDimensions = {
  __typename: 'ContentDimensions'
  height: Scalars['Int']['output']
  width: Scalars['Int']['output']
}

export type ContentImage = {
  __typename: 'ContentImage'
  description: Scalars['String']['output']
  dimensions: ContentDimensions
  url: Scalars['String']['output']
}

export type ContentImageurlArgs = {
  background?: InputMaybe<Scalars['String']['input']>
  fit?: InputMaybe<ContentImageFit>
  focus?: InputMaybe<ContentImageFocus>
  format?: InputMaybe<ContentImageFormat>
  height?: InputMaybe<Scalars['Int']['input']>
  quality?: InputMaybe<Scalars['Int']['input']>
  width?: InputMaybe<Scalars['Int']['input']>
}

export enum ContentImageFit {
  crop = 'crop',
  fill = 'fill',
  thumb = 'thumb',
}

export enum ContentImageFocus {
  bottom = 'bottom',
  left = 'left',
  right = 'right',
  top = 'top',
}

export enum ContentImageFormat {
  jpg = 'jpg',
  png = 'png',
  webp = 'webp',
}

export type ContentItem = {
  __typename: 'ContentItem'
  id: Scalars['String']['output']
}

export type ContentMetadata = {
  __typename: 'ContentMetadata'
  experiment?: Maybe<ContentMetadataExperiment>
  variation?: Maybe<ContentMetadataVariation>
}

export type ContentMetadataExperiment = {
  __typename: 'ContentMetadataExperiment'
  key: Scalars['String']['output']
  value: Scalars['String']['output']
}

export type ContentMetadataVariation = {
  __typename: 'ContentMetadataVariation'
  key: Scalars['String']['output']
  value: Scalars['String']['output']
}

export type ContentModule = {
  meta: ContentMetadata
}

export enum ContentPlatform {
  android = 'android',
  ios = 'ios',
  web = 'web',
}

export type ContentReminderOccasion = {
  __typename: 'ContentReminderOccasion'
  id: Scalars['ID']['output']
  name: Scalars['String']['output']
}

export type ContentReminderRelation = {
  __typename: 'ContentReminderRelation'
  id: Scalars['ID']['output']
  name: Scalars['String']['output']
}

export type ContentSearchFacet = {
  __typename: 'ContentSearchFacet'
  name: Scalars['String']['output']
  value: Scalars['String']['output']
}

export type ContentSearchFacetDetails = {
  __typename: 'ContentSearchFacetDetails'
  group?: Maybe<Scalars['String']['output']>
  key?: Maybe<Scalars['String']['output']>
  /** @deprecated use key instead */
  name: Scalars['String']['output']
  /** @deprecated use key instead */
  path: Scalars['String']['output']
  /** @deprecated use key instead */
  value: Scalars['String']['output']
}

export type ContentSearchParameters = {
  __typename: 'ContentSearchParameters'
  departments: Array<Scalars['String']['output']>
  facetDetails: Array<ContentSearchFacetDetails>
  keywords: Scalars['String']['output']
  promotionId?: Maybe<Scalars['String']['output']>
}

export type ContentVariationInput = {
  name: Scalars['String']['input']
  value: Scalars['String']['input']
}

export type ContentVideo = {
  __typename: 'ContentVideo'
  contentType: Scalars['String']['output']
  description: Scalars['String']['output']
  url: Scalars['String']['output']
}

export type Country = {
  __typename: 'Country'
  code: Scalars['String']['output']
  label: Scalars['String']['output']
}

export enum Courier {
  AN_POST = 'AN_POST',
  AUS_POST = 'AUS_POST',
  DPD = 'DPD',
  DPD_IE = 'DPD_IE',
  PACKS = 'PACKS',
  POST_NL = 'POST_NL',
  ROYAL_MAIL = 'ROYAL_MAIL',
  STARTRACK = 'STARTRACK',
  UNKNOWN = 'UNKNOWN',
  USPS = 'USPS',
}

export type CourierDetails = {
  __typename: 'CourierDetails'
  courier: Courier
  displayName: Scalars['String']['output']
  shortCode?: Maybe<Scalars['String']['output']>
}

export type CreateAddressRequestInput = {
  recipientFirstName: Scalars['String']['input']
  recipientLastName: Scalars['String']['input']
}

export type CreateAddressRequestResult =
  | AddressRequestInputError
  | CreateAddressRequestSuccess
  | { __typename?: '%other' }

export type CreateAddressRequestSuccess = {
  __typename: 'CreateAddressRequestSuccess'
  addressRequest: AddressRequest
  addressRequests?: Maybe<AddressRequests>
}

export type CreateAudioMediaInput = {
  designToken: Scalars['String']['input']
}

export type CreateAudioMediaResult =
  | MediaInvalidTokenError
  | MediaServiceError
  | MediaUpload
  | { __typename?: '%other' }

export type CreateCustomerCreationsCustomFontResponse =
  | CustomerCreationsCustomFont
  | CustomerCreationsServiceError
  | { __typename?: '%other' }

export type CreateCustomerCreationsCustomFontSubmissionResponse =
  | CustomerCreationsCustomFontSubmissionCreateError
  | CustomerCreationsCustomFontSubmissionPending
  | CustomerCreationsServiceError
  | { __typename?: '%other' }

export type CreateDemoMediaInput = {
  designToken: Scalars['String']['input']
}

export type CreateDemoMediaResult =
  | Media
  | MediaInvalidTokenError
  | MediaServiceError
  | { __typename?: '%other' }

export type CreateDesignAiCreationsFaceswapResponse =
  | DesignAiCreationsFaceswapUploadPending
  | DesignAiCreationsServiceError
  | { __typename?: '%other' }

/** Input for creating a new image upload slot. */
export type CreateDesignImageUploadInput = {
  /** ID of the design to create the upload for */
  designId: Scalars['ID']['input']
}

/** Result type for the createDesignImageUpload mutation. */
export type CreateDesignImageUploadResult =
  | DesignAuthorizationError
  | DesignImageUpload
  | DesignImageUploadLimitReachedError
  | DesignNotFoundError
  | DesignServiceError
  | { __typename?: '%other' }

/** Input for creating a new design. */
export type CreateDesignInput = {
  /** @deprecated No longer used */
  allowAllCharacters?: InputMaybe<Scalars['Boolean']['input']>
  /**
   * A set of flags to determine what the client can support.
   * Should be used in conjunction with feature flags on each client.
   */
  capabilities?: InputMaybe<Array<DesignCapability>>
  /** Whether to use flexible layout system for this design */
  preferFlexibleLayout?: InputMaybe<Scalars['Boolean']['input']>
  /** Should use overlay text on this design. By using overlay text, templated text elements on the inside scenes of a card will be removed. */
  preferOverlayText?: InputMaybe<Scalars['Boolean']['input']>
  /**
   * Similar to `preferOverlayText` but enables overlay elements on the front of the card, removing any existing text elements.
   * There are only a select number of cards which support this. Enabling this for cards which do not support flexible content on the front will have no effect.
   */
  preferOverlayTextFront?: InputMaybe<Scalars['Boolean']['input']>
  /** Product key identifying the product to create a design for */
  productKey: Scalars['String']['input']
  /** Optional initial customisations to apply to scenes */
  scenes?: InputMaybe<Array<DesignCustomisationsSceneByIndexInput>>
  /** SKU for the specific variant/size (optional, can be set later) */
  sku?: InputMaybe<Scalars['String']['input']>
  /** Initial state for the design (defaults to DRAFT) */
  state?: InputMaybe<DesignState>
  /** @deprecated No longer used */
  variantKey?: InputMaybe<Scalars['String']['input']>
  /** @deprecated No longer used */
  videoCardId?: InputMaybe<Scalars['String']['input']>
}

/** Result type for the createDesign mutation. */
export type CreateDesignResult =
  | Design
  | DesignCustomisationsInputError
  | DesignInvalidTokenError
  | DesignServiceError
  | DesignTemplatesServiceError
  | ProductNotPersonalisableError
  | { __typename?: '%other' }

export type CreateDesignStickerAI = {
  __typename: 'CreateDesignStickerAI'
  taskId: Scalars['String']['output']
}

export type CreateDesignStickerAIInput = {
  designId: Scalars['ID']['input']
  prompt: Scalars['String']['input']
}

export type CreateDesignStickerAIResult =
  | CreateDesignStickerAI
  | DesignServiceError
  | DesignStickerAIInputError
  | DesignStickerAILimitReachedError
  | DesignStickerAIModerationError
  | DesignStickerAIUnavailableError
  | DesignStickerCopyrightError
  | { __typename?: '%other' }

/** Input for creating a draft copy of an existing design. */
export type CreateDraftFromDesignInput = {
  /** ID of the design to copy */
  sourceId: Scalars['String']['input']
}

/** Result type for the createDraftFromDesign mutation. */
export type CreateDraftFromDesignResult =
  | Design
  | DesignAuthorizationError
  | DesignNotFoundError
  | DesignServiceError
  | DesignTemplatesServiceError
  | { __typename?: '%other' }

/** Input for creating an in-project copy of an existing design. */
export type CreateInProjectFromDesignInput = {
  /** Capabilities supported by the client */
  capabilities?: InputMaybe<Array<DesignCapability>>
  /** ID of the design to copy */
  sourceId: Scalars['String']['input']
}

/** Result type for the createInProjectFromDesign mutation. */
export type CreateInProjectFromDesignResult =
  | Design
  | DesignAuthorizationError
  | DesignNotFoundError
  | DesignServiceError
  | DesignTemplatesServiceError
  | { __typename?: '%other' }

export type CreateIncentivisedRemindersResult =
  | BadRequest
  | CreatedIncentivisedReminders
  | { __typename?: '%other' }

export type CreatePhotoUploadInput = {
  sessionId: Scalars['ID']['input']
}

export type CreatePhotoUploadResult =
  | MediaServiceError
  | PhotoUpload
  | PhotoUploadSessionNotFoundError
  | { __typename?: '%other' }

export type CreatePhotoUploadSessionResult = {
  __typename: 'CreatePhotoUploadSessionResult'
  sessionId: Scalars['ID']['output']
}

export type CreateReminderFromDraftInput = {
  orderId: Scalars['ID']['input']
}

export type CreateReminderFromDraftResult =
  | CreateReminderFromDraftSuccess
  | { __typename?: '%other' }

export type CreateReminderFromDraftSuccess = {
  __typename: 'CreateReminderFromDraftSuccess'
  reminder?: Maybe<Reminder>
  suggestedReminders: Array<DraftSuggestedReminder>
}

export type CreateReminderResult =
  | BadRequest
  | CreatedReminder
  | ReminderAlreadyExists
  | { __typename?: '%other' }

export type CreateRemindersAsyncResult = {
  __typename: 'CreateRemindersAsyncResult'
  message: Scalars['String']['output']
}

export type CreateRemindersFromProductsResult =
  | BadRequest
  | CreatedRemindersFromProducts
  | { __typename?: '%other' }

export type CreateVideoMediaInput = {
  designToken: Scalars['String']['input']
  termsAndConditionsAccepted: Scalars['Boolean']['input']
}

export type CreateVideoMediaResult =
  | MediaInvalidTokenError
  | MediaServiceError
  | MediaTermsAndConditionsNotAcceptedError
  | MediaUpload
  | { __typename?: '%other' }

export type CreatedIncentivisedReminders = {
  __typename: 'CreatedIncentivisedReminders'
  reminders: Array<Reminder>
}

export type CreatedReminder = Node & {
  __typename: 'CreatedReminder'
  id: Scalars['ID']['output']
}

export type CreatedReminderFromProduct = Node & {
  __typename: 'CreatedReminderFromProduct'
  id: Scalars['ID']['output']
  name: Scalars['String']['output']
  occasion: Occasion
  occasionDate: OccasionDate
  relationship?: Maybe<Relationship>
}

export type CreatedRemindersFromProducts = {
  __typename: 'CreatedRemindersFromProducts'
  reminders: Array<CreatedReminderFromProduct>
}

export type CreditAccount = {
  __typename: 'CreditAccount'
  id: Scalars['ID']['output']
  records?: Maybe<Array<CreditRecord>>
  remainingBalance?: Maybe<Money>
  store: Scalars['String']['output']
}

export type CreditActivity = {
  __typename: 'CreditActivity'
  amount: Money
  authorizer?: Maybe<Scalars['String']['output']>
  creditId: Scalars['String']['output']
  date?: Maybe<Scalars['String']['output']>
  newBalance: Money
  orderId?: Maybe<Scalars['String']['output']>
  reason?: Maybe<Scalars['String']['output']>
  store?: Maybe<Scalars['String']['output']>
  type: Scalars['String']['output']
}

export type CreditRecord = {
  __typename: 'CreditRecord'
  authCode?: Maybe<Scalars['String']['output']>
  createdDate?: Maybe<Scalars['String']['output']>
  expiredBy?: Maybe<Scalars['String']['output']>
  expiryDate?: Maybe<Scalars['String']['output']>
  id: Scalars['ID']['output']
  initialBalance: Money
  isExpired?: Maybe<Scalars['Boolean']['output']>
  reason?: Maybe<Scalars['String']['output']>
  remainingBalance: Money
}

export type CreditsBreakdown = {
  __typename: 'CreditsBreakdown'
  available: Money
  remaining: Money
  used: Money
}

export type CriteriaInput = {
  excludeDirectSmile?: InputMaybe<Scalars['Boolean']['input']>
  excludeRude?: InputMaybe<Scalars['Boolean']['input']>
  facets?: InputMaybe<Array<FacetInput>>
  groupedFacets?: InputMaybe<Array<GroupedFacetInput>>
  hasAugmentedReality?: InputMaybe<Scalars['Boolean']['input']>
  hasCollageMaker?: InputMaybe<Scalars['Boolean']['input']>
  hasFaceSwap?: InputMaybe<Scalars['Boolean']['input']>
  integerFilter?: InputMaybe<IntegerFilterInput>
  occasion?: InputMaybe<Scalars['String']['input']>
  onlyPPCResults?: InputMaybe<Scalars['Boolean']['input']>
  promotionId?: InputMaybe<Scalars['String']['input']>
  recipient?: InputMaybe<Scalars['String']['input']>
  variants?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
}

export type CrmDeleteReminderResult =
  | BadRequest
  | DeletedRemindersSuccess
  | { __typename?: '%other' }

export type CrmDeleteRemindersInput = {
  encryptedPayload: Scalars['String']['input']
}

export type CrmDetails = {
  __typename: 'CrmDetails'
  cookie?: Maybe<Scalars['String']['output']>
  id?: Maybe<Scalars['String']['output']>
}

export type CustomAction = {
  __typename: 'CustomAction'
  configJson: Scalars['String']['output']
  title?: Maybe<Scalars['String']['output']>
  type: Scalars['String']['output']
}

export type Customer = Versioned & {
  __typename: 'Customer'
  businessDetails?: Maybe<BusinessDetails>
  businessOrder?: Maybe<BusinessOrderResponse>
  businessOrdersConnection: BusinessOrdersConnection
  contactPreferences: ContactPreferences
  credits?: Maybe<CustomerCredits>
  /** Customer crmDetails. Returns SailThru Id for Moonpig & Canopy Deploy Id for Greetz. Cookie information is just for Sailthru. */
  crmDetails?: Maybe<CrmDetails>
  email: Scalars['String']['output']
  favourites: Favourites
  firstName: Scalars['String']['output']
  fullPhoneNumber?: Maybe<Scalars['String']['output']>
  groupCardProject: GroupCardProjectResult
  groupCardProjectV2: GroupCardProjectResultV2
  groupCardProjects: GroupCardProjectsResult
  groupCardProjectsV2: GroupCardProjectsResultV2
  hasBusinessOrders: Scalars['Boolean']['output']
  /** Unique identifier for the customer */
  id: Scalars['ID']['output']
  identityDetails?: Maybe<IdentityDetails>
  intercom?: Maybe<IntercomData>
  /** @deprecated Temporary field for migration purposes, will be removed soon */
  isMigrated?: Maybe<Scalars['Boolean']['output']>
  lastName: Scalars['String']['output']
  /** @deprecated Exists only for migration from commerce-api. Use contactPreferences property instead */
  marketingConsentPosition: MarketingConsentPosition
  membership?: Maybe<Membership>
  myAddresses: Array<ShippingAddress>
  order?: Maybe<Order>
  orderCount: Scalars['Int']['output']
  orderHistory: OrderConnection
  orderLifecycleStatus: Scalars['String']['output']
  /** @deprecated Use orderHistory instead. */
  orders?: Maybe<Orders>
  otherAddresses: Array<ShippingAddress>
  /** @deprecated Proof of concept feature, can be deleted */
  promotionGroups?: Maybe<Array<Scalars['String']['output']>>
  recommendations: CustomerRecommendationsResponse
  savedCards?: Maybe<Array<SavedCard>>
  title?: Maybe<Scalars['String']['output']>
  version: Scalars['Long']['output']
}

export type CustomerbusinessOrderArgs = {
  input: BusinessOrderInput
}

export type CustomerbusinessOrdersConnectionArgs = {
  input: BusinessOrdersConnectionInput
}

export type CustomergroupCardProjectArgs = {
  projectId: Scalars['ID']['input']
}

export type CustomergroupCardProjectV2Args = {
  projectId: Scalars['ID']['input']
}

export type CustomerorderArgs = {
  id: Scalars['ID']['input']
}

export type CustomerorderHistoryArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  limit?: Scalars['Int']['input']
}

export type CustomerordersArgs = {
  limit?: InputMaybe<Scalars['Long']['input']>
  offset?: InputMaybe<Scalars['Long']['input']>
}

export type CustomerrecommendationsArgs = {
  request: CustomerRecommendationsRequest
}

export type CustomersavedCardsArgs = {
  store?: InputMaybe<Store>
}

export type CustomerAddressInput = {
  addressFirstLine: Scalars['String']['input']
  city?: InputMaybe<Scalars['String']['input']>
  country: Scalars['String']['input']
  extraAddressLine?: InputMaybe<Scalars['String']['input']>
  firstName: Scalars['String']['input']
  houseNumber?: InputMaybe<Scalars['String']['input']>
  houseNumberExtension?: InputMaybe<Scalars['String']['input']>
  isMyAddress: Scalars['Boolean']['input']
  lastName: Scalars['String']['input']
  postcode?: InputMaybe<Scalars['String']['input']>
  state?: InputMaybe<Scalars['String']['input']>
  /** @deprecated No longer in use */
  title?: InputMaybe<Scalars['String']['input']>
  version: Scalars['Long']['input']
}

export type CustomerAddressInvalidCountry = Error & {
  __typename: 'CustomerAddressInvalidCountry'
  message: Scalars['String']['output']
}

export type CustomerAddressInvalidError = Error & {
  __typename: 'CustomerAddressInvalidError'
  message: Scalars['String']['output']
}

export type CustomerAddressesInput = {
  addresses: Array<CustomerMultiAddressInput>
  version: Scalars['Long']['input']
}

export type CustomerCreationsCustomFont = {
  __typename: 'CustomerCreationsCustomFont'
  createdAt: Scalars['String']['output']
  fontFace?: Maybe<CustomerCreationsCustomFontFace>
  id: Scalars['ID']['output']
  name: Scalars['String']['output']
  points?: Maybe<CustomerCreationsCustomFontPoints>
  status: CustomerCreationsCustomFontStatus
  updatedAt: Scalars['String']['output']
  upload?: Maybe<CustomerCreationsCustomFontUpload>
}

export type CustomerCreationsCustomFontDeleteComplete = {
  __typename: 'CustomerCreationsCustomFontDeleteComplete'
  id: Scalars['ID']['output']
}

export type CustomerCreationsCustomFontDeleteResponse =
  | CustomerCreationsCustomFontDeleteComplete
  | CustomerCreationsServiceError
  | { __typename?: '%other' }

export type CustomerCreationsCustomFontEdge = {
  __typename: 'CustomerCreationsCustomFontEdge'
  cursor: Scalars['ID']['output']
  node: CustomerCreationsCustomFont
}

export type CustomerCreationsCustomFontError = Error & {
  __typename: 'CustomerCreationsCustomFontError'
  message: Scalars['String']['output']
}

/** A custom font face uploaded by the customer via Customer Creations feature. */
export type CustomerCreationsCustomFontFace = {
  __typename: 'CustomerCreationsCustomFontFace'
  customFontId: Scalars['ID']['output']
  /** Unique identifier for the custom font face */
  id: Scalars['ID']['output']
  metrics?: Maybe<CustomerCreationsCustomFontFaceMetrics>
  name: Scalars['String']['output']
  urls: CustomerCreationsCustomFontFaceUrls
}

export type CustomerCreationsCustomFontFaceMetrics = {
  __typename: 'CustomerCreationsCustomFontFaceMetrics'
  head: CustomerCreationsCustomFontFaceMetricsHead
  hhea: CustomerCreationsCustomFontFaceMetricsHhea
  os2: CustomerCreationsCustomFontFaceMetricsOs2
}

export type CustomerCreationsCustomFontFaceMetricsHead = {
  __typename: 'CustomerCreationsCustomFontFaceMetricsHead'
  unitsPerEm: Scalars['Float']['output']
  yMax: Scalars['Float']['output']
  yMin: Scalars['Float']['output']
}

export type CustomerCreationsCustomFontFaceMetricsHhea = {
  __typename: 'CustomerCreationsCustomFontFaceMetricsHhea'
  ascender: Scalars['Float']['output']
  descender: Scalars['Float']['output']
  lineGap: Scalars['Float']['output']
}

export type CustomerCreationsCustomFontFaceMetricsOs2 = {
  __typename: 'CustomerCreationsCustomFontFaceMetricsOs2'
  fsSelection: Scalars['Float']['output']
  fsType: Scalars['Float']['output']
  sCapHeight: Scalars['Float']['output']
  sTypoAscender: Scalars['Float']['output']
  sTypoDescender: Scalars['Float']['output']
  sTypoLineGap: Scalars['Float']['output']
  sxHeight: Scalars['Float']['output']
  usWinAscent: Scalars['Float']['output']
  usWinDescent: Scalars['Float']['output']
}

export type CustomerCreationsCustomFontFaceUrls = {
  __typename: 'CustomerCreationsCustomFontFaceUrls'
  ttf: Scalars['String']['output']
  woff: Scalars['String']['output']
  woff2: Scalars['String']['output']
}

export type CustomerCreationsCustomFontPoints = {
  __typename: 'CustomerCreationsCustomFontPoints'
  url: Scalars['String']['output']
}

export type CustomerCreationsCustomFontResponse =
  | CustomerCreationsCustomFontError
  | CustomerCreationsCustomFontsList
  | { __typename?: '%other' }

export enum CustomerCreationsCustomFontStatus {
  COMPLETE = 'COMPLETE',
  DELETED = 'DELETED',
  ERROR = 'ERROR',
  PROCESSING = 'PROCESSING',
  UPLOADING = 'UPLOADING',
}

export type CustomerCreationsCustomFontSubmission = {
  createdAt: Scalars['String']['output']
  id: Scalars['ID']['output']
  updatedAt: Scalars['String']['output']
}

export type CustomerCreationsCustomFontSubmissionComplete =
  CustomerCreationsCustomFontSubmission & {
    __typename: 'CustomerCreationsCustomFontSubmissionComplete'
    createdAt: Scalars['String']['output']
    font: CustomerCreationsCustomFont
    id: Scalars['ID']['output']
    updatedAt: Scalars['String']['output']
  }

export type CustomerCreationsCustomFontSubmissionCreateError = Error & {
  __typename: 'CustomerCreationsCustomFontSubmissionCreateError'
  message: Scalars['String']['output']
}

export type CustomerCreationsCustomFontSubmissionError =
  CustomerCreationsCustomFontSubmission &
    Error & {
      __typename: 'CustomerCreationsCustomFontSubmissionError'
      createdAt: Scalars['String']['output']
      id: Scalars['ID']['output']
      message: Scalars['String']['output']
      updatedAt: Scalars['String']['output']
    }

export type CustomerCreationsCustomFontSubmissionNotFoundError = Error & {
  __typename: 'CustomerCreationsCustomFontSubmissionNotFoundError'
  message: Scalars['String']['output']
}

export type CustomerCreationsCustomFontSubmissionPending =
  CustomerCreationsCustomFontSubmission & {
    __typename: 'CustomerCreationsCustomFontSubmissionPending'
    createdAt: Scalars['String']['output']
    id: Scalars['ID']['output']
    maxRetryCount: Scalars['Int']['output']
    pollingIntervalMs: Scalars['Int']['output']
    updatedAt: Scalars['String']['output']
    upload: CustomerCreationsCustomFontSubmissionUpload
  }

export type CustomerCreationsCustomFontSubmissionProcessing =
  CustomerCreationsCustomFontSubmission & {
    __typename: 'CustomerCreationsCustomFontSubmissionProcessing'
    createdAt: Scalars['String']['output']
    id: Scalars['ID']['output']
    maxRetryCount: Scalars['Int']['output']
    pollingIntervalMs: Scalars['Int']['output']
    updatedAt: Scalars['String']['output']
  }

export type CustomerCreationsCustomFontSubmissionResponse =
  | CustomerCreationsCustomFontSubmissionComplete
  | CustomerCreationsCustomFontSubmissionError
  | CustomerCreationsCustomFontSubmissionNotFoundError
  | CustomerCreationsCustomFontSubmissionPending
  | CustomerCreationsCustomFontSubmissionProcessing
  | CustomerCreationsServiceError
  | { __typename?: '%other' }

export type CustomerCreationsCustomFontSubmissionUpload = {
  __typename: 'CustomerCreationsCustomFontSubmissionUpload'
  fields: Array<CustomerCreationsCustomFontSubmissionUploadField>
  url: Scalars['String']['output']
}

export type CustomerCreationsCustomFontSubmissionUploadField = {
  __typename: 'CustomerCreationsCustomFontSubmissionUploadField'
  key: Scalars['String']['output']
  value: Scalars['String']['output']
}

export type CustomerCreationsCustomFontUpload = {
  __typename: 'CustomerCreationsCustomFontUpload'
  fields: Array<CustomerCreationsCustomFontUploadField>
  uploadUrl: Scalars['String']['output']
}

export type CustomerCreationsCustomFontUploadField = {
  __typename: 'CustomerCreationsCustomFontUploadField'
  key: Scalars['String']['output']
  value: Scalars['String']['output']
}

export type CustomerCreationsCustomFontsList = {
  __typename: 'CustomerCreationsCustomFontsList'
  edges: Array<CustomerCreationsCustomFontEdge>
  pageInfo: CustomerCreationsCustomFontsPageInfo
  totalCount: Scalars['Int']['output']
}

export type CustomerCreationsCustomFontsPageInfo = {
  __typename: 'CustomerCreationsCustomFontsPageInfo'
  endCursor?: Maybe<Scalars['ID']['output']>
  hasNextPage: Scalars['Boolean']['output']
}

export type CustomerCreationsServiceError = Error & {
  __typename: 'CustomerCreationsServiceError'
  message: Scalars['String']['output']
}

export type CustomerCredits = {
  __typename: 'CustomerCredits'
  accounts?: Maybe<Array<CreditAccount>>
  activity?: Maybe<Array<CreditActivity>>
  availableBalance?: Maybe<Money>
  id: Scalars['ID']['output']
}

export type CustomerDeleteAddressInput = {
  addressId: Scalars['String']['input']
  version: Scalars['Long']['input']
}

export type CustomerFeedbackError = {
  __typename: 'CustomerFeedbackError'
  message: Scalars['String']['output']
}

export type CustomerFeedbackInput = {
  comment?: InputMaybe<Scalars['String']['input']>
  orderId?: InputMaybe<Scalars['String']['input']>
  satisfied: Scalars['Boolean']['input']
  source?: InputMaybe<Scalars['String']['input']>
}

export type CustomerFeedbackResult =
  | CustomerFeedbackError
  | CustomerFeedbackSuccess
  | { __typename?: '%other' }

export type CustomerFeedbackSuccess = {
  __typename: 'CustomerFeedbackSuccess'
  brand: Scalars['String']['output']
  client: Scalars['String']['output']
  comment: Scalars['String']['output']
  creation: Scalars['String']['output']
  customerId: Scalars['String']['output']
  feedbackId: Scalars['String']['output']
  orderId?: Maybe<Scalars['String']['output']>
  satisfied: Scalars['Boolean']['output']
  source?: Maybe<Scalars['String']['output']>
  store: Scalars['String']['output']
}

export type CustomerInformation = {
  __typename: 'CustomerInformation'
  email: Scalars['String']['output']
  firstName?: Maybe<Scalars['String']['output']>
  id: Scalars['ID']['output']
  lastName?: Maybe<Scalars['String']['output']>
}

export type CustomerMultiAddressInput = {
  addressFirstLine: Scalars['String']['input']
  addressKey: Scalars['String']['input']
  city?: InputMaybe<Scalars['String']['input']>
  country: Scalars['String']['input']
  extraAddressLine?: InputMaybe<Scalars['String']['input']>
  firstName: Scalars['String']['input']
  houseNumber?: InputMaybe<Scalars['String']['input']>
  houseNumberExtension?: InputMaybe<Scalars['String']['input']>
  isMyAddress: Scalars['Boolean']['input']
  lastName: Scalars['String']['input']
  postcode?: InputMaybe<Scalars['String']['input']>
  state?: InputMaybe<Scalars['String']['input']>
}

export type CustomerRecommendationSource = {
  __typename: 'CustomerRecommendationSource'
  orderId: Scalars['String']['output']
  orderItemId: Scalars['String']['output']
  reminderId: Scalars['String']['output']
}

export type CustomerRecommendationsRequest = {
  algorithm?: InputMaybe<Scalars['String']['input']>
  legacyId: Scalars['String']['input']
}

export type CustomerRecommendationsResponse = {
  __typename: 'CustomerRecommendationsResponse'
  occasion: Scalars['String']['output']
  products: Array<Maybe<Product>>
  source: CustomerRecommendationSource
  type: Scalars['String']['output']
}

export type CustomerRequestOrderCancellationInput = {
  deliveries?: InputMaybe<Array<Scalars['String']['input']>>
  orderId: Scalars['String']['input']
}

export enum CustomerSegment {
  ACTIVE_CUSTOMER_HAS_ATTACHED = 'ACTIVE_CUSTOMER_HAS_ATTACHED',
  ACTIVE_CUSTOMER_NEVER_ATTACHED = 'ACTIVE_CUSTOMER_NEVER_ATTACHED',
  LAPSED_CUSTOMER = 'LAPSED_CUSTOMER',
  NEW_CUSTOMER_NEVER_ATTACHED = 'NEW_CUSTOMER_NEVER_ATTACHED',
  NOT_PLUS_CUSTOMER = 'NOT_PLUS_CUSTOMER',
  PLUS_CUSTOMER = 'PLUS_CUSTOMER',
}

export type CustomerSelfServiceFailed = CustomerSelfServiceResponse & {
  __typename: 'CustomerSelfServiceFailed'
  message: Scalars['String']['output']
}

export type CustomerSelfServiceInput = {
  orderId: Scalars['ID']['input']
  orderLineItemIds: Array<Scalars['ID']['input']>
  reason: Scalars['String']['input']
  resolution: Scalars['String']['input']
}

export type CustomerSelfServiceResponse = {
  message: Scalars['String']['output']
}

export type CustomerSelfServiceSuccess = CustomerSelfServiceResponse & {
  __typename: 'CustomerSelfServiceSuccess'
  message: Scalars['String']['output']
}

export type CustomerUpdateAddressInput = {
  addressFirstLine: Scalars['String']['input']
  addressId: Scalars['String']['input']
  city?: InputMaybe<Scalars['String']['input']>
  country: Scalars['String']['input']
  extraAddressLine?: InputMaybe<Scalars['String']['input']>
  firstName: Scalars['String']['input']
  houseNumber?: InputMaybe<Scalars['String']['input']>
  houseNumberExtension?: InputMaybe<Scalars['String']['input']>
  isMyAddress: Scalars['Boolean']['input']
  lastName: Scalars['String']['input']
  postcode?: InputMaybe<Scalars['String']['input']>
  state?: InputMaybe<Scalars['String']['input']>
  /** @deprecated No longer in use */
  title?: InputMaybe<Scalars['String']['input']>
  /** @deprecated No longer required please remove */
  version?: InputMaybe<Scalars['Long']['input']>
}

export type CutOff = {
  __typename: 'CutOff'
  message: Scalars['String']['output']
  time: Scalars['String']['output']
}

export type DefaultPackagingInput = {
  sku: Scalars['String']['input']
}

export type DefaultPackagingResult =
  | VariantPackaging
  | { __typename?: '%other' }

export type DeleteBasketInput = {
  id: Scalars['ID']['input']
  /** @deprecated No longer required please remove */
  version?: InputMaybe<Scalars['Long']['input']>
}

export type DeleteBasketResult =
  | BasketNotFoundError
  | ConcurrentModificationError
  | DeleteBasketSuccessResult
  | { __typename?: '%other' }

export type DeleteBasketSuccessResult = {
  __typename: 'DeleteBasketSuccessResult'
  id: Scalars['ID']['output']
}

export type DeleteBusinessProjectOutput = {
  __typename: 'DeleteBusinessProjectOutput'
  success: Scalars['Boolean']['output']
}

export type DeleteBusinessProjectResponse =
  | DeleteBusinessProjectOutput
  | InputValidationError
  | { __typename?: '%other' }

/**
 * Input for the deleteDesignInlay mutation.
 * Removes the inlay association from a design.
 */
export type DeleteDesignInlayInput = {
  /** ID of the design to remove the inlay from */
  designId: Scalars['String']['input']
}

export type DeleteDesignInlayResult =
  | Design
  | DesignAuthorizationError
  | DesignNotFoundError
  | DesignServiceError
  | DesignStateError
  | DesignTemplatesServiceError
  | { __typename?: '%other' }

/** Input for deleting a draft design. */
export type DeleteDraftDesignInput = {
  /** ID of the draft design to delete */
  id: Scalars['String']['input']
}

/** Result type for the deleteDraftDesign mutation. */
export type DeleteDraftDesignResult =
  | DesignAuthorizationError
  | DesignDeleted
  | DesignNotDraftError
  | DesignNotFoundError
  | DesignServiceError
  | { __typename?: '%other' }

export type DeleteLineItemInput = {
  id?: InputMaybe<Scalars['ID']['input']>
  lineItemId: Scalars['ID']['input']
  /** @deprecated No longer required please remove */
  version?: InputMaybe<Scalars['Long']['input']>
}

export type DeleteLineItemResult =
  | Basket
  | BasketNotFoundError
  | ConcurrentModificationError
  | { __typename?: '%other' }

export type DeleteRecipientInput = {
  id: Scalars['ID']['input']
}

export type DeleteRecipientResult =
  | DeleteRecipientSuccessResult
  | { __typename?: '%other' }

export type DeleteRecipientSuccessResult = {
  __typename: 'DeleteRecipientSuccessResult'
  id: Scalars['ID']['output']
  recipients: RecipientList
}

export type DeleteReminderResult =
  | DeletedReminder
  | ReminderNotFound
  | { __typename?: '%other' }

export type DeletedReminder = Node & {
  __typename: 'DeletedReminder'
  id: Scalars['ID']['output']
}

export type DeletedRemindersSuccess = {
  __typename: 'DeletedRemindersSuccess'
  success: Scalars['Int']['output']
  total: Scalars['Int']['output']
}

export type Delivery = {
  __typename: 'Delivery'
  /** @deprecated Use recipientAddress */
  address: ShippingAddress
  availableDeliveryDates: Array<Scalars['Date']['output']>
  /** @deprecated No longer used by any known client. Use options for the available delivery options per date, or method for the currently selected delivery method. */
  availableMethods: Array<DeliveryMethod>
  canHaveGiftNote: Scalars['Boolean']['output']
  deliveryDate: Scalars['Date']['output']
  dispatchDate: Scalars['Date']['output']
  /** @deprecated For internal use only */
  fulfilmentCentre?: Maybe<FulfilmentCentre>
  giftNote?: Maybe<Scalars['String']['output']>
  id: Scalars['ID']['output']
  instructions?: Maybe<Scalars['String']['output']>
  lineItems: Array<LineItem>
  method: DeliveryMethod
  mobile?: Maybe<Scalars['String']['output']>
  options?: Maybe<AvailableDeliveryOptions>
  recipientAddress: RecipientAddress
}

export type DeliveryavailableDeliveryDatesArgs = {
  from?: InputMaybe<Scalars['Date']['input']>
  to?: InputMaybe<Scalars['Date']['input']>
}

export type DeliveryAddressInvalidError = Error & {
  __typename: 'DeliveryAddressInvalidError'
  message: Scalars['String']['output']
}

export type DeliveryCancellationRequested = DeliveryPipelineOnHold &
  DeliveryStatus & {
    __typename: 'DeliveryCancellationRequested'
    deliveryStages?: Maybe<Array<DeliveryStage>>
    display: DeliveryStatusDisplay
    isBlocked: Scalars['Boolean']['output']
    pipelineStatus: DeliveryPipelineStatus
    state: DeliveryState
  }

export type DeliveryCancelled = DeliveryPipelineCancelled &
  DeliveryStatus & {
    __typename: 'DeliveryCancelled'
    deliveryStages?: Maybe<Array<DeliveryStage>>
    display: DeliveryStatusDisplay
    isBlocked: Scalars['Boolean']['output']
    pipelineStatus: DeliveryPipelineStatus
    state: DeliveryState
  }

export type DeliveryDateNotAvailableError = Error & {
  __typename: 'DeliveryDateNotAvailableError'
  message: Scalars['String']['output']
}

export type DeliveryDelivered = DeliveryPipelineComplete &
  DeliveryStatus & {
    __typename: 'DeliveryDelivered'
    deliveredDate?: Maybe<Scalars['Date']['output']>
    deliveryStages?: Maybe<Array<DeliveryStage>>
    dispatchDate?: Maybe<Scalars['Date']['output']>
    display: DeliveryStatusDisplay
    isBlocked: Scalars['Boolean']['output']
    pipelineStatus: DeliveryPipelineStatus
    state: DeliveryState
  }

export type DeliveryDispatched = DeliveryPipelineComplete &
  DeliveryStatus & {
    __typename: 'DeliveryDispatched'
    deliveryStages?: Maybe<Array<DeliveryStage>>
    dispatchDate?: Maybe<Scalars['Date']['output']>
    display: DeliveryStatusDisplay
    isBlocked: Scalars['Boolean']['output']
    pipelineStatus: DeliveryPipelineStatus
    state: DeliveryState
  }

export type DeliveryGuarantee = {
  __typename: 'DeliveryGuarantee'
  termsAndConditions?: Maybe<TermsAndConditions>
}

export type DeliveryMethod = {
  __typename: 'DeliveryMethod'
  acceptsDeliveryInstructions: Scalars['Boolean']['output']
  deliveryGuarantee?: Maybe<DeliveryGuarantee>
  description: Scalars['String']['output']
  isGuaranteed: Scalars['Boolean']['output']
  isTracked: Scalars['Boolean']['output']
  methodId: Scalars['String']['output']
  name: Scalars['String']['output']
  peakService?: Maybe<PeakService>
  price: Money
  priceDisplay?: Maybe<Scalars['String']['output']>
}

export type DeliveryMethodNotAvailableError = Error & {
  __typename: 'DeliveryMethodNotAvailableError'
  message: Scalars['String']['output']
}

export type DeliveryNotFoundError = Error & {
  __typename: 'DeliveryNotFoundError'
  deliveryId: Scalars['String']['output']
  message: Scalars['String']['output']
}

export type DeliveryOnHold = DeliveryPipelineOnHold &
  DeliveryStatus & {
    __typename: 'DeliveryOnHold'
    deliveryStages?: Maybe<Array<DeliveryStage>>
    display: DeliveryStatusDisplay
    isBlocked: Scalars['Boolean']['output']
    pipelineStatus: DeliveryPipelineStatus
    state: DeliveryState
  }

export type DeliveryOption = {
  __typename: 'DeliveryOption'
  availableMethods: Array<DeliveryMethod>
  deliveryDate: Scalars['Date']['output']
  fromPrice: Money
}

export type DeliveryOptions = {
  __typename: 'DeliveryOptions'
  /** @deprecated Beta feature. Do not use yet */
  availableDeliveryDates: Array<Scalars['Date']['output']>
  deliveries: Array<Delivery>
  deliveryInfoValid: Scalars['Boolean']['output']
}

export type DeliveryOptionsavailableDeliveryDatesArgs = {
  deliveryId: Scalars['ID']['input']
  from: Scalars['Date']['input']
}

export type DeliveryOutForDelivery = DeliveryPipelineComplete &
  DeliveryStatus & {
    __typename: 'DeliveryOutForDelivery'
    deliveryStages?: Maybe<Array<DeliveryStage>>
    dispatchDate?: Maybe<Scalars['Date']['output']>
    display: DeliveryStatusDisplay
    isBlocked: Scalars['Boolean']['output']
    pipelineStatus: DeliveryPipelineStatus
    state: DeliveryState
  }

export type DeliveryPacked = DeliveryPipelineInProgress &
  DeliveryStatus & {
    __typename: 'DeliveryPacked'
    deliveryStages?: Maybe<Array<DeliveryStage>>
    display: DeliveryStatusDisplay
    isBlocked: Scalars['Boolean']['output']
    pipelineStatus: DeliveryPipelineStatus
    state: DeliveryState
  }

export type DeliveryPipelineCancelled = {
  deliveryStages?: Maybe<Array<DeliveryStage>>
  display: DeliveryStatusDisplay
  isBlocked: Scalars['Boolean']['output']
  pipelineStatus: DeliveryPipelineStatus
  state: DeliveryState
}

export type DeliveryPipelineComplete = {
  deliveryStages?: Maybe<Array<DeliveryStage>>
  dispatchDate?: Maybe<Scalars['Date']['output']>
  display: DeliveryStatusDisplay
  isBlocked: Scalars['Boolean']['output']
  pipelineStatus: DeliveryPipelineStatus
  state: DeliveryState
}

export type DeliveryPipelineFailed = {
  deliveryStages?: Maybe<Array<DeliveryStage>>
  display: DeliveryStatusDisplay
  isBlocked: Scalars['Boolean']['output']
  pipelineStatus: DeliveryPipelineStatus
  state: DeliveryState
}

export type DeliveryPipelineInProgress = {
  deliveryStages?: Maybe<Array<DeliveryStage>>
  display: DeliveryStatusDisplay
  isBlocked: Scalars['Boolean']['output']
  pipelineStatus: DeliveryPipelineStatus
  state: DeliveryState
}

export type DeliveryPipelineOnHold = {
  deliveryStages?: Maybe<Array<DeliveryStage>>
  display: DeliveryStatusDisplay
  isBlocked: Scalars['Boolean']['output']
  pipelineStatus: DeliveryPipelineStatus
  state: DeliveryState
}

export type DeliveryPipelinePending = {
  deliveryStages?: Maybe<Array<DeliveryStage>>
  display: DeliveryStatusDisplay
  isBlocked: Scalars['Boolean']['output']
  pipelineStatus: DeliveryPipelineStatus
  state: DeliveryState
}

/** Used to help determine how far a delivery is along a specific pipeline state */
export enum DeliveryPipelineProgressState {
  COMPLETE = 'COMPLETE',
  FAILED = 'FAILED',
  IN_PROGRESS = 'IN_PROGRESS',
  PENDING = 'PENDING',
}

/** Used to help determine how a specific delivery state aligns itself in its overall process */
export enum DeliveryPipelineState {
  /** CANCELLED - The Delivery has been successfully cancelled. */
  CANCELLED = 'CANCELLED',
  /** COMPLETE - The delivery has left the Fulfilment Centre and is being handled by the courier */
  COMPLETE = 'COMPLETE',
  /** FAILED - We currently cannot, or will not be processing the delivery. */
  FAILED = 'FAILED',
  /** IN_PROGRESS - A delivery is being processed in one of the fulfilment centres */
  IN_PROGRESS = 'IN_PROGRESS',
  /** ON_HOLD - The progress of the delivery is paused until further confirmation has been received. */
  ON_HOLD = 'ON_HOLD',
  /** PENDING - We've created the delivery but we are awaiting confirmation. */
  PENDING = 'PENDING',
}

export type DeliveryPipelineStatus = {
  __typename: 'DeliveryPipelineStatus'
  progress: DeliveryPipelineProgressState
  state: DeliveryPipelineState
}

export type DeliveryProcessing = DeliveryPipelineInProgress &
  DeliveryStatus & {
    __typename: 'DeliveryProcessing'
    deliveryStages?: Maybe<Array<DeliveryStage>>
    display: DeliveryStatusDisplay
    isBlocked: Scalars['Boolean']['output']
    pipelineStatus: DeliveryPipelineStatus
    state: DeliveryState
  }

export type DeliveryReceived = DeliveryPipelinePending &
  DeliveryStatus & {
    __typename: 'DeliveryReceived'
    deliveryStages?: Maybe<Array<DeliveryStage>>
    display: DeliveryStatusDisplay
    isBlocked: Scalars['Boolean']['output']
    pipelineStatus: DeliveryPipelineStatus
    state: DeliveryState
  }

export type DeliveryRestrictedError = Error & {
  __typename: 'DeliveryRestrictedError'
  message: Scalars['String']['output']
  restrictions: Array<Scalars['String']['output']>
}

export type DeliveryServiceTarget = {
  __typename: 'DeliveryServiceTarget'
  display: DeliveryServiceTargetDisplay
  hasBrandGuarantee: Scalars['Boolean']['output']
  serviceType: DeliveryServiceTargetType
  targetDate?: Maybe<OrderDate>
}

export type DeliveryServiceTargetDisplay = {
  __typename: 'DeliveryServiceTargetDisplay'
  targetSummary: Scalars['String']['output']
}

export enum DeliveryServiceTargetType {
  DELIVERY_BY = 'DELIVERY_BY',
  DELIVERY_FROM = 'DELIVERY_FROM',
  GUARANTEED_BY = 'GUARANTEED_BY',
}

export type DeliveryStage = {
  label: Scalars['String']['output']
  progress: DeliveryPipelineProgressState
  stageNumber: Scalars['Int']['output']
  timestamp?: Maybe<Scalars['Date']['output']>
}

export enum DeliveryState {
  CANCELLATION_REQUESTED = 'CANCELLATION_REQUESTED',
  CANCELLED = 'CANCELLED',
  DELIVERED = 'DELIVERED',
  DISPATCHED = 'DISPATCHED',
  ON_HOLD = 'ON_HOLD',
  OUT_FOR_DELIVERY = 'OUT_FOR_DELIVERY',
  PACKED = 'PACKED',
  PROCESSING = 'PROCESSING',
  RECEIVED = 'RECEIVED',
}

export type DeliveryStatus = {
  deliveryStages?: Maybe<Array<DeliveryStage>>
  display: DeliveryStatusDisplay
  isBlocked: Scalars['Boolean']['output']
  pipelineStatus: DeliveryPipelineStatus
  /** Delivery State: direct consumption is not recommended - Use pipelineStatus instead. */
  state: DeliveryState
}

export type DeliveryStatusDisplay = {
  __typename: 'DeliveryStatusDisplay'
  /** Detailed Status Title - longer title with additional context. Useful for order details */
  detailedStatusTitle: Scalars['String']['output']
  /** Icon - Used to determine which assets to load on the client */
  icon?: Maybe<DeliveryStatusDisplayIcon>
  /** Status Details - expanded explanation of the what the status means to the customer */
  statusDetails?: Maybe<Scalars['String']['output']>
  /** Status Name: (English Only) - used for tagging/attribution */
  statusName: Scalars['String']['output']
  /** Status Title - short summary or status. useful for order history */
  statusTitle: Scalars['String']['output']
}

export type DeliveryStatusDisplayIcon = {
  __typename: 'DeliveryStatusDisplayIcon'
  assetKey: Scalars['String']['output']
}

export enum DeliveryType {
  EMAIL = 'EMAIL',
  POSTAL = 'POSTAL',
}

export type DeliveryValidation = BasketValidation & {
  __typename: 'DeliveryValidation'
  isBlocking: Scalars['Boolean']['output']
  message: Scalars['String']['output']
  title: Scalars['String']['output']
}

export type DemoInlay = Inlay & {
  __typename: 'DemoInlay'
  id: Scalars['ID']['output']
  scene: InlayScene
  sceneObjects: Array<InlaySceneObject>
}

export type DepartmentCount = {
  __typename: 'DepartmentCount'
  count?: Maybe<Scalars['Int']['output']>
  department: DepartmentsEnum
}

export enum DepartmentsEnum {
  ACRYLICS = 'ACRYLICS',
  ALCOHOL_GIFTS = 'ALCOHOL_GIFTS',
  ALL_CARDS = 'ALL_CARDS',
  ALL_FLOWERS_AND_PLANTS = 'ALL_FLOWERS_AND_PLANTS',
  ALL_GIFTS = 'ALL_GIFTS',
  ARENA_POSTAL_FLOWERS = 'ARENA_POSTAL_FLOWERS',
  BALLOONS = 'BALLOONS',
  BEAUTY = 'BEAUTY',
  CALENDAR_PHOTOBOX = 'CALENDAR_PHOTOBOX',
  CANVASES = 'CANVASES',
  CASES = 'CASES',
  DIGITAL_GIFTS = 'DIGITAL_GIFTS',
  DIGITAL_GIFT_CARDS = 'DIGITAL_GIFT_CARDS',
  FLOWERS = 'FLOWERS',
  FOOD_GIFTS = 'FOOD_GIFTS',
  FRAMES = 'FRAMES',
  GADGETS_AND_NOVELTIES = 'GADGETS_AND_NOVELTIES',
  GIFTS_FOR_HOME = 'GIFTS_FOR_HOME',
  GIFT_BOXES = 'GIFT_BOXES',
  GIFT_EXPERIENCES = 'GIFT_EXPERIENCES',
  GIFT_VOUCHERS = 'GIFT_VOUCHERS',
  GREETING_CARDS = 'GREETING_CARDS',
  GUERNSEY_POSTAL_FLOWERS = 'GUERNSEY_POSTAL_FLOWERS',
  INVITATIONS_AND_ANNOUNCEMENTS = 'INVITATIONS_AND_ANNOUNCEMENTS',
  JEWELLERY_AND_ACCESSORIES = 'JEWELLERY_AND_ACCESSORIES',
  LETTERBOX_GIFTS = 'LETTERBOX_GIFTS',
  MINI_CARDS = 'MINI_CARDS',
  MUGS = 'MUGS',
  NON_CUSTOMISABLE_GIFTS = 'NON_CUSTOMISABLE_GIFTS',
  PARTY = 'PARTY',
  PLANTS = 'PLANTS',
  SOFT_TOYS = 'SOFT_TOYS',
  STATIONERY_AND_CRAFT = 'STATIONERY_AND_CRAFT',
  TOYS_AND_GAMES = 'TOYS_AND_GAMES',
  TSHIRTS = 'TSHIRTS',
  WALL_ART = 'WALL_ART',
  WEDDING_STATIONERY = 'WEDDING_STATIONERY',
}

export enum Dependencies {
  DIRECT_SMILE = 'DIRECT_SMILE',
}

/**
 * A complete design for a customisable product.
 * Contains all scenes, customisations, and metadata.
 */
export type Design = {
  __typename: 'Design'
  /** Sets of stickers available for this design */
  availableStickerSets: Array<DesignAvailableStickerSet>
  /** Text styling options available for this design */
  availableTextStyles: DesignAvailableTextStyles
  /** Capabilities supported by the client that created this design */
  capabilities: Array<DesignCapability>
  /** Information about the client that created the design */
  clientOrigin?: Maybe<DesignClientOrigin>
  /** Compositions defining how scenes are combined for preview/print */
  compositions: Array<DesignComposition>
  /** ISO 8601 timestamp when the design was created */
  createdAt: Scalars['String']['output']
  /** Default text styling for new text elements */
  defaultTextStyle?: Maybe<DesignDefaultTextStyle>
  /** Unix timestamp when this design will expire and be deleted */
  expiresOn: Scalars['Int']['output']
  /** Unique identifier for the design */
  id: Scalars['ID']['output']
  images: SceneImagesResult
  /** Layout type of the design based on product category */
  layout: DesignLayout
  /** @deprecated Use owner.id instead */
  legacyCustomerId?: Maybe<Scalars['String']['output']>
  /** Limits on the number of overlay elements */
  limits: DesignLimits
  /** AWS region where the design was originally created (data is replicated across regions) */
  originRegion: Scalars['String']['output']
  /** Customer who owns this design */
  owner?: Maybe<Customer>
  /** Product key identifying the product this design is for */
  productKey: Scalars['String']['output']
  /** Whether this design requires the new renderer for preview/print */
  requiresNewRenderer: Scalars['Boolean']['output']
  /** All scenes in this design (e.g., front, inside, back) */
  scenes: Array<DesignScene>
  /** SKU for the specific variant of the product */
  sku?: Maybe<Scalars['String']['output']>
  /** ID of the source design if this was duplicated */
  sourceId?: Maybe<Scalars['ID']['output']>
  /** Theme for stamp elements (light or dark) */
  stampTheme: DesignStampTheme
  /** Current lifecycle state of the design */
  state: DesignState
  /**
   * Legacy store field. Not used by the Design API in any way and not used by any consumers.
   * Verified across all clients that this field is not used on 2023-04-26.
   * @deprecated No longer used by API or clients
   */
  store?: Maybe<DesignStore>
  /** Access token for anonymous access to this design */
  token: Scalars['String']['output']
  /** ISO 8601 timestamp when the design was last updated */
  updatedAt: Scalars['String']['output']
  /** Features that have been used across all scenes */
  usedFeatures: Array<EditorFeature>
  /** Version number, incremented with each update */
  version: Scalars['Int']['output']
}

/**
 * A complete design for a customisable product.
 * Contains all scenes, customisations, and metadata.
 */
export type DesignimagesArgs = {
  composition?: InputMaybe<Scalars['Boolean']['input']>
  debugOverlay?: InputMaybe<Scalars['Boolean']['input']>
  experimental?: InputMaybe<Scalars['Boolean']['input']>
  harfBuzzVersion?: InputMaybe<RendererHarfBuzzVersion>
  legacySessionId?: InputMaybe<Scalars['String']['input']>
  substitutions?: InputMaybe<Array<RendererSubstitutionInput>>
  textOnly?: InputMaybe<Scalars['Boolean']['input']>
  useCacheOnly?: InputMaybe<Scalars['Boolean']['input']>
  useNewCache?: InputMaybe<Scalars['Boolean']['input']>
}

/** Response when a design is successfully added to the basket. */
export type DesignAddedToBasket = {
  __typename: 'DesignAddedToBasket'
  /** The basket entity */
  basket: Basket
  /** ID of the basket the design was added to */
  basketId: Scalars['ID']['output']
  /** Total number of items now in the basket */
  basketTotalItems: Scalars['Int']['output']
  /** ID of the customer who owns the basket */
  customerId?: Maybe<Scalars['String']['output']>
  /** Line items that were added to the basket */
  lineItems: Array<DesignLineItem>
}

/** Input for specifying an addon product (e.g., gift wrapping, express shipping). */
export type DesignAddonInput = {
  /** SKU of the addon product */
  sku: Scalars['String']['input']
}

export type DesignAiCreationsConfig = {
  __typename: 'DesignAiCreationsConfig'
  faceswap: FaceswapConfig
}

export type DesignAiCreationsFaceswapCompleted = {
  __typename: 'DesignAiCreationsFaceswapCompleted'
  faceswapImage: DesignImageGenerated
  faceswapImageId: Scalars['ID']['output']
}

export type DesignAiCreationsFaceswapError = Error & {
  __typename: 'DesignAiCreationsFaceswapError'
  message: Scalars['String']['output']
}

export type DesignAiCreationsFaceswapInputImageError = Error & {
  __typename: 'DesignAiCreationsFaceswapInputImageError'
  message: Scalars['String']['output']
}

export type DesignAiCreationsFaceswapNotFound = Error & {
  __typename: 'DesignAiCreationsFaceswapNotFound'
  message: Scalars['String']['output']
}

export type DesignAiCreationsFaceswapProcessing = {
  __typename: 'DesignAiCreationsFaceswapProcessing'
  faceswapImageId: Scalars['ID']['output']
}

export type DesignAiCreationsFaceswapReportError = Error & {
  __typename: 'DesignAiCreationsFaceswapReportError'
  message: Scalars['String']['output']
}

export type DesignAiCreationsFaceswapReportResponse =
  | DesignAiCreationsFaceswapReportError
  | DesignAiCreationsFaceswapReportSuccess
  | { __typename?: '%other' }

export type DesignAiCreationsFaceswapReportSuccess = {
  __typename: 'DesignAiCreationsFaceswapReportSuccess'
  faceswapImageId: Scalars['ID']['output']
}

export type DesignAiCreationsFaceswapResult =
  | DesignAiCreationsFaceswapCompleted
  | DesignAiCreationsFaceswapError
  | DesignAiCreationsFaceswapInputImageError
  | DesignAiCreationsFaceswapNotFound
  | DesignAiCreationsFaceswapProcessing
  | DesignAiCreationsFaceswapUploadPending
  | DesignAiCreationsServiceError
  | { __typename?: '%other' }

export type DesignAiCreationsFaceswapUpload = {
  __typename: 'DesignAiCreationsFaceswapUpload'
  fields: Array<DesignAiCreationsFaceswapUploadField>
  url: Scalars['String']['output']
}

export type DesignAiCreationsFaceswapUploadField = {
  __typename: 'DesignAiCreationsFaceswapUploadField'
  key: Scalars['String']['output']
  value: Scalars['String']['output']
}

export type DesignAiCreationsFaceswapUploadPending = {
  __typename: 'DesignAiCreationsFaceswapUploadPending'
  faceswapImageId: Scalars['ID']['output']
  upload: DesignAiCreationsFaceswapUpload
}

export type DesignAiCreationsServiceError = Error & {
  __typename: 'DesignAiCreationsServiceError'
  message: Scalars['String']['output']
}

export type DesignAmendmentFailure = AmendResult & {
  __typename: 'DesignAmendmentFailure'
  errorCode: AmendErrorCode
  message: Scalars['String']['output']
}

export type DesignAmendmentInput = {
  conversationId?: InputMaybe<Scalars['String']['input']>
  customerId: Scalars['ID']['input']
  deliveryId: Scalars['String']['input']
  lineItemIds?: InputMaybe<Array<Scalars['String']['input']>>
  orderId: Scalars['ID']['input']
  source: Scalars['String']['input']
}

export type DesignAmendmentItem = {
  __typename: 'DesignAmendmentItem'
  amendmentUrl: Scalars['String']['output']
  designId: Scalars['String']['output']
  lineItemId: Scalars['String']['output']
}

export type DesignAmendmentSuccess = AmendResult & {
  __typename: 'DesignAmendmentSuccess'
  amendments: Array<DesignAmendmentItem>
  customerId: Scalars['ID']['output']
  deliveryId: Scalars['String']['output']
  message: Scalars['String']['output']
  orderId: Scalars['ID']['output']
}

/** Error returned when the user is not authorized to access or modify a design. */
export type DesignAuthorizationError = Error & {
  __typename: 'DesignAuthorizationError'
  /** Error message explaining the authorization failure */
  message: Scalars['String']['output']
  /** Whether the user needs to log in to access this resource */
  requiresLogin: Scalars['Boolean']['output']
}

/** A set of colors available for use in the design. */
export type DesignAvailableColorSet = {
  __typename: 'DesignAvailableColorSet'
  /** Unique identifier for the color set */
  id: Scalars['ID']['output']
}

/** A set of fonts available for use in the design. */
export type DesignAvailableFontSet = {
  __typename: 'DesignAvailableFontSet'
  /** Unique identifier for the font set */
  id: Scalars['ID']['output']
}

/** A set of stickers available for use in the design. */
export type DesignAvailableStickerSet = {
  __typename: 'DesignAvailableStickerSet'
  /** Unique identifier for the sticker set */
  id: Scalars['ID']['output']
}

/** Available text styling options for the design. */
export type DesignAvailableTextStyles = {
  __typename: 'DesignAvailableTextStyles'
  /** List of available colors */
  availableColors: Array<DesignColor>
  /** List of available font faces */
  availableFontFaces: Array<DesignFontFace>
  /** List of available font sizes in points */
  availableFontSizes: Array<Scalars['Float']['output']>
  /** List of customer-uploaded custom fonts */
  customerCreationsCustomFontFaces: Array<CustomerCreationsCustomFontFace>
}

/**
 * Client capabilities indicating what features are supported.
 * Used to enable/disable features based on client version.
 */
export enum DesignCapability {
  /** AI-generated sticker support */
  AI_STICKERS = 'AI_STICKERS',
  /** Audio overlay support */
  AUDIO = 'AUDIO',
  /** Flexible layout support */
  LAYOUTS = 'LAYOUTS',
  /** Handwriting overlay support */
  OVERLAY_HANDWRITING = 'OVERLAY_HANDWRITING',
  /** Image overlay support */
  OVERLAY_IMAGE = 'OVERLAY_IMAGE',
  /** Text overlay support */
  OVERLAY_TEXT = 'OVERLAY_TEXT',
  /** Smart text AI generation support */
  SMART_TEXT = 'SMART_TEXT',
  /** Sticker overlay support */
  STICKERS = 'STICKERS',
  /** Text style sets support */
  TEXT_STYLE_SETS = 'TEXT_STYLE_SETS',
  /** Video overlay support */
  VIDEO = 'VIDEO',
}

/** Information about the client application that created the design. */
export type DesignClientOrigin = {
  __typename: 'DesignClientOrigin'
  /** Name of the client application (e.g., 'web', 'ios', 'android') */
  name: Scalars['String']['output']
  /** Version of the client application */
  version?: Maybe<Scalars['String']['output']>
}

/** A collage grid defines the layout structure for image collages with cells and gutters. */
export type DesignCollageGrid = {
  __typename: 'DesignCollageGrid'
  /** Background styling for the grid */
  background?: Maybe<DesignCollageGridBackground>
  /** Border styling for the grid */
  border?: Maybe<DesignCollageGridBorder>
  /** List of cells in the grid */
  cells: Array<DesignCollageGridCell>
  /** List of gutters dividing the grid */
  gutters: Array<DesignCollageGridGutter>
  /** Unique identifier for the grid */
  id: Scalars['ID']['output']
}

/** Background styling for a collage grid. */
export type DesignCollageGridBackground = {
  __typename: 'DesignCollageGridBackground'
  /** Background color as a hex string (e.g., '#FFFFFF') */
  color: Scalars['String']['output']
}

/** Input for background styling when creating or updating a collage grid. */
export type DesignCollageGridBackgroundInput = {
  /** Background color as a hex string (e.g., '#FFFFFF') */
  color: Scalars['String']['input']
}

/** Border widths for a collage grid in millimeters. */
export type DesignCollageGridBorder = {
  __typename: 'DesignCollageGridBorder'
  /** Bottom border width in millimeters */
  bottom: Scalars['Float']['output']
  /** Inner border width between cells in millimeters */
  inner: Scalars['Float']['output']
  /** Left border width in millimeters */
  left: Scalars['Float']['output']
  /** Right border width in millimeters */
  right: Scalars['Float']['output']
  /** Top border width in millimeters */
  top: Scalars['Float']['output']
}

/** Input for border widths when creating or updating a collage grid. */
export type DesignCollageGridBorderInput = {
  /** Bottom border width in millimeters */
  bottom: Scalars['Float']['input']
  /** Inner border width between cells in millimeters */
  inner: Scalars['Float']['input']
  /** Left border width in millimeters */
  left: Scalars['Float']['input']
  /** Right border width in millimeters */
  right: Scalars['Float']['input']
  /** Top border width in millimeters */
  top: Scalars['Float']['input']
}

/** Represents a single cell in a collage grid with its boundaries and content. */
export type DesignCollageGridCell = {
  __typename: 'DesignCollageGridCell'
  /** Anchors defining the cell boundaries */
  anchors: DesignCollageGridCellAnchors
  /** Content displayed in the cell */
  content: DesignCollageGridCellContent
  /** Unique identifier for the cell */
  id: Scalars['ID']['output']
}

/** Anchors define the boundaries of a collage grid cell by referencing gutter IDs. */
export type DesignCollageGridCellAnchors = {
  __typename: 'DesignCollageGridCellAnchors'
  /** ID of the gutter forming the bottom boundary */
  bottom?: Maybe<Scalars['ID']['output']>
  /** ID of the gutter forming the left boundary */
  left?: Maybe<Scalars['ID']['output']>
  /** ID of the gutter forming the right boundary */
  right?: Maybe<Scalars['ID']['output']>
  /** ID of the gutter forming the top boundary */
  top?: Maybe<Scalars['ID']['output']>
}

/** Input for cell anchors when creating or updating a collage grid. */
export type DesignCollageGridCellAnchorsInput = {
  /** ID of the gutter forming the bottom boundary */
  bottom?: InputMaybe<Scalars['ID']['input']>
  /** ID of the gutter forming the left boundary */
  left?: InputMaybe<Scalars['ID']['input']>
  /** ID of the gutter forming the right boundary */
  right?: InputMaybe<Scalars['ID']['input']>
  /** ID of the gutter forming the top boundary */
  top?: InputMaybe<Scalars['ID']['input']>
}

/** Union of possible content types for a collage grid cell. */
export type DesignCollageGridCellContent = {
  __typename: 'DesignCollageGridCellContent'
  /** Image content for the cell */
  image?: Maybe<DesignCollageGridCellContentImage>
  /** Placeholder content for the cell */
  placeholder?: Maybe<DesignCollageGridCellContentPlaceholder>
}

/** Content for a collage grid cell containing an image. */
export type DesignCollageGridCellContentImage = {
  __typename: 'DesignCollageGridCellContentImage'
  /** Source image information for this cell */
  sourceImage: DesignCollageGridCellSourceImage
}

/** Input for image content in a collage grid cell. */
export type DesignCollageGridCellContentImageInput = {
  /** Source image information for this cell */
  sourceImage: DesignCollageGridCellSourceImageInput
}

/** Input for cell content when creating or updating a collage grid. */
export type DesignCollageGridCellContentInput = {
  /** Image content for the cell */
  image?: InputMaybe<DesignCollageGridCellContentImageInput>
  /** Placeholder content for the cell */
  placeholder?: InputMaybe<DesignCollageGridCellContentPlaceholderInput>
}

/** Content for a collage grid cell containing a placeholder. */
export type DesignCollageGridCellContentPlaceholder = {
  __typename: 'DesignCollageGridCellContentPlaceholder'
  /** Type of placeholder content */
  kind: DesignCollageGridCellContentPlaceholderKind
  /** ID of the placed content if any */
  placedId?: Maybe<Scalars['ID']['output']>
}

/** Input for placeholder content in a collage grid cell. */
export type DesignCollageGridCellContentPlaceholderInput = {
  /** Type of placeholder content */
  kind: DesignCollageGridCellContentPlaceholderKind
  /** ID of the placed content if any */
  placedId?: InputMaybe<Scalars['ID']['input']>
}

/** Type of placeholder content in a collage grid cell. */
export enum DesignCollageGridCellContentPlaceholderKind {
  /** Image placeholder */
  IMAGE = 'IMAGE',
  /** Text placeholder */
  TEXT = 'TEXT',
}

/** Input for a collage grid cell when creating or updating a grid. */
export type DesignCollageGridCellInput = {
  /** Anchors defining the cell boundaries */
  anchors: DesignCollageGridCellAnchorsInput
  /** Content to display in the cell */
  content: DesignCollageGridCellContentInput
  /** Unique identifier for the cell (optional for new cells) */
  id?: InputMaybe<Scalars['ID']['input']>
}

/** Represents the source image used within a collage grid cell, including its position and scale. */
export type DesignCollageGridCellSourceImage = {
  __typename: 'DesignCollageGridCellSourceImage'
  /** Unique identifier of the source image */
  id: Scalars['ID']['output']
  /** Horizontal offset of the image in millimeters */
  offsetX: Scalars['Float']['output']
  /** Vertical offset of the image in millimeters */
  offsetY: Scalars['Float']['output']
  /** Scale factor applied to the image */
  scale: Scalars['Float']['output']
}

/** Input for source image information in a collage grid cell. */
export type DesignCollageGridCellSourceImageInput = {
  /** Unique identifier of the source image */
  id: Scalars['ID']['input']
  /** Horizontal offset of the image in millimeters */
  offsetX: Scalars['Float']['input']
  /** Vertical offset of the image in millimeters */
  offsetY: Scalars['Float']['input']
  /** Scale factor applied to the image */
  scale: Scalars['Float']['input']
}

/** A gutter is a dividing line in a collage grid that separates cells. */
export type DesignCollageGridGutter = {
  __typename: 'DesignCollageGridGutter'
  /** Anchors defining the gutter extent */
  anchors: DesignCollageGridGutterAnchors
  /** Unique identifier for the gutter */
  id: Scalars['ID']['output']
  /** Position offset of the gutter in millimeters */
  offset: Scalars['Float']['output']
  /** Orientation of the gutter */
  orientation: DesignCollageGridGutterOrientation
}

/** Anchors for a gutter defining its start and end points. */
export type DesignCollageGridGutterAnchors = {
  __typename: 'DesignCollageGridGutterAnchors'
  /** ID of the anchor at the end of the gutter */
  end?: Maybe<Scalars['ID']['output']>
  /** ID of the anchor at the start of the gutter */
  start?: Maybe<Scalars['ID']['output']>
}

/** Input for gutter anchors when creating or updating a collage grid. */
export type DesignCollageGridGutterAnchorsInput = {
  /** ID of the anchor at the end of the gutter */
  end?: InputMaybe<Scalars['ID']['input']>
  /** ID of the anchor at the start of the gutter */
  start?: InputMaybe<Scalars['ID']['input']>
}

/** Input for a gutter when creating or updating a collage grid. */
export type DesignCollageGridGutterInput = {
  /** Anchors defining the gutter extent */
  anchors: DesignCollageGridGutterAnchorsInput
  /** Unique identifier for the gutter */
  id: Scalars['ID']['input']
  /** Position offset of the gutter in millimeters */
  offset: Scalars['Float']['input']
  /** Orientation of the gutter */
  orientation: DesignCollageGridGutterOrientation
}

/** Orientation of a gutter in a collage grid. */
export enum DesignCollageGridGutterOrientation {
  /** Horizontal gutter running left to right */
  HORIZONTAL = 'HORIZONTAL',
  /** Vertical gutter running top to bottom */
  VERTICAL = 'VERTICAL',
}

/** Input for creating or updating a collage grid. */
export type DesignCollageGridInput = {
  /** Background styling for the grid */
  background?: InputMaybe<DesignCollageGridBackgroundInput>
  /** Border styling for the grid */
  border?: InputMaybe<DesignCollageGridBorderInput>
  /** List of cells in the grid */
  cells: Array<DesignCollageGridCellInput>
  /** List of gutters dividing the grid */
  gutters: Array<DesignCollageGridGutterInput>
  /** Unique identifier for the grid (optional for new grids) */
  id?: InputMaybe<Scalars['ID']['input']>
}

export type DesignCollageGrids = {
  __typename: 'DesignCollageGrids'
  grids: Array<DesignCollageGrid>
}

export type DesignCollageGridsResult =
  | DesignCollageGrids
  | DesignServiceError
  | { __typename?: '%other' }

/** A color available for use in text customisations. */
export type DesignColor = {
  __typename: 'DesignColor'
  /** Unique identifier for the color */
  id: Scalars['ID']['output']
  /** Display name of the color */
  name: Scalars['String']['output']
  /** Hex color value (e.g., '#FF0000') */
  value: Scalars['String']['output']
}

/**
 * Composition defines how multiple scenes are combined for preview/print.
 * Used for multi-scene products like greeting cards.
 */
export type DesignComposition = {
  __typename: 'DesignComposition'
  /** Height of the composition in pixels */
  height: Scalars['Int']['output']
  /** Ordered list of layers from bottom to top */
  layers: Array<DesignCompositionLayer>
  /** Width of the composition in pixels */
  width: Scalars['Int']['output']
}

/** Union of composition layer types. */
export type DesignCompositionLayer =
  | DesignCompositionLayerMapping
  | DesignCompositionLayerStatic
  | { __typename?: '%other' }

/** Blend mode for composition layers (used in advanced rendering). */
export enum DesignCompositionLayerBlendMode {
  /** Color blend mode */
  COLOR = 'COLOR',
  /** Color burn blend mode */
  COLOR_BURN = 'COLOR_BURN',
  /** Color dodge blend mode */
  COLOR_DODGE = 'COLOR_DODGE',
  /** Darken blend mode */
  DARKEN = 'DARKEN',
  /** Difference blend mode */
  DIFFERENCE = 'DIFFERENCE',
  /** Exclusion blend mode */
  EXCLUSION = 'EXCLUSION',
  /** Hard light blend mode */
  HARD_LIGHT = 'HARD_LIGHT',
  /** Hue blend mode */
  HUE = 'HUE',
  /** Lighten blend mode */
  LIGHTEN = 'LIGHTEN',
  /** Lighter blend mode */
  LIGHTER = 'LIGHTER',
  /** Multiply blend mode */
  MULTIPLY = 'MULTIPLY',
  /** Overlay blend mode */
  OVERLAY = 'OVERLAY',
  /** Saturation blend mode */
  SATURATION = 'SATURATION',
  /** Screen blend mode */
  SCREEN = 'SCREEN',
  /** Soft light blend mode */
  SOFT_LIGHT = 'SOFT_LIGHT',
  /** Source over (normal) blend mode */
  SOURCE_OVER = 'SOURCE_OVER',
}

/** Dynamic composition layer that maps to a specific scene. */
export type DesignCompositionLayerMapping = {
  __typename: 'DesignCompositionLayerMapping'
  /** Blend mode for this layer */
  blendMode: DesignCompositionLayerBlendMode
  /** URL to the layer image */
  imageUrl: Scalars['String']['output']
  /** Opacity of this layer (0.0 to 1.0) */
  opacity: Scalars['Float']['output']
  /** ID of the scene this layer maps to */
  sceneId: Scalars['ID']['output']
}

/** Static composition layer with a fixed image. */
export type DesignCompositionLayerStatic = {
  __typename: 'DesignCompositionLayerStatic'
  /** Blend mode for this layer */
  blendMode: DesignCompositionLayerBlendMode
  /** URL to the static layer image */
  imageUrl: Scalars['String']['output']
  /** Opacity of this layer (0.0 to 1.0) */
  opacity: Scalars['Float']['output']
}

/** Customisation for an image collage element in a template. */
export type DesignCustomisationElementImageCollage = {
  __typename: 'DesignCustomisationElementImageCollage'
  /** The final edited image for this collage */
  editedImage: DesignImageUploaded
  /** ID of the template element being customised */
  elementId: Scalars['ID']['output']
  /** Grid configuration for the collage */
  grid?: Maybe<DesignCollageGrid>
}

/** Input for customising an image collage element in a template. */
export type DesignCustomisationElementImageCollageInput = {
  /** The final edited image for this collage */
  editedImage: DesignImageUploadedInput
  /** ID of the template element being customised */
  elementId: Scalars['ID']['input']
  /** Grid configuration for the collage */
  grid?: InputMaybe<DesignCollageGridInput>
}

/**
 * Customisation for a dynamic image element in a template.
 * Legacy feature: applies text to images to make it appear in-situ (e.g., writing in sand, clouds).
 */
export type DesignCustomisationElementImageDynamic = {
  __typename: 'DesignCustomisationElementImageDynamic'
  /** ID of the template element being customised */
  elementId: Scalars['ID']['output']
  /** Text parts to generate the dynamic image from */
  textParts: Array<Scalars['String']['output']>
}

/** Input for customising a dynamic image element. */
export type DesignCustomisationElementImageDynamicInput = {
  /** ID of the template element being customised */
  elementId: Scalars['ID']['input']
  /** Text parts to generate the dynamic image from */
  textParts: Array<Scalars['String']['input']>
}

export type DesignCustomisationElementImageFaceswap = {
  __typename: 'DesignCustomisationElementImageFaceswap'
  elementId: Scalars['ID']['output']
  generatedImage: DesignImageGenerated
}

/** Input for customising a face swap image element in a template. */
export type DesignCustomisationElementImageFaceswapInput = {
  /** ID of the template element being customised */
  elementId: Scalars['ID']['input']
  /** The AI-generated face swap image */
  generatedImage: DesignImageGeneratedInput
}

/** Customisation for an image upload element in a template. */
export type DesignCustomisationElementImageUpload = {
  __typename: 'DesignCustomisationElementImageUpload'
  /** The final edited/cropped image */
  editedImage: DesignImageUploaded
  /** ID of the template element being customised */
  elementId: Scalars['ID']['output']
  /** Optional source image with transform information for re-editing */
  sourceImage?: Maybe<DesignImageSource>
}

/** Input for customising an image upload element. */
export type DesignCustomisationElementImageUploadInput = {
  /** The final edited/cropped image */
  editedImage: DesignImageUploadedInput
  /** ID of the template element being customised */
  elementId: Scalars['ID']['input']
  /** Optional source image with transform information for re-editing */
  sourceImage?: InputMaybe<DesignImageSourceInput>
  /** @deprecated Ignored, use sourceImage.transform instead */
  transform?: InputMaybe<DesignTransformInput>
}

/**
 * Customisation for a text placeholder element in a template.
 * Placeholder text contains static and editable parts.
 */
export type DesignCustomisationElementTextPlaceholder = {
  __typename: 'DesignCustomisationElementTextPlaceholder'
  /** ID of the template element being customised */
  elementId: Scalars['ID']['output']
  /** Array of text parts (both static and editable) */
  textParts: Array<Scalars['String']['output']>
}

/** Input for customising a text placeholder element. */
export type DesignCustomisationElementTextPlaceholderInput = {
  /** ID of the template element being customised */
  elementId: Scalars['ID']['input']
  /** Array of text parts (both static and editable) */
  textParts: Array<Scalars['String']['input']>
}

/**
 * Customisation for a plain text element in a template.
 * Plain text only allows content changes, not styling.
 */
export type DesignCustomisationElementTextPlain = {
  __typename: 'DesignCustomisationElementTextPlain'
  /** ID of the template element being customised */
  elementId: Scalars['ID']['output']
  /** List of variable keys that exist in the text for dynamic substitution */
  substitutions?: Maybe<Array<Scalars['String']['output']>>
  /** The text content */
  text: Scalars['String']['output']
}

/** Input for customising a plain text element. */
export type DesignCustomisationElementTextPlainInput = {
  /** ID of the template element being customised */
  elementId: Scalars['ID']['input']
  /** List of variable keys that exist in the text for dynamic substitution */
  substitutions?: InputMaybe<Array<Scalars['String']['input']>>
  /** The text content */
  text: Scalars['String']['input']
}

/**
 * Customisation for a styled text element in a template.
 * Styled text allows the customer to change font, size, and color.
 */
export type DesignCustomisationElementTextStyled = {
  __typename: 'DesignCustomisationElementTextStyled'
  /** ID of the color to use */
  colorId: Scalars['String']['output']
  /** ID of the template element being customised */
  elementId: Scalars['ID']['output']
  /** ID of the font face to use */
  fontFaceId: Scalars['String']['output']
  /** Font size in points */
  fontSize: Scalars['Float']['output']
  /** Horizontal alignment of text */
  horizontalAlignment: DesignHorizontalAlignment
  /** List of variable keys that exist in the text for dynamic substitution */
  substitutions?: Maybe<Array<Scalars['String']['output']>>
  /** The text content */
  text: Scalars['String']['output']
  /** Vertical alignment of text */
  verticalAlignment: DesignVerticalAlignment
}

/** Input for customising a styled text element. */
export type DesignCustomisationElementTextStyledInput = {
  /** ID of the color to use */
  colorId: Scalars['String']['input']
  /** ID of the template element being customised */
  elementId: Scalars['ID']['input']
  /** ID of the font face to use */
  fontFaceId: Scalars['String']['input']
  /** Font size in points */
  fontSize: Scalars['Float']['input']
  /** Horizontal alignment of text */
  horizontalAlignment: DesignHorizontalAlignment
  /** List of variable keys that exist in the text for dynamic substitution */
  substitutions?: InputMaybe<Array<Scalars['String']['input']>>
  /** The text content */
  text: Scalars['String']['input']
  /** Vertical alignment of text */
  verticalAlignment: DesignVerticalAlignment
}

export type DesignCustomisationPageInfo = {
  __typename: 'DesignCustomisationPageInfo'
  endCursor?: Maybe<Scalars['ID']['output']>
  hasNextPage: Scalars['Boolean']['output']
}

/**
 * Container for all customisations applied to a scene.
 * Organizes customisations by type for type-safe input/output.
 */
export type DesignCustomisations = {
  __typename: 'DesignCustomisations'
  /** Group messages customisation */
  groupMessages?: Maybe<DesignCustomisationsGroupMessages>
  /** Handwriting customisation */
  handwriting?: Maybe<DesignCustomisationsHandwriting>
  /** Scene-level image upload customisation */
  imageUpload?: Maybe<DesignCustomisationsImageUpload>
  /** Layout customisation (for flexible layouts) */
  layout?: Maybe<DesignCustomisationsLayout>
  /** Overlay element customisations */
  overlay?: Maybe<DesignCustomisationsOverlay>
  /** Template element customisations */
  template?: Maybe<DesignCustomisationsTemplate>
}

/**
 * Customisation for scene-level group messages feature.
 * Legacy feature: allowed multiple customers to contribute messages on inside pages of greeting cards.
 */
export type DesignCustomisationsGroupMessages = {
  __typename: 'DesignCustomisationsGroupMessages'
  /** The group messages composite image */
  image: DesignImageUploaded
  /** Optional source image with transform information */
  sourceImage?: Maybe<DesignImageSource>
}

/** Input for group messages customisation. */
export type DesignCustomisationsGroupMessagesInput = {
  /** The group messages composite image */
  image: DesignImageUploadedInput
  /** Optional source image with transform information */
  sourceImage?: InputMaybe<DesignImageSourceInput>
}

/**
 * Customisation for scene-level handwriting feature.
 * Legacy feature: allowed handwritten messages on inside pages of greeting cards.
 */
export type DesignCustomisationsHandwriting = {
  __typename: 'DesignCustomisationsHandwriting'
  /** The handwriting image */
  image: DesignImageUploaded
  /** Optional source image with transform information */
  sourceImage?: Maybe<DesignImageSource>
}

/** Input for handwriting customisation. */
export type DesignCustomisationsHandwritingInput = {
  /** The handwriting image */
  image: DesignImageUploadedInput
  /** Optional source image with transform information */
  sourceImage?: InputMaybe<DesignImageSourceInput>
}

/**
 * Customisation for scene-level image upload feature.
 * Allows a full-scene image upload (e.g., for postcards).
 */
export type DesignCustomisationsImageUpload = {
  __typename: 'DesignCustomisationsImageUpload'
  /** The uploaded image */
  image: DesignImageUploaded
  /** Optional source image with transform information */
  sourceImage?: Maybe<DesignImageSource>
}

/** Input for scene-level image upload customisation. */
export type DesignCustomisationsImageUploadInput = {
  /** The uploaded image */
  image: DesignImageUploadedInput
  /** Optional source image with transform information */
  sourceImage?: InputMaybe<DesignImageSourceInput>
}

/**
 * Input for all customisations in a scene.
 * When providing customisations for a scene, you must provide ALL customisations for that customisation type.
 * For example, if providing template customisations, all template arrays (imageUpload, textStyled, etc.) must be included.
 * Any omitted elements within the provided type will be cleared.
 * However, omitted customisation types (e.g., if you don't provide 'handwriting') will remain unchanged.
 */
export type DesignCustomisationsInput = {
  /** Group messages customisation */
  groupMessages?: InputMaybe<DesignCustomisationsGroupMessagesInput>
  /** Handwriting customisation */
  handwriting?: InputMaybe<DesignCustomisationsHandwritingInput>
  /** Scene-level image upload customisation */
  imageUpload?: InputMaybe<DesignCustomisationsImageUploadInput>
  /** Layout customisation */
  layout?: InputMaybe<DesignCustomisationsLayoutInput>
  /** Overlay element customisations */
  overlay?: InputMaybe<DesignCustomisationsOverlayInput>
  /** Template element customisations */
  template?: InputMaybe<DesignCustomisationsTemplateInput>
}

/**
 * Error returned when customisations input validation fails.
 * Contains an array of specific input errors.
 */
export type DesignCustomisationsInputError = Error & {
  __typename: 'DesignCustomisationsInputError'
  /** List of specific input errors */
  errors: Array<DesignInputError>
  /** Overall input error message */
  message: Scalars['String']['output']
}

/** Layout customisation using a flexible collage grid system. */
export type DesignCustomisationsLayout = {
  __typename: 'DesignCustomisationsLayout'
  /** The collage grid configuration */
  grid: DesignCollageGrid
}

/** Input for layout customisation. */
export type DesignCustomisationsLayoutInput = {
  /** The collage grid configuration */
  grid: DesignCollageGridInput
}

/** Container for all overlay customisations in a design scene. */
export type DesignCustomisationsOverlay = {
  __typename: 'DesignCustomisationsOverlay'
  /** List of all overlay elements in the scene */
  overlays: Array<DesignOverlay>
}

/**
 * Input for all overlay customisations in a scene.
 * When providing overlay customisations, you must provide ALL overlay arrays you want to keep.
 * Omitted overlay type arrays will be cleared (set to empty).
 * If the entire overlay field is omitted from DesignCustomisationsInput, existing overlays remain unchanged.
 */
export type DesignCustomisationsOverlayInput = {
  /** List of AI-generated sticker overlays */
  aiSticker?: InputMaybe<Array<DesignOverlayAIStickerInput>>
  /** List of image overlays */
  image?: InputMaybe<Array<DesignOverlayImageInput>>
  /** List of inlay overlays */
  inlay?: InputMaybe<Array<DesignOverlayInlayInput>>
  /** List of media (video/audio) overlays */
  media?: InputMaybe<Array<DesignOverlayMediaInput>>
  /** List of sticker overlays */
  sticker?: InputMaybe<Array<DesignOverlayStickerInput>>
  /** List of text overlays */
  text?: InputMaybe<Array<DesignOverlayTextInput>>
}

/** Input for applying customisations to a scene by index. */
export type DesignCustomisationsSceneByIndexInput = {
  /** Customisations to apply to this scene */
  customisations: DesignCustomisationsInput
  /** Zero-based index of the scene to customise */
  index: Scalars['Int']['input']
}

/** Input for applying customisations to a specific scene by ID. */
export type DesignCustomisationsSceneInput = {
  /** Customisations to apply to this scene */
  customisations: DesignCustomisationsInput
  /** ID of the scene to customise */
  id: Scalars['ID']['input']
}

/** Container for all template element customisations in a scene. */
export type DesignCustomisationsTemplate = {
  __typename: 'DesignCustomisationsTemplate'
  /** Customisations for image collage elements */
  imageCollage: Array<DesignCustomisationElementImageCollage>
  /** Customisations for dynamic image elements (legacy: text applied in-situ) */
  imageDynamic: Array<DesignCustomisationElementImageDynamic>
  imageFaceswap?: Maybe<Array<DesignCustomisationElementImageFaceswap>>
  /** Customisations for image upload elements */
  imageUpload: Array<DesignCustomisationElementImageUpload>
  /** Customisations for text placeholder elements */
  textPlaceholder: Array<DesignCustomisationElementTextPlaceholder>
  /** Customisations for plain text elements */
  textPlain: Array<DesignCustomisationElementTextPlain>
  /** Customisations for styled text elements */
  textStyled: Array<DesignCustomisationElementTextStyled>
}

/**
 * Input for template element customisations.
 * Provide arrays of customisations for each element type.
 */
export type DesignCustomisationsTemplateInput = {
  /** List of image collage element customisations */
  imageCollage?: InputMaybe<Array<DesignCustomisationElementImageCollageInput>>
  /** List of dynamic image element customisations */
  imageDynamic?: InputMaybe<Array<DesignCustomisationElementImageDynamicInput>>
  /** List of face swap image element customisations */
  imageFaceswap?: InputMaybe<
    Array<DesignCustomisationElementImageFaceswapInput>
  >
  /** List of image upload element customisations */
  imageUpload: Array<DesignCustomisationElementImageUploadInput>
  /** List of text placeholder element customisations */
  textPlaceholder: Array<DesignCustomisationElementTextPlaceholderInput>
  /** List of plain text element customisations */
  textPlain: Array<DesignCustomisationElementTextPlainInput>
  /** List of styled text element customisations */
  textStyled: Array<DesignCustomisationElementTextStyledInput>
}

/** Types of customisations available for a design. */
export enum DesignCustomisationsType {
  /** AI-generated sticker customisations */
  AI_STICKERS = 'AI_STICKERS',
  /** Audio overlay customisations */
  AUDIO = 'AUDIO',
  /** Group messages customisations */
  GROUP_MESSAGES = 'GROUP_MESSAGES',
  /** Handwriting customisations */
  HANDWRITING = 'HANDWRITING',
  /** Scene-level image upload customisations */
  IMAGE_UPLOAD = 'IMAGE_UPLOAD',
  /** Layout customisations (flexible layouts) */
  LAYOUTS = 'LAYOUTS',
  /** Handwriting overlay customisations */
  OVERLAY_HANDWRITING = 'OVERLAY_HANDWRITING',
  /** Image overlay customisations */
  OVERLAY_IMAGE = 'OVERLAY_IMAGE',
  /** Text overlay customisations */
  OVERLAY_TEXT = 'OVERLAY_TEXT',
  /** Smart text AI-generated messages */
  SMART_TEXT = 'SMART_TEXT',
  /** Sticker overlay customisations */
  STICKERS = 'STICKERS',
  /** Template element customisations (text, image uploads, etc.) */
  TEMPLATE = 'TEMPLATE',
  /** Video overlay customisations */
  VIDEO = 'VIDEO',
}

/** Default text styling applied to new text elements. */
export type DesignDefaultTextStyle = {
  __typename: 'DesignDefaultTextStyle'
  /** ID of the default color */
  colorId: Scalars['String']['output']
  /** ID of the default font face */
  fontFaceId: Scalars['String']['output']
  /** Default font size in points */
  fontSize: Scalars['Float']['output']
}

/** Response type indicating a design was successfully deleted. */
export type DesignDeleted = {
  __typename: 'DesignDeleted'
  /** ID of the deleted design */
  id: Scalars['ID']['output']
}

export type DesignElement =
  | DesignElementImageCollage
  | DesignElementImageDynamic
  | DesignElementImageFaceSwap
  | DesignElementImageStatic
  | DesignElementImageUpload
  | DesignElementShapeRectangle
  | DesignElementTextPlaceholder
  | DesignElementTextPlain
  | DesignElementTextStatic
  | DesignElementTextStyled
  | { __typename?: '%other' }

export type DesignElementImageCollage = {
  __typename: 'DesignElementImageCollage'
  defaultPreviewImageUrlVariants: DesignImageUrlVariants
  height: Scalars['Float']['output']
  id: Scalars['ID']['output']
  /** @deprecated Required for legacy only */
  num?: Maybe<Scalars['Int']['output']>
  placeholderImageUrlVariants: DesignImageUrlVariants
  width: Scalars['Float']['output']
  x: Scalars['Float']['output']
  y: Scalars['Float']['output']
}

export type DesignElementImageCommon = {
  height: Scalars['Float']['output']
  id: Scalars['ID']['output']
  /** Returns same as maskUrlVariants.editor */
  maskUrl?: Maybe<Scalars['String']['output']>
  maskUrlVariants?: Maybe<DesignImageUrlVariants>
  /** @deprecated Required for legacy only */
  num?: Maybe<Scalars['Int']['output']>
  /** @deprecated Not used */
  opacity: Scalars['Float']['output']
  rotation: Scalars['Float']['output']
  /** Returns same as urlVariants.editor */
  url: Scalars['String']['output']
  urlVariants?: Maybe<DesignImageUrlVariants>
  width: Scalars['Float']['output']
  x: Scalars['Float']['output']
  y: Scalars['Float']['output']
}

export type DesignElementImageDynamic = {
  __typename: 'DesignElementImageDynamic'
  dynamic: DesignImageDynamic
  height: Scalars['Float']['output']
  id: Scalars['ID']['output']
  /** @deprecated Required for legacy only */
  num?: Maybe<Scalars['Int']['output']>
  /** @deprecated Not used */
  opacity: Scalars['Float']['output']
  rotation: Scalars['Float']['output']
  textParts: Array<DesignTextPartEditable>
  width: Scalars['Float']['output']
  x: Scalars['Float']['output']
  y: Scalars['Float']['output']
}

/**
 * A face swap image element in a template.
 * Uses AI to swap faces in a source image with customer-provided faces.
 */
export type DesignElementImageFaceSwap = DesignElementImageCommon & {
  __typename: 'DesignElementImageFaceSwap'
  /** List of faces to swap */
  faces?: Maybe<Array<DesignElementImageFaceSwapFaces>>
  /** Height in millimeters */
  height: Scalars['Float']['output']
  /** Unique identifier for the element */
  id: Scalars['ID']['output']
  /** Returns same as maskUrlVariants.editor */
  maskUrl?: Maybe<Scalars['String']['output']>
  /** Mask URL variants for different rendering contexts */
  maskUrlVariants?: Maybe<DesignImageUrlVariants>
  /** @deprecated Required for legacy only */
  num?: Maybe<Scalars['Int']['output']>
  /** @deprecated Not used */
  opacity: Scalars['Float']['output']
  /** Whether this face swap element is required */
  required: Scalars['Boolean']['output']
  /** Rotation angle in radians */
  rotation: Scalars['Float']['output']
  /** ID of the source image used for face swap */
  sourceImageId: Scalars['String']['output']
  /** Returns same as urlVariants.editor */
  url: Scalars['String']['output']
  /** URL variants for different rendering contexts */
  urlVariants?: Maybe<DesignImageUrlVariants>
  /** Width in millimeters */
  width: Scalars['Float']['output']
  /** Horizontal position in millimeters */
  x: Scalars['Float']['output']
  /** Vertical position in millimeters */
  y: Scalars['Float']['output']
}

export type DesignElementImageFaceSwapFaces = {
  __typename: 'DesignElementImageFaceSwapFaces'
  /** Original bounding box in millimiters */
  box: DesignElementImageFaceSwapFacesBox
  /** Normalised bounding box in percentages relative to the source image dimensions */
  normalisedBox: DesignElementImageFaceSwapFacesNormalisedBox
}

export type DesignElementImageFaceSwapFacesBox = {
  __typename: 'DesignElementImageFaceSwapFacesBox'
  /** Height of the face in the source image in millimeters */
  height: Scalars['Float']['output']
  /** Width of the face in the source image in millimeters */
  width: Scalars['Float']['output']
  /** Horizontal position of the face in the source image in millimeters */
  x: Scalars['Float']['output']
  /** Vertical position of the face in the source image in millimeters */
  y: Scalars['Float']['output']
}

export type DesignElementImageFaceSwapFacesNormalisedBox = {
  __typename: 'DesignElementImageFaceSwapFacesNormalisedBox'
  /** Height of the face in the source image as a percentage */
  height: Scalars['Float']['output']
  /** Width of the face in the source image as a percentage */
  width: Scalars['Float']['output']
  /** Horizontal position of the face in the source image as a percentage */
  x: Scalars['Float']['output']
  /** Vertical position of the face in the source image as a percentage */
  y: Scalars['Float']['output']
}

export type DesignElementImageStatic = DesignElementImageCommon & {
  __typename: 'DesignElementImageStatic'
  height: Scalars['Float']['output']
  id: Scalars['ID']['output']
  /** Returns same as maskUrlVariants.editor */
  maskUrl?: Maybe<Scalars['String']['output']>
  maskUrlVariants?: Maybe<DesignImageUrlVariants>
  /** @deprecated Required for legacy only */
  num?: Maybe<Scalars['Int']['output']>
  /** @deprecated Not used */
  opacity: Scalars['Float']['output']
  rotation: Scalars['Float']['output']
  /** Returns same as urlVariants.editor */
  url: Scalars['String']['output']
  urlVariants?: Maybe<DesignImageUrlVariants>
  width: Scalars['Float']['output']
  x: Scalars['Float']['output']
  y: Scalars['Float']['output']
}

export type DesignElementImageUpload = DesignElementImageCommon & {
  __typename: 'DesignElementImageUpload'
  height: Scalars['Float']['output']
  id: Scalars['ID']['output']
  /** Returns same as maskUrlVariants.editor */
  maskUrl?: Maybe<Scalars['String']['output']>
  maskUrlVariants?: Maybe<DesignImageUrlVariants>
  /** @deprecated Required for legacy only */
  num?: Maybe<Scalars['Int']['output']>
  /** @deprecated Not used */
  opacity: Scalars['Float']['output']
  required: Scalars['Boolean']['output']
  rotation: Scalars['Float']['output']
  /** Returns same as urlVariants.editor */
  url: Scalars['String']['output']
  urlVariants?: Maybe<DesignImageUrlVariants>
  width: Scalars['Float']['output']
  x: Scalars['Float']['output']
  y: Scalars['Float']['output']
}

/** Error returned when a required design element is missing its customisation. */
export type DesignElementMissingRequiredError = Error & {
  __typename: 'DesignElementMissingRequiredError'
  /** ID of the element that is missing required content */
  elementId: Scalars['String']['output']
  /** Error message describing the missing required element */
  message: Scalars['String']['output']
  /** ID of the scene containing the missing element */
  sceneId: Scalars['String']['output']
  /** ID of the template */
  templateId: Scalars['String']['output']
}

export type DesignElementShapeRectangle = {
  __typename: 'DesignElementShapeRectangle'
  fillColor: Scalars['String']['output']
  height: Scalars['Float']['output']
  id: Scalars['ID']['output']
  /** @deprecated Required for legacy only */
  num?: Maybe<Scalars['Int']['output']>
  /** @deprecated Not used */
  opacity: Scalars['Float']['output']
  outline?: Maybe<DesignOutline>
  rotation: Scalars['Float']['output']
  width: Scalars['Float']['output']
  x: Scalars['Float']['output']
  y: Scalars['Float']['output']
}

export type DesignElementTextCommon = {
  color: DesignColor
  fontFace: DesignFontFace
  fontSize: Scalars['Float']['output']
  height: Scalars['Float']['output']
  horizontalAlignment: DesignHorizontalAlignment
  id: Scalars['ID']['output']
  /** @deprecated Required for legacy only */
  legacyLineSpacing?: Maybe<Scalars['Float']['output']>
  lineSpacing: Scalars['Float']['output']
  /** @deprecated Required for legacy only */
  num?: Maybe<Scalars['Int']['output']>
  /** @deprecated Not used */
  opacity: Scalars['Float']['output']
  rotation: Scalars['Float']['output']
  shadow?: Maybe<DesignTextShadow>
  trackingEm: Scalars['Float']['output']
  verticalAlignment: DesignVerticalAlignment
  width: Scalars['Float']['output']
  x: Scalars['Float']['output']
  y: Scalars['Float']['output']
}

export type DesignElementTextPlaceholder = DesignElementTextCommon & {
  __typename: 'DesignElementTextPlaceholder'
  color: DesignColor
  fontFace: DesignFontFace
  fontSize: Scalars['Float']['output']
  height: Scalars['Float']['output']
  horizontalAlignment: DesignHorizontalAlignment
  id: Scalars['ID']['output']
  /** @deprecated Required for legacy only */
  legacyLineSpacing?: Maybe<Scalars['Float']['output']>
  lineSpacing: Scalars['Float']['output']
  /** @deprecated Required for legacy only */
  num?: Maybe<Scalars['Int']['output']>
  /** @deprecated Not used */
  opacity: Scalars['Float']['output']
  rotation: Scalars['Float']['output']
  shadow?: Maybe<DesignTextShadow>
  textParts: Array<DesignTextPart>
  trackingEm: Scalars['Float']['output']
  verticalAlignment: DesignVerticalAlignment
  width: Scalars['Float']['output']
  x: Scalars['Float']['output']
  y: Scalars['Float']['output']
}

export type DesignElementTextPlain = DesignElementTextCommon & {
  __typename: 'DesignElementTextPlain'
  color: DesignColor
  editableText: DesignTextEditable
  fontFace: DesignFontFace
  fontSize: Scalars['Float']['output']
  height: Scalars['Float']['output']
  horizontalAlignment: DesignHorizontalAlignment
  id: Scalars['ID']['output']
  /** @deprecated Required for legacy only */
  legacyLineSpacing?: Maybe<Scalars['Float']['output']>
  lineSpacing: Scalars['Float']['output']
  /** @deprecated Required for legacy only */
  num?: Maybe<Scalars['Int']['output']>
  /** @deprecated Not used */
  opacity: Scalars['Float']['output']
  rotation: Scalars['Float']['output']
  shadow?: Maybe<DesignTextShadow>
  trackingEm: Scalars['Float']['output']
  verticalAlignment: DesignVerticalAlignment
  width: Scalars['Float']['output']
  x: Scalars['Float']['output']
  y: Scalars['Float']['output']
}

export type DesignElementTextStatic = DesignElementTextCommon & {
  __typename: 'DesignElementTextStatic'
  color: DesignColor
  fontFace: DesignFontFace
  fontSize: Scalars['Float']['output']
  height: Scalars['Float']['output']
  horizontalAlignment: DesignHorizontalAlignment
  id: Scalars['ID']['output']
  /** @deprecated Required for legacy only */
  legacyLineSpacing?: Maybe<Scalars['Float']['output']>
  lineSpacing: Scalars['Float']['output']
  /** @deprecated Required for legacy only */
  num?: Maybe<Scalars['Int']['output']>
  /** @deprecated Not used */
  opacity: Scalars['Float']['output']
  rotation: Scalars['Float']['output']
  shadow?: Maybe<DesignTextShadow>
  text: Scalars['String']['output']
  trackingEm: Scalars['Float']['output']
  verticalAlignment: DesignVerticalAlignment
  width: Scalars['Float']['output']
  x: Scalars['Float']['output']
  y: Scalars['Float']['output']
}

export type DesignElementTextStyled = DesignElementTextCommon & {
  __typename: 'DesignElementTextStyled'
  availableColors: Array<DesignColor>
  availableFontFaces: Array<DesignFontFace>
  availableFontSizes: Array<Scalars['Float']['output']>
  color: DesignColor
  editableText: DesignTextEditable
  fontFace: DesignFontFace
  fontSize: Scalars['Float']['output']
  height: Scalars['Float']['output']
  horizontalAlignment: DesignHorizontalAlignment
  id: Scalars['ID']['output']
  /** @deprecated Required for legacy only */
  legacyLineSpacing?: Maybe<Scalars['Float']['output']>
  lineSpacing: Scalars['Float']['output']
  /** @deprecated Required for legacy only */
  num?: Maybe<Scalars['Int']['output']>
  /** @deprecated Not used */
  opacity: Scalars['Float']['output']
  rotation: Scalars['Float']['output']
  shadow?: Maybe<DesignTextShadow>
  trackingEm: Scalars['Float']['output']
  verticalAlignment: DesignVerticalAlignment
  width: Scalars['Float']['output']
  x: Scalars['Float']['output']
  y: Scalars['Float']['output']
}

/** Input for filtering design data when querying. */
export type DesignFilterInput = {
  /** Whether to include print-only scenes in the response */
  includePrintOnlyScenes?: InputMaybe<Scalars['Boolean']['input']>
  /** @deprecated No longer used */
  videoCardId?: InputMaybe<Scalars['String']['input']>
}

/** A font face available for use in text customisations. */
export type DesignFontFace = {
  __typename: 'DesignFontFace'
  /** Unique identifier for the font face */
  id: Scalars['ID']['output']
  /** Font metrics for precise text rendering */
  metrics?: Maybe<DesignFontFaceMetrics>
  /** Display name of the font */
  name: Scalars['String']['output']
  /** URLs to download the font in different formats */
  urls: DesignFontFaceUrls
}

/** Complete font metrics for precise text rendering and layout. */
export type DesignFontFaceMetrics = {
  __typename: 'DesignFontFaceMetrics'
  /** HEAD table metrics */
  head: DesignFontFaceMetricsHead
  /** HHEA table metrics */
  hhea: DesignFontFaceMetricsHhea
  /** OS/2 table metrics */
  os2: DesignFontFaceMetricsOs2
}

/** Font metrics from the HEAD table for precise text rendering. */
export type DesignFontFaceMetricsHead = {
  __typename: 'DesignFontFaceMetricsHead'
  /** Units per em (defines the scaling factor) */
  unitsPerEm: Scalars['Float']['output']
  /** Maximum Y coordinate value */
  yMax: Scalars['Float']['output']
  /** Minimum Y coordinate value */
  yMin: Scalars['Float']['output']
}

/** Font metrics from the HHEA table for horizontal layout. */
export type DesignFontFaceMetricsHhea = {
  __typename: 'DesignFontFaceMetricsHhea'
  /** Typographic ascender */
  ascender: Scalars['Float']['output']
  /** Typographic descender */
  descender: Scalars['Float']['output']
  /** Typographic line gap */
  lineGap: Scalars['Float']['output']
}

/** Font metrics from the OS/2 table for Windows compatibility. */
export type DesignFontFaceMetricsOs2 = {
  __typename: 'DesignFontFaceMetricsOs2'
  /** Font selection flags */
  fsSelection: Scalars['Float']['output']
  /** Font embedding licensing rights */
  fsType: Scalars['Float']['output']
  /** Height of uppercase letters */
  sCapHeight: Scalars['Float']['output']
  /** Typographic ascender */
  sTypoAscender: Scalars['Float']['output']
  /** Typographic descender */
  sTypoDescender: Scalars['Float']['output']
  /** Typographic line gap */
  sTypoLineGap: Scalars['Float']['output']
  /** Height of lowercase x */
  sxHeight: Scalars['Float']['output']
  /** Windows ascent */
  usWinAscent: Scalars['Float']['output']
  /** Windows descent */
  usWinDescent: Scalars['Float']['output']
}

/** URLs for different font file formats. */
export type DesignFontFaceUrls = {
  __typename: 'DesignFontFaceUrls'
  /** URL to TTF font file */
  ttf: Scalars['String']['output']
  /** URL to WOFF font file */
  woff: Scalars['String']['output']
  /** URL to WOFF2 font file */
  woff2: Scalars['String']['output']
}

/** Horizontal alignment options for text. */
export enum DesignHorizontalAlignment {
  /** Center text horizontally */
  CENTER = 'CENTER',
  /** Justify text to both edges */
  JUSTIFY = 'JUSTIFY',
  /** Align text to the left edge */
  LEFT = 'LEFT',
  /** Align text to the right edge */
  RIGHT = 'RIGHT',
}

/** Configuration for image upload constraints. */
export type DesignImageConfig = {
  __typename: 'DesignImageConfig'
  /** Maximum allowed file size in bytes */
  maxSizeBytes: Scalars['Int']['output']
  /** Minimum required file size in bytes */
  minSizeBytes: Scalars['Int']['output']
}

export type DesignImageDynamic = {
  __typename: 'DesignImageDynamic'
  format: DesignImageDynamicFormat
  id: Scalars['ID']['output']
}

export enum DesignImageDynamicFormat {
  JPEG = 'JPEG',
  PNG = 'PNG',
}

/** An image generated by AI services (e.g., faceswap, rendered previews). */
export type DesignImageGenerated = {
  __typename: 'DesignImageGenerated'
  /** ID of the design this image belongs to */
  designId: Scalars['ID']['output']
  /** Unique identifier for the generated image */
  id: Scalars['ID']['output']
  /** URL to access the generated image */
  url?: Maybe<Scalars['String']['output']>
}

/** Input for referencing an AI-generated image (e.g., from faceswap service). */
export type DesignImageGeneratedInput = {
  /** Unique identifier of the generated image */
  id: Scalars['ID']['input']
}

/** Source image with transform information for editing purposes. */
export type DesignImageSource = {
  __typename: 'DesignImageSource'
  /** Unique identifier of the source image */
  id: Scalars['ID']['output']
  /** Transform applied to the source image */
  transform: DesignTransform
}

/** Input for referencing a source image with its transform information. */
export type DesignImageSourceInput = {
  /** ID of the source image */
  id: Scalars['ID']['input']
  /** Transform applied to the source image */
  transform: DesignTransformInput
}

/** Information needed to upload an image to the Design API. */
export type DesignImageUpload = {
  __typename: 'DesignImageUpload'
  /** Form fields that must be included in the upload request */
  fields: Array<DesignImageUploadField>
  /** Unique identifier for the image upload */
  imageId: Scalars['ID']['output']
  /** URL to POST the image to */
  url: Scalars['String']['output']
}

/** A field for the image upload form data. */
export type DesignImageUploadField = {
  __typename: 'DesignImageUploadField'
  /** Form field key */
  key: Scalars['String']['output']
  /** Form field value */
  value: Scalars['String']['output']
}

/** Error returned when the maximum number of image uploads has been reached for a design. */
export type DesignImageUploadLimitReachedError = Error & {
  __typename: 'DesignImageUploadLimitReachedError'
  /** Error message explaining the upload limit */
  message: Scalars['String']['output']
}

/** An uploaded customer image available for use in the design. */
export type DesignImageUploaded = {
  __typename: 'DesignImageUploaded'
  /** Unique identifier for the uploaded image */
  id: Scalars['ID']['output']
  /** URL to access the uploaded image */
  url?: Maybe<Scalars['String']['output']>
}

/** Input for referencing an uploaded image by its ID. */
export type DesignImageUploadedInput = {
  /** ID of the uploaded image */
  id: Scalars['ID']['input']
}

export type DesignImageUrlVariants = {
  __typename: 'DesignImageUrlVariants'
  editor: Scalars['String']['output']
  preview: Scalars['String']['output']
  preview2: Scalars['String']['output']
  print: Scalars['String']['output']
  print2: Scalars['String']['output']
}

/** Metadata for an inlay product. */
export type DesignInlayMetadata = {
  /** Line item ID in the basket */
  lineItemId: Scalars['String']['input']
  /** SKU of the inlay product */
  sku: Scalars['String']['input']
}

/** Error returned when there is a problem with the design input. */
export type DesignInputDesignError = Error & {
  __typename: 'DesignInputDesignError'
  /** Error message describing the design error */
  message: Scalars['String']['output']
}

/** Union of all possible design input errors. */
export type DesignInputError =
  | DesignElementMissingRequiredError
  | DesignInputDesignError
  | DesignInputInvalidElementError
  | DesignInputProfanityError
  | DesignInputSceneError
  | DesignInputSceneNotFoundError
  | DesignInputTemplateElementNotFoundError
  | { __typename?: '%other' }

/** Error returned when an input element ID is invalid or has incorrect type. */
export type DesignInputInvalidElementError = Error & {
  __typename: 'DesignInputInvalidElementError'
  /** ID of the invalid input element */
  inputElementId: Scalars['String']['output']
  /** Error message describing the invalid element */
  message: Scalars['String']['output']
  /** ID of the scene containing the error */
  sceneId: Scalars['String']['output']
  /** ID of the template containing the error */
  templateId: Scalars['String']['output']
  /** Expected type of the element */
  type?: Maybe<Scalars['String']['output']>
}

/** Error returned when input text contains profanity or inappropriate content. */
export type DesignInputProfanityError = Error & {
  __typename: 'DesignInputProfanityError'
  /** ID of the input element with profanity */
  inputElementId: Scalars['String']['output']
  /** Error message describing the profanity issue */
  message: Scalars['String']['output']
  /** ID of the scene containing the error */
  sceneId: Scalars['String']['output']
  /** ID of the template containing the error */
  templateId: Scalars['String']['output']
  /** Type of the element */
  type?: Maybe<Scalars['String']['output']>
}

/** Error returned when there is a problem with the scene input. */
export type DesignInputSceneError = Error & {
  __typename: 'DesignInputSceneError'
  /** ID of the scene with the error */
  inputSceneId: Scalars['String']['output']
  /** Error message describing the scene error */
  message: Scalars['String']['output']
}

/** Error returned when a referenced scene cannot be found. */
export type DesignInputSceneNotFoundError = Error & {
  __typename: 'DesignInputSceneNotFoundError'
  /** ID of the scene that could not be found */
  inputSceneId: Scalars['String']['output']
  /** Error message indicating the scene was not found */
  message: Scalars['String']['output']
}

/** Error returned when a referenced template element cannot be found. */
export type DesignInputTemplateElementNotFoundError = Error & {
  __typename: 'DesignInputTemplateElementNotFoundError'
  /** ID of the element that could not be found */
  inputElementId: Scalars['String']['output']
  /** Error message indicating the element was not found */
  message: Scalars['String']['output']
  /** ID of the scene being customised */
  sceneId: Scalars['String']['output']
  /** ID of the template */
  templateId: Scalars['String']['output']
}

export type DesignIntent = {
  intent: Intent
  ordinal?: InputMaybe<Scalars['String']['input']>
  value: Scalars['String']['input']
}

/** Error returned when an invalid pagination cursor is provided. */
export type DesignInvalidCursorError = Error & {
  __typename: 'DesignInvalidCursorError'
  /** Error message explaining the cursor issue */
  message: Scalars['String']['output']
}

/** Error returned when an invalid or expired token is provided. */
export type DesignInvalidTokenError = Error & {
  __typename: 'DesignInvalidTokenError'
  /** Error message explaining the token issue */
  message: Scalars['String']['output']
}

export type DesignIsValid = {
  __typename: 'DesignIsValid'
  isValid: Scalars['Boolean']['output']
}

export type DesignIsValidInput = {
  id: Scalars['ID']['input']
}

export type DesignIsValidResult =
  | DesignAuthorizationError
  | DesignIsValid
  | DesignNotFoundError
  | DesignServiceError
  | DesignTemplatesServiceError
  | { __typename?: '%other' }

/** Layout type of a design based on product category and orientation. */
export enum DesignLayout {
  /** Landscape greeting card layout */
  CARD_LANDSCAPE = 'CARD_LANDSCAPE',
  /** Portrait greeting card layout */
  CARD_PORTRAIT = 'CARD_PORTRAIT',
  /** Square greeting card layout */
  CARD_SQUARE = 'CARD_SQUARE',
  /** Generic product layout */
  GENERIC = 'GENERIC',
  /** Landscape labels layout */
  LABELS_LANDSCAPE = 'LABELS_LANDSCAPE',
  /** Portrait labels layout */
  LABELS_PORTRAIT = 'LABELS_PORTRAIT',
  /** Mug product layout */
  MUG = 'MUG',
  /** Landscape postcard layout */
  POSTCARD_LANDSCAPE = 'POSTCARD_LANDSCAPE',
  /** Portrait postcard layout */
  POSTCARD_PORTRAIT = 'POSTCARD_PORTRAIT',
  /** Horizontal sleeve layout */
  SLEEVE_HORIZONTAL = 'SLEEVE_HORIZONTAL',
  /** Vertical sleeve layout */
  SLEEVE_VERTICAL = 'SLEEVE_VERTICAL',
  TSHIRT = 'TSHIRT',
  TSHIRT_FRONT = 'TSHIRT_FRONT',
  TSHIRT_FRONT_BACK = 'TSHIRT_FRONT_BACK',
  /** Unknown or unrecognized layout */
  UNKNOWN = 'UNKNOWN',
}

/** Limits on the number of overlay elements that can be added to a design. */
export type DesignLimits = {
  __typename: 'DesignLimits'
  /** Maximum number of handwriting elements */
  maxHandwritingCount: Scalars['Int']['output']
  /** Maximum number of image overlays */
  maxImageCount: Scalars['Int']['output']
  /** Maximum number of inlay overlays */
  maxInlayCount: Scalars['Int']['output']
  /** Maximum number of media (video/audio) overlays */
  maxMediaCount: Scalars['Int']['output']
  /** Maximum number of sticker overlays */
  maxStickerCount: Scalars['Int']['output']
  /** Maximum number of text overlays */
  maxTextCount: Scalars['Int']['output']
}

/** A line item representing a design added to the basket. */
export type DesignLineItem = {
  __typename: 'DesignLineItem'
  /** Type of product (e.g., 'Card', 'Mug') */
  productType: Scalars['String']['output']
  /** Title of the product */
  title: Scalars['String']['output']
  /** Total price for this line item */
  totalPrice: Money
}

/** Type of media content for overlay elements. */
export enum DesignMediaKind {
  /** Audio content */
  AUDIO = 'AUDIO',
  /** Video content */
  VIDEO = 'VIDEO',
}

/** Error returned when attempting an operation that requires a draft design on a non-draft design. */
export type DesignNotDraftError = Error & {
  __typename: 'DesignNotDraftError'
  /** Error message explaining the design must be in draft state */
  message: Scalars['String']['output']
}

/** Error returned when a requested design cannot be found. */
export type DesignNotFoundError = Error & {
  __typename: 'DesignNotFoundError'
  /** Error message indicating the design was not found */
  message: Scalars['String']['output']
}

/** Orientation of a design template or scene. */
export enum DesignOrientation {
  /** Landscape orientation (width > height) */
  LANDSCAPE = 'LANDSCAPE',
  /** Portrait orientation (height > width) */
  PORTRAIT = 'PORTRAIT',
}

export type DesignOutline = {
  __typename: 'DesignOutline'
  color: Scalars['String']['output']
  width: Scalars['Float']['output']
}

/** Union of all possible overlay element types that can be added to a design. */
export type DesignOverlay =
  | DesignOverlayAISticker
  | DesignOverlayImage
  | DesignOverlayInlay
  | DesignOverlayMedia
  | DesignOverlaySticker
  | DesignOverlayText
  | { __typename?: '%other' }

/** An AI-generated sticker overlay created from a customer prompt. */
export type DesignOverlayAISticker = DesignOverlayCommon & {
  __typename: 'DesignOverlayAISticker'
  /** Content details for the AI sticker */
  content: DesignOverlayAIStickerContent
  /** Height in millimeters */
  height: Scalars['Float']['output']
  /** Z-index for layering overlays */
  index: Scalars['Int']['output']
  /** Rotation angle in degrees */
  rotation: Scalars['Float']['output']
  /** Width in millimeters */
  width: Scalars['Float']['output']
  /** Horizontal position in millimeters */
  x: Scalars['Float']['output']
  /** Vertical position in millimeters */
  y: Scalars['Float']['output']
}

/** Content for an AI-generated sticker overlay. */
export type DesignOverlayAIStickerContent = {
  __typename: 'DesignOverlayAIStickerContent'
  /** @deprecated Not used, use editedImage.id instead */
  aiStickerId?: Maybe<Scalars['ID']['output']>
  /** The AI-generated sticker image */
  editedImage: DesignImageUploaded
  /** Optional source image if the AI sticker was based on a customer upload */
  sourceImage?: Maybe<DesignImageSource>
  /** @deprecated Not used, use editedImage.url instead */
  url?: Maybe<Scalars['String']['output']>
}

/** Input for AI sticker overlay content when creating or updating overlays. */
export type DesignOverlayAIStickerContentInput = {
  /** @deprecated Provide editedImage.id instead */
  aiStickerId?: InputMaybe<Scalars['ID']['input']>
  /** The AI-generated sticker image */
  editedImage: DesignImageUploadedInput
  /** Optional source image if the AI sticker was based on a customer upload */
  sourceImage?: InputMaybe<DesignImageSourceInput>
  /** @deprecated Never used, provide editedImage.id instead */
  url?: InputMaybe<Scalars['String']['input']>
}

/** Input for creating or updating an AI sticker overlay element. */
export type DesignOverlayAIStickerInput = {
  /** Content for the AI sticker overlay */
  content: DesignOverlayAIStickerContentInput
  /** Height in millimeters */
  height: Scalars['Float']['input']
  /** Z-index for layering (higher values appear on top) */
  index: Scalars['Int']['input']
  /** Rotation angle in degrees (positive = clockwise) */
  rotation: Scalars['Float']['input']
  /** Width in millimeters */
  width: Scalars['Float']['input']
  /** Horizontal position in millimeters from the left edge */
  x: Scalars['Float']['input']
  /** Vertical position in millimeters from the top edge */
  y: Scalars['Float']['input']
}

/**
 * Common properties shared by all overlay elements in a design.
 * Overlays are elements that can be freely positioned and rotated on top of the base design.
 */
export type DesignOverlayCommon = {
  /** Height of the overlay in millimeters */
  height: Scalars['Float']['output']
  /** Z-index for layering overlays; higher values appear on top */
  index: Scalars['Int']['output']
  /** Rotation angle in degrees (positive values = clockwise) */
  rotation: Scalars['Float']['output']
  /** Width of the overlay in millimeters */
  width: Scalars['Float']['output']
  /** Horizontal position in millimeters from the left edge */
  x: Scalars['Float']['output']
  /** Vertical position in millimeters from the top edge */
  y: Scalars['Float']['output']
}

/** An image overlay element allowing customers to add photos or handwriting to the design. */
export type DesignOverlayImage = DesignOverlayCommon & {
  __typename: 'DesignOverlayImage'
  /** Content details for the image */
  content: DesignOverlayImageContent
  /** Height in millimeters */
  height: Scalars['Float']['output']
  /** Z-index for layering overlays */
  index: Scalars['Int']['output']
  /** Rotation angle in degrees */
  rotation: Scalars['Float']['output']
  /** Width in millimeters */
  width: Scalars['Float']['output']
  /** Horizontal position in millimeters */
  x: Scalars['Float']['output']
  /** Vertical position in millimeters */
  y: Scalars['Float']['output']
}

/** Content details for an image overlay element. */
export type DesignOverlayImageContent = {
  __typename: 'DesignOverlayImageContent'
  /** The final edited/cropped image to display */
  editedImage: DesignImageUploaded
  /** Whether the image position is fixed and cannot be moved by the user */
  fixed?: Maybe<Scalars['Boolean']['output']>
  /** Type of image content */
  imageKind?: Maybe<DesignOverlayImageKind>
  /** Optional mask to apply to the image */
  mask?: Maybe<DesignOverlayImageContentMask>
  /** Optional source image with transform information */
  sourceImage?: Maybe<DesignImageSource>
}

/** Input for image overlay content when creating or updating overlays. */
export type DesignOverlayImageContentInput = {
  /** The final edited/cropped image to display */
  editedImage: DesignImageUploadedInput
  /** Whether the image position is fixed and cannot be moved by the user */
  fixed?: InputMaybe<Scalars['Boolean']['input']>
  /** Type of image content (photo or handwriting) */
  imageKind?: InputMaybe<DesignOverlayImageKind>
  /** Optional mask to apply to the image */
  mask?: InputMaybe<DesignOverlayImageContentMaskInput>
  /** Optional source image with transform information */
  sourceImage?: InputMaybe<DesignImageSourceInput>
}

/** Mask applied to an overlay image for special effects. */
export type DesignOverlayImageContentMask = {
  __typename: 'DesignOverlayImageContentMask'
  /** Unique identifier for the mask */
  id: Scalars['ID']['output']
  /** URL to the mask image */
  url: Scalars['String']['output']
}

/** Input for mask to apply to an overlay image. */
export type DesignOverlayImageContentMaskInput = {
  /** ID of the mask to apply */
  id: Scalars['ID']['input']
}

/** Input for creating or updating an image overlay element. */
export type DesignOverlayImageInput = {
  /** Content for the image overlay */
  content: DesignOverlayImageContentInput
  /** Height in millimeters */
  height: Scalars['Float']['input']
  /** Z-index for layering (higher values appear on top) */
  index: Scalars['Int']['input']
  /** Rotation angle in degrees (positive = clockwise) */
  rotation: Scalars['Float']['input']
  /** Width in millimeters */
  width: Scalars['Float']['input']
  /** Horizontal position in millimeters from the left edge */
  x: Scalars['Float']['input']
  /** Vertical position in millimeters from the top edge */
  y: Scalars['Float']['input']
}

/** Type of image content in an overlay. */
export enum DesignOverlayImageKind {
  /** Customer handwriting upload */
  HANDWRITING = 'HANDWRITING',
  /** Customer photo upload */
  PHOTO = 'PHOTO',
}

/**
 * An inlay overlay represents a separate product inserted into the main design.
 * Currently used for vouchers (digital gifts), could be extended for other products in the future.
 */
export type DesignOverlayInlay = DesignOverlayCommon & {
  __typename: 'DesignOverlayInlay'
  /** Content details for the inlay */
  content: DesignOverlayInlayContent
  /** Height in millimeters */
  height: Scalars['Float']['output']
  /** Z-index for layering overlays */
  index: Scalars['Int']['output']
  /** Rotation angle in degrees */
  rotation: Scalars['Float']['output']
  /** Width in millimeters */
  width: Scalars['Float']['output']
  /** Horizontal position in millimeters */
  x: Scalars['Float']['output']
  /** Vertical position in millimeters */
  y: Scalars['Float']['output']
}

/** Content for an inlay overlay, referencing an inlay product to be inserted. */
export type DesignOverlayInlayContent = {
  __typename: 'DesignOverlayInlayContent'
  /** Height of the inlay in millimeters */
  height: Scalars['Float']['output']
  image: RendererInlayImageResult
  /** Unique identifier of the inlay product */
  inlayId: Scalars['ID']['output']
  scene: InlayScene
  sceneObjects: Array<InlaySceneObject>
  /** Width of the inlay in millimeters */
  width: Scalars['Float']['output']
}

/** Input for inlay overlay content when creating or updating overlays. */
export type DesignOverlayInlayContentInput = {
  /** ID of the inlay product to insert */
  inlayId: Scalars['ID']['input']
}

/** Input for creating or updating an inlay overlay element. */
export type DesignOverlayInlayInput = {
  /** Content for the inlay overlay */
  content: DesignOverlayInlayContentInput
  /** Height in millimeters */
  height: Scalars['Float']['input']
  /** Z-index for layering (higher values appear on top) */
  index: Scalars['Int']['input']
  /** Rotation angle in degrees (positive = clockwise) */
  rotation: Scalars['Float']['input']
  /** Width in millimeters */
  width: Scalars['Float']['input']
  /** Horizontal position in millimeters from the left edge */
  x: Scalars['Float']['input']
  /** Vertical position in millimeters from the top edge */
  y: Scalars['Float']['input']
}

/** A media overlay element allowing customers to add video or audio to the design. */
export type DesignOverlayMedia = DesignOverlayCommon & {
  __typename: 'DesignOverlayMedia'
  /** Content details for the media */
  content: DesignOverlayMediaContent
  /** Height in millimeters */
  height: Scalars['Float']['output']
  /** Z-index for layering overlays */
  index: Scalars['Int']['output']
  /** Rotation angle in degrees */
  rotation: Scalars['Float']['output']
  /** Width in millimeters */
  width: Scalars['Float']['output']
  /** Horizontal position in millimeters */
  x: Scalars['Float']['output']
  /** Vertical position in millimeters */
  y: Scalars['Float']['output']
}

/** Content details for a media (video/audio) overlay element. */
export type DesignOverlayMediaContent = {
  __typename: 'DesignOverlayMediaContent'
  /** Design this media belongs to */
  designId: Scalars['ID']['output']
  /** Height of the media element in millimeters */
  height: Scalars['Float']['output']
  /** Type of media (video or audio) */
  kind?: Maybe<DesignMediaKind>
  media: MediaResult
  /** Unique identifier for the media */
  mediaId: Scalars['ID']['output']
  scene: MediaScene
  /** Width of the media element in millimeters */
  width: Scalars['Float']['output']
}

/** Input for media overlay content when creating or updating overlays. */
export type DesignOverlayMediaContentInput = {
  /** Type of media (video or audio) */
  kind?: InputMaybe<DesignMediaKind>
  /** Token for the uploaded media file */
  mediaToken: Scalars['String']['input']
}

/** Input for creating or updating a media overlay element. */
export type DesignOverlayMediaInput = {
  /** Content for the media overlay */
  content: DesignOverlayMediaContentInput
  /** Height in millimeters */
  height: Scalars['Float']['input']
  /** Z-index for layering (higher values appear on top) */
  index: Scalars['Int']['input']
  /** Rotation angle in degrees (positive = clockwise) */
  rotation: Scalars['Float']['input']
  /** Width in millimeters */
  width: Scalars['Float']['input']
  /** Horizontal position in millimeters from the left edge */
  x: Scalars['Float']['input']
  /** Vertical position in millimeters from the top edge */
  y: Scalars['Float']['input']
}

/** A sticker overlay representing a decorative pre-designed sticker element. */
export type DesignOverlaySticker = DesignOverlayCommon & {
  __typename: 'DesignOverlaySticker'
  /** Content details for the sticker */
  content: DesignOverlayStickerContent
  /** Height in millimeters */
  height: Scalars['Float']['output']
  /** Z-index for layering overlays */
  index: Scalars['Int']['output']
  /** Rotation angle in degrees */
  rotation: Scalars['Float']['output']
  /** Width in millimeters */
  width: Scalars['Float']['output']
  /** Horizontal position in millimeters */
  x: Scalars['Float']['output']
  /** Vertical position in millimeters */
  y: Scalars['Float']['output']
}

/** Content for a sticker overlay, referencing a pre-designed sticker asset. */
export type DesignOverlayStickerContent = {
  __typename: 'DesignOverlayStickerContent'
  /** Unique identifier of the sticker */
  stickerId: Scalars['ID']['output']
  /** URLs for different resolutions of the sticker image */
  urls: StickerUrls
}

/** Input for sticker overlay content when creating or updating overlays. */
export type DesignOverlayStickerContentInput = {
  /** ID of the sticker to use */
  stickerId: Scalars['ID']['input']
}

/** Input for creating or updating a sticker overlay element. */
export type DesignOverlayStickerInput = {
  /** Content for the sticker overlay */
  content: DesignOverlayStickerContentInput
  /** Height in millimeters */
  height: Scalars['Float']['input']
  /** Z-index for layering (higher values appear on top) */
  index: Scalars['Int']['input']
  /** Rotation angle in degrees (positive = clockwise) */
  rotation: Scalars['Float']['input']
  /** Width in millimeters */
  width: Scalars['Float']['input']
  /** Horizontal position in millimeters from the left edge */
  x: Scalars['Float']['input']
  /** Vertical position in millimeters from the top edge */
  y: Scalars['Float']['input']
}

/** A text overlay element allowing customers to add custom text to the design. */
export type DesignOverlayText = DesignOverlayCommon & {
  __typename: 'DesignOverlayText'
  /** Content details for the text */
  content: DesignOverlayTextContent
  /** Height in millimeters */
  height: Scalars['Float']['output']
  /** Z-index for layering overlays */
  index: Scalars['Int']['output']
  /** Rotation angle in degrees */
  rotation: Scalars['Float']['output']
  /** Width in millimeters */
  width: Scalars['Float']['output']
  /** Horizontal position in millimeters */
  x: Scalars['Float']['output']
  /** Vertical position in millimeters */
  y: Scalars['Float']['output']
}

/** Content details for a text overlay element. */
export type DesignOverlayTextContent = {
  __typename: 'DesignOverlayTextContent'
  /**
   * Author of the customisation as determined by the client.
   *
   * Currently optional until client consistency is reached.
   */
  author?: Maybe<DesignTextAuthor>
  /** ID of the color to use for the text */
  colorId: Scalars['ID']['output']
  /** The text box is not intended to be moved, rotated, or resized by the user. */
  fixed?: Maybe<Scalars['Boolean']['output']>
  /** ID of the font face to use */
  fontFaceId: Scalars['ID']['output']
  /** Type of font face (template or custom) */
  fontFaceType?: Maybe<FontFaceType>
  /** Font size in points */
  fontSize: Scalars['Float']['output']
  /** Optional text fragments for advanced layout */
  fragments?: Maybe<Array<DesignTextFragment>>
  /** Horizontal alignment of text within the overlay */
  horizontalAlignment: DesignHorizontalAlignment
  /** List of variable keys that exist in the text for dynamic substitution */
  substitutions?: Maybe<Array<Scalars['String']['output']>>
  /** The text content to display */
  text: Scalars['String']['output']
  /** Vertical alignment of text within the overlay */
  verticalAlignment: DesignVerticalAlignment
}

/** Input for text overlay content when creating or updating overlays. */
export type DesignOverlayTextContentInput = {
  /**
   * Author of the customisation as determined by the client.
   *
   * Currently optional until client consistency is reached.
   */
  author?: InputMaybe<DesignTextAuthor>
  /** ID of the color to use for the text */
  colorId: Scalars['ID']['input']
  /** The text box is not intended to be moved, rotated, or resized by the user. */
  fixed?: InputMaybe<Scalars['Boolean']['input']>
  /** ID of the font face to use */
  fontFaceId: Scalars['ID']['input']
  /** Type of font face (template or custom) */
  fontFaceType?: InputMaybe<FontFaceType>
  /** Font size in points */
  fontSize: Scalars['Float']['input']
  /** Optional text fragments for advanced layout */
  fragments?: InputMaybe<Array<DesignTextFragmentInput>>
  /** Horizontal alignment of text within the overlay */
  horizontalAlignment: DesignHorizontalAlignment
  /** List of variable keys that exist in the text for dynamic substitution */
  substitutions?: InputMaybe<Array<Scalars['String']['input']>>
  /** The text content to display */
  text: Scalars['String']['input']
  /** Vertical alignment of text within the overlay */
  verticalAlignment: DesignVerticalAlignment
}

/** Input for creating or updating a text overlay element. */
export type DesignOverlayTextInput = {
  /** Content for the text overlay */
  content: DesignOverlayTextContentInput
  /** Height in millimeters */
  height: Scalars['Float']['input']
  /** Z-index for layering (higher values appear on top) */
  index: Scalars['Int']['input']
  /** Rotation angle in degrees (positive = clockwise) */
  rotation: Scalars['Float']['input']
  /** Width in millimeters */
  width: Scalars['Float']['input']
  /** Horizontal position in millimeters from the left edge */
  x: Scalars['Float']['input']
  /** Vertical position in millimeters from the top edge */
  y: Scalars['Float']['input']
}

/** Union of placeholder types shown in the editor. */
export type DesignPlaceholders =
  | PlaceholderPhoto
  | PlaceholderSticker
  | { __typename?: '%other' }

/** Placement rectangle defining position and size for design elements. */
export type DesignPlacement = {
  __typename: 'DesignPlacement'
  /** Height in millimeters */
  height: Scalars['Float']['output']
  /** Width in millimeters */
  width: Scalars['Float']['output']
  /** Horizontal position in millimeters */
  x: Scalars['Float']['output']
  /** Vertical position in millimeters */
  y: Scalars['Float']['output']
}

/** Container for all placement rectangles in a scene. */
export type DesignPlacements = {
  __typename: 'DesignPlacements'
  /** Placement area for handwriting elements */
  handwriting: DesignPlacement
  /** Placement area for media elements */
  media: DesignPlacement
}

/** Error returned when a requested product cannot be found. */
export type DesignProductNotFoundError = Error & {
  __typename: 'DesignProductNotFoundError'
  /** Error message indicating the product was not found */
  message: Scalars['String']['output']
}

/**
 * Rendering method for designs, mapped from the Template API.
 * These values are currently in use despite their legacy naming.
 */
export enum DesignRenderMethod {
  /** GDI rendering method from Template API */
  LEGACY_1 = 'LEGACY_1',
  /** WPF rendering method from Template API */
  LEGACY_2 = 'LEGACY_2',
}

/** Result type for the design query. */
export type DesignResult =
  | Design
  | DesignAuthorizationError
  | DesignNotFoundError
  | DesignServiceError
  | DesignTemplatesServiceError
  | { __typename?: '%other' }

/**
 * A scene represents one face or page of a design (e.g., front, inside left, inside right, back).
 * Contains a template with applied customisations.
 */
export type DesignScene = {
  __typename: 'DesignScene'
  /** Types of customisations available for this scene */
  availableCustomisations: Array<DesignCustomisationsType>
  /** All customisations applied to this scene */
  customisations: DesignCustomisations
  /** Group messages area configuration if available */
  groupMessages?: Maybe<DesignSceneGroupMessages>
  /** Handwriting area configuration if available */
  handwriting?: Maybe<DesignSceneHandwriting>
  /** Visible height of the scene in millimeters */
  height: Scalars['Float']['output']
  /** Unique identifier for the scene */
  id: Scalars['ID']['output']
  /** Image upload area configuration if available */
  imageUpload?: Maybe<DesignSceneImageUpload>
  /** Whether any customisations have been applied to this scene */
  isCustomised: Scalars['Boolean']['output']
  /** Original layout before any modifications (for flexible layouts) */
  layoutOriginal?: Maybe<DesignCustomisationsLayout>
  /** Placeholder elements shown in the editor */
  placeholders?: Maybe<Array<DesignPlaceholders>>
  /** Placement areas for different types of content */
  placements: DesignPlacements
  /** Template defining the structure of this scene */
  template: DesignTemplate
  /** Display title for the scene (e.g., 'Front', 'Inside Left') */
  title: Scalars['String']['output']
  /** Features that have been used in this scene */
  usedFeatures: Array<EditorFeature>
  /** Visible width of the scene in millimeters */
  width: Scalars['Float']['output']
}

/** Defines the area available for group messages in a scene. */
export type DesignSceneGroupMessages = {
  __typename: 'DesignSceneGroupMessages'
  /** Height of group messages area in millimeters */
  height: Scalars['Float']['output']
  /** Width of group messages area in millimeters */
  width: Scalars['Float']['output']
  /** Horizontal position in millimeters */
  x: Scalars['Float']['output']
  /** Vertical position in millimeters */
  y: Scalars['Float']['output']
}

/** Defines the area available for handwriting in a scene. */
export type DesignSceneHandwriting = {
  __typename: 'DesignSceneHandwriting'
  /** Height of handwriting area in millimeters */
  height: Scalars['Float']['output']
  /** Width of handwriting area in millimeters */
  width: Scalars['Float']['output']
  /** Horizontal position in millimeters */
  x: Scalars['Float']['output']
  /** Vertical position in millimeters */
  y: Scalars['Float']['output']
}

/** Defines the area available for scene-level image upload. */
export type DesignSceneImageUpload = {
  __typename: 'DesignSceneImageUpload'
  /** Height of image upload area in millimeters */
  height: Scalars['Float']['output']
  /** Width of image upload area in millimeters */
  width: Scalars['Float']['output']
  /** Horizontal position in millimeters */
  x: Scalars['Float']['output']
  /** Vertical position in millimeters */
  y: Scalars['Float']['output']
}

export type DesignSceneLayouts = {
  __typename: 'DesignSceneLayouts'
  grids: Array<DesignCollageGrid>
}

export type DesignSceneLayoutsResult =
  | DesignSceneLayouts
  | DesignServiceError
  | { __typename?: '%other' }

/** Generic error response from a request to the Design API. */
export type DesignServiceError = Error & {
  __typename: 'DesignServiceError'
  /** Error message describing what went wrong */
  message: Scalars['String']['output']
}

/** Error returned when setting an inlay fails. */
export type DesignSetInlayError = Error & {
  __typename: 'DesignSetInlayError'
  /** Error message explaining why setting the inlay failed */
  message: Scalars['String']['output']
}

/** Successful SmartText response. */
export type DesignSmartText = {
  __typename: 'DesignSmartText'
  /** Message generated by SmartText engine. */
  text: Scalars['String']['output']
}

/**
 * Smart text config includes information about whether or not the feature is enabled and
 * how many more requests the user can make for the day.
 */
export type DesignSmartTextConfig = {
  __typename: 'DesignSmartTextConfig'
  enabled: Scalars['Boolean']['output']
  /** Maximum length of the user prompt. */
  maxPromptLength: Scalars['Int']['output']
  /** Number of requests remaining at this time. */
  remainingRequests: Scalars['Int']['output']
}

export type DesignSmartTextConfigResult =
  | DesignServiceError
  | DesignSmartTextConfig
  | { __typename?: '%other' }

export type DesignSmartTextInput = {
  /** Customer provided prompt for the AI engine to use. */
  prompt: Scalars['String']['input']
}

/**
 * Error response returned when the prompt given exceeds the maximum length allowed.
 *
 * Maximum prompt length is defined in DesignSmartTextConfig.maxPromptLength.
 */
export type DesignSmartTextInputError = Error & {
  __typename: 'DesignSmartTextInputError'
  message: Scalars['String']['output']
}

/**
 * Error response returned when client makes too many requests. Requests are limited per user (auth token).
 *
 * Retries may be allowed but are likely to return the same error.
 *
 * Users are restricted to 25 requests in the space of 24 hours as a rolling period.
 */
export type DesignSmartTextLimitReachedError = Error & {
  __typename: 'DesignSmartTextLimitReachedError'
  message: Scalars['String']['output']
}

/**
 * Error response returned when the prompt given for the query fails moderation checking.
 *
 * Subsequent requests with the same prompt should not be made again.
 */
export type DesignSmartTextModerationError = Error & {
  __typename: 'DesignSmartTextModerationError'
  message: Scalars['String']['output']
}

/** SmartText response. */
export type DesignSmartTextResult =
  | DesignServiceError
  | DesignSmartText
  | DesignSmartTextInputError
  | DesignSmartTextLimitReachedError
  | DesignSmartTextModerationError
  | DesignSmartTextUnavailableError
  | { __typename?: '%other' }

/** This error is returned when the feature has been turned off through terraform variables. */
export type DesignSmartTextUnavailableError = Error & {
  __typename: 'DesignSmartTextUnavailableError'
  message: Scalars['String']['output']
}

/** Theme for stamp elements in the design. */
export enum DesignStampTheme {
  /** Dark theme for stamp on light backgrounds */
  DARK = 'DARK',
  /** Light theme for stamp on dark backgrounds */
  LIGHT = 'LIGHT',
}

/** Lifecycle state of a design. */
export enum DesignState {
  /** Design is being edited and not yet added to basket */
  DRAFT = 'DRAFT',
  /** Design has been added to the basket but not yet ordered */
  IN_BASKET = 'IN_BASKET',
  /** Design is part of a business project (e.g., Moonpig for Business, potentially Group Cards) */
  IN_PROJECT = 'IN_PROJECT',
  /** Design has been ordered and is being fulfilled */
  ORDERED = 'ORDERED',
}

/** Error returned when attempting an operation not allowed for the current design state. */
export type DesignStateError = Error & {
  __typename: 'DesignStateError'
  /** Error message explaining the state conflict */
  message: Scalars['String']['output']
}

export type DesignStickerAIConfig = {
  __typename: 'DesignStickerAIConfig'
  enabled: Scalars['Boolean']['output']
  maxPromptLength: Scalars['Int']['output']
  remainingRequests: Scalars['Int']['output']
}

export type DesignStickerAIConfigResult =
  | DesignServiceError
  | DesignStickerAIConfig
  | { __typename?: '%other' }

export type DesignStickerAIInputError = Error & {
  __typename: 'DesignStickerAIInputError'
  message: Scalars['String']['output']
}

export type DesignStickerAILimitReachedError = Error & {
  __typename: 'DesignStickerAILimitReachedError'
  message: Scalars['String']['output']
}

export type DesignStickerAIModerationError = Error & {
  __typename: 'DesignStickerAIModerationError'
  message: Scalars['String']['output']
}

export type DesignStickerAIUnavailableError = Error & {
  __typename: 'DesignStickerAIUnavailableError'
  message: Scalars['String']['output']
}

export type DesignStickerCopyrightError = Error & {
  __typename: 'DesignStickerCopyrightError'
  message: Scalars['String']['output']
}

/** Store region for the design. */
export enum DesignStore {
  /** Australia */
  AU = 'AU',
  /** Ireland */
  IE = 'IE',
  /** Netherlands */
  NL = 'NL',
  /** United Kingdom */
  UK = 'UK',
  /** United States */
  US = 'US',
}

/**
 * A design template defining the structure and elements of a scene.
 * Templates are snapshots taken from the Templates Service when a design is created.
 */
export type DesignTemplate = {
  __typename: 'DesignTemplate'
  /** List of elements in the template (images, text, shapes, etc.) */
  elements: Array<DesignElement>
  /** Unique identifier for the template */
  id: Scalars['ID']['output']
  /** Orientation of the template */
  orientation: DesignOrientation
  /** Rendering method for legacy templates */
  renderMethod?: Maybe<DesignRenderMethod>
}

/** Error returned when the Templates Service encounters an issue. */
export type DesignTemplatesServiceError = Error & {
  __typename: 'DesignTemplatesServiceError'
  /** Error message from the Templates Service */
  message: Scalars['String']['output']
}

/**
 * The author of the overlay text customisation.
 *
 * Clients will determine this and supply to setCustomisations mutations inputs.
 */
export enum DesignTextAuthor {
  /** Customer generated text, no editor tooling used. */
  CUSTOMER = 'CUSTOMER',
  /** Message generated by our new AI message feature without any modification. */
  SMART_TEXT = 'SMART_TEXT',
  /** Message generated by our new AI message but then modified by the customer. */
  SMART_TEXT_MODIFIED = 'SMART_TEXT_MODIFIED',
  /** Starter message used without any modification. */
  STARTER = 'STARTER',
  /** Starter message used but then modified by the customer. */
  STARTER_MODIFIED = 'STARTER_MODIFIED',
}

export type DesignTextEditable = {
  __typename: 'DesignTextEditable'
  allowBlankText: Scalars['Boolean']['output']
  allowDefaultText: Scalars['Boolean']['output']
  /** @deprecated Required for legacy only */
  customNum?: Maybe<Scalars['Int']['output']>
  defaultPreviewText?: Maybe<Scalars['String']['output']>
  defaultText: Scalars['String']['output']
  /** @deprecated Required for legacy only */
  editableNum?: Maybe<Scalars['Int']['output']>
  maxCharacters?: Maybe<Scalars['Int']['output']>
  textTransform?: Maybe<DesignTextTransform>
}

/**
 * A fragment of text with specific positioning and sizing within a text overlay.
 * Used for advanced text layout and positioning.
 */
export type DesignTextFragment = {
  __typename: 'DesignTextFragment'
  /** Font size in points for this fragment */
  fontSize: Scalars['Float']['output']
  /** The text content of this fragment */
  text: Scalars['String']['output']
  /** Horizontal position in millimeters */
  x: Scalars['Float']['output']
  /** Vertical position in millimeters */
  y: Scalars['Float']['output']
}

/** Input for a text fragment when creating or updating text overlays. */
export type DesignTextFragmentInput = {
  /** Font size in points for this fragment */
  fontSize: Scalars['Float']['input']
  /** The text content of this fragment */
  text: Scalars['String']['input']
  /** Horizontal position in millimeters */
  x: Scalars['Float']['input']
  /** Vertical position in millimeters */
  y: Scalars['Float']['input']
}

export type DesignTextPart =
  | DesignTextPartEditable
  | DesignTextPartStatic
  | { __typename?: '%other' }

export type DesignTextPartEditable = {
  __typename: 'DesignTextPartEditable'
  allowBlankText: Scalars['Boolean']['output']
  allowDefaultText: Scalars['Boolean']['output']
  /** @deprecated Required for legacy only */
  customNum?: Maybe<Scalars['Int']['output']>
  defaultText: Scalars['String']['output']
  /** @deprecated Required for legacy only */
  editableNum?: Maybe<Scalars['Int']['output']>
  maxCharacters?: Maybe<Scalars['Int']['output']>
  textTransform?: Maybe<DesignTextTransform>
}

export type DesignTextPartStatic = {
  __typename: 'DesignTextPartStatic'
  text: Scalars['String']['output']
}

/** Shadow effect applied to text elements. */
export type DesignTextShadow = {
  __typename: 'DesignTextShadow'
  /** Shadow color as a hex string (e.g., '#000000') */
  color: Scalars['String']['output']
  /** Horizontal offset of shadow in millimeters */
  offsetX: Scalars['Float']['output']
  /** Vertical offset of shadow in millimeters */
  offsetY: Scalars['Float']['output']
}

/** Text transformation options. */
export enum DesignTextTransform {
  /** Transform all text to uppercase */
  UPPERCASE = 'UPPERCASE',
}

/** Transform applied to an image including position, rotation, and scale. */
export type DesignTransform = {
  __typename: 'DesignTransform'
  /** Position offset from center */
  position: DesignTransformPosition
  /** Rotation angle in radians (positive = clockwise) */
  rotation: Scalars['Float']['output']
  /** Scale factor (1.0 = original size) */
  scale: Scalars['Float']['output']
}

/** Input for specifying image transforms. */
export type DesignTransformInput = {
  /** Position offset from center */
  position: DesignTransformPositionInput
  /** Rotation angle in radians (positive = clockwise) */
  rotation: Scalars['Float']['input']
  /** Scale factor (1.0 = original size) */
  scale: Scalars['Float']['input']
}

/** Position component of a transform in 2D space. */
export type DesignTransformPosition = {
  __typename: 'DesignTransformPosition'
  /** Horizontal position in millimeters */
  x: Scalars['Float']['output']
  /** Vertical position in millimeters */
  y: Scalars['Float']['output']
}

/** Input for position component when specifying transforms. */
export type DesignTransformPositionInput = {
  /** Horizontal position in millimeters */
  x: Scalars['Float']['input']
  /** Vertical position in millimeters */
  y: Scalars['Float']['input']
}

/**
 * Error returned when design validation fails.
 * Contains an array of specific validation errors.
 */
export type DesignValidationError = Error & {
  __typename: 'DesignValidationError'
  /** List of specific validation errors */
  errors: Array<DesignValidationErrorError>
  /** Overall validation error message */
  message: Scalars['String']['output']
}

/** Union of specific validation error types. */
export type DesignValidationErrorError =
  | DesignElementMissingRequiredError
  | { __typename?: '%other' }

/** Vertical alignment options for text. */
export enum DesignVerticalAlignment {
  /** Align text to the bottom edge */
  BOTTOM = 'BOTTOM',
  /** Center text vertically */
  MIDDLE = 'MIDDLE',
  /** Align text to the top edge */
  TOP = 'TOP',
}

/** Container for a list of designs. */
export type Designs = {
  __typename: 'Designs'
  /** List of design items */
  items: Array<Design>
}

/** Input for filtering designs when listing. */
export type DesignsFilterInput = {
  /** Maximum number of designs to return */
  limit?: InputMaybe<Scalars['Int']['input']>
  /** @deprecated No longer used */
  productKey?: InputMaybe<Scalars['String']['input']>
  /** @deprecated No longer used, will be assumed to be DRAFT */
  state?: InputMaybe<DesignState>
}

export type DesignsResult =
  | DesignServiceError
  | DesignTemplatesServiceError
  | Designs
  | { __typename?: '%other' }

export type DigitalFormat = {
  __typename: 'DigitalFormat'
  name: Scalars['String']['output']
}

export type DigitalRecipientStage = DeliveryStage & {
  __typename: 'DigitalRecipientStage'
  label: Scalars['String']['output']
  progress: DeliveryPipelineProgressState
  stageNumber: Scalars['Int']['output']
  timestamp?: Maybe<Scalars['Date']['output']>
}

export type Dimensions = {
  __typename: 'Dimensions'
  height: Scalars['Int']['output']
  width: Scalars['Int']['output']
}

export type DiscountedLineItemPrice = {
  __typename: 'DiscountedLineItemPrice'
  discountType?: Maybe<LineItemDiscountType>
  discounted: Money
  original: Money
}

export type DraftSuggestedReminder = {
  __typename: 'DraftSuggestedReminder'
  date: OccasionDate
  name: Scalars['String']['output']
  occasion: Occasion
  relationship?: Maybe<Relationship>
}

export type DuplicateLineItemInput = {
  id: Scalars['ID']['input']
  lineItemId: Scalars['ID']['input']
  /** @deprecated No longer required please remove */
  version?: InputMaybe<Scalars['Long']['input']>
}

export type DuplicateLineItemResult =
  | BasketNotFoundError
  | ConcurrentModificationError
  | LineItemDuplicateRestrictedError
  | LineItemDuplicatedBasketResult
  | LineItemNotFoundError
  | ProductNotFoundError
  | { __typename?: '%other' }

export type DuplicateRecipientError = Error & {
  __typename: 'DuplicateRecipientError'
  message: Scalars['String']['output']
  recipientId?: Maybe<Scalars['ID']['output']>
}

export type DynamicImage = {
  __typename: 'DynamicImage'
  title: Scalars['String']['output']
  url: Scalars['String']['output']
}

export type DynamicImageFormat = {
  __typename: 'DynamicImageFormat'
  jpeg: Array<DynamicImage>
  webp: Array<DynamicImage>
}

export type DynamicImagesResponse = {
  __typename: 'DynamicImagesResponse'
  intentKey: Scalars['String']['output']
  large: DynamicImageFormat
  medium: DynamicImageFormat
  original: DynamicImageFormat
  small: DynamicImageFormat
}

/** Union of all possible editor features. */
export type EditorFeature =
  | EditorFeatureAllCharacters
  | EditorFeatureAudio
  | EditorFeatureLayout
  | EditorFeatureOverlayAISticker
  | EditorFeatureOverlayImage
  | EditorFeatureOverlayImageMask
  | EditorFeatureOverlayInlay
  | EditorFeatureOverlaySticker
  | EditorFeatureOverlayText
  | EditorFeatureSceneGroupMessages
  | EditorFeatureSceneHandwriting
  | EditorFeatureSceneImageUpload
  | EditorFeatureTemplateBaseline
  | EditorFeatureTemplateImageCollage
  | EditorFeatureTemplateImageDynamic
  | EditorFeatureTemplateImageFaceSwap
  | EditorFeatureVideo
  | { __typename?: '%other' }

/** Feature indicating all character support is available. */
export type EditorFeatureAllCharacters = EditorFeatureCommon & {
  __typename: 'EditorFeatureAllCharacters'
  /** Whether all character support is required */
  required: Scalars['Boolean']['output']
  /** @deprecated No longer used */
  title: Scalars['String']['output']
}

/** Feature indicating audio overlays are available. */
export type EditorFeatureAudio = EditorFeatureCommon & {
  __typename: 'EditorFeatureAudio'
  /** Whether audio overlays are required */
  required: Scalars['Boolean']['output']
  /** @deprecated No longer used */
  title: Scalars['String']['output']
}

/**
 * Common properties for editor feature types.
 * Features indicate what customisation capabilities are available in the editor.
 */
export type EditorFeatureCommon = {
  /** Whether this feature is required to be used before the design can be completed */
  required: Scalars['Boolean']['output']
  /** @deprecated No longer used */
  title: Scalars['String']['output']
}

/** Feature indicating flexible layout customisation is available. */
export type EditorFeatureLayout = EditorFeatureCommon & {
  __typename: 'EditorFeatureLayout'
  /** Whether layout customisation is required */
  required: Scalars['Boolean']['output']
  /** @deprecated No longer used */
  title: Scalars['String']['output']
}

/** Feature indicating AI sticker overlays are available. */
export type EditorFeatureOverlayAISticker = EditorFeatureCommon & {
  __typename: 'EditorFeatureOverlayAISticker'
  /** Whether AI sticker overlays are required */
  required: Scalars['Boolean']['output']
  /** @deprecated No longer used */
  title: Scalars['String']['output']
}

/** Feature indicating image overlays are available. */
export type EditorFeatureOverlayImage = EditorFeatureCommon & {
  __typename: 'EditorFeatureOverlayImage'
  /** Whether image overlays are required */
  required: Scalars['Boolean']['output']
  /** @deprecated No longer used */
  title: Scalars['String']['output']
}

/** Feature indicating image masks for overlays are available. */
export type EditorFeatureOverlayImageMask = EditorFeatureCommon & {
  __typename: 'EditorFeatureOverlayImageMask'
  /** Whether image masks are required */
  required: Scalars['Boolean']['output']
  /** @deprecated No longer used */
  title: Scalars['String']['output']
}

/** Feature indicating inlay overlays are available. */
export type EditorFeatureOverlayInlay = EditorFeatureCommon & {
  __typename: 'EditorFeatureOverlayInlay'
  /** Whether inlay overlays are required */
  required: Scalars['Boolean']['output']
  /** @deprecated No longer used */
  title: Scalars['String']['output']
}

/** Feature indicating sticker overlays are available. */
export type EditorFeatureOverlaySticker = EditorFeatureCommon & {
  __typename: 'EditorFeatureOverlaySticker'
  /** Whether sticker overlays are required */
  required: Scalars['Boolean']['output']
  /** @deprecated No longer used */
  title: Scalars['String']['output']
}

/** Feature indicating text overlays are available. */
export type EditorFeatureOverlayText = EditorFeatureCommon & {
  __typename: 'EditorFeatureOverlayText'
  /** Whether text overlays are required */
  required: Scalars['Boolean']['output']
  /** @deprecated No longer used */
  title: Scalars['String']['output']
}

/** Feature indicating group messages are available for this scene. */
export type EditorFeatureSceneGroupMessages = EditorFeatureCommon & {
  __typename: 'EditorFeatureSceneGroupMessages'
  /** Whether group messages are required */
  required: Scalars['Boolean']['output']
  /** @deprecated No longer used */
  title: Scalars['String']['output']
}

/** Feature indicating handwriting is available for this scene. */
export type EditorFeatureSceneHandwriting = EditorFeatureCommon & {
  __typename: 'EditorFeatureSceneHandwriting'
  /** Whether handwriting is required */
  required: Scalars['Boolean']['output']
  /** @deprecated No longer used */
  title: Scalars['String']['output']
}

/** Feature indicating scene-level image upload is available. */
export type EditorFeatureSceneImageUpload = EditorFeatureCommon & {
  __typename: 'EditorFeatureSceneImageUpload'
  /** Whether image upload is required */
  required: Scalars['Boolean']['output']
  /** @deprecated No longer used */
  title: Scalars['String']['output']
}

/** Feature indicating baseline template customisation is available. */
export type EditorFeatureTemplateBaseline = EditorFeatureCommon & {
  __typename: 'EditorFeatureTemplateBaseline'
  /** Whether template customisation is required */
  required: Scalars['Boolean']['output']
  /** @deprecated No longer used */
  title: Scalars['String']['output']
}

/** Feature indicating image collage elements are available. */
export type EditorFeatureTemplateImageCollage = EditorFeatureCommon & {
  __typename: 'EditorFeatureTemplateImageCollage'
  /** Whether image collages are required */
  required: Scalars['Boolean']['output']
  /** @deprecated No longer used */
  title: Scalars['String']['output']
}

/** Feature indicating dynamic image elements are available. */
export type EditorFeatureTemplateImageDynamic = EditorFeatureCommon & {
  __typename: 'EditorFeatureTemplateImageDynamic'
  /** Whether dynamic images are required */
  required: Scalars['Boolean']['output']
  /** @deprecated No longer used */
  title: Scalars['String']['output']
}

/** Feature indicating face swap functionality is available. */
export type EditorFeatureTemplateImageFaceSwap = EditorFeatureCommon & {
  __typename: 'EditorFeatureTemplateImageFaceSwap'
  /** Whether face swap is required */
  required: Scalars['Boolean']['output']
  /** @deprecated No longer used */
  title: Scalars['String']['output']
}

/** Feature indicating video overlays are available. */
export type EditorFeatureVideo = EditorFeatureCommon & {
  __typename: 'EditorFeatureVideo'
  /** Whether video overlays are required */
  required: Scalars['Boolean']['output']
  /** @deprecated No longer used */
  title: Scalars['String']['output']
}

export type EmailAddress = {
  __typename: 'EmailAddress'
  email: Scalars['String']['output']
  name: Scalars['String']['output']
}

/** Base error interface for all error types in the schema. */
export type Error = {
  /** Human-readable error message describing what went wrong */
  message: Scalars['String']['output']
}

export type Errors = {
  messages: Array<Scalars['String']['output']>
}

export type ExpireCreditsInput = {
  authCode: Scalars['String']['input']
  creditId: Scalars['String']['input']
}

export type ExpireCreditsResult = {
  __typename: 'ExpireCreditsResult'
  accounts?: Maybe<Array<Maybe<CreditAccount>>>
  message?: Maybe<Scalars['String']['output']>
  success: Scalars['Boolean']['output']
}

export type ExplorationTileList = CategoryListRecommendation & {
  __typename: 'ExplorationTileList'
  description?: Maybe<Scalars['String']['output']>
  items?: Maybe<Array<Maybe<ExplorationTiles>>>
  name: Scalars['String']['output']
}

export type ExplorationTiles = {
  __typename: 'ExplorationTiles'
  altText: Scalars['String']['output']
  id: Scalars['String']['output']
  image: ContentImage
  link: Scalars['String']['output']
  title: Scalars['String']['output']
}

export type FaceswapConfig = {
  __typename: 'FaceswapConfig'
  maxSizeBytes: Scalars['Int']['output']
  minSizeBytes: Scalars['Int']['output']
  pollingIntervalMs: Scalars['Int']['output']
  pollingTimeoutMs: Scalars['Int']['output']
}

export type Facet = {
  __typename: 'Facet'
  children?: Maybe<Array<Facet>>
  count: Scalars['Int']['output']
  facetKey?: Maybe<Scalars['String']['output']>
  id: Scalars['String']['output']
  label?: Maybe<Scalars['String']['output']>
  /** @deprecated Use 'group' instead. */
  name: Scalars['String']['output']
  nbaScore?: Maybe<Scalars['Float']['output']>
  /** @deprecated No longer supported */
  path?: Maybe<Scalars['String']['output']>
  /** @deprecated Use 'facetKey' instead as it is language agnostic */
  value: Scalars['String']['output']
}

export type FacetGroup = {
  __typename: 'FacetGroup'
  department: DepartmentsEnum
  group: Scalars['String']['output']
}

export type FacetInput = {
  facetKey?: InputMaybe<Scalars['String']['input']>
  group?: InputMaybe<Scalars['String']['input']>
  name?: InputMaybe<Scalars['String']['input']>
  path?: InputMaybe<Scalars['String']['input']>
  value?: InputMaybe<Scalars['String']['input']>
}

export type FacetKeyWithMetadata = {
  facetKey: Scalars['String']['input']
  source: FilterSource
}

export type Facets = {
  __typename: 'Facets'
  all?: Maybe<Array<Maybe<Facet>>>
  hierarchical?: Maybe<Array<Maybe<Facet>>>
  /** @deprecated Use 'all' collection instead. */
  occasion?: Maybe<Array<Maybe<Facet>>>
  /** @deprecated Use 'all' collection instead. */
  recipient?: Maybe<Array<Maybe<Facet>>>
}

export type Favourites = {
  __typename: 'Favourites'
  list: FavouritesList
}

export type FavouriteslistArgs = {
  listId?: Scalars['ID']['input']
}

export type FavouritesList = {
  __typename: 'FavouritesList'
  id: Scalars['ID']['output']
  name: Scalars['String']['output']
  products: Array<Maybe<Product>>
}

export type FetchStickerAITaskFailed = {
  __typename: 'FetchStickerAITaskFailed'
  message: Scalars['String']['output']
  taskId: Scalars['String']['output']
}

export type FetchStickerAITaskInput = {
  taskId: Scalars['String']['input']
}

export type FetchStickerAITaskItem = {
  __typename: 'FetchStickerAITaskItem'
  aiStickerId: Scalars['String']['output']
  url: Scalars['String']['output']
}

export type FetchStickerAITaskNotFound = Error & {
  __typename: 'FetchStickerAITaskNotFound'
  message: Scalars['String']['output']
}

export type FetchStickerAITaskPending = {
  __typename: 'FetchStickerAITaskPending'
  message: Scalars['String']['output']
  taskId: Scalars['String']['output']
}

export type FetchStickerAITaskResult =
  | DesignServiceError
  | FetchStickerAITaskFailed
  | FetchStickerAITaskNotFound
  | FetchStickerAITaskPending
  | FetchStickerAITaskSuccess
  | { __typename?: '%other' }

export type FetchStickerAITaskSuccess = {
  __typename: 'FetchStickerAITaskSuccess'
  items: Array<FetchStickerAITaskItem>
  softError?: Maybe<Scalars['String']['output']>
  taskId: Scalars['String']['output']
}

export type FilterFacet = {
  __typename: 'FilterFacet'
  all?: Maybe<Scalars['Boolean']['output']>
  children?: Maybe<Array<FilterItem>>
  count: Scalars['Int']['output']
  facetKey: Scalars['String']['output']
  group: Scalars['String']['output']
  hasSelectedChildren: Scalars['Boolean']['output']
  icon?: Maybe<Scalars['String']['output']>
  id: Scalars['String']['output']
  isAutoApplied?: Maybe<Scalars['Boolean']['output']>
  isQuickFilter?: Maybe<Scalars['Boolean']['output']>
  isSelected: Scalars['Boolean']['output']
  isUserSelected: Scalars['Boolean']['output']
  label: Scalars['String']['output']
  /** @deprecated Unused field */
  layoutKey?: Maybe<Scalars['String']['output']>
  /** @deprecated Use label instead */
  name: Scalars['String']['output']
  nbaScore?: Maybe<Scalars['Float']['output']>
  parentKey: Scalars['String']['output']
  /** @deprecated Use facetKey instead */
  path?: Maybe<Scalars['String']['output']>
  /** @deprecated Unused field */
  promoted?: Maybe<Scalars['Boolean']['output']>
  /** @deprecated Unused field */
  sorting?: Maybe<FilterSorting>
  /** @deprecated Use facetKey instead */
  value: Scalars['String']['output']
}

export type FilterHeader = {
  __typename: 'FilterHeader'
  name: Scalars['String']['output']
}

export type FilterItem =
  | FilterFacet
  | FilterHeader
  | IntegerFilter
  | InvertedToggleFilter
  | ToggleFilter
  | { __typename?: '%other' }

export type FilterResults = {
  __typename: 'FilterResults'
  count: Scalars['Int']['output']
  facets?: Maybe<Array<Maybe<FilterFacet>>>
  facetsWithNoResults?: Maybe<Array<Maybe<ApplicableFilter>>>
  facetsWithToggles?: Maybe<Array<Maybe<ApplicableFilter>>>
  quickFilterKeys?: Maybe<Array<Scalars['String']['output']>>
}

export enum FilterSorting {
  ALPHABETICAL = 'ALPHABETICAL',
  COUNT = 'COUNT',
  GROUP = 'GROUP',
  NONE = 'NONE',
}

export enum FilterSource {
  FILTER = 'FILTER',
  SUGGESTION = 'SUGGESTION',
}

export type FixedQuantity = {
  __typename: 'FixedQuantity'
  required: Scalars['Int']['output']
}

export type Font = {
  __typename: 'Font'
  id: Scalars['ID']['output']
  metrics: DesignFontFaceMetrics
  name: Scalars['String']['output']
  urls: FontUrls
}

export type FontEdge = {
  __typename: 'FontEdge'
  cursor: Scalars['ID']['output']
  node: Font
}

export type FontEdges = {
  __typename: 'FontEdges'
  edges: Array<FontEdge>
  pageInfo: DesignCustomisationPageInfo
  totalCount: Scalars['Int']['output']
}

/** Type of font face being used in the design. */
export enum FontFaceType {
  /** Custom font uploaded by the customer via Customer Creations */
  CUSTOMER_CREATIONS = 'CUSTOMER_CREATIONS',
  /** Font provided by the template */
  TEMPLATE = 'TEMPLATE',
}

export type FontUrls = {
  __typename: 'FontUrls'
  ttf: Scalars['String']['output']
  woff: Scalars['String']['output']
  woff2: Scalars['String']['output']
}

/** Input for filtering fonts by set IDs. */
export type FontsFilterInput = {
  /** List of font set IDs to filter by */
  fontSetIds: Array<Scalars['ID']['input']>
}

export type FontsResult =
  | DesignInvalidCursorError
  | DesignServiceError
  | FontEdges
  | { __typename?: '%other' }

export type ForgottenPasswordInput = {
  email: Scalars['String']['input']
  region?: InputMaybe<Region>
}

export type ForgottenPasswordInvalidEmail = Error & {
  __typename: 'ForgottenPasswordInvalidEmail'
  message: Scalars['String']['output']
}

export type ForgottenPasswordInvalidStore = Error & {
  __typename: 'ForgottenPasswordInvalidStore'
  message: Scalars['String']['output']
}

export type ForgottenPasswordResult =
  | ForgottenPasswordInvalidEmail
  | ForgottenPasswordInvalidStore
  | ForgottenPasswordSent
  | { __typename?: '%other' }

export type ForgottenPasswordSent = {
  __typename: 'ForgottenPasswordSent'
  message: Scalars['String']['output']
}

export type ForwardPage = {
  cursor?: InputMaybe<Scalars['String']['input']>
  first: Scalars['Int']['input']
}

export type FulfilmentCentre = {
  __typename: 'FulfilmentCentre'
  countryCode?: Maybe<Scalars['String']['output']>
  id: Scalars['String']['output']
}

export type GenerateTrackingLinkFailed = Error & {
  __typename: 'GenerateTrackingLinkFailed'
  message: Scalars['String']['output']
}

export type GenerateTrackingLinkInput = {
  deliveryId: Scalars['String']['input']
  orderId: Scalars['ID']['input']
}

export type GenerateTrackingLinkResponse =
  | GenerateTrackingLinkFailed
  | GenerateTrackingLinkSuccess
  | { __typename?: '%other' }

export type GenerateTrackingLinkSuccess = {
  __typename: 'GenerateTrackingLinkSuccess'
  trackingLink: Scalars['String']['output']
}

/**
 * Input for the getOrCreateDraftDesign mutation.
 * Gets an existing draft design or creates a new one if none exists.
 */
export type GetOrCreateDraftDesignInput = {
  /** @deprecated No longer used */
  allowAllCharacters?: InputMaybe<Scalars['Boolean']['input']>
  /**
   * A set of flags to determine what the client can support.
   * Should be used in conjunction with feature flags on each client.
   */
  capabilities?: InputMaybe<Array<DesignCapability>>
  /** Whether to use flexible layout system */
  preferFlexibleLayout?: InputMaybe<Scalars['Boolean']['input']>
  /**
   * Should use overlay text on this design when creating a new design.
   * If an existing design is found, the overlay preference is not changed, i.e. if it is false, it will remain false.
   * By using overlay text, templated text elements on the inside scenes of a card will be removed.
   */
  preferOverlayText?: InputMaybe<Scalars['Boolean']['input']>
  /**
   * Similar to `preferOverlayText` but enables overlay elements on the front of the card, removing any existing text elements.
   * There are only a select number of cards which support this. Enabling this for cards which do not support flexible content on the front will have no effect.
   */
  preferOverlayTextFront?: InputMaybe<Scalars['Boolean']['input']>
  /** Product key to get or create a design for */
  productKey: Scalars['String']['input']
  /** SKU for the specific variant/size (optional) */
  sku?: InputMaybe<Scalars['String']['input']>
  /** @deprecated No longer used */
  variantKey?: InputMaybe<Scalars['String']['input']>
  /** @deprecated No longer used */
  videoCardId?: InputMaybe<Scalars['String']['input']>
}

export type GetOrCreateDraftDesignResult =
  | Design
  | DesignServiceError
  | DesignTemplatesServiceError
  | ProductNotPersonalisableError
  | { __typename?: '%other' }

export type GetReminderInput = {
  id: Scalars['String']['input']
  store?: InputMaybe<Store>
}

export type GetReminderResult =
  | Reminder
  | ReminderNotFound
  | { __typename?: '%other' }

export type GetRemindersInput = {
  endDate?: InputMaybe<Scalars['String']['input']>
  startDate?: InputMaybe<Scalars['String']['input']>
  store?: InputMaybe<Store>
  take?: InputMaybe<Scalars['Int']['input']>
}

export type GroupAddMessageResult =
  | GroupCardAuthenticationError
  | GroupCardInputInvalidError
  | GroupCardMessage
  | GroupCardMessagesLimitReachedError
  | GroupCardServiceError
  | { __typename?: '%other' }

export type GroupAddMessageResultV2 =
  | GroupCardAuthenticatedMessageV2
  | GroupCardAuthenticationError
  | GroupCardInputInvalidError
  | GroupCardMessageV2
  | GroupCardMessagesExceedCapacityError
  | GroupCardMessagesLimitReachedError
  | GroupCardServiceError
  | GroupCardUnavailableError
  | { __typename?: '%other' }

export type GroupCardAddMessageInput = {
  addMessageToken: Scalars['String']['input']
  authorName: Scalars['String']['input']
  message: Scalars['String']['input']
}

export type GroupCardAddMessageInputV2 = {
  addMessageToken: Scalars['String']['input']
  authorName: Scalars['String']['input']
  /** @deprecated Use font field instead */
  colorId?: InputMaybe<Scalars['Int']['input']>
  font?: InputMaybe<GroupCardFontInput>
  /** @deprecated Use font field instead */
  fontFaceId?: InputMaybe<Scalars['Int']['input']>
  message: Scalars['String']['input']
}

export type GroupCardArchiveProjectInput = {
  projectId: Scalars['ID']['input']
}

export type GroupCardArchiveProjectResult =
  | GroupCardNotFoundError
  | GroupCardServiceError
  | GroupCardSuccess
  | { __typename?: '%other' }

export type GroupCardAuthenticatedMessageV2 = {
  __typename: 'GroupCardAuthenticatedMessageV2'
  authorName: Scalars['String']['output']
  colorId: Scalars['Int']['output']
  font: GroupCardFont
  fontFaceId: Scalars['Int']['output']
  message: Scalars['String']['output']
  messageId: Scalars['ID']['output']
  productId: Scalars['String']['output']
  projectId: Scalars['ID']['output']
  scenes: Array<GroupCardsScene>
}

export type GroupCardAuthenticatedMessageV2scenesArgs = {
  pages: Scalars['Int']['input']
}

export type GroupCardAuthenticationError = GroupCardError & {
  __typename: 'GroupCardAuthenticationError'
  message: Scalars['String']['output']
}

export type GroupCardConfig = {
  __typename: 'GroupCardConfig'
  authorNameCharacterLimit: Scalars['Int']['output']
  messageCharacterLimit: Scalars['Int']['output']
  projectMessageLimit: Scalars['Int']['output']
  projectNameCharacterLimit: Scalars['Int']['output']
  projectsLimit: Scalars['Int']['output']
}

export type GroupCardConfigV2 = {
  __typename: 'GroupCardConfigV2'
  authorNameCharacterLimit: Scalars['Int']['output']
  messageCharacterLimit: Scalars['Int']['output']
  projectMessageLimit: Scalars['Int']['output']
}

export type GroupCardCreateDesignInput = {
  projectId: Scalars['ID']['input']
}

export type GroupCardCreateDesignResult =
  | GroupCardNotFoundError
  | GroupCardServiceError
  | GroupCardSuccess
  | { __typename?: '%other' }

export type GroupCardCreateProjectInput = {
  deadlineTime?: InputMaybe<Scalars['String']['input']>
  occasion?: InputMaybe<Occasion>
  productId?: InputMaybe<Scalars['String']['input']>
  productVariantSku?: InputMaybe<Scalars['String']['input']>
  projectName: Scalars['String']['input']
  recipient?: InputMaybe<Scalars['String']['input']>
}

export type GroupCardCreateProjectInputV2 = {
  deadlineTime?: InputMaybe<Scalars['String']['input']>
  occasion?: InputMaybe<Occasion>
  productId: Scalars['String']['input']
  productVariantSku: Scalars['String']['input']
  projectName: Scalars['String']['input']
  recipient: Scalars['String']['input']
}

export type GroupCardCreateProjectResult =
  | GroupCardInputInvalidError
  | GroupCardProject
  | GroupCardProjectsLimitReachedError
  | GroupCardServiceError
  | { __typename?: '%other' }

export type GroupCardCreateProjectResultV2 =
  | GroupCardInputInvalidError
  | GroupCardProjectV2
  | GroupCardServiceError
  | { __typename?: '%other' }

export type GroupCardDeleteMessageInput = {
  messageId: Scalars['ID']['input']
  projectId: Scalars['ID']['input']
}

export type GroupCardDeleteProjectInput = {
  projectId: Scalars['ID']['input']
}

export type GroupCardDeleteProjectResult =
  | GroupCardServiceError
  | GroupCardSuccess
  | { __typename?: '%other' }

export type GroupCardError = {
  message: Scalars['String']['output']
}

export type GroupCardFont = {
  __typename: 'GroupCardFont'
  colorId: Scalars['String']['output']
  fontFaceId: Scalars['String']['output']
}

export type GroupCardFontInput = {
  colorId: Scalars['String']['input']
  fontFaceId: Scalars['String']['input']
}

export type GroupCardInputInvalidError = GroupCardError & {
  __typename: 'GroupCardInputInvalidError'
  message: Scalars['String']['output']
}

export type GroupCardMessage = {
  __typename: 'GroupCardMessage'
  authorName: Scalars['String']['output']
  message: Scalars['String']['output']
  messageId: Scalars['ID']['output']
}

export type GroupCardMessageV2 = {
  __typename: 'GroupCardMessageV2'
  authorName: Scalars['String']['output']
  colorId: Scalars['Int']['output']
  font: GroupCardFont
  fontFaceId: Scalars['Int']['output']
  isOwner: Scalars['Boolean']['output']
  message: Scalars['String']['output']
  messageId: Scalars['ID']['output']
}

export type GroupCardMessagesExceedCapacityError = GroupCardError & {
  __typename: 'GroupCardMessagesExceedCapacityError'
  message: Scalars['String']['output']
}

export type GroupCardMessagesLimitReachedError = GroupCardError & {
  __typename: 'GroupCardMessagesLimitReachedError'
  message: Scalars['String']['output']
}

export type GroupCardNotFoundError = GroupCardError & {
  __typename: 'GroupCardNotFoundError'
  message: Scalars['String']['output']
}

export type GroupCardOccasion = {
  __typename: 'GroupCardOccasion'
  occasion: Occasion
}

export type GroupCardOccasions = {
  __typename: 'GroupCardOccasions'
  occasions: Array<GroupCardOccasion>
}

export type GroupCardOccasionsResult =
  | GroupCardOccasions
  | GroupCardServiceError
  | { __typename?: '%other' }

export type GroupCardProject = {
  __typename: 'GroupCardProject'
  addMessageToken: Scalars['String']['output']
  addMessageUrl: Scalars['String']['output']
  createdTime: Scalars['String']['output']
  deadlineTime?: Maybe<Scalars['String']['output']>
  imageUrl: Scalars['String']['output']
  messages: Array<GroupCardMessage>
  occasion?: Maybe<Occasion>
  productId?: Maybe<Scalars['String']['output']>
  productVariantSku?: Maybe<Scalars['String']['output']>
  projectId: Scalars['ID']['output']
  projectName: Scalars['String']['output']
  recipient?: Maybe<Scalars['String']['output']>
}

export type GroupCardProjectimageUrlArgs = {
  heightPx: Scalars['Int']['input']
  textColor?: InputMaybe<Scalars['String']['input']>
  widthPx: Scalars['Int']['input']
}

export type GroupCardProjectArchivedState = {
  __typename: 'GroupCardProjectArchivedState'
  projectId: Scalars['ID']['output']
}

export type GroupCardProjectClosedState = {
  __typename: 'GroupCardProjectClosedState'
  message: Scalars['String']['output']
}

export type GroupCardProjectClosedStateV2 = {
  __typename: 'GroupCardProjectClosedStateV2'
  message: Scalars['String']['output']
}

export type GroupCardProjectFullState = {
  __typename: 'GroupCardProjectFullState'
  projectName: Scalars['String']['output']
}

export type GroupCardProjectFullStateV2 = {
  __typename: 'GroupCardProjectFullStateV2'
  projectName: Scalars['String']['output']
}

export type GroupCardProjectOpenAuthenticatedState = {
  __typename: 'GroupCardProjectOpenAuthenticatedState'
  imageUrl: Scalars['String']['output']
  productId?: Maybe<Scalars['String']['output']>
  productVariantSku?: Maybe<Scalars['String']['output']>
  projectId: Scalars['ID']['output']
  projectName: Scalars['String']['output']
}

export type GroupCardProjectOpenAuthenticatedStateimageUrlArgs = {
  heightPx: Scalars['Int']['input']
  textColor?: InputMaybe<Scalars['String']['input']>
  widthPx: Scalars['Int']['input']
}

export type GroupCardProjectOpenAuthenticatedStateV2 = {
  __typename: 'GroupCardProjectOpenAuthenticatedStateV2'
  deadlineTime?: Maybe<Scalars['String']['output']>
  isOwner: Scalars['Boolean']['output']
  myMessage?: Maybe<GroupCardMessageV2>
  occasion?: Maybe<Occasion>
  productId: Scalars['String']['output']
  productVariantSku: Scalars['String']['output']
  projectId: Scalars['ID']['output']
  projectName: Scalars['String']['output']
  recipient: Scalars['String']['output']
  scenes: Array<GroupCardsScene>
}

export type GroupCardProjectOpenAuthenticatedStateV2scenesArgs = {
  pages: Scalars['Int']['input']
}

export type GroupCardProjectOpenState = {
  __typename: 'GroupCardProjectOpenState'
  productId?: Maybe<Scalars['String']['output']>
  productVariantSku?: Maybe<Scalars['String']['output']>
  projectName: Scalars['String']['output']
}

export type GroupCardProjectOpenStateV2 = {
  __typename: 'GroupCardProjectOpenStateV2'
  deadlineTime?: Maybe<Scalars['String']['output']>
  myMessage?: Maybe<GroupCardMessageV2>
  occasion?: Maybe<Occasion>
  productId: Scalars['String']['output']
  productVariantSku: Scalars['String']['output']
  projectId: Scalars['ID']['output']
  projectName: Scalars['String']['output']
  recipient: Scalars['String']['output']
}

export type GroupCardProjectResult =
  | GroupCardNotFoundError
  | GroupCardProject
  | GroupCardServiceError
  | { __typename?: '%other' }

export type GroupCardProjectResultV2 =
  | GroupCardNotFoundError
  | GroupCardProjectV2
  | GroupCardServiceError
  | { __typename?: '%other' }

export type GroupCardProjectV2 = {
  __typename: 'GroupCardProjectV2'
  addMessageToken: Scalars['String']['output']
  addMessageUrl: Scalars['String']['output']
  createdTime: Scalars['String']['output']
  deadlineTime?: Maybe<Scalars['String']['output']>
  designId?: Maybe<Scalars['String']['output']>
  messageCount: Scalars['Int']['output']
  messages: Array<GroupCardMessageV2>
  occasion?: Maybe<Occasion>
  productId: Scalars['String']['output']
  productVariantSku: Scalars['String']['output']
  projectId: Scalars['ID']['output']
  projectName: Scalars['String']['output']
  recipient: Scalars['String']['output']
  scenes: Array<GroupCardsScene>
}

export type GroupCardProjectV2scenesArgs = {
  pages: Scalars['Int']['input']
}

export type GroupCardProjects = {
  __typename: 'GroupCardProjects'
  projects: Array<GroupCardProject>
}

export type GroupCardProjectsLimitReachedError = GroupCardError & {
  __typename: 'GroupCardProjectsLimitReachedError'
  message: Scalars['String']['output']
}

export type GroupCardProjectsResult =
  | GroupCardProjects
  | GroupCardServiceError
  | { __typename?: '%other' }

export type GroupCardProjectsResultV2 =
  | GroupCardProjectsV2
  | GroupCardServiceError
  | { __typename?: '%other' }

export type GroupCardProjectsV2 = {
  __typename: 'GroupCardProjectsV2'
  projects: Array<GroupCardProjectV2>
}

export type GroupCardServiceError = GroupCardError & {
  __typename: 'GroupCardServiceError'
  message: Scalars['String']['output']
}

export type GroupCardSuccess = {
  __typename: 'GroupCardSuccess'
  id: Scalars['ID']['output']
}

export type GroupCardTrackCheckoutInput = {
  projectId: Scalars['ID']['input']
}

export type GroupCardTrackCheckoutResult =
  | GroupCardNotFoundError
  | GroupCardServiceError
  | GroupCardSuccess
  | { __typename?: '%other' }

export type GroupCardTrackSignupEventResult =
  | GroupCardServiceError
  | GroupCardSuccess
  | { __typename?: '%other' }

export type GroupCardUnavailableError = GroupCardError & {
  __typename: 'GroupCardUnavailableError'
  message: Scalars['String']['output']
}

export type GroupCardUpdateProjectInput = {
  deadlineTime?: InputMaybe<Scalars['String']['input']>
  occasion?: InputMaybe<Occasion>
  productId?: InputMaybe<Scalars['String']['input']>
  productVariantSku?: InputMaybe<Scalars['String']['input']>
  projectId: Scalars['ID']['input']
  projectName: Scalars['String']['input']
  recipient?: InputMaybe<Scalars['String']['input']>
}

export type GroupCardUpdateProjectInputV2 = {
  deadlineTime?: InputMaybe<Scalars['String']['input']>
  occasion?: InputMaybe<Occasion>
  productId: Scalars['String']['input']
  productVariantSku: Scalars['String']['input']
  projectId: Scalars['ID']['input']
  projectName: Scalars['String']['input']
  recipient: Scalars['String']['input']
}

export type GroupCardUpdateProjectResult =
  | GroupCardInputInvalidError
  | GroupCardNotFoundError
  | GroupCardServiceError
  | GroupCardUpdatedProject
  | { __typename?: '%other' }

export type GroupCardUpdateProjectResultV2 =
  | GroupCardInputInvalidError
  | GroupCardNotFoundError
  | GroupCardProjectV2
  | GroupCardServiceError
  | GroupCardUnavailableError
  | { __typename?: '%other' }

export type GroupCardUpdateProjectWithDesignInput = {
  designId: Scalars['String']['input']
  projectId: Scalars['ID']['input']
}

export type GroupCardUpdateProjectWithDesignResult =
  | GroupCardServiceError
  | GroupCardSuccess
  | { __typename?: '%other' }

export type GroupCardUpdatedProject = {
  __typename: 'GroupCardUpdatedProject'
  addMessageToken: Scalars['String']['output']
  createdTime: Scalars['String']['output']
  deadlineTime?: Maybe<Scalars['String']['output']>
  occasion?: Maybe<Occasion>
  productId?: Maybe<Scalars['String']['output']>
  productVariantSku?: Maybe<Scalars['String']['output']>
  projectId: Scalars['ID']['output']
  projectName: Scalars['String']['output']
  recipient?: Maybe<Scalars['String']['output']>
}

export type GroupCardsScene = {
  __typename: 'GroupCardsScene'
  height: Scalars['Float']['output']
  page: Scalars['Int']['output']
  sceneObjects: Array<GroupCardsSceneObject>
  width: Scalars['Float']['output']
}

export type GroupCardsSceneObject =
  | GroupCardsSceneText
  | { __typename?: '%other' }

export type GroupCardsSceneText = {
  __typename: 'GroupCardsSceneText'
  colorId: Scalars['Int']['output']
  fixedFontSize: Scalars['Float']['output']
  font: GroupCardFont
  fontFaceId: Scalars['Int']['output']
  height: Scalars['Float']['output']
  isOwner: Scalars['Boolean']['output']
  lineHeight: Scalars['Float']['output']
  size: Scalars['Float']['output']
  text: Scalars['String']['output']
  width: Scalars['Float']['output']
  x: Scalars['Float']['output']
  y: Scalars['Float']['output']
}

export type GroupDeleteMessageResult =
  | GroupCardAuthenticationError
  | GroupCardServiceError
  | GroupCardSuccess
  | { __typename?: '%other' }

export type GroupDeleteMessageResultV2 =
  | GroupCardAuthenticationError
  | GroupCardNotFoundError
  | GroupCardServiceError
  | GroupCardSuccess
  | { __typename?: '%other' }

export type GroupedFacetInput = {
  group: Scalars['String']['input']
  keys: Array<Scalars['String']['input']>
  keysWithMetadata?: InputMaybe<Array<FacetKeyWithMetadata>>
  userApplied?: InputMaybe<Scalars['Boolean']['input']>
}

export type HeaderLogo = {
  __typename: 'HeaderLogo'
  icon?: Maybe<ContentImage>
}

export type IdentityDetails = {
  __typename: 'IdentityDetails'
  oidc?: Maybe<Array<OidcProvider>>
  password: Scalars['Boolean']['output']
  state?: Maybe<Scalars['String']['output']>
}

export type Image = {
  __typename: 'Image'
  /** @deprecated Please do not use this field. It will be removed in the coming releases */
  dimensions: Dimensions
  url: Scalars['String']['output']
}

export enum ImagePlacement {
  ImageLeft = 'ImageLeft',
  ImageRight = 'ImageRight',
}

export type InfoBanner = {
  __typename: 'InfoBanner'
  text: Scalars['String']['output']
}

export type InfoBlock = {
  __typename: 'InfoBlock'
  image: ContentImage
  text: Scalars['String']['output']
  title: Scalars['String']['output']
}

export type Inlay = {
  id: Scalars['ID']['output']
  scene: InlayScene
  sceneObjects: Array<InlaySceneObject>
}

export type InlayImageUrls = {
  __typename: 'InlayImageUrls'
  editor: Scalars['String']['output']
  preview: Scalars['String']['output']
  print: Scalars['String']['output']
}

export type InlayNotFoundError = Error & {
  __typename: 'InlayNotFoundError'
  message: Scalars['String']['output']
}

export type InlayResult =
  | DemoInlay
  | InlayNotFoundError
  | InlayServiceError
  | VoucherInlay
  | { __typename?: '%other' }

export type InlayScene = {
  __typename: 'InlayScene'
  height: Scalars['Float']['output']
  id: Scalars['ID']['output']
  image: RendererImageResult
  sceneObjects: Array<RendererSceneObject>
  width: Scalars['Float']['output']
}

export type InlaySceneObject =
  | InlaySceneObjectImage
  | InlaySceneObjectText
  | { __typename?: '%other' }

export type InlaySceneObjectCommon = {
  height: Scalars['Float']['output']
  rotation: Scalars['Float']['output']
  width: Scalars['Float']['output']
  x: Scalars['Float']['output']
  y: Scalars['Float']['output']
}

export type InlaySceneObjectImage = InlaySceneObjectCommon & {
  __typename: 'InlaySceneObjectImage'
  height: Scalars['Float']['output']
  rotation: Scalars['Float']['output']
  urls: InlayImageUrls
  width: Scalars['Float']['output']
  x: Scalars['Float']['output']
  y: Scalars['Float']['output']
}

export type InlaySceneObjectText = InlaySceneObjectCommon & {
  __typename: 'InlaySceneObjectText'
  fontSize: Scalars['Float']['output']
  height: Scalars['Float']['output']
  rotation: Scalars['Float']['output']
  text: Scalars['String']['output']
  width: Scalars['Float']['output']
  x: Scalars['Float']['output']
  y: Scalars['Float']['output']
}

export type InlayServiceError = Error & {
  __typename: 'InlayServiceError'
  message: Scalars['String']['output']
}

export type InputValidationError = Error & {
  __typename: 'InputValidationError'
  message: Scalars['String']['output']
}

export type InspirationItem =
  | ProductInspiration
  | SearchTermInspiration
  | { __typename?: '%other' }

export type IntegerFilter = {
  __typename: 'IntegerFilter'
  group: Scalars['String']['output']
  icon?: Maybe<Scalars['String']['output']>
  integerFilterKey: Scalars['String']['output']
  integerFilterType: IntegerFilterType
  isQuickFilter?: Maybe<Scalars['Boolean']['output']>
  isSelected: Scalars['Boolean']['output']
  label: Scalars['String']['output']
  max: Scalars['Int']['output']
  min: Scalars['Int']['output']
  selectedValue?: Maybe<Scalars['Int']['output']>
  selectedValueLabel?: Maybe<Scalars['String']['output']>
}

export type IntegerFilterInput = {
  age?: InputMaybe<IntegerValueInput>
}

export enum IntegerFilterType {
  AGE = 'AGE',
}

export type IntegerValueInput = {
  max: Scalars['Int']['input']
  min: Scalars['Int']['input']
}

export enum Intent {
  MILESTONE = 'MILESTONE',
}

export type IntercomData = {
  __typename: 'IntercomData'
  userDataJwt: Scalars['String']['output']
}

export type InvalidCustomerAddressResult = {
  __typename: 'InvalidCustomerAddressResult'
  address: ShippingAddress
}

export type InvalidDeliveryMethod = {
  __typename: 'InvalidDeliveryMethod'
  description: Scalars['String']['output']
  title: Scalars['String']['output']
}

export type InvalidEmailError = {
  __typename: 'InvalidEmailError'
  emailAddress: Scalars['String']['output']
}

export type InvertedToggleFilter = {
  __typename: 'InvertedToggleFilter'
  facetKey: Scalars['String']['output']
  group: Scalars['String']['output']
  icon?: Maybe<Scalars['String']['output']>
  isAutoApplied?: Maybe<Scalars['Boolean']['output']>
  isQuickFilter?: Maybe<Scalars['Boolean']['output']>
  isSelected: Scalars['Boolean']['output']
  isUserSelected: Scalars['Boolean']['output']
  label: Scalars['String']['output']
  nbaScore?: Maybe<Scalars['Float']['output']>
  toggleType: ToggleType
}

export type KeyedAddAddressesError = {
  __typename: 'KeyedAddAddressesError'
  key: Scalars['String']['output']
  message: Scalars['String']['output']
}

export type KeyedCustomerAddressErrorMessage = {
  __typename: 'KeyedCustomerAddressErrorMessage'
  key: Scalars['String']['output']
  message: Scalars['String']['output']
}

export type KeyedRecipientAddressError = {
  __typename: 'KeyedRecipientAddressError'
  key: Scalars['String']['output']
  message: Scalars['String']['output']
}

export type KeyedRecipientError = {
  __typename: 'KeyedRecipientError'
  key: Scalars['String']['output']
  message: Scalars['String']['output']
}

export type LabelPromo = {
  __typename: 'LabelPromo'
  text: Scalars['String']['output']
}

export type LabelRoundel = {
  __typename: 'LabelRoundel'
  bottom: Scalars['String']['output']
  prefix: Scalars['String']['output']
  top: Scalars['String']['output']
}

export type LabelledOccasion = {
  __typename: 'LabelledOccasion'
  /** @deprecated Labels will be stored in the client */
  label: Scalars['String']['output']
  occasion: Occasion
}

export type LabelledRelationship = {
  __typename: 'LabelledRelationship'
  /** @deprecated Labels will be stored in the client */
  label: Scalars['String']['output']
  relationship: Relationship
}

export type LineItem = Node & {
  __typename: 'LineItem'
  addons: Array<LineItemAddon>
  availability: VariantAvailability
  availableVariants?: Maybe<Array<LineItemVariantOption>>
  canBeDuplicated: Scalars['Boolean']['output']
  /** @deprecated Use the more specific productCoverImage field */
  coverImage?: Maybe<Image>
  customisationId?: Maybe<Scalars['String']['output']>
  /** @deprecated Private field for child resolver */
  deliveryId?: Maybe<Scalars['String']['output']>
  /** @deprecated Private field for child resolver */
  deliveryMethodId?: Maybe<Scalars['String']['output']>
  deliveryType: DeliveryType
  description?: Maybe<Scalars['String']['output']>
  design?: Maybe<Design>
  /** @deprecated Beta feature. Do not use yet. A design is a combination of a template and it's customizations. A designId refers to one of these instances of a design. */
  designId?: Maybe<Scalars['ID']['output']>
  digitalGift?: Maybe<LineItemDigitalGift>
  displayName?: Maybe<Scalars['String']['output']>
  eCardSku?: Maybe<Scalars['String']['output']>
  /** @deprecated Please do not use this field. It should be constructed by clients */
  editUrl?: Maybe<Scalars['String']['output']>
  id: Scalars['ID']['output']
  packaging?: Maybe<LineItemPackaging>
  price: LineItemPrice
  productCoverImage?: Maybe<Image>
  productId: Scalars['ID']['output']
  productSlug?: Maybe<Scalars['String']['output']>
  productType?: Maybe<Scalars['String']['output']>
  productTypeName: Scalars['String']['output']
  quantity: Scalars['Int']['output']
  quantityOption?: Maybe<QuantityOption>
  recipientAddress?: Maybe<RecipientAddress>
  /** @deprecated Use recipientAddress */
  shippingAddress?: Maybe<ShippingAddress>
  size?: Maybe<Scalars['String']['output']>
  sku?: Maybe<Scalars['String']['output']>
  title: Scalars['String']['output']
  totalGrossTaxedPrice?: Maybe<Money>
  totalPrice: Money
  unitPrice: Money
  /** @deprecated Will be removed in upcoming release, use sku instead */
  variantId: Scalars['Int']['output']
  /** @deprecated Use availableVariants */
  variants: Array<LineItemVariant>
}

export type LineItemAddon = {
  __typename: 'LineItemAddon'
  addon: Addon
  id: Scalars['ID']['output']
}

export type LineItemDeliveryRestrictedError = {
  __typename: 'LineItemDeliveryRestrictedError'
  lineItemId: Scalars['String']['output']
  restrictions: Array<Scalars['String']['output']>
}

export type LineItemDigitalGift = {
  __typename: 'LineItemDigitalGift'
  id: Scalars['ID']['output']
  image?: Maybe<Image>
  inStock: Scalars['Boolean']['output']
  price: Money
  productId: Scalars['String']['output']
  sku: Scalars['String']['output']
  title: Scalars['String']['output']
}

export enum LineItemDiscountType {
  PLUS = 'PLUS',
}

export type LineItemDuplicateRestrictedError = Error & {
  __typename: 'LineItemDuplicateRestrictedError'
  message: Scalars['String']['output']
}

export type LineItemDuplicatedBasketResult = {
  __typename: 'LineItemDuplicatedBasketResult'
  basket: Basket
  lineItem: LineItem
}

export type LineItemNotFoundError = Error & {
  __typename: 'LineItemNotFoundError'
  message: Scalars['String']['output']
}

export type LineItemPackaging = {
  __typename: 'LineItemPackaging'
  availablePackaging: Packaging
  id: Scalars['ID']['output']
  selectedPackaging: VariantPackaging
  sku: Scalars['String']['output']
}

export type LineItemPrice =
  | DiscountedLineItemPrice
  | StandardLineItemPrice
  | { __typename?: '%other' }

export type LineItemToAddress = {
  addressId: Scalars['String']['input']
  lineItemId: Scalars['ID']['input']
}

export type LineItemVariant = {
  __typename: 'LineItemVariant'
  additionalInfo?: Maybe<Scalars['String']['output']>
  description: Scalars['String']['output']
  price: Money
  priceLabel: Scalars['String']['output']
  sku: Scalars['String']['output']
  /** @deprecated Will be removed in upcoming release, use sku instead */
  variantId: Scalars['Int']['output']
}

export type LineItemVariantOption = {
  __typename: 'LineItemVariantOption'
  isLandscape: Scalars['Boolean']['output']
  priceLabel: Scalars['String']['output']
  productVariant: ProductVariant
}

export type LinkAction = {
  __typename: 'LinkAction'
  shouldFormat?: Maybe<Scalars['Boolean']['output']>
  title?: Maybe<Scalars['String']['output']>
  url: Scalars['String']['output']
}

export type Location = {
  __typename: 'Location'
  city: Scalars['String']['output']
  county: Scalars['String']['output']
  postcode: Scalars['String']['output']
}

export type LookupAddress = {
  __typename: 'LookupAddress'
  addressFirstLine: Scalars['String']['output']
  city?: Maybe<Scalars['String']['output']>
  houseNumber?: Maybe<Scalars['String']['output']>
  houseNumberExtension?: Maybe<Scalars['String']['output']>
  id?: Maybe<Scalars['String']['output']>
  postcode: Scalars['String']['output']
  state?: Maybe<Scalars['String']['output']>
  streetName?: Maybe<Scalars['String']['output']>
}

export type LookupAddressUk = {
  __typename: 'LookupAddressUk'
  addressLines: Scalars['String']['output']
  county?: Maybe<Scalars['String']['output']>
  id: Scalars['String']['output']
  postTown?: Maybe<Scalars['String']['output']>
  postcode: Scalars['String']['output']
}

export type LookupAddressesUkResult = {
  __typename: 'LookupAddressesUkResult'
  addresses: Array<LookupAddressUk>
}

export type MarketingConsentPosition = {
  __typename: 'MarketingConsentPosition'
  position?: Maybe<ConsentPosition>
}

export enum MarketingConsentSource {
  APP = 'APP',
  APPCHECKOUT = 'APPCHECKOUT',
  CUSTOMER_SERVICES = 'CUSTOMER_SERVICES',
  EMAIL_UNSUBSCRIBE = 'EMAIL_UNSUBSCRIBE',
  GROUP_CARDS_SIGN_UP = 'GROUP_CARDS_SIGN_UP',
  LANDING_PAGE = 'LANDING_PAGE',
  MIGRATION = 'MIGRATION',
  MY_ACCOUNT_PAGE = 'MY_ACCOUNT_PAGE',
  REMINDERS_INFLOW_PAGE = 'REMINDERS_INFLOW_PAGE',
  WEBCHECKOUT = 'WEBCHECKOUT',
  WEB_REGISTER = 'WEB_REGISTER',
}

export type Mask = {
  __typename: 'Mask'
  id: Scalars['ID']['output']
  name: Scalars['String']['output']
  urls: MaskUrls
}

export type MaskEdge = {
  __typename: 'MaskEdge'
  cursor: Scalars['ID']['output']
  node: Mask
}

export type MaskEdges = {
  __typename: 'MaskEdges'
  edges: Array<MaskEdge>
  pageInfo?: Maybe<MaskPageInfo>
  totalCount: Scalars['Int']['output']
}

export type MaskPageInfo = {
  __typename: 'MaskPageInfo'
  endCursor?: Maybe<Scalars['ID']['output']>
  hasNextPage: Scalars['Boolean']['output']
}

export type MaskUrls = {
  __typename: 'MaskUrls'
  editor: Scalars['String']['output']
  editorThumbnail: Scalars['String']['output']
  preview: Scalars['String']['output']
  print: Scalars['String']['output']
}

export type MasksResult =
  | DesignInvalidCursorError
  | DesignServiceError
  | MaskEdges
  | { __typename?: '%other' }

export type Me = {
  __typename: 'Me'
  addressBook?: Maybe<AddressBook>
  addressRequests?: Maybe<AddressRequests>
  addresses?: Maybe<AddressList>
  anonymousId?: Maybe<Scalars['ID']['output']>
  basket?: Maybe<Basket>
  business?: Maybe<Business>
  customer?: Maybe<Customer>
  multiBuyList?: Maybe<MultiBuyList>
  recipients?: Maybe<RecipientList>
  segments?: Maybe<Array<CustomerSegment>>
}

export type MebasketArgs = {
  store?: InputMaybe<Store>
}

export type Media = {
  __typename: 'Media'
  activated: Scalars['Boolean']['output']
  id: Scalars['ID']['output']
  interactive: Scalars['Boolean']['output']
  kind: MediaKind
  scene: MediaScene
  token: Scalars['String']['output']
}

export type MediasceneArgs = {
  height: Scalars['Float']['input']
  width: Scalars['Float']['input']
}

export type MediaConfig = {
  __typename: 'MediaConfig'
  audio: MediaConfigKind
  video: MediaConfigKind
}

export type MediaConfigKind = {
  __typename: 'MediaConfigKind'
  maxDurationSeconds?: Maybe<Scalars['Int']['output']>
  maxSizeBytes: Scalars['Int']['output']
  sceneAspectRatio: Scalars['Float']['output']
  /** List of supported mime types ordered by preference. If available, clients should use the first mime type from this list. */
  supportedMimeTypes: Array<Scalars['String']['output']>
}

export type MediaInvalidTokenError = Error & {
  __typename: 'MediaInvalidTokenError'
  message: Scalars['String']['output']
}

export enum MediaKind {
  Audio = 'Audio',
  Video = 'Video',
}

export type MediaNotFoundError = Error & {
  __typename: 'MediaNotFoundError'
  message: Scalars['String']['output']
}

export type MediaNotReadyError = Error & {
  __typename: 'MediaNotReadyError'
  message: Scalars['String']['output']
}

export type MediaRecipient = {
  __typename: 'MediaRecipient'
  downloadUrl: Scalars['String']['output']
  expiresAt: Scalars['String']['output']
  id: Scalars['ID']['output']
  kind: MediaKind
  url: Scalars['String']['output']
}

export type MediaRecipientResult =
  | MediaNotFoundError
  | MediaNotReadyError
  | MediaRecipient
  | MediaServiceError
  | { __typename?: '%other' }

export type MediaResult =
  | Media
  | MediaNotFoundError
  | MediaServiceError
  | { __typename?: '%other' }

export type MediaScene = {
  __typename: 'MediaScene'
  height: Scalars['Float']['output']
  id: Scalars['ID']['output']
  image: RendererImageResult
  sceneObjects: Array<RendererSceneObject>
  width: Scalars['Float']['output']
}

export type MediaServiceError = Error & {
  __typename: 'MediaServiceError'
  message: Scalars['String']['output']
}

export type MediaTermsAndConditionsNotAcceptedError = Error & {
  __typename: 'MediaTermsAndConditionsNotAcceptedError'
  message: Scalars['String']['output']
}

export type MediaUpload = {
  __typename: 'MediaUpload'
  fields: Array<MediaUploadField>
  media: Media
  url: Scalars['String']['output']
}

export type MediaUploadField = {
  __typename: 'MediaUploadField'
  key: Scalars['String']['output']
  value: Scalars['String']['output']
}

export type MemberPrice = {
  __typename: 'MemberPrice'
  member: Money
  original: Money
  suffix?: Maybe<Scalars['String']['output']>
}

export type MemberPrices = {
  __typename: 'MemberPrices'
  firstPurchase: Money
}

export type MemberStrikethroughPrice = {
  __typename: 'MemberStrikethroughPrice'
  member: Money
  original: Money
}

export type Membership = {
  __typename: 'Membership'
  amountPaid?: Maybe<Money>
  customerId: Scalars['ID']['output']
  expiryDate: Scalars['String']['output']
  gracePeriod: Scalars['Boolean']['output']
  label: Scalars['String']['output']
  membershipType: MembershipType
  paymentMethodId?: Maybe<Scalars['String']['output']>
  payments?: Maybe<Array<Maybe<MembershipPayment>>>
  refund: MembershipRefund
  renewalFrequency: RenewalFrequency
  retentionIncentives?: Maybe<MembershipRetentionIncentives>
  savings?: Maybe<MembershipSavings>
  signupSource?: Maybe<SignupSource>
  startDate: Scalars['String']['output']
  status: MembershipStatus
}

export type MembershipretentionIncentivesArgs = {
  timezone?: InputMaybe<Scalars['String']['input']>
}

export type MembershipFeedback = {
  canContact?: InputMaybe<Scalars['Boolean']['input']>
  questions?: InputMaybe<Array<MembershipFeedbackQuestion>>
}

export type MembershipFeedbackQuestion = {
  answer: Scalars['String']['input']
  question: Scalars['String']['input']
}

export type MembershipFiveCardsOffer = {
  __typename: 'MembershipFiveCardsOffer'
  isMember: Scalars['Boolean']['output']
  message: Scalars['String']['output']
  progressCount: Scalars['Int']['output']
  progressTotal: Scalars['Int']['output']
  title: Scalars['String']['output']
}

export type MembershipLineItem = {
  __typename: 'MembershipLineItem'
  membershipType: MembershipType
  price: Money
  renewalFrequency?: Maybe<RenewalFrequency>
  slug: Scalars['String']['output']
  subtext: Scalars['String']['output']
  title: Scalars['String']['output']
}

export type MembershipOrderItem = {
  __typename: 'MembershipOrderItem'
  membershipType: MembershipType
  price: Money
}

export type MembershipPayment = {
  __typename: 'MembershipPayment'
  date: Scalars['String']['output']
  interactionId?: Maybe<Scalars['String']['output']>
  money: Money
}

export type MembershipRecommendation = {
  __typename: 'MembershipRecommendation'
  price: Money
  title: Scalars['String']['output']
  type: MembershipType
}

export type MembershipRefund = {
  __typename: 'MembershipRefund'
  eligible: Scalars['Boolean']['output']
  interactionId?: Maybe<Scalars['String']['output']>
  money?: Maybe<Money>
}

export type MembershipRetentionIncentives = {
  __typename: 'MembershipRetentionIncentives'
  renewalDiscount?: Maybe<RenewalDiscountContent>
}

export type MembershipSavings = {
  __typename: 'MembershipSavings'
  total: Money
}

export enum MembershipStatus {
  ACTIVE = 'ACTIVE',
  CANCELLED = 'CANCELLED',
  GRACE_PERIOD = 'GRACE_PERIOD',
  NON_RECURRING = 'NON_RECURRING',
}

export enum MembershipType {
  MOONPIG_PLUS = 'MOONPIG_PLUS',
  PLUS = 'PLUS',
}

export type MembershipUnavailableError = Error & {
  __typename: 'MembershipUnavailableError'
  message: Scalars['String']['output']
}

export type MembershipUpsellContent = {
  __typename: 'MembershipUpsellContent'
  card?: Maybe<MembershipUpsellContentCard>
  selectorTitle?: Maybe<Scalars['String']['output']>
}

export type MembershipUpsellContentBenefitsSection = {
  __typename: 'MembershipUpsellContentBenefitsSection'
  main: Array<Scalars['String']['output']>
}

export type MembershipUpsellContentCard = {
  __typename: 'MembershipUpsellContentCard'
  content: MembershipUpsellContentPlusCard
  info: MembershipUpsellContentInformation
}

export type MembershipUpsellContentInformation = {
  __typename: 'MembershipUpsellContentInformation'
  addCta: Scalars['String']['output']
  benefitsSection?: Maybe<MembershipUpsellContentBenefitsSection>
  declineCta: Scalars['String']['output']
  headline: Scalars['String']['output']
  legalInformation: Array<MembershipUpsellContentLegalInformationItem>
  price: Scalars['String']['output']
  renewalInformation: Scalars['String']['output']
  socialProof: MembershipUpsellContentInformationSocialProof
  uspBanner?: Maybe<MembershipUpsellContentUspBanner>
}

export type MembershipUpsellContentInformationSocialProof = {
  __typename: 'MembershipUpsellContentInformationSocialProof'
  backgroundColorHex: Scalars['String']['output']
  text: Scalars['String']['output']
  textColorHex: Scalars['String']['output']
}

export type MembershipUpsellContentLegalInformationItem =
  | MembershipUpsellContentLegalInformationItemLink
  | MembershipUpsellContentLegalInformationItemText
  | { __typename?: '%other' }

export type MembershipUpsellContentLegalInformationItemLink = {
  __typename: 'MembershipUpsellContentLegalInformationItemLink'
  selectContentTracking?: Maybe<Scalars['String']['output']>
  text: Scalars['String']['output']
  url: Scalars['String']['output']
}

export type MembershipUpsellContentLegalInformationItemText = {
  __typename: 'MembershipUpsellContentLegalInformationItemText'
  text: Scalars['String']['output']
}

export type MembershipUpsellContentPlusCard = {
  __typename: 'MembershipUpsellContentPlusCard'
  ctaText: Scalars['String']['output']
  subtitle: Scalars['String']['output']
  title: Scalars['String']['output']
}

export type MembershipUpsellContentUspBanner = {
  __typename: 'MembershipUpsellContentUspBanner'
  subtitle: Scalars['String']['output']
  title: MembershipUpsellContentUspBannerTitle
}

export type MembershipUpsellContentUspBannerTitle = {
  __typename: 'MembershipUpsellContentUspBannerTitle'
  main: Scalars['String']['output']
  prefix: Scalars['String']['output']
  suffix: Scalars['String']['output']
}

export type MembershipUpsellIntrusive = {
  __typename: 'MembershipUpsellIntrusive'
  info: MembershipUpsellContentInformation
}

export type MembershipVoucherError = Error & {
  __typename: 'MembershipVoucherError'
  message: Scalars['String']['output']
}

export type MissionButton = {
  __typename: 'MissionButton'
  image?: Maybe<ContentImage>
  title: Scalars['String']['output']
  url: Scalars['String']['output']
}

export enum ModalTarget {
  Gallery = 'Gallery',
  Homepage = 'Homepage',
  Landing = 'Landing',
  Search = 'Search',
}

export type Module =
  | ModuleAlert
  | ModuleBanner
  | ModuleBlogHomepageImage
  | ModuleBlogPostAuthor
  | ModuleBlogPostCategory
  | ModuleBlogPostDate
  | ModuleBlogPostRelatedArticles
  | ModuleBlogPostsCategories
  | ModuleBlogPostsListing
  | ModuleBreadcrumbs
  | ModuleButtons
  | ModuleCTAStrip
  | ModuleCard
  | ModuleCarousel
  | ModuleDeliveryStrip
  | ModuleDescription
  | ModuleDynamicHero
  | ModuleDynamicMissionButtons
  | ModuleEmailCapture
  | ModuleFacetTile
  | ModuleHeading
  | ModuleHero
  | ModuleIncentivisedReminders
  | ModuleInfo
  | ModuleInlineMessaging
  | ModuleMissionButtons
  | ModuleModal
  | ModuleOfferStrip
  | ModulePanel
  | ModulePlacards
  | ModulePlaceholder
  | ModulePromoTile
  | ModuleRecommendationsForCustomer
  | ModuleRichText
  | ModuleRichTextImage
  | ModuleSEO
  | ModuleSearchResults
  | ModuleTabbedProductLists
  | ModuleTiles
  | ModuleTwoColumnPlacard
  | ModuleUspCarousel
  | ModuleVideo
  | { __typename?: '%other' }

export type ModuleAlert = {
  __typename: 'ModuleAlert'
  dismissible: Scalars['Boolean']['output']
  message: Scalars['String']['output']
  severity: ModuleAlertSeverity
  title: Scalars['String']['output']
}

export enum ModuleAlertSeverity {
  Critical = 'Critical',
  Info = 'Info',
  Warning = 'Warning',
}

export type ModuleBanner = {
  __typename: 'ModuleBanner'
  action?: Maybe<Action>
  text: Scalars['String']['output']
  theme: Scalars['String']['output']
}

export type ModuleBlogHomepageImage = {
  __typename: 'ModuleBlogHomepageImage'
  image: ContentImage
}

export type ModuleBlogPostAuthor = {
  __typename: 'ModuleBlogPostAuthor'
  image: ContentImage
  jobTitle: Scalars['String']['output']
  name: Scalars['String']['output']
}

export type ModuleBlogPostCategory = {
  __typename: 'ModuleBlogPostCategory'
  category: Scalars['String']['output']
  url: Scalars['String']['output']
}

export type ModuleBlogPostDate = {
  __typename: 'ModuleBlogPostDate'
  date: Scalars['String']['output']
}

export type ModuleBlogPostRelatedArticles = {
  __typename: 'ModuleBlogPostRelatedArticles'
  items: Array<BlogPostRelatedArticle>
  title: Scalars['String']['output']
}

export type ModuleBlogPostsCategories = {
  __typename: 'ModuleBlogPostsCategories'
  items: Array<ModuleBlogPostCategory>
}

export type ModuleBlogPostsListing = {
  __typename: 'ModuleBlogPostsListing'
  items: Array<BlogPostListItem>
  title: Scalars['String']['output']
}

export type ModuleBreadcrumbs = {
  __typename: 'ModuleBreadcrumbs'
  breadcrumbs: Array<Breadcrumb>
}

export type ModuleButtons = {
  __typename: 'ModuleButtons'
  items: Array<CTA>
}

export type ModuleCTAStrip = ContentModule & {
  __typename: 'ModuleCTAStrip'
  backgroundImage?: Maybe<ContentImage>
  banner: Scalars['Boolean']['output']
  cta: CTA
  meta: ContentMetadata
  text: Scalars['String']['output']
}

export type ModuleCard = {
  __typename: 'ModuleCard'
  ctas?: Maybe<Array<CTA>>
  image: ContentImage
  pills?: Maybe<Array<Scalars['String']['output']>>
  subtitle: Scalars['String']['output']
  text: Scalars['String']['output']
  title: Scalars['String']['output']
  video?: Maybe<ContentVideo>
}

export type ModuleCarousel = {
  __typename: 'ModuleCarousel'
  items: Array<ModuleCarouselItem>
  title: Scalars['String']['output']
}

export type ModuleCarouselItem =
  | ModuleFacetTile
  | ModuleHero
  | Tile
  | { __typename?: '%other' }

export type ModuleDeliveryStrip = {
  __typename: 'ModuleDeliveryStrip'
  cta?: Maybe<CTA>
  text: Scalars['String']['output']
}

export type ModuleDescription = {
  __typename: 'ModuleDescription'
  description: Scalars['String']['output']
}

export type ModuleDynamicHero = {
  __typename: 'ModuleDynamicHero'
  ctas?: Maybe<Array<CTA>>
  image: ContentImage
  offer: Scalars['Boolean']['output']
  promotionId?: Maybe<Scalars['String']['output']>
  subtitle: Scalars['String']['output']
  title: Scalars['String']['output']
  variant: ModuleHeroVariant
}

export type ModuleDynamicMissionButtons = ContentModule & {
  __typename: 'ModuleDynamicMissionButtons'
  meta: ContentMetadata
  missionButtons: Array<MissionButton>
  promotionId?: Maybe<Scalars['String']['output']>
  title: Scalars['String']['output']
}

export type ModuleEmailCapture = {
  __typename: 'ModuleEmailCapture'
  actionButtonText: Scalars['String']['output']
  display: Scalars['String']['output']
  errorText: Scalars['String']['output']
  heading: Scalars['String']['output']
  image: ContentImage
  inputLabel: Scalars['String']['output']
  inputPlaceholder?: Maybe<Scalars['String']['output']>
  privacyPolicy: LinkAction
  text: Scalars['String']['output']
  thankYouButtonText: Scalars['String']['output']
  thankYouHeading: Scalars['String']['output']
  thankYouText: Scalars['String']['output']
  unsubscribeText: Scalars['String']['output']
}

export type ModuleFacetTile = {
  __typename: 'ModuleFacetTile'
  facetDetails: Array<ContentSearchFacetDetails>
  tile: Tile
}

export type ModuleHeading = {
  __typename: 'ModuleHeading'
  heading: Scalars['String']['output']
  hidden: Scalars['Boolean']['output']
}

export type ModuleHero = {
  __typename: 'ModuleHero'
  ctas?: Maybe<Array<CTA>>
  image: ContentImage
  offer: Scalars['Boolean']['output']
  promotionId?: Maybe<Scalars['String']['output']>
  subtitle: Scalars['String']['output']
  title: Scalars['String']['output']
  variant: ModuleHeroVariant
}

export enum ModuleHeroVariant {
  FullWidth = 'FullWidth',
  LimitedWidth = 'LimitedWidth',
}

export type ModuleIncentivisedReminders = {
  __typename: 'ModuleIncentivisedReminders'
  endImage: ContentImage
  endText: Scalars['String']['output']
  endTitle: Scalars['String']['output']
  introImage: ContentImage
  introText: Scalars['String']['output']
  introTitle: Scalars['String']['output']
  notificationTitle: Scalars['String']['output']
  numberOfRemindersInOffer: Scalars['Int']['output']
  occasions?: Maybe<Array<ContentReminderOccasion>>
  relations?: Maybe<Array<ContentReminderRelation>>
  title: Scalars['String']['output']
  voucherCode?: Maybe<Scalars['String']['output']>
  voucherDescription: Scalars['String']['output']
}

export type ModuleInfo = {
  __typename: 'ModuleInfo'
  items: Array<InfoBlock>
  title: Scalars['String']['output']
}

export type ModuleInlineMessaging = {
  __typename: 'ModuleInlineMessaging'
  messages: Array<Scalars['String']['output']>
}

export type ModuleMissionButtons = ContentModule & {
  __typename: 'ModuleMissionButtons'
  meta: ContentMetadata
  missionButtons: Array<MissionButton>
  promotionId?: Maybe<Scalars['String']['output']>
  title: Scalars['String']['output']
}

export type ModuleModal = {
  __typename: 'ModuleModal'
  /** @deprecated this is legacy and will be removed in the future */
  buttons: Array<CTA>
  /** @deprecated this is legacy and will be removed in the future */
  cookieName: Scalars['String']['output']
  /** @deprecated this is legacy and will be removed in the future */
  dismissalMessage: Scalars['String']['output']
  /** @deprecated this is legacy and will be removed in the future */
  heading: Scalars['String']['output']
  /** @deprecated this is legacy and will be removed in the future */
  platforms: Array<BrowserPlatform>
  /** @deprecated this is legacy and will be removed in the future */
  text: Scalars['String']['output']
}

export type ModuleOfferStrip = {
  __typename: 'ModuleOfferStrip'
  enabled: Scalars['Boolean']['output']
  text: Scalars['String']['output']
}

export type ModulePanel = {
  __typename: 'ModulePanel'
  cta: CTA
  image: ContentImage
  name: Scalars['String']['output']
}

export type ModulePlacards = {
  __typename: 'ModulePlacards'
  items: Array<Placard>
  subtitle: Scalars['String']['output']
  title: Scalars['String']['output']
}

export type ModulePlaceholder = {
  __typename: 'ModulePlaceholder'
  variant: ModulePlaceholderVariant
}

export enum ModulePlaceholderVariant {
  Bundles = 'Bundles',
  Collections = 'Collections',
  CollectionsLandingBirthday = 'CollectionsLandingBirthday',
  CollectionsLandingFathersDay = 'CollectionsLandingFathersDay',
  ContinueJourney = 'ContinueJourney',
  CookieList = 'CookieList',
  CustomerSatisfaction = 'CustomerSatisfaction',
  Drafts = 'Drafts',
  GroupCardsStarter = 'GroupCardsStarter',
  MostRecentOrder = 'MostRecentOrder',
  RecentlyViewed = 'RecentlyViewed',
  ReminderImport = 'ReminderImport',
  Reminders = 'Reminders',
  Voucher = 'Voucher',
}

export type ModulePromoTile = {
  __typename: 'ModulePromoTile'
  cta: CTA
  description: Scalars['String']['output']
  image: ContentImage
  internallyPromoted: Scalars['Boolean']['output']
  name: Scalars['String']['output']
  title: Scalars['String']['output']
}

export type ModulePromotionalCard = {
  __typename: 'ModulePromotionalCard'
  description: Scalars['String']['output']
  icon?: Maybe<ContentImage>
  link?: Maybe<CTA>
  title: Scalars['String']['output']
}

export type ModuleRecommendationsForCustomer = {
  __typename: 'ModuleRecommendationsForCustomer'
  algorithm: Scalars['String']['output']
  subtitle: Scalars['String']['output']
  title: Scalars['String']['output']
}

export type ModuleRichText = {
  __typename: 'ModuleRichText'
  blocks: Array<RichTextBlock>
}

export type ModuleRichTextImage = {
  __typename: 'ModuleRichTextImage'
  altText: Scalars['String']['output']
  image: ContentImage
}

export type ModuleSEO = {
  __typename: 'ModuleSEO'
  items: Array<SEOBlock>
}

export type ModuleSearchResults = {
  __typename: 'ModuleSearchResults'
  departments: Array<Scalars['String']['output']>
  facetDetails: Array<ContentSearchFacetDetails>
  id: Scalars['ID']['output']
  keywords: Scalars['String']['output']
  promotionId?: Maybe<Scalars['String']['output']>
  sponsoredProducts: Array<SponsoredProduct>
  subtitle: Scalars['String']['output']
  title: Scalars['String']['output']
  url: Scalars['String']['output']
}

export type ModuleTabbedProductLists = {
  __typename: 'ModuleTabbedProductLists'
  productLists: Array<ModuleSearchResults>
  title: Scalars['String']['output']
}

export type ModuleTiles = {
  __typename: 'ModuleTiles'
  items: Array<Tile>
  subtitle: Scalars['String']['output']
  title: Scalars['String']['output']
  variant: ModuleTilesVariant
}

export enum ModuleTilesVariant {
  Default = 'Default',
  Round = 'Round',
}

export type ModuleTwoColumnPlacard = {
  __typename: 'ModuleTwoColumnPlacard'
  body: Scalars['String']['output']
  cta?: Maybe<CTA>
  image: ContentImage
  imagePlacement: ImagePlacement
  title: Scalars['String']['output']
  variant: ColumnWidthVariant
}

export type ModuleUspCarousel = {
  __typename: 'ModuleUspCarousel'
  items: Array<USP>
}

export type ModuleVideo = {
  __typename: 'ModuleVideo'
  id: Scalars['ID']['output']
  subtitle: Scalars['String']['output']
  title: Scalars['String']['output']
  titleHidden: Scalars['Boolean']['output']
}

/** Money value with currency and formatting information. */
export type Money = {
  __typename: 'Money'
  /** Amount as a decimal string (e.g., '10.99') */
  amount: Scalars['String']['output']
  /** Amount in cents/pence (e.g., 1099 = £10.99) */
  centAmount: Scalars['Long']['output']
  /** ISO 4217 currency code (e.g., 'GBP', 'USD') */
  currencyCode: Scalars['Currency']['output']
  /** Formatted display string with currency symbol (e.g., '£10.99') */
  display: Scalars['String']['output']
  /** Number of decimal places for this currency */
  fractionDigits: Scalars['Int']['output']
}

export type MoneyInput = {
  centAmount: Scalars['Long']['input']
  currencyCode: Scalars['Currency']['input']
  fractionDigits: Scalars['Int']['input']
}

export type MultiBuyList = {
  __typename: 'MultiBuyList'
  id: Scalars['ID']['output']
  itemCount: Scalars['Int']['output']
  itemLimit: Scalars['Int']['output']
  itemLimitReached: Scalars['Boolean']['output']
  items: Array<MultiBuyListItem>
  nextItem?: Maybe<MultiBuyListItem>
}

export type MultiBuyListItem =
  | MultiBuyListPersonalisableItem
  | { __typename?: '%other' }

export type MultiBuyListPersonalisableItem = {
  __typename: 'MultiBuyListPersonalisableItem'
  id: Scalars['ID']['output']
  variant: ProductVariant
}

export type MultiBuyListProduct = {
  __typename: 'MultiBuyListProduct'
  count: Scalars['Int']['output']
}

/**
 * Root mutation type for the Design API.
 * Provides operations to create, update, and manage designs.
 */
export type Mutation = {
  __typename: 'Mutation'
  activateRedemption: RedemptionResult
  addAddress?: Maybe<AddAddressResult>
  addAddressRequestAddress: AddAddressRequestAddressResult
  addAddresses?: Maybe<AddAddressesResult>
  addCardAndDigitalGiftToBasket?: Maybe<AddCardAndDigitalGiftResult>
  addCredits?: Maybe<AddCreditsResult>
  addCustomerAddress?: Maybe<AddCustomerAddressResult>
  addCustomerAddresses?: Maybe<AddCustomerAddressesResult>
  addCustomerSelfService?: Maybe<CustomerSelfServiceResponse>
  /** Add a completed design to the customer's basket for checkout */
  addDesignToBasket: AddDesignToBasketResult
  addDigitalGiftToBasket?: Maybe<AddDigitalGiftToBasketResult>
  addGiftToBusinessProject: BusinessProjectResponse
  addKeywordToBusinessProject: BusinessProjectResponse
  addMembershipToBasket: AddMembershipToBasketResult
  addRecipient: AddRecipientResult
  addRecipientAddress: AddRecipientAddressResult
  addToBasket?: Maybe<AddToBasketResult>
  addToBasketAndSplit?: Maybe<AddToBasketAndSplitResult>
  addToFavouritesList: AddToFavouritesList
  addToMultiBuyList: AddToMultiBuyListResult
  amendDeliveryDesign: AmendResult
  applyAutoPromo?: Maybe<ApplyAutoPromoResult>
  applyPromo?: Maybe<ApplyPromoResult>
  applyPromotionCodeToBusinessProject: ApplyPromotionCodeToBusinessProjectResult
  applyRenewalDiscount: ApplyRenewalDiscountResponse
  assignABTestVariant?: Maybe<AssignABTestVariantResult>
  assignBasketAddress?: Maybe<AssignBasketAddressResult>
  assignBasketAddressRecipient?: Maybe<AssignBasketAddressRecipientResult>
  assignBasketVoucher?: Maybe<AssignBasketVoucherResult>
  assignBillingAddress?: Maybe<AssignBillingAddressResult>
  assignCustomerAddress?: Maybe<AssignAddressResult>
  assignDeliveryAddress?: Maybe<AssignDeliveryAddressResult>
  assignDeliveryDate?: Maybe<AssignDeliveryDateResult>
  assignDeliveryGiftNote?: Maybe<AssignDeliveryGiftNoteResult>
  assignDeliveryMethod?: Maybe<AssignDeliveryMethodResult>
  assignDeliveryMethodAndDate?: Maybe<AssignDeliveryMethodAndDateResult>
  assignLineItemAddress?: Maybe<AssignLineItemAddressResult>
  assignLineItemEmailAddress?: Maybe<AssignLineItemEmailAddressResult>
  assignRecipientAddress?: Maybe<AssignAddressResult>
  cancelMembership: Membership
  checkoutBusinessProject: CheckoutBusinessProjectResponse
  cloneSharedReminder: CloneSharedReminderResult
  completeAmendDeliveryDesign: CompleteAmendResult
  createAddressRequest: CreateAddressRequestResult
  createAudioMedia: CreateAudioMediaResult
  /** @deprecated Use createCustomerCreationsCustomFontSubmission */
  createCustomerCreationsCustomFont: CreateCustomerCreationsCustomFontResponse
  createCustomerCreationsCustomFontSubmission: CreateCustomerCreationsCustomFontSubmissionResponse
  createCustomerFeedback: CustomerFeedbackResult
  createDemoMedia: CreateDemoMediaResult
  /** Create a new design for a product with optional initial customisations */
  createDesign: CreateDesignResult
  createDesignAiCreationsFaceswap: CreateDesignAiCreationsFaceswapResponse
  /** Generate a pre-signed URL for uploading an image to a design */
  createDesignImageUpload: CreateDesignImageUploadResult
  /** Create an AI-generated sticker from a text prompt */
  createDesignStickerAI: CreateDesignStickerAIResult
  /** Create a draft copy of an existing design (for editing from basket) */
  createDraftFromDesign: CreateDraftFromDesignResult
  /** Create an in-project copy of an existing design */
  createInProjectFromDesign: CreateInProjectFromDesignResult
  createIncentivisedReminders: CreateIncentivisedRemindersResult
  createPhotoUpload: CreatePhotoUploadResult
  createPhotoUploadSession: CreatePhotoUploadSessionResult
  createReminder: CreateReminderResult
  createReminderFromDraft: CreateReminderFromDraftResult
  createRemindersAsync: CreateRemindersAsyncResult
  createRemindersFromProducts: CreateRemindersFromProductsResult
  createVideoMedia: CreateVideoMediaResult
  crmDeleteReminders: CrmDeleteReminderResult
  customerRequestOrderCancellation: RequestOrderCancellationResult
  deleteBasket?: Maybe<DeleteBasketResult>
  deleteBusinessProject: DeleteBusinessProjectResponse
  deleteCustomerCreationsCustomFont: CustomerCreationsCustomFontDeleteResponse
  /** Remove the inlay association from a design */
  deleteDesignInlay: DeleteDesignInlayResult
  /** Delete a draft design that is no longer needed */
  deleteDraftDesign: DeleteDraftDesignResult
  deleteLineItem?: Maybe<DeleteLineItemResult>
  deleteRecipient: DeleteRecipientResult
  deleteReminder: DeleteReminderResult
  duplicateLineItem?: Maybe<DuplicateLineItemResult>
  expireCredits?: Maybe<ExpireCreditsResult>
  forgottenPassword?: Maybe<ForgottenPasswordResult>
  generateBillingPortalUrl: Scalars['String']['output']
  generateTrackingLink?: Maybe<GenerateTrackingLinkResponse>
  /** Get existing draft design or create new one for a product (idempotent) */
  getOrCreateDraftDesign: GetOrCreateDraftDesignResult
  groupCardAddMessage: GroupAddMessageResult
  groupCardAddMessageV2: GroupAddMessageResultV2
  groupCardArchiveProject: GroupCardArchiveProjectResult
  groupCardCreateDesign: GroupCardCreateDesignResult
  groupCardCreateProject: GroupCardCreateProjectResult
  groupCardCreateProjectV2: GroupCardCreateProjectResultV2
  groupCardDeleteMessage: GroupDeleteMessageResult
  groupCardDeleteMessageV2: GroupDeleteMessageResultV2
  groupCardDeleteProject: GroupCardDeleteProjectResult
  groupCardTrackCheckout: GroupCardTrackCheckoutResult
  groupCardTrackSignupEvent: GroupCardTrackSignupEventResult
  groupCardUpdateProject: GroupCardUpdateProjectResult
  groupCardUpdateProjectV2: GroupCardUpdateProjectResultV2
  groupCardUpdateProjectWithDesign: GroupCardUpdateProjectWithDesignResult
  processBusinessRecipientData: ProcessBusinessRecipientDataResult
  reactivateMembership: Membership
  registerEmail: RegisterEmailResult
  removeAddress?: Maybe<RemoveAddressResult>
  removeBasketAddressRecipient?: Maybe<RemoveBasketAddressRecipientResult>
  removeBasketVoucher?: Maybe<RemoveBasketVoucherResult>
  removeCustomerAddress?: Maybe<RemoveCustomerAddressResult>
  removeFromFavouritesList: RemoveFromFavouritesList
  removeFromMultiBuyList: RemoveFromMultiBuyListResult
  removeGiftFromBusinessProject: BusinessProjectResponse
  removeKeywordFromBusinessProject: BusinessProjectResponse
  removeMembershipFromBasket: RemoveMembershipFromBasketResult
  removePromotionCodeFromBusinessProject: BusinessProject
  removeRecipientAddress: RemoveRecipientAddressResult
  removeSavedCard?: Maybe<RemoveSavedCardResult>
  reportDesignAiCreationsFaceswap: DesignAiCreationsFaceswapReportResponse
  requestOrderCancellation: RequestOrderCancellationResult
  requestResend: RequestResendResult
  revokeMembershipByCustomerId: RevokeMembershipByCustomerIdResponse
  selfValidateAddress: SelfValidateAddressResult
  setBusinessCardCustomisation: BusinessProjectResponse
  setBusinessCardProductAndDesign: BusinessProjectResponse
  setBusinessProjectSource: BusinessProjectResponse
  setBusinessRecipients: BusinessProjectResponse
  /** Update customisations for one or more scenes in a design */
  setDesignCustomisations: SetDesignCustomisationsResult
  /** Associate an inlay product with a design */
  setDesignInlay: SetDesignInlayResult
  shareReminder: ShareReminderResult
  splitLineItemQuantity?: Maybe<SplitLineItemQuantityResult>
  splitMultiQuantityCards?: Maybe<SplitMultiCardsResult>
  trackRecipient?: Maybe<TrackRecipientResult>
  unlinkReminderFromOrder: UnlinkReminderFromOrderResult
  updateAddress?: Maybe<UpdateAddressResult>
  updateAddressPackaging?: Maybe<UpdateAddressPackagingResult>
  updateAddressType?: Maybe<UpdateAddressTypeResult>
  updateBasketAddressPackaging?: Maybe<UpdateBasketAddressPackagingResult>
  updateContactPreferences?: Maybe<ContactPreferences>
  updateCustomerAddress?: Maybe<UpdateCustomerAddressResult>
  updateCustomerDetails?: Maybe<UpdateCustomerDetailsResult>
  /** @deprecated Exists only for migration from commerce-api. Use updateContactPreferences instead */
  updateCustomerMarketingConsentPosition?: Maybe<UpdateCustomerMarketingConsentPositionResult>
  updateEmail?: Maybe<UpdateEmailResult>
  updateLineItem?: Maybe<UpdateLineItemResult>
  /** @deprecated Replaced by updateLineItem */
  updateLineItemQuantity?: Maybe<UpdateLineItemQuantityResult>
  /** @deprecated Replaced by updateLineItem */
  updateLineItemVariant?: Maybe<UpdateLineItemVariantResult>
  updatePhoneNumber?: Maybe<UpdatePhoneNumberResult>
  updateRecipient: UpdateRecipientResult
  updateRecipientAddress: UpdateRecipientAddressResult
  updateReminder: UpdateReminderResult
  validateBasket?: Maybe<ValidateBasketResult>
  validateCustomerAddress: ValidateCustomerAddressResult
}

/**
 * Root mutation type for the Design API.
 * Provides operations to create, update, and manage designs.
 */
export type MutationactivateRedemptionArgs = {
  input: ActivateRedemptionInput
}

/**
 * Root mutation type for the Design API.
 * Provides operations to create, update, and manage designs.
 */
export type MutationaddAddressArgs = {
  input: AddAddressInput
}

/**
 * Root mutation type for the Design API.
 * Provides operations to create, update, and manage designs.
 */
export type MutationaddAddressRequestAddressArgs = {
  input: AddAddressRequestAddressInput
}

/**
 * Root mutation type for the Design API.
 * Provides operations to create, update, and manage designs.
 */
export type MutationaddAddressesArgs = {
  input: AddAddressesInput
}

/**
 * Root mutation type for the Design API.
 * Provides operations to create, update, and manage designs.
 */
export type MutationaddCardAndDigitalGiftToBasketArgs = {
  input: AddCardAndDigitalGiftToBasketInput
}

/**
 * Root mutation type for the Design API.
 * Provides operations to create, update, and manage designs.
 */
export type MutationaddCreditsArgs = {
  input: AddCreditsInput
}

/**
 * Root mutation type for the Design API.
 * Provides operations to create, update, and manage designs.
 */
export type MutationaddCustomerAddressArgs = {
  input: CustomerAddressInput
}

/**
 * Root mutation type for the Design API.
 * Provides operations to create, update, and manage designs.
 */
export type MutationaddCustomerAddressesArgs = {
  input: CustomerAddressesInput
}

/**
 * Root mutation type for the Design API.
 * Provides operations to create, update, and manage designs.
 */
export type MutationaddCustomerSelfServiceArgs = {
  input: CustomerSelfServiceInput
}

/**
 * Root mutation type for the Design API.
 * Provides operations to create, update, and manage designs.
 */
export type MutationaddDesignToBasketArgs = {
  input: AddDesignToBasketInput
}

/**
 * Root mutation type for the Design API.
 * Provides operations to create, update, and manage designs.
 */
export type MutationaddDigitalGiftToBasketArgs = {
  input: AddDigitalGiftToBasketInput
}

/**
 * Root mutation type for the Design API.
 * Provides operations to create, update, and manage designs.
 */
export type MutationaddGiftToBusinessProjectArgs = {
  input: BusinessGiftInput
}

/**
 * Root mutation type for the Design API.
 * Provides operations to create, update, and manage designs.
 */
export type MutationaddKeywordToBusinessProjectArgs = {
  input: BusinessProjectKeywordInput
}

/**
 * Root mutation type for the Design API.
 * Provides operations to create, update, and manage designs.
 */
export type MutationaddMembershipToBasketArgs = {
  input: AddMembershipToBasketInput
}

/**
 * Root mutation type for the Design API.
 * Provides operations to create, update, and manage designs.
 */
export type MutationaddRecipientArgs = {
  input: AddRecipientInput
}

/**
 * Root mutation type for the Design API.
 * Provides operations to create, update, and manage designs.
 */
export type MutationaddRecipientAddressArgs = {
  input: AddRecipientAddressInput
}

/**
 * Root mutation type for the Design API.
 * Provides operations to create, update, and manage designs.
 */
export type MutationaddToBasketArgs = {
  input: AddToBasketInput
}

/**
 * Root mutation type for the Design API.
 * Provides operations to create, update, and manage designs.
 */
export type MutationaddToBasketAndSplitArgs = {
  input: AddToBasketAndSplitInput
}

/**
 * Root mutation type for the Design API.
 * Provides operations to create, update, and manage designs.
 */
export type MutationaddToFavouritesListArgs = {
  listId?: Scalars['ID']['input']
  productIds: Array<Scalars['String']['input']>
}

/**
 * Root mutation type for the Design API.
 * Provides operations to create, update, and manage designs.
 */
export type MutationaddToMultiBuyListArgs = {
  input: AddToMultiBuyListInput
}

/**
 * Root mutation type for the Design API.
 * Provides operations to create, update, and manage designs.
 */
export type MutationamendDeliveryDesignArgs = {
  input: DesignAmendmentInput
}

/**
 * Root mutation type for the Design API.
 * Provides operations to create, update, and manage designs.
 */
export type MutationapplyAutoPromoArgs = {
  input: ApplyAutoPromoInput
}

/**
 * Root mutation type for the Design API.
 * Provides operations to create, update, and manage designs.
 */
export type MutationapplyPromoArgs = {
  input: ApplyPromoInput
}

/**
 * Root mutation type for the Design API.
 * Provides operations to create, update, and manage designs.
 */
export type MutationapplyPromotionCodeToBusinessProjectArgs = {
  input: BusinessProjectPromotionCodeInput
}

/**
 * Root mutation type for the Design API.
 * Provides operations to create, update, and manage designs.
 */
export type MutationassignABTestVariantArgs = {
  input: AssignABTestVariantInput
}

/**
 * Root mutation type for the Design API.
 * Provides operations to create, update, and manage designs.
 */
export type MutationassignBasketAddressArgs = {
  input: AssignBasketAddressInput
}

/**
 * Root mutation type for the Design API.
 * Provides operations to create, update, and manage designs.
 */
export type MutationassignBasketAddressRecipientArgs = {
  input: AssignBasketAddressRecipientInput
}

/**
 * Root mutation type for the Design API.
 * Provides operations to create, update, and manage designs.
 */
export type MutationassignBasketVoucherArgs = {
  input: AssignBasketVoucherInput
}

/**
 * Root mutation type for the Design API.
 * Provides operations to create, update, and manage designs.
 */
export type MutationassignBillingAddressArgs = {
  addressId: Scalars['String']['input']
}

/**
 * Root mutation type for the Design API.
 * Provides operations to create, update, and manage designs.
 */
export type MutationassignCustomerAddressArgs = {
  input: AssignCustomerAddressInput
}

/**
 * Root mutation type for the Design API.
 * Provides operations to create, update, and manage designs.
 */
export type MutationassignDeliveryAddressArgs = {
  input: AssignDeliveryAddressInput
}

/**
 * Root mutation type for the Design API.
 * Provides operations to create, update, and manage designs.
 */
export type MutationassignDeliveryDateArgs = {
  input: AssignDeliveryDateInput
}

/**
 * Root mutation type for the Design API.
 * Provides operations to create, update, and manage designs.
 */
export type MutationassignDeliveryGiftNoteArgs = {
  input: AssignDeliveryGiftNoteInput
}

/**
 * Root mutation type for the Design API.
 * Provides operations to create, update, and manage designs.
 */
export type MutationassignDeliveryMethodArgs = {
  input: AssignDeliveryMethodInput
}

/**
 * Root mutation type for the Design API.
 * Provides operations to create, update, and manage designs.
 */
export type MutationassignDeliveryMethodAndDateArgs = {
  input: AssignDeliveryMethodAndDateInput
}

/**
 * Root mutation type for the Design API.
 * Provides operations to create, update, and manage designs.
 */
export type MutationassignLineItemAddressArgs = {
  input: AssignLineItemAddressInput
}

/**
 * Root mutation type for the Design API.
 * Provides operations to create, update, and manage designs.
 */
export type MutationassignLineItemEmailAddressArgs = {
  input: AssignLineItemEmailAddressInput
}

/**
 * Root mutation type for the Design API.
 * Provides operations to create, update, and manage designs.
 */
export type MutationassignRecipientAddressArgs = {
  input: AssignRecipientAddressInput
}

/**
 * Root mutation type for the Design API.
 * Provides operations to create, update, and manage designs.
 */
export type MutationcancelMembershipArgs = {
  feedback?: InputMaybe<MembershipFeedback>
}

/**
 * Root mutation type for the Design API.
 * Provides operations to create, update, and manage designs.
 */
export type MutationcloneSharedReminderArgs = {
  sharedReminder: Scalars['String']['input']
}

/**
 * Root mutation type for the Design API.
 * Provides operations to create, update, and manage designs.
 */
export type MutationcompleteAmendDeliveryDesignArgs = {
  input: CompleteDesignAmendmentInput
}

/**
 * Root mutation type for the Design API.
 * Provides operations to create, update, and manage designs.
 */
export type MutationcreateAddressRequestArgs = {
  input: CreateAddressRequestInput
}

/**
 * Root mutation type for the Design API.
 * Provides operations to create, update, and manage designs.
 */
export type MutationcreateAudioMediaArgs = {
  input: CreateAudioMediaInput
}

/**
 * Root mutation type for the Design API.
 * Provides operations to create, update, and manage designs.
 */
export type MutationcreateCustomerCreationsCustomFontSubmissionArgs = {
  assetId?: InputMaybe<Scalars['ID']['input']>
}

/**
 * Root mutation type for the Design API.
 * Provides operations to create, update, and manage designs.
 */
export type MutationcreateCustomerFeedbackArgs = {
  input: CustomerFeedbackInput
}

/**
 * Root mutation type for the Design API.
 * Provides operations to create, update, and manage designs.
 */
export type MutationcreateDemoMediaArgs = {
  input: CreateDemoMediaInput
}

/**
 * Root mutation type for the Design API.
 * Provides operations to create, update, and manage designs.
 */
export type MutationcreateDesignArgs = {
  input: CreateDesignInput
}

/**
 * Root mutation type for the Design API.
 * Provides operations to create, update, and manage designs.
 */
export type MutationcreateDesignAiCreationsFaceswapArgs = {
  designId: Scalars['String']['input']
  sourceImageId: Scalars['String']['input']
}

/**
 * Root mutation type for the Design API.
 * Provides operations to create, update, and manage designs.
 */
export type MutationcreateDesignImageUploadArgs = {
  input: CreateDesignImageUploadInput
}

/**
 * Root mutation type for the Design API.
 * Provides operations to create, update, and manage designs.
 */
export type MutationcreateDesignStickerAIArgs = {
  input: CreateDesignStickerAIInput
}

/**
 * Root mutation type for the Design API.
 * Provides operations to create, update, and manage designs.
 */
export type MutationcreateDraftFromDesignArgs = {
  input: CreateDraftFromDesignInput
}

/**
 * Root mutation type for the Design API.
 * Provides operations to create, update, and manage designs.
 */
export type MutationcreateInProjectFromDesignArgs = {
  input: CreateInProjectFromDesignInput
}

/**
 * Root mutation type for the Design API.
 * Provides operations to create, update, and manage designs.
 */
export type MutationcreateIncentivisedRemindersArgs = {
  input: Array<ReminderInput>
}

/**
 * Root mutation type for the Design API.
 * Provides operations to create, update, and manage designs.
 */
export type MutationcreatePhotoUploadArgs = {
  input: CreatePhotoUploadInput
}

/**
 * Root mutation type for the Design API.
 * Provides operations to create, update, and manage designs.
 */
export type MutationcreateReminderArgs = {
  input: ReminderInput
}

/**
 * Root mutation type for the Design API.
 * Provides operations to create, update, and manage designs.
 */
export type MutationcreateReminderFromDraftArgs = {
  input: CreateReminderFromDraftInput
}

/**
 * Root mutation type for the Design API.
 * Provides operations to create, update, and manage designs.
 */
export type MutationcreateRemindersAsyncArgs = {
  input: Array<ReminderInput>
}

/**
 * Root mutation type for the Design API.
 * Provides operations to create, update, and manage designs.
 */
export type MutationcreateRemindersFromProductsArgs = {
  input: RemindersFromProductsInput
}

/**
 * Root mutation type for the Design API.
 * Provides operations to create, update, and manage designs.
 */
export type MutationcreateVideoMediaArgs = {
  input: CreateVideoMediaInput
}

/**
 * Root mutation type for the Design API.
 * Provides operations to create, update, and manage designs.
 */
export type MutationcrmDeleteRemindersArgs = {
  input: CrmDeleteRemindersInput
}

/**
 * Root mutation type for the Design API.
 * Provides operations to create, update, and manage designs.
 */
export type MutationcustomerRequestOrderCancellationArgs = {
  input: CustomerRequestOrderCancellationInput
}

/**
 * Root mutation type for the Design API.
 * Provides operations to create, update, and manage designs.
 */
export type MutationdeleteBasketArgs = {
  input?: InputMaybe<DeleteBasketInput>
}

/**
 * Root mutation type for the Design API.
 * Provides operations to create, update, and manage designs.
 */
export type MutationdeleteCustomerCreationsCustomFontArgs = {
  assetId: Scalars['String']['input']
}

/**
 * Root mutation type for the Design API.
 * Provides operations to create, update, and manage designs.
 */
export type MutationdeleteDesignInlayArgs = {
  input: DeleteDesignInlayInput
}

/**
 * Root mutation type for the Design API.
 * Provides operations to create, update, and manage designs.
 */
export type MutationdeleteDraftDesignArgs = {
  input: DeleteDraftDesignInput
}

/**
 * Root mutation type for the Design API.
 * Provides operations to create, update, and manage designs.
 */
export type MutationdeleteLineItemArgs = {
  input: DeleteLineItemInput
}

/**
 * Root mutation type for the Design API.
 * Provides operations to create, update, and manage designs.
 */
export type MutationdeleteRecipientArgs = {
  input: DeleteRecipientInput
}

/**
 * Root mutation type for the Design API.
 * Provides operations to create, update, and manage designs.
 */
export type MutationdeleteReminderArgs = {
  id: Scalars['ID']['input']
  store?: InputMaybe<Store>
}

/**
 * Root mutation type for the Design API.
 * Provides operations to create, update, and manage designs.
 */
export type MutationduplicateLineItemArgs = {
  input: DuplicateLineItemInput
}

/**
 * Root mutation type for the Design API.
 * Provides operations to create, update, and manage designs.
 */
export type MutationexpireCreditsArgs = {
  input: ExpireCreditsInput
}

/**
 * Root mutation type for the Design API.
 * Provides operations to create, update, and manage designs.
 */
export type MutationforgottenPasswordArgs = {
  input: ForgottenPasswordInput
}

/**
 * Root mutation type for the Design API.
 * Provides operations to create, update, and manage designs.
 */
export type MutationgenerateTrackingLinkArgs = {
  input: GenerateTrackingLinkInput
}

/**
 * Root mutation type for the Design API.
 * Provides operations to create, update, and manage designs.
 */
export type MutationgetOrCreateDraftDesignArgs = {
  input: GetOrCreateDraftDesignInput
}

/**
 * Root mutation type for the Design API.
 * Provides operations to create, update, and manage designs.
 */
export type MutationgroupCardAddMessageArgs = {
  input: GroupCardAddMessageInput
}

/**
 * Root mutation type for the Design API.
 * Provides operations to create, update, and manage designs.
 */
export type MutationgroupCardAddMessageV2Args = {
  input: GroupCardAddMessageInputV2
}

/**
 * Root mutation type for the Design API.
 * Provides operations to create, update, and manage designs.
 */
export type MutationgroupCardArchiveProjectArgs = {
  input: GroupCardArchiveProjectInput
}

/**
 * Root mutation type for the Design API.
 * Provides operations to create, update, and manage designs.
 */
export type MutationgroupCardCreateDesignArgs = {
  input: GroupCardCreateDesignInput
}

/**
 * Root mutation type for the Design API.
 * Provides operations to create, update, and manage designs.
 */
export type MutationgroupCardCreateProjectArgs = {
  input: GroupCardCreateProjectInput
}

/**
 * Root mutation type for the Design API.
 * Provides operations to create, update, and manage designs.
 */
export type MutationgroupCardCreateProjectV2Args = {
  input: GroupCardCreateProjectInputV2
}

/**
 * Root mutation type for the Design API.
 * Provides operations to create, update, and manage designs.
 */
export type MutationgroupCardDeleteMessageArgs = {
  input: GroupCardDeleteMessageInput
}

/**
 * Root mutation type for the Design API.
 * Provides operations to create, update, and manage designs.
 */
export type MutationgroupCardDeleteMessageV2Args = {
  input: GroupCardDeleteMessageInput
}

/**
 * Root mutation type for the Design API.
 * Provides operations to create, update, and manage designs.
 */
export type MutationgroupCardDeleteProjectArgs = {
  input: GroupCardDeleteProjectInput
}

/**
 * Root mutation type for the Design API.
 * Provides operations to create, update, and manage designs.
 */
export type MutationgroupCardTrackCheckoutArgs = {
  input: GroupCardTrackCheckoutInput
}

/**
 * Root mutation type for the Design API.
 * Provides operations to create, update, and manage designs.
 */
export type MutationgroupCardUpdateProjectArgs = {
  input: GroupCardUpdateProjectInput
}

/**
 * Root mutation type for the Design API.
 * Provides operations to create, update, and manage designs.
 */
export type MutationgroupCardUpdateProjectV2Args = {
  input: GroupCardUpdateProjectInputV2
}

/**
 * Root mutation type for the Design API.
 * Provides operations to create, update, and manage designs.
 */
export type MutationgroupCardUpdateProjectWithDesignArgs = {
  input: GroupCardUpdateProjectWithDesignInput
}

/**
 * Root mutation type for the Design API.
 * Provides operations to create, update, and manage designs.
 */
export type MutationprocessBusinessRecipientDataArgs = {
  input: ProcessBusinessRecipientDataInput
}

/**
 * Root mutation type for the Design API.
 * Provides operations to create, update, and manage designs.
 */
export type MutationregisterEmailArgs = {
  input: RegisterEmailInput
}

/**
 * Root mutation type for the Design API.
 * Provides operations to create, update, and manage designs.
 */
export type MutationremoveAddressArgs = {
  input: RemoveAddressInput
}

/**
 * Root mutation type for the Design API.
 * Provides operations to create, update, and manage designs.
 */
export type MutationremoveBasketAddressRecipientArgs = {
  input: RemoveBasketAddressRecipientInput
}

/**
 * Root mutation type for the Design API.
 * Provides operations to create, update, and manage designs.
 */
export type MutationremoveBasketVoucherArgs = {
  input: RemoveBasketVoucherInput
}

/**
 * Root mutation type for the Design API.
 * Provides operations to create, update, and manage designs.
 */
export type MutationremoveCustomerAddressArgs = {
  input: CustomerDeleteAddressInput
}

/**
 * Root mutation type for the Design API.
 * Provides operations to create, update, and manage designs.
 */
export type MutationremoveFromFavouritesListArgs = {
  listId?: Scalars['ID']['input']
  productIds: Array<Scalars['String']['input']>
}

/**
 * Root mutation type for the Design API.
 * Provides operations to create, update, and manage designs.
 */
export type MutationremoveFromMultiBuyListArgs = {
  input: RemoveFromMultiBuyListInput
}

/**
 * Root mutation type for the Design API.
 * Provides operations to create, update, and manage designs.
 */
export type MutationremoveKeywordFromBusinessProjectArgs = {
  input: BusinessProjectKeywordInput
}

/**
 * Root mutation type for the Design API.
 * Provides operations to create, update, and manage designs.
 */
export type MutationremoveMembershipFromBasketArgs = {
  input: RemoveMembershipFromBasketInput
}

/**
 * Root mutation type for the Design API.
 * Provides operations to create, update, and manage designs.
 */
export type MutationremoveRecipientAddressArgs = {
  input: RemoveRecipientAddressInput
}

/**
 * Root mutation type for the Design API.
 * Provides operations to create, update, and manage designs.
 */
export type MutationremoveSavedCardArgs = {
  input: RemoveSavedCardInput
}

/**
 * Root mutation type for the Design API.
 * Provides operations to create, update, and manage designs.
 */
export type MutationreportDesignAiCreationsFaceswapArgs = {
  faceswapImageId: Scalars['ID']['input']
}

/**
 * Root mutation type for the Design API.
 * Provides operations to create, update, and manage designs.
 */
export type MutationrequestOrderCancellationArgs = {
  input: RequestOrderCancellationInput
}

/**
 * Root mutation type for the Design API.
 * Provides operations to create, update, and manage designs.
 */
export type MutationrequestResendArgs = {
  input: RequestResendInput
}

/**
 * Root mutation type for the Design API.
 * Provides operations to create, update, and manage designs.
 */
export type MutationrevokeMembershipByCustomerIdArgs = {
  customerId: Scalars['String']['input']
}

/**
 * Root mutation type for the Design API.
 * Provides operations to create, update, and manage designs.
 */
export type MutationselfValidateAddressArgs = {
  input: SelfValidateAddressInput
}

/**
 * Root mutation type for the Design API.
 * Provides operations to create, update, and manage designs.
 */
export type MutationsetBusinessCardCustomisationArgs = {
  input: BusinessCardCustomisationInput
}

/**
 * Root mutation type for the Design API.
 * Provides operations to create, update, and manage designs.
 */
export type MutationsetBusinessCardProductAndDesignArgs = {
  input: BusinessCardProductAndDesignInput
}

/**
 * Root mutation type for the Design API.
 * Provides operations to create, update, and manage designs.
 */
export type MutationsetBusinessProjectSourceArgs = {
  input: SetBusinessProjectSourceInput
}

/**
 * Root mutation type for the Design API.
 * Provides operations to create, update, and manage designs.
 */
export type MutationsetBusinessRecipientsArgs = {
  input: SetBusinessRecipientsInput
}

/**
 * Root mutation type for the Design API.
 * Provides operations to create, update, and manage designs.
 */
export type MutationsetDesignCustomisationsArgs = {
  input: SetDesignCustomisationsInput
}

/**
 * Root mutation type for the Design API.
 * Provides operations to create, update, and manage designs.
 */
export type MutationsetDesignInlayArgs = {
  input: SetDesignInlayInput
}

/**
 * Root mutation type for the Design API.
 * Provides operations to create, update, and manage designs.
 */
export type MutationshareReminderArgs = {
  input: ShareReminderInput
}

/**
 * Root mutation type for the Design API.
 * Provides operations to create, update, and manage designs.
 */
export type MutationsplitLineItemQuantityArgs = {
  input: SplitLineItemQuantityInput
}

/**
 * Root mutation type for the Design API.
 * Provides operations to create, update, and manage designs.
 */
export type MutationsplitMultiQuantityCardsArgs = {
  input: SplitMultiCardsInput
}

/**
 * Root mutation type for the Design API.
 * Provides operations to create, update, and manage designs.
 */
export type MutationtrackRecipientArgs = {
  input: TrackRecipientInput
}

/**
 * Root mutation type for the Design API.
 * Provides operations to create, update, and manage designs.
 */
export type MutationunlinkReminderFromOrderArgs = {
  orderId: Scalars['ID']['input']
  reminderId: Scalars['ID']['input']
}

/**
 * Root mutation type for the Design API.
 * Provides operations to create, update, and manage designs.
 */
export type MutationupdateAddressArgs = {
  input: UpdateAddressInput
}

/**
 * Root mutation type for the Design API.
 * Provides operations to create, update, and manage designs.
 */
export type MutationupdateAddressPackagingArgs = {
  input: UpdateAddressPackagingInput
}

/**
 * Root mutation type for the Design API.
 * Provides operations to create, update, and manage designs.
 */
export type MutationupdateAddressTypeArgs = {
  input: UpdateAddressTypeInput
}

/**
 * Root mutation type for the Design API.
 * Provides operations to create, update, and manage designs.
 */
export type MutationupdateBasketAddressPackagingArgs = {
  input: UpdateBasketAddressPackagingInput
}

/**
 * Root mutation type for the Design API.
 * Provides operations to create, update, and manage designs.
 */
export type MutationupdateContactPreferencesArgs = {
  input: UpdateContactPreferencesInput
}

/**
 * Root mutation type for the Design API.
 * Provides operations to create, update, and manage designs.
 */
export type MutationupdateCustomerAddressArgs = {
  input: CustomerUpdateAddressInput
}

/**
 * Root mutation type for the Design API.
 * Provides operations to create, update, and manage designs.
 */
export type MutationupdateCustomerDetailsArgs = {
  input: UpdateCustomerDetailsInput
}

/**
 * Root mutation type for the Design API.
 * Provides operations to create, update, and manage designs.
 */
export type MutationupdateCustomerMarketingConsentPositionArgs = {
  input: UpdateCustomerMarketingConsentPositionInput
}

/**
 * Root mutation type for the Design API.
 * Provides operations to create, update, and manage designs.
 */
export type MutationupdateEmailArgs = {
  newEmail: Scalars['String']['input']
}

/**
 * Root mutation type for the Design API.
 * Provides operations to create, update, and manage designs.
 */
export type MutationupdateLineItemArgs = {
  input: UpdateLineItemInput
}

/**
 * Root mutation type for the Design API.
 * Provides operations to create, update, and manage designs.
 */
export type MutationupdateLineItemQuantityArgs = {
  input: UpdateLineItemQuantityInput
}

/**
 * Root mutation type for the Design API.
 * Provides operations to create, update, and manage designs.
 */
export type MutationupdateLineItemVariantArgs = {
  input: UpdateLineItemVariantInput
}

/**
 * Root mutation type for the Design API.
 * Provides operations to create, update, and manage designs.
 */
export type MutationupdatePhoneNumberArgs = {
  input: PhoneNumberInput
}

/**
 * Root mutation type for the Design API.
 * Provides operations to create, update, and manage designs.
 */
export type MutationupdateRecipientArgs = {
  input: UpdateRecipientInput
}

/**
 * Root mutation type for the Design API.
 * Provides operations to create, update, and manage designs.
 */
export type MutationupdateRecipientAddressArgs = {
  input: UpdateRecipientAddressInput
}

/**
 * Root mutation type for the Design API.
 * Provides operations to create, update, and manage designs.
 */
export type MutationupdateReminderArgs = {
  id: Scalars['ID']['input']
  input: UpdateReminderInput
}

/**
 * Root mutation type for the Design API.
 * Provides operations to create, update, and manage designs.
 */
export type MutationvalidateBasketArgs = {
  input: ValidateBasketInput
}

/**
 * Root mutation type for the Design API.
 * Provides operations to create, update, and manage designs.
 */
export type MutationvalidateCustomerAddressArgs = {
  input: ValidateCustomerAddressInput
}

export type NationalOccasionDateResult = {
  __typename: 'NationalOccasionDateResult'
  day: Scalars['Int']['output']
  month: Scalars['Int']['output']
  nextDate: Scalars['String']['output']
  occasion: Occasion
}

export type Navigation = {
  __typename: 'Navigation'
  items: Array<NavigationItem>
  navigationEntries: Array<NavigationEntry>
}

export enum NavigationCapability {
  CARD_FINDER = 'CARD_FINDER',
  COLLAGE_CARD = 'COLLAGE_CARD',
  DIGITAL_GIFTS = 'DIGITAL_GIFTS',
  MOONPIG_PLUS = 'MOONPIG_PLUS',
}

export type NavigationEntry =
  | ModuleCarousel
  | NavigationItem
  | { __typename?: '%other' }

export type NavigationItem = {
  __typename: 'NavigationItem'
  icon: Scalars['String']['output']
  image?: Maybe<ContentImage>
  items: Array<NavigationItem>
  label?: Maybe<Scalars['String']['output']>
  requiredCapabilities?: Maybe<Array<NavigationCapability>>
  title: Scalars['String']['output']
  url: Scalars['String']['output']
}

export type NoLineItemsExistForDeliveryIdError = Error & {
  __typename: 'NoLineItemsExistForDeliveryIdError'
  message: Scalars['String']['output']
}

export type Node = {
  id: Scalars['ID']['output']
}

export enum Occasion {
  ANNIVERSARY = 'ANNIVERSARY',
  BIRTHDAY = 'BIRTHDAY',
  BON_VOYAGE = 'BON_VOYAGE',
  CHINESE_NEW_YEAR = 'CHINESE_NEW_YEAR',
  CHRISTENINGS = 'CHRISTENINGS',
  CHRISTMAS = 'CHRISTMAS',
  CONFIRMATION = 'CONFIRMATION',
  CONGRATULATIONS = 'CONGRATULATIONS',
  DIWALI = 'DIWALI',
  DRIVING_TEST = 'DRIVING_TEST',
  EASTER = 'EASTER',
  EID = 'EID',
  ENGAGEMENT = 'ENGAGEMENT',
  EXAMS = 'EXAMS',
  FATHERS_DAY = 'FATHERS_DAY',
  GET_WELL = 'GET_WELL',
  GOOD_LUCK = 'GOOD_LUCK',
  GRADUATION = 'GRADUATION',
  HALLOWEEN = 'HALLOWEEN',
  HOLY_COMMUNION = 'HOLY_COMMUNION',
  IN_REMEMBRANCE = 'IN_REMEMBRANCE',
  JEWISH_CELEBRATIONS = 'JEWISH_CELEBRATIONS',
  JUST_A_NOTE = 'JUST_A_NOTE',
  LEAVING = 'LEAVING',
  LOVE = 'LOVE',
  MOTHERS_DAY = 'MOTHERS_DAY',
  NEW_BABY = 'NEW_BABY',
  NEW_HOME = 'NEW_HOME',
  NEW_JOB = 'NEW_JOB',
  NEW_SCHOOL = 'NEW_SCHOOL',
  NEW_YEAR = 'NEW_YEAR',
  PREGNANCY = 'PREGNANCY',
  RETIREMENT = 'RETIREMENT',
  SAINTS_DAYS = 'SAINTS_DAYS',
  SAINT_NICHOLAS = 'SAINT_NICHOLAS',
  SORRY = 'SORRY',
  SPECIAL_OCCASION = 'SPECIAL_OCCASION',
  SYMPATHY = 'SYMPATHY',
  THANKSGIVING = 'THANKSGIVING',
  THANK_YOU = 'THANK_YOU',
  THINKING_OF_YOU = 'THINKING_OF_YOU',
  VALENTINES_DAY = 'VALENTINES_DAY',
  WEDDING = 'WEDDING',
}

export type OccasionDate = {
  __typename: 'OccasionDate'
  day: Scalars['Int']['output']
  month: Scalars['Int']['output']
}

export type OccasionDateInput = {
  day: Scalars['Int']['input']
  month: Scalars['Int']['input']
}

export type OidcProvider = {
  __typename: 'OidcProvider'
  id: Scalars['String']['output']
  name: Scalars['String']['output']
}

export type OpenGraph = {
  __typename: 'OpenGraph'
  description: Scalars['String']['output']
  image: ContentImage
  locale: Scalars['String']['output']
  siteName: Scalars['String']['output']
  title: Scalars['String']['output']
  type?: Maybe<Scalars['String']['output']>
  url: Scalars['String']['output']
}

export type Order = Node &
  Versioned & {
    __typename: 'Order'
    appliedDiscount?: Maybe<AppliedDiscount>
    client?: Maybe<Scalars['String']['output']>
    costBreakdown: OrderCostBreakdown
    /**
     * Payments: Total of all customerCredit payments on the order
     * @deprecated Payment Breakdowns are no longer provided by orders
     */
    creditsUsed: Money
    customerEmail?: Maybe<Scalars['String']['output']>
    customerId: Scalars['ID']['output']
    id: Scalars['ID']['output']
    membershipOrderItem?: Maybe<MembershipOrderItem>
    orderDate: Scalars['Date']['output']
    orderDeliveries: Array<OrderDelivery>
    /** @deprecated Will be removed in upcoming release, use orderItems on orderDeliveries */
    orderItems: Array<OrderItem>
    orderNumber?: Maybe<Scalars['String']['output']>
    orderRegion: Scalars['String']['output']
    payments: Array<Maybe<Payment>>
    /**
     * Total: Shipping price for the order
     * @deprecated Use costBreakdown.postageTotal instead
     */
    postagePrice: Money
    selfServe: SelfServe
    selfServiceSupportOptions: SelfServiceSupportOptions
    /** @deprecated Will be removed in upcoming release, use shippingAddress on orderDeliveries */
    shippingAddress: ShippingAddress
    showSupportButton: Scalars['Boolean']['output']
    /** @deprecated Use orderRegion instead */
    store: Store
    /**
     * Total: total of order (itemprice + shipping + tax) w/o (discount)
     * @deprecated Use costBreakdown.subtotal instead
     */
    subTotalIncTax: Money
    /**
     * Total: total of order (itemprice + tax + discount) w/o (shipping)
     * @deprecated Use costBreakdown.subtotal instead
     */
    subTotalPrice: Money
    supportOptions: SupportOptions
    /**
     * Total: discount applied to the order
     * @deprecated Use costBreakdown.discountTotal instead
     */
    totalDiscount?: Maybe<Money>
    /**
     * Total: price of all items in the order
     * @deprecated Use costBreakdown.itemTotal instead
     */
    totalItemPrice: Money
    totalItems: Scalars['Int']['output']
    /**
     * Payments: Total of all non-customerCredit payments on the order
     * @deprecated Payment Breakdowns are excluded by Orders, use costBreakdown.total.gross for the closest alternative
     */
    totalPaid: Money
    /**
     * Total: total of order (itemprice + shipping + tax)
     * @deprecated Use costBreakdown.total instead
     */
    totalPrice: Money
    /**
     * Total: total of order (itemprice + shipping) w/o (tax)
     * @deprecated Use costBreakdown.total instead
     */
    totalPriceGross: Money
    /**
     * Total: Shipping price for the order
     * @deprecated Use costBreakdown.postageTotal instead
     */
    totalShippingPrice: Money
    /**
     * Total: total of order w/o tax
     * @deprecated Use costBreakdown.total.net instead
     */
    totalTaxExclusive?: Maybe<Money>
    version: Scalars['Long']['output']
  }

export type OrderAddon = {
  __typename: 'OrderAddon'
  costBreakdown: OrderLineItemCostBreakdown
  coverImage?: Maybe<Image>
  id: Scalars['ID']['output']
  isHighFatSaltSugar: Scalars['Boolean']['output']
  sku: Scalars['String']['output']
  title: Scalars['String']['output']
  /** @deprecated Use costBreakdown.total */
  totalPrice: Money
  /** @deprecated Use costBreakdown.unitValue */
  unitPrice: Money
}

export type OrderCancellationError = {
  __typename: 'OrderCancellationError'
  errorDetails: Scalars['String']['output']
  orderId: Scalars['ID']['output']
}

export type OrderCancellationSummary = {
  __typename: 'OrderCancellationSummary'
  customerId: Scalars['ID']['output']
  deliveries?: Maybe<Array<Scalars['String']['output']>>
  orderId: Scalars['ID']['output']
}

export type OrderConnection = {
  __typename: 'OrderConnection'
  edges: Array<OrderEdge>
  pageInfo: OrderConnectionPageInfo
}

export type OrderConnectionPageInfo = {
  __typename: 'OrderConnectionPageInfo'
  /**
   * Opaque cursor for the last edge on this page. Pass it as after to fetch
   * the next page. Null when the page is empty.
   */
  endCursor?: Maybe<Scalars['String']['output']>
  hasNextPage: Scalars['Boolean']['output']
  hasPreviousPage: Scalars['Boolean']['output']
  /** Opaque cursor for the first edge on this page. Null when the page is empty. */
  startCursor?: Maybe<Scalars['String']['output']>
}

export type OrderCostBreakdown = {
  __typename: 'OrderCostBreakdown'
  /** Discount Total: Total Discount (after VAT & Order-wide discounts) */
  discountTotal?: Maybe<OrderDiscountTotal>
  /** Item Total: Total of all line items in the order (before Order-level VAT & discounts) */
  itemTotal: OrderSubtotal
  /** Membership Total: Total of any included memberships (before Order-level VAT & discounts) */
  membershipTotal?: Maybe<OrderSubtotal>
  /** Postage Total: Total of all delivery-related costs (before Order-level VAT & discounts) */
  postageTotal: OrderSubtotal
  /** Subtotal: Total of Order (before Order-level VAT & discounts) */
  subtotal: OrderSubtotal
  /** Total: Total of Order (after Order-wide VAT & discounts) */
  total: OrderTotal
}

export type OrderDate = {
  __typename: 'OrderDate'
  timestamp: Scalars['Date']['output']
}

export type OrderDelivery = {
  __typename: 'OrderDelivery'
  actualDispatchDate?: Maybe<Scalars['Date']['output']>
  /** @deprecated Use recipientAddress */
  address: ShippingAddress
  costBreakdown: OrderDeliveryCostBreakdown
  deliveryDate: Scalars['Date']['output']
  deliveryInformation?: Maybe<OrderDeliveryInformation>
  deliveryStatus: DeliveryStatus
  estimatedDispatchDate?: Maybe<Scalars['Date']['output']>
  id: Scalars['ID']['output']
  instructions?: Maybe<Scalars['String']['output']>
  isShareable: Scalars['Boolean']['output']
  mobile?: Maybe<Scalars['String']['output']>
  order: Order
  orderItems: Array<OrderItem>
  recipientAddress: RecipientAddress
  selfServiceSupportOptions: SelfServiceSupportOptions
  serviceTarget: DeliveryServiceTarget
  /** @deprecated Use costBreakdown.postageTotal */
  shippingPrice: Money
  /** @deprecated Use deliveryStatus */
  status: OrderStatus
  supportOptions: SupportOptions
}

export type OrderDeliveryConnection = {
  __typename: 'OrderDeliveryConnection'
  edges: Array<OrderDeliveryEdge>
  pageInfo: OrderConnectionPageInfo
}

export type OrderDeliveryCostBreakdown = {
  __typename: 'OrderDeliveryCostBreakdown'
  itemTotal: OrderSubtotal
  postageTotal: OrderSubtotal
  subtotal: OrderSubtotal
}

export type OrderDeliveryEdge = {
  __typename: 'OrderDeliveryEdge'
  cursor: Scalars['String']['output']
  node: OrderDelivery
}

export type OrderDeliveryInformation = {
  __typename: 'OrderDeliveryInformation'
  courierDetails: CourierDetails
  deliveryMethodId?: Maybe<Scalars['String']['output']>
  deliveryMethodName?: Maybe<Scalars['String']['output']>
  fulfilmentCentre?: Maybe<FulfilmentCentre>
  fullTrackingUrl?: Maybe<Scalars['String']['output']>
  isTracked: Scalars['Boolean']['output']
  /** @deprecated Will be removed in upcoming release, for Id use deliveryMethodId, for human readable version use deliveryMethodName */
  postageType?: Maybe<PostageType>
  trackingNumber?: Maybe<Scalars['String']['output']>
  /** @deprecated Use `fullTrackingUrl`. */
  trackingUrl?: Maybe<Scalars['String']['output']>
}

export type OrderDeliveryInformationcourierDetailsArgs = {
  excludeFromDisplay?: InputMaybe<Array<Courier>>
}

export type OrderDeliverySearchFilter = {
  recipientEmail?: InputMaybe<Scalars['String']['input']>
  recipientPostcode?: InputMaybe<Scalars['String']['input']>
}

export type OrderDigitalGift = {
  __typename: 'OrderDigitalGift'
  costBreakdown: OrderLineItemCostBreakdown
  coverImage?: Maybe<Image>
  id: Scalars['ID']['output']
  sku: Scalars['String']['output']
  title: Scalars['String']['output']
  /** @deprecated Use costBreakdown.total */
  totalPrice: Money
  /** @deprecated Use costBreakdown.unitValue */
  unitPrice: Money
}

export type OrderDiscountTotal = OrderTaxBreakdown & {
  __typename: 'OrderDiscountTotal'
  gross: Money
  net: Money
}

export type OrderEdge = {
  __typename: 'OrderEdge'
  cursor: Scalars['String']['output']
  node: Order
}

export type OrderItem = Node & {
  __typename: 'OrderItem'
  addons: Array<Maybe<OrderAddon>>
  costBreakdown: OrderLineItemCostBreakdown
  /** @deprecated Use 'previewImages' instead. */
  coverImage?: Maybe<Image>
  deliveryId: Scalars['String']['output']
  design?: Maybe<Design>
  digitalGift?: Maybe<OrderDigitalGift>
  id: Scalars['ID']['output']
  isHighFatSaltSugar: Scalars['Boolean']['output']
  lineItemId: Scalars['String']['output']
  packaging?: Maybe<OrderPackaging>
  previewImages: Array<Maybe<Image>>
  productKey?: Maybe<Scalars['String']['output']>
  productSlug?: Maybe<Scalars['String']['output']>
  productType?: Maybe<Scalars['String']['output']>
  productVariantDetails?: Maybe<ProductVariant>
  quantity: Scalars['Int']['output']
  size?: Maybe<Scalars['String']['output']>
  sku?: Maybe<Scalars['String']['output']>
  title: Scalars['String']['output']
  /** @deprecated Use costBreakdown.total.discount */
  totalDiscount?: Maybe<Money>
  /** @deprecated Use costBreakdown.total */
  totalPrice: Money
  /** @deprecated Use costBreakdown.unitValue */
  unitPrice: Money
}

export type OrderLineItemCostBreakdown = {
  __typename: 'OrderLineItemCostBreakdown'
  total: OrderSubtotal
  unitValue?: Maybe<Money>
}

export type OrderPackaging = {
  __typename: 'OrderPackaging'
  costBreakdown: OrderLineItemCostBreakdown
  coverImage?: Maybe<Image>
  id: Scalars['ID']['output']
  sku: Scalars['String']['output']
  title: Scalars['String']['output']
  /** @deprecated Use costBreakdown.total */
  totalPrice: Money
  /** @deprecated Use costBreakdown.unitValue */
  unitPrice: Money
}

export type OrderRecipientData = {
  productIds: Array<Scalars['String']['input']>
  recipientName: Scalars['String']['input']
}

export type OrderSearchFilter = {
  orderId?: InputMaybe<Scalars['ID']['input']>
  orderNumber?: InputMaybe<Scalars['String']['input']>
}

export enum OrderStatus {
  CANCELLED = 'CANCELLED',
  ON_HOLD = 'ON_HOLD',
  PRINTING = 'PRINTING',
  RECEIVED = 'RECEIVED',
  SENT = 'SENT',
}

export type OrderSubtotal = OrderTaxBreakdown &
  OrderValueBreakdown & {
    __typename: 'OrderSubtotal'
    discount?: Maybe<OrderDiscountTotal>
    gross: Money
    net: Money
    tax?: Maybe<Money>
    value: Money
  }

export type OrderTaxBreakdown = {
  /** Gross: Tax-inclusive price after discount */
  gross: Money
  /** Net: Tax-exclusive price after discount */
  net: Money
}

export type OrderTotal = OrderTaxBreakdown & {
  __typename: 'OrderTotal'
  gross: Money
  net: Money
  tax?: Maybe<Money>
}

export type OrderValueBreakdown = {
  /** Value: Price before any discounts or tax */
  value: Money
}

export type Orders = {
  __typename: 'Orders'
  items: Array<Order>
  totalCount: Scalars['Long']['output']
}

export type OrdersByDeliveryPostcodeInput = {
  deliveryPostcode: Scalars['String']['input']
  limit?: InputMaybe<Scalars['Long']['input']>
  offset?: InputMaybe<Scalars['Long']['input']>
}

export type OrdersByOrderIdInput = {
  limit?: InputMaybe<Scalars['Long']['input']>
  offset?: InputMaybe<Scalars['Long']['input']>
  orderId: Scalars['ID']['input']
}

export type OrdersByOrderReferenceInput = {
  limit?: InputMaybe<Scalars['Long']['input']>
  offset?: InputMaybe<Scalars['Long']['input']>
  orderReference: Scalars['String']['input']
}

export type Packaging = {
  __typename: 'Packaging'
  defaultSku: Scalars['String']['output']
  title: Scalars['String']['output']
  variants: Array<VariantPackaging>
}

export type Page = {
  __typename: 'Page'
  canonicalSubPath: Scalars['String']['output']
  /** @deprecated canonicalUrl is deprecated. Use canonicalSubPath instead */
  canonicalUrl: Scalars['String']['output']
  description: Scalars['String']['output']
  layout: PageLayout
  modules: Array<Module>
  noIndex: Scalars['Boolean']['output']
  openGraph: OpenGraph
  path: Scalars['String']['output']
  structuredData: Array<StructuredData>
  title: Scalars['String']['output']
}

export type PageInfo = {
  __typename: 'PageInfo'
  endCursor?: Maybe<Scalars['String']['output']>
  hasNextPage: Scalars['Boolean']['output']
  hasPreviousPage: Scalars['Boolean']['output']
  startCursor?: Maybe<Scalars['String']['output']>
}

export enum PageLayout {
  AppHomepage = 'AppHomepage',
  BlogCategoryPage = 'BlogCategoryPage',
  BlogHomepage = 'BlogHomepage',
  BlogPost = 'BlogPost',
  Gallery = 'Gallery',
  Homepage = 'Homepage',
  Info = 'Info',
  Landing = 'Landing',
}

export type PageResult = Page | Redirect | { __typename?: '%other' }

export type Payment = {
  __typename: 'Payment'
  amountPlanned: Money
  createdAt: Scalars['String']['output']
  id: Scalars['ID']['output']
  paymentMethodInfo?: Maybe<PaymentMethodInfo>
  transactions: Array<Maybe<Transaction>>
  version: Scalars['Int']['output']
}

export type PaymentMethodInfo = {
  __typename: 'PaymentMethodInfo'
  method?: Maybe<Scalars['String']['output']>
  paymentInterface: Scalars['String']['output']
}

export type PaymentProvider = {
  __typename: 'PaymentProvider'
  name: Scalars['String']['output']
}

export type PeakService = {
  __typename: 'PeakService'
  deliveryDate: Scalars['Date']['output']
}

export enum PersonalisationFlow {
  CAN_PERSONALISE = 'CAN_PERSONALISE',
  MUST_PERSONALISE = 'MUST_PERSONALISE',
  NONE = 'NONE',
}

export type PhoneNumberInput = {
  phoneNumber: Scalars['String']['input']
  source: Scalars['String']['input']
}

export type Photo = {
  __typename: 'Photo'
  id: Scalars['ID']['output']
  url: Scalars['String']['output']
}

export type PhotoUpload = {
  __typename: 'PhotoUpload'
  fields: Array<MediaUploadField>
  url: Scalars['String']['output']
}

export type PhotoUploadSessionNotFoundError = Error & {
  __typename: 'PhotoUploadSessionNotFoundError'
  message: Scalars['String']['output']
}

export type PhotoUploadSessionUnauthorisedError = Error & {
  __typename: 'PhotoUploadSessionUnauthorisedError'
  message: Scalars['String']['output']
}

export type Photos = {
  __typename: 'Photos'
  photos: Array<Photo>
}

export type PhotosResult =
  | MediaServiceError
  | PhotoUploadSessionNotFoundError
  | PhotoUploadSessionUnauthorisedError
  | Photos
  | { __typename?: '%other' }

export type PhysicalDeliveryCompleteStage = DeliveryStage & {
  __typename: 'PhysicalDeliveryCompleteStage'
  label: Scalars['String']['output']
  progress: DeliveryPipelineProgressState
  stageNumber: Scalars['Int']['output']
  timestamp?: Maybe<Scalars['Date']['output']>
}

export type PhysicalDeliveryOverviewStage = DeliveryStage & {
  __typename: 'PhysicalDeliveryOverviewStage'
  label: Scalars['String']['output']
  progress: DeliveryPipelineProgressState
  stageNumber: Scalars['Int']['output']
  timestamp?: Maybe<Scalars['Date']['output']>
}

export type PhysicalFormat = {
  __typename: 'PhysicalFormat'
  name: Scalars['String']['output']
}

export type Placard = {
  __typename: 'Placard'
  cta: CTA
  image: ContentImage
  title: Scalars['String']['output']
}

/** Placeholder photo shown in the editor before customisation. */
export type PlaceholderPhoto = {
  __typename: 'PlaceholderPhoto'
  /** Height in millimeters */
  height: Scalars['Float']['output']
  /** Image for the placeholder photo */
  image: PlaceholderPhotoImage
  /** Rotation angle in degrees (optional) */
  rotation?: Maybe<Scalars['Float']['output']>
  /** Width in millimeters */
  width: Scalars['Float']['output']
  /** Horizontal position in millimeters */
  x: Scalars['Float']['output']
  /** Vertical position in millimeters */
  y: Scalars['Float']['output']
}

/** Image information for a placeholder photo. */
export type PlaceholderPhotoImage = {
  __typename: 'PlaceholderPhotoImage'
  /** URL to the placeholder photo image */
  url: Scalars['String']['output']
}

/** Placeholder sticker shown in the editor before customisation. */
export type PlaceholderSticker = {
  __typename: 'PlaceholderSticker'
  /** Height in millimeters */
  height: Scalars['Float']['output']
  /** Image for the placeholder sticker */
  image: PlaceholderStickerImage
  /** Rotation angle in degrees (optional) */
  rotation?: Maybe<Scalars['Float']['output']>
  /** Width in millimeters */
  width: Scalars['Float']['output']
  /** Horizontal position in millimeters */
  x: Scalars['Float']['output']
  /** Vertical position in millimeters */
  y: Scalars['Float']['output']
}

/** Image information for a placeholder sticker. */
export type PlaceholderStickerImage = {
  __typename: 'PlaceholderStickerImage'
  /** URL to the placeholder sticker image */
  url: Scalars['String']['output']
}

export enum Platform {
  ANDROID = 'ANDROID',
  IOS = 'IOS',
  MOBILE_WEB = 'MOBILE_WEB',
  UNSPECIFIED = 'UNSPECIFIED',
  WEB = 'WEB',
}

export enum PostageType {
  AIR_MAIL_AUSTRAILIA_TO_NEW_ZEALAND = 'AIR_MAIL_AUSTRAILIA_TO_NEW_ZEALAND',
  AIR_MAIL_EUROPE = 'AIR_MAIL_EUROPE',
  AIR_MAIL_OUTSIDE_EUROPE = 'AIR_MAIL_OUTSIDE_EUROPE',
  AUSTRALIAN_EXPRESS_POST_NEXT_DAY_DELIVERY = 'AUSTRALIAN_EXPRESS_POST_NEXT_DAY_DELIVERY',
  AUSTRALIAN_POST = 'AUSTRALIAN_POST',
  DPD_COURIER = 'DPD_COURIER',
  DX_COURIER = 'DX_COURIER',
  EMAIL = 'EMAIL',
  EXPRESS_2ND_DAY = 'EXPRESS_2ND_DAY',
  EXPRESS_OVERNIGHT = 'EXPRESS_OVERNIGHT',
  EXPRESS_POST = 'EXPRESS_POST',
  FEDEX_SATURDAY = 'FEDEX_SATURDAY',
  FEDEX_STANDARD = 'FEDEX_STANDARD',
  FIRST_CLASS = 'FIRST_CLASS',
  FIRST_CLASS_VIA_USPS = 'FIRST_CLASS_VIA_USPS',
  FIRST_CLASS__ORDER_BY_7PM = 'FIRST_CLASS__ORDER_BY_7PM',
  FREE_DELIVERY = 'FREE_DELIVERY',
  INTERLINK = 'INTERLINK',
  MOTHERS_DAY_DELIVERY = 'MOTHERS_DAY_DELIVERY',
  NONE = 'NONE',
  PRINT_SITE_DELIVERY = 'PRINT_SITE_DELIVERY',
  PRINT_SITE_SATURDAY_DELIVERY = 'PRINT_SITE_SATURDAY_DELIVERY',
  RM_TRACKED = 'RM_TRACKED',
  SATURDAY_COURIER = 'SATURDAY_COURIER',
  SECOND_CLASS = 'SECOND_CLASS',
  SPECIAL_DELIVERY = 'SPECIAL_DELIVERY',
  SPECIAL_DELIVERY_SATURDAY = 'SPECIAL_DELIVERY_SATURDAY',
  STANDARD = 'STANDARD',
  STANDARD_COURIER = 'STANDARD_COURIER',
  STANDARD_COURIER_NEXT_BUSINESS_DAY = 'STANDARD_COURIER_NEXT_BUSINESS_DAY',
  STANDARD_PRIORITY = 'STANDARD_PRIORITY',
  TELEGRAM = 'TELEGRAM',
  UK_MAIL = 'UK_MAIL',
  US_POSTAL_SERVICE_STANDARD_DELIVERY = 'US_POSTAL_SERVICE_STANDARD_DELIVERY',
  VALENTINES_DAY_DELIVERY = 'VALENTINES_DAY_DELIVERY',
  YODEL_COURIER = 'YODEL_COURIER',
  YODEL_STANDARD_DELIVERY = 'YODEL_STANDARD_DELIVERY',
}

export type PostcodeLookupError = Error & {
  __typename: 'PostcodeLookupError'
  message: Scalars['String']['output']
}

export type PostcodeLookupResult =
  | LookupAddressesUkResult
  | PostcodeLookupError
  | { __typename?: '%other' }

export type PreviewImage = {
  __typename: 'PreviewImage'
  height: Scalars['Int']['output']
  title: Scalars['String']['output']
  url: Scalars['String']['output']
  width: Scalars['Int']['output']
}

export type PreviewImages = {
  __typename: 'PreviewImages'
  images: Array<PreviewImage>
}

export type PreviewImagesResult =
  | PreviewImages
  | RendererServiceError
  | { __typename?: '%other' }

export type ProcessBusinessRecipientDataInput = {
  header: Scalars['String']['input']
  rows: Array<Scalars['String']['input']>
}

export type ProcessBusinessRecipientDataResult = {
  __typename: 'ProcessBusinessRecipientDataResult'
  recipients: Array<ProcessBusinessRecipientDataResultRecipient>
  successRatePercentage: Scalars['Long']['output']
}

export type ProcessBusinessRecipientDataResultRecipient = {
  __typename: 'ProcessBusinessRecipientDataResultRecipient'
  addressLine1: Scalars['String']['output']
  city: Scalars['String']['output']
  deliveryDate?: Maybe<Scalars['String']['output']>
  firstName: Scalars['String']['output']
  id: Scalars['String']['output']
  lastName: Scalars['String']['output']
  postcode: Scalars['String']['output']
}

export type Product = {
  __typename: 'Product'
  appliedIntents?: Maybe<Array<AppliedIntent>>
  category: ProductCategory
  clickRankDocumentCount: Scalars['Int']['output']
  customisable: Scalars['Boolean']['output']
  dependencies: Array<Maybe<Dependencies>>
  description: Scalars['String']['output']
  dynamicImages?: Maybe<DynamicImagesResponse>
  editableTextFieldCount: Scalars['Int']['output']
  facets: Array<ProductFacet>
  hasAugmentedReality: Scalars['Boolean']['output']
  hasCollageMaker: Scalars['Boolean']['output']
  /** Unique identifier for the product */
  id: Scalars['String']['output']
  isFavourited?: Maybe<Scalars['Boolean']['output']>
  isHighFatSaltSugar: Scalars['Boolean']['output']
  isLandscape: Scalars['Boolean']['output']
  isSponsored: Scalars['Boolean']['output']
  masterVariant: ProductVariant
  moreLikeThis?: Maybe<Array<Product>>
  multiBuyList: MultiBuyListProduct
  /** Personalisation requirements and capabilities for this product */
  personalisation: ProductPersonalisationResult
  photoUploadCount: Scalars['Int']['output']
  primaryProductPill?: Maybe<ProductPill>
  productPills: Array<ProductPill>
  publishDate?: Maybe<Scalars['DateTime']['output']>
  range?: Maybe<ProductRange>
  rating?: Maybe<ProductRating>
  recommendations: Recommendations
  relatedTerms?: Maybe<RelatedTerms>
  restrictions?: Maybe<Restrictions>
  slug: Scalars['String']['output']
  title: Scalars['String']['output']
  usps?: Maybe<UspGroup>
  variants: Array<ProductVariant>
  voucherOptions?: Maybe<VoucherOptions>
}

export type ProductdynamicImagesArgs = {
  appliedIntents?: InputMaybe<Array<AppliedIntentInput>>
}

export type ProductmoreLikeThisArgs = {
  appliedIntents?: InputMaybe<Array<AppliedIntentInput>>
  department?: InputMaybe<DepartmentsEnum>
  limit?: InputMaybe<Scalars['Int']['input']>
  range?: InputMaybe<Scalars['String']['input']>
}

export type ProductrecommendationsArgs = {
  algorithmId?: InputMaybe<Scalars['String']['input']>
  facets?: InputMaybe<RecommendationFacets>
}

export type ProductCategory = {
  __typename: 'ProductCategory'
  /** @deprecated Do not base logic on this value, speak to Product Studio about alternatives. */
  department: DepartmentsEnum
  /** @deprecated Do not base logic on this id, speak to Product Studio about alternatives. */
  id: Scalars['Int']['output']
  name: Scalars['String']['output']
  /** @deprecated Do not base logic on this value, speak to Product Studio about alternatives. */
  parentDepartment: DepartmentsEnum
  slug: Scalars['String']['output']
}

export type ProductFacet = {
  __typename: 'ProductFacet'
  facetKey?: Maybe<Scalars['String']['output']>
  label?: Maybe<Scalars['String']['output']>
  /** @deprecated Use 'group' instead. */
  name: Scalars['String']['output']
  /** @deprecated No longer supported */
  path?: Maybe<Scalars['String']['output']>
  /** @deprecated Use 'facetKey' instead as it is language agnostic */
  value: Scalars['String']['output']
}

export type ProductImage = {
  __typename: 'ProductImage'
  extraLarge: SizedImage
  large: SizedImage
  medium: SizedImage
  original: SizedImage
  small: SizedImage
  thumb: SizedImage
}

export type ProductImages = {
  __typename: 'ProductImages'
  images: Array<ProductImage>
  mainImage: ProductImage
}

export type ProductInspiration = {
  __typename: 'ProductInspiration'
  department: DepartmentsEnum
  productSku: Scalars['String']['output']
}

export type ProductList = CategoryListRecommendation & {
  __typename: 'ProductList'
  description?: Maybe<Scalars['String']['output']>
  name: Scalars['String']['output']
  products: Array<Maybe<Product>>
}

export type ProductLookupResults = {
  __typename: 'ProductLookupResults'
  count: Scalars['Int']['output']
  products: Array<Product>
}

export type ProductNotFoundError = Error & {
  __typename: 'ProductNotFoundError'
  message: Scalars['String']['output']
}

/** Error returned when attempting to create a design for a product that is not personalisable. */
export type ProductNotPersonalisableError = Error & {
  __typename: 'ProductNotPersonalisableError'
  /** Error message describing why the product is not personalisable */
  message: Scalars['String']['output']
}

export type ProductPage = {
  __typename: 'ProductPage'
  department: Scalars['ID']['output']
  modules: Array<ProductPageModule>
}

export type ProductPageInput = {
  parentDepartmentID: Scalars['String']['input']
  preview?: InputMaybe<Scalars['Boolean']['input']>
  subDepartmentID: Scalars['String']['input']
}

export type ProductPageModule =
  | ModulePromotionalCard
  | ModuleUspCarousel
  | { __typename?: '%other' }

/** Product personalisation information indicating whether a product requires editing. */
export type ProductPersonalisation = {
  __typename: 'ProductPersonalisation'
  /** Whether the product requires editing before it can be ordered */
  requiresEditing: Scalars['Boolean']['output']
}

/** Result type for product personalisation queries. */
export type ProductPersonalisationResult =
  | DesignServiceError
  | ProductNotPersonalisableError
  | ProductPersonalisation
  | { __typename?: '%other' }

export type ProductPill = {
  __typename: 'ProductPill'
  displayLabel: Scalars['String']['output']
  displayVariant: ProductPillType
}

export enum ProductPillType {
  ECO = 'ECO',
  MARKETING = 'MARKETING',
  PLUS = 'PLUS',
  PRICE = 'PRICE',
  UNIQUE_SELLING_POINT = 'UNIQUE_SELLING_POINT',
}

export type ProductRange = {
  __typename: 'ProductRange'
  key: Scalars['String']['output']
}

export type ProductRating = {
  __typename: 'ProductRating'
  count: Scalars['Int']['output']
  score: Scalars['Float']['output']
}

export type ProductSearchResults = {
  __typename: 'ProductSearchResults'
  appliedIntents: Array<AppliedIntent>
  count: Scalars['Int']['output']
  departmentCounts: Array<AlternativeSearchDepartmentCount>
  isMultiBuySupported?: Maybe<Scalars['Boolean']['output']>
  products: Array<Product>
  redirectedDepartment?: Maybe<DepartmentsEnum>
  spellingCorrection?: Maybe<SpellingCorrection>
  suggestions: Array<Product>
  supportedSortOrders: Array<SortOrderDescriptor>
  totalClickRankDocumentCount: Scalars['Int']['output']
}

export type ProductVariant = {
  __typename: 'ProductVariant'
  addons?: Maybe<Array<Addon>>
  availablePackaging?: Maybe<Packaging>
  capabilities?: Maybe<Capabilities>
  content?: Maybe<ProductVariantContentResult>
  dimensions?: Maybe<ProductVariantDimensions>
  discountedPercentage?: Maybe<Scalars['Float']['output']>
  flows: ProductVariantFlow
  format: ProductVariantFormat
  fullPrice: Money
  /** @deprecated Use new productImages fields */
  images: Array<Image>
  inStock: Scalars['Boolean']['output']
  /** @deprecated Use SKU for identity */
  key: Scalars['String']['output']
  locations?: Maybe<Array<Location>>
  /** @deprecated Use new productImages fields */
  masterImage: Image
  memberPrices?: Maybe<MemberPrices>
  /** @deprecated Use 'quantity' instead. */
  minimumQuantity: Scalars['Int']['output']
  price: Money
  productId: Scalars['ID']['output']
  productImages: ProductImages
  quantityOption?: Maybe<QuantityOption>
  /** @deprecated Do not use for conditionals; instead use more descriptive properties such as flows and format */
  sizeId: Scalars['Int']['output']
  sku?: Maybe<Scalars['String']['output']>
  subtitle?: Maybe<Scalars['String']['output']>
  title: Scalars['String']['output']
}

export type ProductVariantaddonsArgs = {
  clientUsesDescription?: InputMaybe<Scalars['Boolean']['input']>
}

export type ProductVariantContent = {
  __typename: 'ProductVariantContent'
  modules: Array<ProductVariantContentModule>
}

export type ProductVariantContentModule =
  | ProductVariantContentModuleDetails
  | { __typename?: '%other' }

export type ProductVariantContentModuleDetails = {
  __typename: 'ProductVariantContentModuleDetails'
  items: Array<ProductVariantContentModuleDetailsItem>
}

export type ProductVariantContentModuleDetailsItem = {
  __typename: 'ProductVariantContentModuleDetailsItem'
  key: Scalars['String']['output']
  title: Scalars['String']['output']
  value: Scalars['String']['output']
}

export type ProductVariantContentNotFoundError = Error & {
  __typename: 'ProductVariantContentNotFoundError'
  message: Scalars['String']['output']
}

export type ProductVariantContentResult =
  | ProductVariantContent
  | ProductVariantContentNotFoundError
  | { __typename?: '%other' }

export type ProductVariantDimensions = {
  __typename: 'ProductVariantDimensions'
  description: Scalars['String']['output']
  height: Scalars['Int']['output']
  width: Scalars['Int']['output']
}

export type ProductVariantFlow = {
  __typename: 'ProductVariantFlow'
  addToBasket: AddToBasketFlow
  personalisation: PersonalisationFlow
}

export type ProductVariantFormat =
  | DigitalFormat
  | PhysicalFormat
  | { __typename?: '%other' }

export type ProductVariantPrice =
  | MemberPrice
  | MemberStrikethroughPrice
  | RegularPrice
  | StrikethroughPrice
  | { __typename?: '%other' }

export type PromoValidation = BasketValidation & {
  __typename: 'PromoValidation'
  isBlocking: Scalars['Boolean']['output']
  message: Scalars['String']['output']
  title: Scalars['String']['output']
}

export type QuantityOption =
  | FixedQuantity
  | RangeQuantity
  | { __typename?: '%other' }

/**
 * Root query type for the Design API.
 * Provides read-only operations for designs, stickers, fonts, colors, and AI features.
 */
export type Query = {
  __typename: 'Query'
  addressLookup: AddressLookupResult
  addressRequest: AddressRequestResult
  addressSchemas: AddressSchemasResult
  addressesSchemaIsOk: Scalars['Boolean']['output']
  announcement?: Maybe<Announcement>
  appBanner?: Maybe<AppBanner>
  autocompleteAddress: AutocompleteAddressResult
  basketSchemaIsOk: Scalars['Boolean']['output']
  businessAvailableSubstitutions: Array<BusinessAvailableSubstitution>
  businessProductVariant?: Maybe<BusinessProductVariantResponse>
  businessSchemaIsOk: Scalars['Boolean']['output']
  /** Get paginated list of available colors filtered by color set IDs */
  colors: ColorsResult
  contactPreferencesSchemaIsOk: Scalars['Boolean']['output']
  content: Content
  contentDepartments: Array<ContentDepartment>
  contentSchemaIsOk: Scalars['Boolean']['output']
  countries: Array<Country>
  customFontSubmission: CustomerCreationsCustomFontSubmissionResponse
  customFonts: CustomerCreationsCustomFontResponse
  customerCreationsSchemaIsOk: Scalars['Boolean']['output']
  customerSatisfactionSchemaIsOk: Scalars['Boolean']['output']
  customerSchemaIsOk: Scalars['Boolean']['output']
  defaultPackaging?: Maybe<DefaultPackagingResult>
  /** Get a single design by ID with optional filtering */
  design: DesignResult
  designAiCreationsConfig: DesignAiCreationsConfig
  designAiCreationsFaceswap: DesignAiCreationsFaceswapResult
  designAiCreationsSchemaIsOk: Scalars['Boolean']['output']
  /** Get available collage grid layouts */
  designCollageGrids: DesignCollageGridsResult
  /** Get the default/empty design template for a product */
  designDefault: DesignResult
  /** Get configuration for image upload constraints */
  designImageConfig: DesignImageConfig
  /** Validate whether a design meets all requirements for ordering */
  designIsValid: DesignIsValidResult
  /** Get available scene layouts for flexible layout designs */
  designSceneLayouts: DesignSceneLayoutsResult
  /** Health check query to verify the schema is loaded correctly */
  designSchemaIsOk: Scalars['Boolean']['output']
  /** Request a SmartText message to be used in a design. */
  designSmartText: DesignSmartTextResult
  /** Returns either the smart text config or design service error indicating something has gone wrong. */
  designSmartTextConfig: DesignSmartTextConfigResult
  /** Returns a list of stickers or an error indicating something went wrong. */
  designStickerAIConfig: DesignStickerAIConfigResult
  /** List designs for the current user with optional filtering */
  designs: DesignsResult
  dynamicImages: Array<Product>
  dynamicImagesSchemaIsOk: Scalars['Boolean']['output']
  favouritesSchemaIsOk: Scalars['Boolean']['output']
  /** Fetch a Sticker AI task. */
  fetchStickerAITask: FetchStickerAITaskResult
  filters: FilterResults
  /** Get paginated list of available fonts filtered by font set IDs */
  fonts: FontsResult
  getBasketById?: Maybe<Basket>
  getBusinessDeliveryOptions: BusinessDeliveryOptions
  groupCardAddMessageState: AddMessageStateResult
  groupCardAddMessageStateV2: AddMessageStateResultV2
  groupCardConfig: GroupCardConfig
  groupCardConfigV2: GroupCardConfigV2
  groupCardOccasions: GroupCardOccasionsResult
  groupCardTestCustomer: Customer
  groupCardsSchemaIsOk: Scalars['Boolean']['output']
  infoBanner?: Maybe<InfoBanner>
  inlay: InlayResult
  inlaysSchemaIsOk: Scalars['Boolean']['output']
  /** Get paginated list of available image masks */
  masks: MasksResult
  me: Me
  media: MediaResult
  mediaConfig: MediaConfig
  mediaRecipient: MediaRecipientResult
  mediaSchemaIsOk: Scalars['Boolean']['output']
  membershipsSchemaIsOk?: Maybe<Scalars['Boolean']['output']>
  moreLikeThis: Array<Product>
  nationalOccasionDates: Array<NationalOccasionDateResult>
  navigation: Navigation
  nextUnfulfilledReminder?: Maybe<Reminder>
  orderDeliverySearch: OrderDeliveryConnection
  orderSearch: OrderConnection
  /** @deprecated Use orderDeliverySearch with a recipientPostcode filter instead. */
  ordersByDeliveryPostcode?: Maybe<Orders>
  /** @deprecated Use orderSearch with an orderId filter instead. */
  ordersByOrderId?: Maybe<Orders>
  /** @deprecated Use orderSearch with an orderNumber filter instead. */
  ordersByOrderReference?: Maybe<Orders>
  ordersSchemaIsOk: Scalars['Boolean']['output']
  page?: Maybe<PageResult>
  paymentsSchemaIsOk: Scalars['Boolean']['output']
  photos: PhotosResult
  postcodeLookup: PostcodeLookupResult
  productAddon?: Maybe<Addon>
  productAddons?: Maybe<Array<Addon>>
  productLookup: ProductLookupResults
  productSearch: ProductSearchResults
  productsLookupSchemaIsOk: Scalars['Boolean']['output']
  productsSchemaIsOk: Scalars['Boolean']['output']
  purchaseIsForReminder: Scalars['Boolean']['output']
  recipientsSchemaIsOk: Scalars['Boolean']['output']
  recommendations: Array<Recommendation>
  recommendationsBySearchCriteria: Array<Product>
  recommendationsSchemaIsOk: Scalars['Boolean']['output']
  redemption: RedemptionResult
  redemptionSchemaIsOk: Scalars['Boolean']['output']
  reminder: GetReminderResult
  reminderOccasions: Array<ReminderOccasion>
  reminderRelationships: Array<ReminderRelationship>
  reminders: Array<Reminder>
  remindersSchemaIsOk: Scalars['Boolean']['output']
  /** @deprecated This feature has been decomissioned and will now always return an error result */
  rendererDynamicImage: RendererDynamicImageResult
  rendererSchemaIsOk: Scalars['Boolean']['output']
  rendererShareableImages: RendererShareableImagesResult
  searchInspirations: SearchInspirationsResults
  searchSchemaIsOk: Scalars['Boolean']['output']
  searchSuggest: SearchSuggestResults
  segmentationSchemaIsOk: Scalars['Boolean']['output']
  sharedReminder: SharedReminderResult
  /** Get paginated list of available stickers filtered by sticker set IDs */
  stickers: StickersResult
  suggestQuickAdds: Array<SuggestedReminder>
  suggestReminders: Array<SuggestedReminder>
  suggestedMessages: Array<SuggestedMessage>
  suggestions: Suggestions
  suggestionsSchemaIsOk: Scalars['Boolean']['output']
  trackingInformation?: Maybe<TrackingInformationResult>
}

/**
 * Root query type for the Design API.
 * Provides read-only operations for designs, stickers, fonts, colors, and AI features.
 */
export type QueryaddressLookupArgs = {
  input: AddressLookupInput
}

/**
 * Root query type for the Design API.
 * Provides read-only operations for designs, stickers, fonts, colors, and AI features.
 */
export type QueryaddressRequestArgs = {
  id: Scalars['String']['input']
}

/**
 * Root query type for the Design API.
 * Provides read-only operations for designs, stickers, fonts, colors, and AI features.
 */
export type QueryannouncementArgs = {
  name: Scalars['String']['input']
  preview?: InputMaybe<Scalars['Boolean']['input']>
}

/**
 * Root query type for the Design API.
 * Provides read-only operations for designs, stickers, fonts, colors, and AI features.
 */
export type QueryappBannerArgs = {
  preview?: InputMaybe<Scalars['Boolean']['input']>
}

/**
 * Root query type for the Design API.
 * Provides read-only operations for designs, stickers, fonts, colors, and AI features.
 */
export type QueryautocompleteAddressArgs = {
  input: AutocompleteAddressInput
}

/**
 * Root query type for the Design API.
 * Provides read-only operations for designs, stickers, fonts, colors, and AI features.
 */
export type QuerybusinessProductVariantArgs = {
  input: BusinessProductVariantInput
}

/**
 * Root query type for the Design API.
 * Provides read-only operations for designs, stickers, fonts, colors, and AI features.
 */
export type QuerycolorsArgs = {
  after?: InputMaybe<Scalars['ID']['input']>
  filter: ColorsFilterInput
  first?: InputMaybe<Scalars['Int']['input']>
}

/**
 * Root query type for the Design API.
 * Provides read-only operations for designs, stickers, fonts, colors, and AI features.
 */
export type QuerycontentDepartmentsArgs = {
  filter?: InputMaybe<Array<Scalars['ID']['input']>>
  platform?: InputMaybe<ContentPlatform>
  preview?: InputMaybe<Scalars['Boolean']['input']>
  region?: InputMaybe<Region>
}

/**
 * Root query type for the Design API.
 * Provides read-only operations for designs, stickers, fonts, colors, and AI features.
 */
export type QuerycustomFontSubmissionArgs = {
  submissionId: Scalars['ID']['input']
}

/**
 * Root query type for the Design API.
 * Provides read-only operations for designs, stickers, fonts, colors, and AI features.
 */
export type QuerydefaultPackagingArgs = {
  input?: InputMaybe<DefaultPackagingInput>
}

/**
 * Root query type for the Design API.
 * Provides read-only operations for designs, stickers, fonts, colors, and AI features.
 */
export type QuerydesignArgs = {
  filter?: InputMaybe<DesignFilterInput>
  id: Scalars['ID']['input']
}

/**
 * Root query type for the Design API.
 * Provides read-only operations for designs, stickers, fonts, colors, and AI features.
 */
export type QuerydesignAiCreationsFaceswapArgs = {
  faceswapImageId: Scalars['ID']['input']
}

/**
 * Root query type for the Design API.
 * Provides read-only operations for designs, stickers, fonts, colors, and AI features.
 */
export type QuerydesignDefaultArgs = {
  capabilities?: InputMaybe<Array<DesignCapability>>
  filter?: InputMaybe<DesignFilterInput>
  intents?: InputMaybe<Array<DesignIntent>>
  productKey: Scalars['String']['input']
}

/**
 * Root query type for the Design API.
 * Provides read-only operations for designs, stickers, fonts, colors, and AI features.
 */
export type QuerydesignIsValidArgs = {
  input: DesignIsValidInput
}

/**
 * Root query type for the Design API.
 * Provides read-only operations for designs, stickers, fonts, colors, and AI features.
 */
export type QuerydesignSmartTextArgs = {
  input: DesignSmartTextInput
}

/**
 * Root query type for the Design API.
 * Provides read-only operations for designs, stickers, fonts, colors, and AI features.
 */
export type QuerydesignsArgs = {
  filter?: InputMaybe<DesignsFilterInput>
}

/**
 * Root query type for the Design API.
 * Provides read-only operations for designs, stickers, fonts, colors, and AI features.
 */
export type QuerydynamicImagesArgs = {
  appliedIntents: Array<AppliedIntentInput>
  productIds: Array<Scalars['String']['input']>
}

/**
 * Root query type for the Design API.
 * Provides read-only operations for designs, stickers, fonts, colors, and AI features.
 */
export type QueryfetchStickerAITaskArgs = {
  input: FetchStickerAITaskInput
}

/**
 * Root query type for the Design API.
 * Provides read-only operations for designs, stickers, fonts, colors, and AI features.
 */
export type QueryfiltersArgs = {
  department?: InputMaybe<Array<InputMaybe<DepartmentsEnum>>>
  experimentValues?: InputMaybe<Scalars['String']['input']>
  filters?: InputMaybe<CriteriaInput>
  isInitialQuery?: InputMaybe<Scalars['Boolean']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  nbaAlgorithm?: InputMaybe<Scalars['String']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  searchTerm?: InputMaybe<Scalars['String']['input']>
  store?: InputMaybe<StoresEnumType>
  useImprovedRecall?: InputMaybe<Scalars['Boolean']['input']>
  useStemming?: InputMaybe<Scalars['Boolean']['input']>
}

/**
 * Root query type for the Design API.
 * Provides read-only operations for designs, stickers, fonts, colors, and AI features.
 */
export type QueryfontsArgs = {
  after?: InputMaybe<Scalars['ID']['input']>
  filter: FontsFilterInput
  first?: InputMaybe<Scalars['Int']['input']>
}

/**
 * Root query type for the Design API.
 * Provides read-only operations for designs, stickers, fonts, colors, and AI features.
 */
export type QuerygetBasketByIdArgs = {
  id: Scalars['ID']['input']
}

/**
 * Root query type for the Design API.
 * Provides read-only operations for designs, stickers, fonts, colors, and AI features.
 */
export type QuerygroupCardAddMessageStateArgs = {
  addMessageToken: Scalars['String']['input']
}

/**
 * Root query type for the Design API.
 * Provides read-only operations for designs, stickers, fonts, colors, and AI features.
 */
export type QuerygroupCardAddMessageStateV2Args = {
  addMessageToken: Scalars['String']['input']
}

/**
 * Root query type for the Design API.
 * Provides read-only operations for designs, stickers, fonts, colors, and AI features.
 */
export type QueryinfoBannerArgs = {
  preview?: InputMaybe<Scalars['Boolean']['input']>
}

/**
 * Root query type for the Design API.
 * Provides read-only operations for designs, stickers, fonts, colors, and AI features.
 */
export type QueryinlayArgs = {
  height: Scalars['Float']['input']
  id: Scalars['ID']['input']
  width: Scalars['Float']['input']
}

/**
 * Root query type for the Design API.
 * Provides read-only operations for designs, stickers, fonts, colors, and AI features.
 */
export type QuerymasksArgs = {
  after?: InputMaybe<Scalars['ID']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
}

/**
 * Root query type for the Design API.
 * Provides read-only operations for designs, stickers, fonts, colors, and AI features.
 */
export type QuerymediaArgs = {
  activated?: InputMaybe<Scalars['Boolean']['input']>
  id: Scalars['ID']['input']
  interactive?: InputMaybe<Scalars['Boolean']['input']>
}

/**
 * Root query type for the Design API.
 * Provides read-only operations for designs, stickers, fonts, colors, and AI features.
 */
export type QuerymediaRecipientArgs = {
  key: Scalars['String']['input']
}

/**
 * Root query type for the Design API.
 * Provides read-only operations for designs, stickers, fonts, colors, and AI features.
 */
export type QuerymoreLikeThisArgs = {
  appliedIntents?: InputMaybe<Array<AppliedIntentInput>>
  department?: InputMaybe<DepartmentsEnum>
  filters?: InputMaybe<CriteriaInput>
  limit?: InputMaybe<Scalars['Int']['input']>
  productKey: Scalars['String']['input']
  range?: InputMaybe<Scalars['String']['input']>
  searchTerm?: InputMaybe<Scalars['String']['input']>
}

/**
 * Root query type for the Design API.
 * Provides read-only operations for designs, stickers, fonts, colors, and AI features.
 */
export type QuerynavigationArgs = {
  capabilities?: InputMaybe<Array<NavigationCapability>>
  name: Scalars['String']['input']
  preview?: InputMaybe<Scalars['Boolean']['input']>
  region?: InputMaybe<Region>
}

/**
 * Root query type for the Design API.
 * Provides read-only operations for designs, stickers, fonts, colors, and AI features.
 */
export type QuerynextUnfulfilledReminderArgs = {
  endDate?: InputMaybe<Scalars['String']['input']>
}

/**
 * Root query type for the Design API.
 * Provides read-only operations for designs, stickers, fonts, colors, and AI features.
 */
export type QueryorderDeliverySearchArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  filter: OrderDeliverySearchFilter
  limit?: Scalars['Int']['input']
}

/**
 * Root query type for the Design API.
 * Provides read-only operations for designs, stickers, fonts, colors, and AI features.
 */
export type QueryorderSearchArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  filter: OrderSearchFilter
  limit?: Scalars['Int']['input']
}

/**
 * Root query type for the Design API.
 * Provides read-only operations for designs, stickers, fonts, colors, and AI features.
 */
export type QueryordersByDeliveryPostcodeArgs = {
  input: OrdersByDeliveryPostcodeInput
}

/**
 * Root query type for the Design API.
 * Provides read-only operations for designs, stickers, fonts, colors, and AI features.
 */
export type QueryordersByOrderIdArgs = {
  input: OrdersByOrderIdInput
}

/**
 * Root query type for the Design API.
 * Provides read-only operations for designs, stickers, fonts, colors, and AI features.
 */
export type QueryordersByOrderReferenceArgs = {
  input: OrdersByOrderReferenceInput
}

/**
 * Root query type for the Design API.
 * Provides read-only operations for designs, stickers, fonts, colors, and AI features.
 */
export type QuerypageArgs = {
  path: Scalars['String']['input']
  platform?: InputMaybe<ContentPlatform>
  preview?: InputMaybe<Scalars['Boolean']['input']>
  variations?: InputMaybe<Array<ContentVariationInput>>
}

/**
 * Root query type for the Design API.
 * Provides read-only operations for designs, stickers, fonts, colors, and AI features.
 */
export type QueryphotosArgs = {
  sessionId: Scalars['ID']['input']
}

/**
 * Root query type for the Design API.
 * Provides read-only operations for designs, stickers, fonts, colors, and AI features.
 */
export type QuerypostcodeLookupArgs = {
  postcode: Scalars['String']['input']
}

/**
 * Root query type for the Design API.
 * Provides read-only operations for designs, stickers, fonts, colors, and AI features.
 */
export type QueryproductAddonArgs = {
  addonSku: Scalars['String']['input']
}

/**
 * Root query type for the Design API.
 * Provides read-only operations for designs, stickers, fonts, colors, and AI features.
 */
export type QueryproductAddonsArgs = {
  sku: Scalars['String']['input']
}

/**
 * Root query type for the Design API.
 * Provides read-only operations for designs, stickers, fonts, colors, and AI features.
 */
export type QueryproductLookupArgs = {
  experimentValues?: InputMaybe<Scalars['String']['input']>
  filters?: InputMaybe<CriteriaInput>
  productIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  store?: InputMaybe<StoresEnumType>
}

/**
 * Root query type for the Design API.
 * Provides read-only operations for designs, stickers, fonts, colors, and AI features.
 */
export type QueryproductSearchArgs = {
  customerId?: InputMaybe<Scalars['String']['input']>
  department?: InputMaybe<Array<InputMaybe<DepartmentsEnum>>>
  departmentId?: InputMaybe<Scalars['Int']['input']>
  experimentValues?: InputMaybe<Scalars['String']['input']>
  filters?: InputMaybe<CriteriaInput>
  isInitialQuery?: InputMaybe<Scalars['Boolean']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  nbaAlgorithm?: InputMaybe<Scalars['String']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
  platform?: InputMaybe<Platform>
  searchTerm?: InputMaybe<Scalars['String']['input']>
  skipSpellingCorrection?: InputMaybe<Scalars['Boolean']['input']>
  sort?: InputMaybe<Sorts>
  sortOrder?: InputMaybe<SortOrder>
  sponsoredProducts?: InputMaybe<Array<SponsoredProductInput>>
  store?: InputMaybe<StoresEnumType>
  useImprovedRecall?: InputMaybe<Scalars['Boolean']['input']>
  useSmartDepartmentRedirection?: InputMaybe<Scalars['Boolean']['input']>
  useStemming?: InputMaybe<Scalars['Boolean']['input']>
}

/**
 * Root query type for the Design API.
 * Provides read-only operations for designs, stickers, fonts, colors, and AI features.
 */
export type QuerypurchaseIsForReminderArgs = {
  name: Scalars['String']['input']
  occasion: Occasion
}

/**
 * Root query type for the Design API.
 * Provides read-only operations for designs, stickers, fonts, colors, and AI features.
 */
export type QueryrecommendationsArgs = {
  algorithmId?: InputMaybe<Scalars['String']['input']>
  productId: Scalars['String']['input']
}

/**
 * Root query type for the Design API.
 * Provides read-only operations for designs, stickers, fonts, colors, and AI features.
 */
export type QueryrecommendationsBySearchCriteriaArgs = {
  facetKeys: Array<Scalars['String']['input']>
  first?: Scalars['Int']['input']
  searchTerm: Scalars['String']['input']
}

/**
 * Root query type for the Design API.
 * Provides read-only operations for designs, stickers, fonts, colors, and AI features.
 */
export type QueryredemptionArgs = {
  input: RedemptionInput
}

/**
 * Root query type for the Design API.
 * Provides read-only operations for designs, stickers, fonts, colors, and AI features.
 */
export type QueryreminderArgs = {
  input: GetReminderInput
}

/**
 * Root query type for the Design API.
 * Provides read-only operations for designs, stickers, fonts, colors, and AI features.
 */
export type QueryremindersArgs = {
  input: GetRemindersInput
}

/**
 * Root query type for the Design API.
 * Provides read-only operations for designs, stickers, fonts, colors, and AI features.
 */
export type QueryrendererDynamicImageArgs = {
  elementHeight: Scalars['Int']['input']
  elementWidth: Scalars['Int']['input']
  format: RendererDynamicImageFormat
  id: Scalars['ID']['input']
  textParts: Array<Scalars['String']['input']>
}

/**
 * Root query type for the Design API.
 * Provides read-only operations for designs, stickers, fonts, colors, and AI features.
 */
export type QueryrendererShareableImagesArgs = {
  key: Scalars['String']['input']
}

/**
 * Root query type for the Design API.
 * Provides read-only operations for designs, stickers, fonts, colors, and AI features.
 */
export type QuerysearchSuggestArgs = {
  autoCompleteVariant?: InputMaybe<AutoCompleteVariant>
  experimentValues?: InputMaybe<Scalars['String']['input']>
  filters?: InputMaybe<CriteriaInput>
  limit?: InputMaybe<Scalars['Int']['input']>
  platform?: InputMaybe<Platform>
  searchTerm: Scalars['String']['input']
  suggesterType?: InputMaybe<SuggesterType>
}

/**
 * Root query type for the Design API.
 * Provides read-only operations for designs, stickers, fonts, colors, and AI features.
 */
export type QuerysharedReminderArgs = {
  payload: Scalars['String']['input']
}

/**
 * Root query type for the Design API.
 * Provides read-only operations for designs, stickers, fonts, colors, and AI features.
 */
export type QuerystickersArgs = {
  after?: InputMaybe<Scalars['ID']['input']>
  filter: StickersFilterInput
  first?: InputMaybe<Scalars['Int']['input']>
}

/**
 * Root query type for the Design API.
 * Provides read-only operations for designs, stickers, fonts, colors, and AI features.
 */
export type QuerysuggestQuickAddsArgs = {
  input?: InputMaybe<SuggestQuickAddsInput>
}

/**
 * Root query type for the Design API.
 * Provides read-only operations for designs, stickers, fonts, colors, and AI features.
 */
export type QuerysuggestRemindersArgs = {
  name?: InputMaybe<Scalars['String']['input']>
}

/**
 * Root query type for the Design API.
 * Provides read-only operations for designs, stickers, fonts, colors, and AI features.
 */
export type QuerytrackingInformationArgs = {
  input: TrackingInformationInput
}

export type RangeQuantity = {
  __typename: 'RangeQuantity'
  maximum: Scalars['Int']['output']
  minimum: Scalars['Int']['output']
}

export type Recipient = {
  __typename: 'Recipient'
  addresses?: Maybe<AddressList>
  firstName?: Maybe<Scalars['String']['output']>
  fullName?: Maybe<Scalars['String']['output']>
  id: Scalars['ID']['output']
  lastName?: Maybe<Scalars['String']['output']>
}

export type RecipientAddress =
  | EmailAddress
  | ShippingAddress
  | { __typename?: '%other' }

export type RecipientAddressValidationError = Error & {
  __typename: 'RecipientAddressValidationError'
  fieldErrors: Array<KeyedRecipientAddressError>
  message: Scalars['String']['output']
}

export type RecipientList = {
  __typename: 'RecipientList'
  id: Scalars['ID']['output']
  items: Array<Recipient>
}

export type RecipientValidationError = Error & {
  __typename: 'RecipientValidationError'
  fieldErrors: Array<KeyedRecipientError>
  message: Scalars['String']['output']
}

export type Recommendation = {
  __typename: 'Recommendation'
  category: ProductCategory
  customisable: Scalars['Boolean']['output']
  description: Scalars['String']['output']
  id: Scalars['String']['output']
  isLandscape: Scalars['Boolean']['output']
  masterVariant: RecommendedProductVariant
  publishDate?: Maybe<Scalars['DateTime']['output']>
  rating?: Maybe<ProductRating>
  slug: Scalars['String']['output']
  title: Scalars['String']['output']
  variants: Array<RecommendedProductVariant>
}

export type RecommendationCategory = {
  __typename: 'RecommendationCategory'
  categoryName: Scalars['String']['output']
  recommendations: Array<Recommendation>
}

export type RecommendationFacet = {
  __typename: 'RecommendationFacet'
  name: Scalars['String']['output']
  value: Scalars['String']['output']
}

export type RecommendationFacetDetails = {
  __typename: 'RecommendationFacetDetails'
  facetKey?: Maybe<Scalars['String']['output']>
  group: Scalars['String']['output']
  name: Scalars['String']['output']
  path: Scalars['String']['output']
  value: Scalars['String']['output']
}

export type RecommendationFacets = {
  age?: InputMaybe<Scalars['String']['input']>
  occasion?: InputMaybe<Scalars['String']['input']>
  recipient?: InputMaybe<Scalars['String']['input']>
}

export type RecommendationProductCategories = {
  __typename: 'RecommendationProductCategories'
  description?: Maybe<Scalars['String']['output']>
  name?: Maybe<Scalars['String']['output']>
  products: Array<Maybe<Product>>
}

export type RecommendationSearchCriteria = {
  __typename: 'RecommendationSearchCriteria'
  department: DepartmentsEnum
  facetDetails: Array<RecommendationFacetDetails>
  /** @deprecated use facet details for new IA */
  facets: Array<RecommendationFacet>
}

export type RecommendationTabList = CategoryListRecommendation & {
  __typename: 'RecommendationTabList'
  description?: Maybe<Scalars['String']['output']>
  items?: Maybe<Array<Maybe<RecommendationTabs>>>
  name: Scalars['String']['output']
}

export type RecommendationTabs = {
  __typename: 'RecommendationTabs'
  id: Scalars['String']['output']
  link: Scalars['String']['output']
  searchParameters: ContentSearchParameters
  title: Scalars['String']['output']
}

export enum RecommendationType {
  FALLBACK = 'FALLBACK',
  PERSONALISED = 'PERSONALISED',
  TRENDING = 'TRENDING',
  USER_AFFINITY = 'USER_AFFINITY',
}

export type Recommendations = {
  __typename: 'Recommendations'
  categories: Array<RecommendationProductCategories>
  categoryList?: Maybe<CategoryListResult>
  context?: Maybe<RecommendationsContext>
  products: Array<Maybe<Product>>
  promotion?: Maybe<RecommendedPromotion>
  recipientName?: Maybe<Scalars['String']['output']>
  referenceLineItemId?: Maybe<Scalars['ID']['output']>
}

export type RecommendationscategoriesArgs = {
  first?: InputMaybe<Scalars['Int']['input']>
  offset?: InputMaybe<Scalars['Int']['input']>
}

export type RecommendationscategoryListArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
}

export type RecommendationsCategory = {
  __typename: 'RecommendationsCategory'
  name: Scalars['String']['output']
  products: Array<Product>
  recommendationCategory?: Maybe<ReminderRecommendationCategory>
  recommendationType: RecommendationType
  searchCriteria: RecommendationSearchCriteria
}

export type RecommendationsContext = {
  __typename: 'RecommendationsContext'
  birthdayMilestone?: Maybe<Scalars['String']['output']>
}

export type RecommendedProductVariant = {
  __typename: 'RecommendedProductVariant'
  images: Array<Image>
  inStock: Scalars['Boolean']['output']
  key: Scalars['String']['output']
  masterImage: Image
  minimumQuantity: Scalars['Int']['output']
  price: Money
  sizeId: Scalars['Int']['output']
  sku?: Maybe<Scalars['String']['output']>
  title: Scalars['String']['output']
}

export type RecommendedPromotion = {
  __typename: 'RecommendedPromotion'
  code: Scalars['String']['output']
  message: Scalars['String']['output']
}

export type RedeemableDigitalGift = {
  __typename: 'RedeemableDigitalGift'
  action: RedemptionAction
  customerFacingReference?: Maybe<Scalars['String']['output']>
  id: Scalars['String']['output']
  sku: Scalars['String']['output']
}

export type Redemption = {
  __typename: 'Redemption'
  items: Array<RedemptionItem>
}

export type RedemptionAction =
  | ActivateDigitalGift
  | RedirectToSupplier
  | ViewDigitalGift
  | { __typename?: '%other' }

export type RedemptionActivationFailedError = Error & {
  __typename: 'RedemptionActivationFailedError'
  message: Scalars['String']['output']
}

export type RedemptionExpiredError = Error & {
  __typename: 'RedemptionExpiredError'
  message: Scalars['String']['output']
}

export type RedemptionInput = {
  id: Scalars['ID']['input']
}

export type RedemptionItem =
  | RedeemableDigitalGift
  | UnredeemableGift
  | { __typename?: '%other' }

export type RedemptionNotFoundError = Error & {
  __typename: 'RedemptionNotFoundError'
  message: Scalars['String']['output']
}

export type RedemptionResult =
  | Redemption
  | RedemptionActivationFailedError
  | RedemptionExpiredError
  | RedemptionNotFoundError
  | { __typename?: '%other' }

export type Redirect = {
  __typename: 'Redirect'
  url: Scalars['String']['output']
}

export type RedirectToSupplier = {
  __typename: 'RedirectToSupplier'
  url: Scalars['String']['output']
}

export enum Region {
  au = 'au',
  ie = 'ie',
  nl = 'nl',
  uk = 'uk',
  us = 'us',
}

export type RegisterEmailInput = {
  emailAddress: Scalars['String']['input']
}

export type RegisterEmailResult =
  | InvalidEmailError
  | RegisterEmailSuccess
  | { __typename?: '%other' }

export type RegisterEmailSuccess = {
  __typename: 'RegisterEmailSuccess'
  emailAddress: Scalars['String']['output']
}

export type RegularPrice = {
  __typename: 'RegularPrice'
  price: Money
}

export type RelatedTerms = {
  __typename: 'RelatedTerms'
  terms: Array<Scalars['String']['output']>
}

export enum Relationship {
  AUNTIE = 'AUNTIE',
  AUNTIEUNCLE = 'AUNTIEUNCLE',
  BOYFRIEND = 'BOYFRIEND',
  BROTHER = 'BROTHER',
  BROTHER_IN_LAW = 'BROTHER_IN_LAW',
  BROTHER_SISTERINLAW = 'BROTHER_SISTERINLAW',
  DAD = 'DAD',
  DATING_COUPLE = 'DATING_COUPLE',
  DAUGHTER = 'DAUGHTER',
  DAUGHTER_SONINLAW = 'DAUGHTER_SONINLAW',
  FEMALE_COLLEAGUE = 'FEMALE_COLLEAGUE',
  FEMALE_COUSIN = 'FEMALE_COUSIN',
  FEMALE_FRIEND = 'FEMALE_FRIEND',
  FEMALE_TEACHER = 'FEMALE_TEACHER',
  FIANCE = 'FIANCE',
  FIANCEE = 'FIANCEE',
  GIRLFRIEND = 'GIRLFRIEND',
  GODDAUGHTER = 'GODDAUGHTER',
  GODSON = 'GODSON',
  GRANDAD = 'GRANDAD',
  GRANDDAUGHTER = 'GRANDDAUGHTER',
  GRANDSON = 'GRANDSON',
  GRANNY = 'GRANNY',
  GRANNYGRANDAD = 'GRANNYGRANDAD',
  HUSBAND = 'HUSBAND',
  MALE_COLLEAGUE = 'MALE_COLLEAGUE',
  MALE_COUSIN = 'MALE_COUSIN',
  MALE_FRIEND = 'MALE_FRIEND',
  MALE_TEACHER = 'MALE_TEACHER',
  MARRIED_COUPLE = 'MARRIED_COUPLE',
  MUM = 'MUM',
  MUMDAD = 'MUMDAD',
  NEWLY_WEDS = 'NEWLY_WEDS',
  NIECE = 'NIECE',
  SISTER = 'SISTER',
  SISTER_IN_LAW = 'SISTER_IN_LAW',
  SON = 'SON',
  SON_DAUGHTERINLAW = 'SON_DAUGHTERINLAW',
  TWINS = 'TWINS',
  UNCLE = 'UNCLE',
  UNCLE_NEPHEW = 'UNCLE_NEPHEW',
  WIFE = 'WIFE',
}

export type Reminder = Node & {
  __typename: 'Reminder'
  created: Scalars['String']['output']
  daysBeforeOccasionToRemind?: Maybe<Scalars['Int']['output']>
  fulfilledThisCalendarYear: Scalars['Boolean']['output']
  id: Scalars['ID']['output']
  lastOrder?: Maybe<Order>
  name: Scalars['String']['output']
  nextDate: Scalars['String']['output']
  occasion: Occasion
  recipientId: Scalars['ID']['output']
  recommendations: Array<RecommendationsCategory>
  relationship?: Maybe<Relationship>
  source: Source
}

export type ReminderrecommendationsArgs = {
  store?: InputMaybe<Store>
}

export type ReminderAlreadyExists = Error & {
  __typename: 'ReminderAlreadyExists'
  message: Scalars['String']['output']
}

export type ReminderInput = {
  checkIfReminderExists?: InputMaybe<Scalars['Boolean']['input']>
  daysBeforeOccasionToRemind?: InputMaybe<Scalars['Int']['input']>
  name: Scalars['String']['input']
  occasion: Occasion
  occasionDate: OccasionDateInput
  orderId?: InputMaybe<Scalars['ID']['input']>
  relationship?: InputMaybe<Relationship>
  source: Source
  store?: InputMaybe<Store>
}

export type ReminderNotFound = Error & {
  __typename: 'ReminderNotFound'
  id: Scalars['ID']['output']
  message: Scalars['String']['output']
}

export type ReminderOccasion = {
  __typename: 'ReminderOccasion'
  defaultDate?: Maybe<OccasionDate>
  defaultRelationship?: Maybe<Relationship>
  facetKeys: Array<Scalars['String']['output']>
  label: Scalars['String']['output']
  occasion: Occasion
}

export enum ReminderRecommendationCategory {
  CARDS = 'CARDS',
  DIGITAL_GIFTS = 'DIGITAL_GIFTS',
  FLOWERS = 'FLOWERS',
  GIFTS = 'GIFTS',
  UNKNOWN = 'UNKNOWN',
}

export type ReminderRelationship = {
  __typename: 'ReminderRelationship'
  label: Scalars['String']['output']
  relationship: Relationship
}

export type RemindersFromProductsInput = {
  orderDate: OccasionDateInput
  orderRecipientData: Array<OrderRecipientData>
  source?: InputMaybe<Source>
}

export type RemoveAddressInput = {
  id: Scalars['String']['input']
}

export type RemoveAddressResult =
  | AddressError
  | RemoveAddressSuccess
  | { __typename?: '%other' }

export type RemoveAddressSuccess = {
  __typename: 'RemoveAddressSuccess'
  addressBook?: Maybe<AddressBook>
}

export type RemoveBasketAddressRecipientInput = {
  addressId: Scalars['ID']['input']
  id: Scalars['ID']['input']
}

export type RemoveBasketAddressRecipientResult =
  | Basket
  | { __typename?: '%other' }

export type RemoveBasketVoucherInput = {
  id: Scalars['ID']['input']
  /** @deprecated No longer required please remove */
  version?: InputMaybe<Scalars['Long']['input']>
}

export type RemoveBasketVoucherResult =
  | Basket
  | BasketNotFoundError
  | ConcurrentModificationError
  | { __typename?: '%other' }

export type RemoveCustomerAddressResult =
  | AddressNotFoundError
  | ConcurrentModificationError
  | Customer
  | { __typename?: '%other' }

export type RemoveFromFavouritesList = {
  __typename: 'RemoveFromFavouritesList'
  products: Array<Maybe<Product>>
}

export type RemoveFromMultiBuyListError = Error & {
  __typename: 'RemoveFromMultiBuyListError'
  message: Scalars['String']['output']
}

/** Either multiBuyListItemId or sku must be provided. sku takes precedence when both are given. */
export type RemoveFromMultiBuyListInput = {
  multiBuyListItemId?: InputMaybe<Scalars['ID']['input']>
  sku?: InputMaybe<Scalars['String']['input']>
}

export type RemoveFromMultiBuyListResult =
  | RemoveFromMultiBuyListError
  | RemoveFromMultiBuyListSuccess
  | { __typename?: '%other' }

export type RemoveFromMultiBuyListSuccess = {
  __typename: 'RemoveFromMultiBuyListSuccess'
  multiBuyList?: Maybe<MultiBuyList>
}

export type RemoveMembershipFromBasketInput = {
  id: Scalars['ID']['input']
  version: Scalars['Long']['input']
}

export type RemoveMembershipFromBasketResult =
  | Basket
  | BasketNotFoundError
  | ConcurrentModificationError
  | UserInputError
  | { __typename?: '%other' }

export type RemoveRecipientAddressInput = {
  addressId: Scalars['String']['input']
}

export type RemoveRecipientAddressResult =
  | RemoveRecipientAddressSuccess
  | { __typename?: '%other' }

export type RemoveRecipientAddressSuccess = {
  __typename: 'RemoveRecipientAddressSuccess'
  addressId: Scalars['String']['output']
  addresses: AddressList
}

export type RemoveSavedCardError = {
  __typename: 'RemoveSavedCardError'
  message: Scalars['String']['output']
}

export type RemoveSavedCardInput = {
  paymentMethodId: Scalars['String']['input']
}

export type RemoveSavedCardResult =
  | RemoveSavedCardError
  | RemoveSavedCardSuccess
  | { __typename?: '%other' }

export type RemoveSavedCardSuccess = {
  __typename: 'RemoveSavedCardSuccess'
  messageId: Scalars['String']['output']
}

export enum RendererContentType {
  jpeg = 'jpeg',
  png = 'png',
}

export type RendererDynamicImage = {
  __typename: 'RendererDynamicImage'
  height: Scalars['Int']['output']
  url: Scalars['String']['output']
  width: Scalars['Int']['output']
}

export enum RendererDynamicImageFormat {
  JPEG = 'JPEG',
  PNG = 'PNG',
}

export type RendererDynamicImageResult =
  | RendererDynamicImage
  | RendererServiceError
  | { __typename?: '%other' }

export enum RendererFontFacePreset {
  BOLD = 'BOLD',
  REGULAR = 'REGULAR',
}

export enum RendererHarfBuzzVersion {
  LEGACY = 'LEGACY',
  V1_6_1 = 'V1_6_1',
}

export type RendererImage = {
  __typename: 'RendererImage'
  height: Scalars['Int']['output']
  url: Scalars['String']['output']
  width: Scalars['Int']['output']
}

export type RendererImageResult =
  | RendererImage
  | RendererServiceError
  | { __typename?: '%other' }

export type RendererImageUrls = {
  __typename: 'RendererImageUrls'
  editor: Scalars['String']['output']
  preview: Scalars['String']['output']
  print: Scalars['String']['output']
}

export type RendererInlayImage = {
  __typename: 'RendererInlayImage'
  height: Scalars['Int']['output']
  url: Scalars['String']['output']
  width: Scalars['Int']['output']
}

export type RendererInlayImageResult =
  | RendererInlayImage
  | RendererServiceError
  | { __typename?: '%other' }

export type RendererInteractiveElement =
  | RendererInteractiveElementLink
  | { __typename?: '%other' }

export type RendererInteractiveElementLink = {
  __typename: 'RendererInteractiveElementLink'
  height: Scalars['Float']['output']
  label: Scalars['String']['output']
  url: Scalars['String']['output']
  width: Scalars['Float']['output']
  x: Scalars['Float']['output']
  y: Scalars['Float']['output']
}

export type RendererNotFoundError = Error & {
  __typename: 'RendererNotFoundError'
  message: Scalars['String']['output']
}

export enum RendererProductCategory {
  LandscapeCard = 'LandscapeCard',
  Mug = 'Mug',
  PortraitCard = 'PortraitCard',
  SquareCard = 'SquareCard',
  TShirt = 'TShirt',
  Unknown = 'Unknown',
}

export type RendererSceneObject =
  | RendererSceneObjectImage
  | RendererSceneObjectLink
  | RendererSceneObjectQRCode
  | RendererSceneObjectText
  | { __typename?: '%other' }

export type RendererSceneObjectCommon = {
  height: Scalars['Float']['output']
  width: Scalars['Float']['output']
  x: Scalars['Float']['output']
  y: Scalars['Float']['output']
}

export type RendererSceneObjectImage = RendererSceneObjectCommon & {
  __typename: 'RendererSceneObjectImage'
  height: Scalars['Float']['output']
  urls: RendererImageUrls
  width: Scalars['Float']['output']
  x: Scalars['Float']['output']
  y: Scalars['Float']['output']
}

/**
 * Link scene object which will be rendered on eCards for recipients to click on.
 * Generally the position & size should cover the whole of the media element so recipients don't have to click in a specific place.
 */
export type RendererSceneObjectLink = RendererSceneObjectCommon & {
  __typename: 'RendererSceneObjectLink'
  height: Scalars['Float']['output']
  /** Title or accessible name of the link. */
  label: Scalars['String']['output']
  /** URL to send the recipient to when they click on the link. */
  url: Scalars['String']['output']
  width: Scalars['Float']['output']
  x: Scalars['Float']['output']
  y: Scalars['Float']['output']
}

export type RendererSceneObjectQRCode = RendererSceneObjectCommon & {
  __typename: 'RendererSceneObjectQRCode'
  height: Scalars['Float']['output']
  value: Scalars['String']['output']
  width: Scalars['Float']['output']
  x: Scalars['Float']['output']
  y: Scalars['Float']['output']
}

export type RendererSceneObjectText = RendererSceneObjectCommon & {
  __typename: 'RendererSceneObjectText'
  height: Scalars['Float']['output']
  text: Scalars['String']['output']
  width: Scalars['Float']['output']
  x: Scalars['Float']['output']
  y: Scalars['Float']['output']
}

export type RendererServiceError = Error & {
  __typename: 'RendererServiceError'
  message: Scalars['String']['output']
}

export type RendererShareableImage = {
  __typename: 'RendererShareableImage'
  height: Scalars['Int']['output']
  url: Scalars['String']['output']
  width: Scalars['Int']['output']
}

export type RendererShareableImageScene = {
  __typename: 'RendererShareableImageScene'
  height: Scalars['Float']['output']
  image: RendererShareableImage
  interactiveElements: Array<RendererInteractiveElement>
  title: Scalars['String']['output']
  width: Scalars['Float']['output']
}

export type RendererShareableImages = {
  __typename: 'RendererShareableImages'
  layout: RendererShareableImagesLayout
  scenes: Array<RendererShareableImageScene>
}

export enum RendererShareableImagesLayout {
  CARD_LANDSCAPE = 'CARD_LANDSCAPE',
  CARD_PORTRAIT = 'CARD_PORTRAIT',
  GENERIC = 'GENERIC',
}

export type RendererShareableImagesResult =
  | RendererNotFoundError
  | RendererServiceError
  | RendererShareableImages
  | { __typename?: '%other' }

export type RendererSubstitutionInput = {
  name: Scalars['String']['input']
  value: Scalars['String']['input']
}

export type RenewalConfirmationTimelineStep = {
  __typename: 'RenewalConfirmationTimelineStep'
  details: Scalars['String']['output']
  label: Scalars['String']['output']
  pill?: Maybe<Scalars['String']['output']>
  status: RenewalConfirmationTimelineStepStatus
}

export enum RenewalConfirmationTimelineStepStatus {
  active = 'active',
  completed = 'completed',
  incomplete = 'incomplete',
}

export type RenewalDiscountConfirmation = {
  __typename: 'RenewalDiscountConfirmation'
  body: Scalars['String']['output']
  cta: Scalars['String']['output']
  headline: Scalars['String']['output']
  timeline: Array<RenewalConfirmationTimelineStep>
}

export type RenewalDiscountContent = {
  __typename: 'RenewalDiscountContent'
  confirmation: RenewalDiscountConfirmation
  offer: RenewalDiscountOffer
}

export type RenewalDiscountOffer = {
  __typename: 'RenewalDiscountOffer'
  acceptCta: Scalars['String']['output']
  body: Scalars['String']['output']
  declineCta: Scalars['String']['output']
  headline: Scalars['String']['output']
  nextPayment: RenewalNextPayment
  price: RenewalPrice
  renewalInformation: Scalars['String']['output']
}

export type RenewalFrequency = {
  __typename: 'RenewalFrequency'
  intervalCount: Scalars['Int']['output']
  intervalUnit: RenewalFrequencyIntervalUnit
}

export enum RenewalFrequencyIntervalUnit {
  DAY = 'DAY',
  HOUR = 'HOUR',
  MINUTE = 'MINUTE',
  MONTH = 'MONTH',
  YEAR = 'YEAR',
}

export type RenewalNextPayment = {
  __typename: 'RenewalNextPayment'
  date: Scalars['String']['output']
  label: Scalars['String']['output']
  price: RenewalPrice
}

export type RenewalPrice = {
  __typename: 'RenewalPrice'
  priceAfterDiscount: Scalars['String']['output']
  priceBeforeDiscount: Scalars['String']['output']
}

export type RequestOrderCancellationInput = {
  customerId?: InputMaybe<Scalars['String']['input']>
  deliveries?: InputMaybe<Array<Scalars['String']['input']>>
  orderId: Scalars['String']['input']
}

export type RequestOrderCancellationResult =
  | OrderCancellationError
  | OrderCancellationSummary
  | { __typename?: '%other' }

export enum RequestResendErrorCode {
  ORDER_NOT_ELIGIBLE = 'ORDER_NOT_ELIGIBLE',
  ORDER_NOT_FOUND = 'ORDER_NOT_FOUND',
  RESEND_ALREADY_EXISTS = 'RESEND_ALREADY_EXISTS',
  UNEXPECTED_ERROR = 'UNEXPECTED_ERROR',
}

export type RequestResendFailure = RequestResendResult & {
  __typename: 'RequestResendFailure'
  errorCode: RequestResendErrorCode
  message: Scalars['String']['output']
}

export type RequestResendInput = {
  customerId: Scalars['String']['input']
  orderId: Scalars['String']['input']
  strategy?: InputMaybe<RequestResendStrategy>
}

export type RequestResendResult = {
  message: Scalars['String']['output']
}

export enum RequestResendStrategy {
  CHEAPEST = 'CHEAPEST',
  EQUIVALENT = 'EQUIVALENT',
  FASTEST = 'FASTEST',
}

export type RequestResendSuccess = RequestResendResult & {
  __typename: 'RequestResendSuccess'
  message: Scalars['String']['output']
  orderId: Scalars['String']['output']
}

export type RequiredAge = {
  __typename: 'RequiredAge'
  description: Scalars['String']['output']
  minAge: Scalars['Int']['output']
  title: Scalars['String']['output']
}

export type Restrictions = {
  __typename: 'Restrictions'
  requiredAge?: Maybe<RequiredAge>
}

export type RevokeMembershipByCustomerIdResponse = {
  __typename: 'RevokeMembershipByCustomerIdResponse'
  success: Scalars['Boolean']['output']
}

export type RichTextBlock =
  | RichTextBlockHTML
  | RichTextBlockModule
  | { __typename?: '%other' }

export type RichTextBlockHTML = {
  __typename: 'RichTextBlockHTML'
  html: Scalars['String']['output']
}

export type RichTextBlockModule = {
  __typename: 'RichTextBlockModule'
  module: Module
}

export type SEOBlock = {
  __typename: 'SEOBlock'
  richText?: Maybe<Scalars['String']['output']>
  text: Scalars['String']['output']
  title: Scalars['String']['output']
}

export type SavedCard = {
  __typename: 'SavedCard'
  cardType: Scalars['String']['output']
  /** @deprecated Use `savedCards` on `basket`. */
  cvcRequired: Scalars['Boolean']['output']
  dateAdded: Scalars['String']['output']
  expired: Scalars['Boolean']['output']
  expiry: Scalars['String']['output']
  hasActiveMembership: Scalars['Boolean']['output']
  isNonWallet: Scalars['Boolean']['output']
  lastFourDigits: Scalars['String']['output']
  nameOnCard: Scalars['String']['output']
  paymentMethodId: Scalars['String']['output']
}

export type SavedCards = {
  __typename: 'SavedCards'
  cvcRequired: Scalars['Boolean']['output']
}

export type SceneImage = {
  __typename: 'SceneImage'
  title: Scalars['String']['output']
  variants: SceneImageVariants
}

export type SceneImageVariant = {
  __typename: 'SceneImageVariant'
  height: Scalars['Int']['output']
  url: Scalars['String']['output']
  width: Scalars['Int']['output']
}

export type SceneImageVariants = {
  __typename: 'SceneImageVariants'
  large: SceneImageVariant
  small: SceneImageVariant
}

export type SceneImages = {
  __typename: 'SceneImages'
  images: Array<SceneImage>
}

export type SceneImagesResult =
  | RendererServiceError
  | SceneImages
  | { __typename?: '%other' }

export type SearchInspirationsResults = {
  __typename: 'SearchInspirationsResults'
  inspirations: Array<InspirationItem>
}

export type SearchSuggestResults = {
  __typename: 'SearchSuggestResults'
  suggestions: Array<SearchSuggestion>
}

export type SearchSuggestion = {
  __typename: 'SearchSuggestion'
  arguments: SearchSuggestionArguments
  departmentCounts: Array<DepartmentCount>
  departments: Array<DepartmentsEnum>
  score: Scalars['Decimal']['output']
  searchTerm: Scalars['String']['output']
}

export type SearchSuggestionArguments = {
  __typename: 'SearchSuggestionArguments'
  filters?: Maybe<SearchSuggestionFilters>
  searchTerm?: Maybe<Scalars['String']['output']>
}

export type SearchSuggestionFacet = {
  __typename: 'SearchSuggestionFacet'
  facetKey: Scalars['String']['output']
  groups: Array<FacetGroup>
  label?: Maybe<Scalars['String']['output']>
  name: Scalars['String']['output']
  path?: Maybe<Scalars['String']['output']>
  value: Scalars['String']['output']
}

export type SearchSuggestionFilters = {
  __typename: 'SearchSuggestionFilters'
  facets?: Maybe<Array<SearchSuggestionFacet>>
}

export type SearchTermInspiration = {
  __typename: 'SearchTermInspiration'
  department: DepartmentsEnum
  searchTerm: Scalars['String']['output']
}

export type SelfServe = {
  canSelfServe: Scalars['Boolean']['output']
}

export type SelfServeCheck = {
  __typename: 'SelfServeCheck'
  ruleName: Scalars['String']['output']
  userFriendlyError: Scalars['String']['output']
}

export type SelfServeFailure = SelfServe & {
  __typename: 'SelfServeFailure'
  canSelfServe: Scalars['Boolean']['output']
  failedChecks?: Maybe<Array<SelfServeCheck>>
}

export type SelfServeSuccess = SelfServe & {
  __typename: 'SelfServeSuccess'
  canSelfServe: Scalars['Boolean']['output']
}

export type SelfServiceSupportOptions = {
  __typename: 'SelfServiceSupportOptions'
  cancel: Scalars['Boolean']['output']
  returnable: Scalars['Boolean']['output']
}

export type SelfValidateAddressInput = {
  id: Scalars['String']['input']
}

export type SelfValidateAddressResult =
  | ConcurrentModificationError
  | SelfValidatedAddressResult
  | { __typename?: '%other' }

export type SelfValidatedAddressResult = {
  __typename: 'SelfValidatedAddressResult'
  address: ShippingAddress
}

export type SetBusinessProjectSourceInput = {
  source: Scalars['String']['input']
}

export type SetBusinessRecipientsInput = {
  recipients: Array<BusinessRecipientInput>
  sendToSelf?: InputMaybe<BusinessProjectSendToSelfInput>
}

/**
 * Input for the setDesignCustomisations mutation.
 * Updates customisations for one or more scenes in a design.
 */
export type SetDesignCustomisationsInput = {
  /** ID of the design to update */
  designId: Scalars['ID']['input']
  /** List of scenes with their customisations to update */
  scenes: Array<DesignCustomisationsSceneInput>
  /** @deprecated No longer used */
  videoCardId?: InputMaybe<Scalars['String']['input']>
}

/** Result type for the setDesignCustomisations mutation. */
export type SetDesignCustomisationsResult =
  | Design
  | DesignAuthorizationError
  | DesignCustomisationsInputError
  | DesignInvalidTokenError
  | DesignNotFoundError
  | DesignServiceError
  | DesignStateError
  | DesignTemplatesServiceError
  | { __typename?: '%other' }

/**
 * Input for the setDesignInlay mutation.
 * Associates an inlay product with a design.
 */
export type SetDesignInlayInput = {
  /** ID of the design to set the inlay for */
  designId: Scalars['String']['input']
  /** ID of the inlay to associate */
  inlayId: Scalars['String']['input']
  /** Metadata about the inlay */
  metadata: DesignInlayMetadata
}

export type SetDesignInlayResult =
  | Design
  | DesignAuthorizationError
  | DesignNotFoundError
  | DesignServiceError
  | DesignSetInlayError
  | DesignStateError
  | DesignTemplatesServiceError
  | { __typename?: '%other' }

export type ShareReminder = {
  __typename: 'ShareReminder'
  url: Scalars['String']['output']
}

export type ShareReminderInput = {
  id: Scalars['String']['input']
  store?: InputMaybe<Store>
}

export type ShareReminderResult =
  | ReminderNotFound
  | ShareReminder
  | { __typename?: '%other' }

export type SharedReminder = {
  __typename: 'SharedReminder'
  id: Scalars['ID']['output']
  name: Scalars['String']['output']
  nextDate: Scalars['String']['output']
  occasion: Occasion
}

export type SharedReminderResult =
  | BadRequest
  | ReminderNotFound
  | SharedReminder
  | { __typename?: '%other' }

export type ShippingAddress = {
  __typename: 'ShippingAddress'
  addressFirstLine: Scalars['String']['output']
  city?: Maybe<Scalars['String']['output']>
  country: Scalars['String']['output']
  deliveryPointSuffix?: Maybe<Scalars['String']['output']>
  extraAddressLine?: Maybe<Scalars['String']['output']>
  firstName: Scalars['String']['output']
  houseNumber?: Maybe<Scalars['String']['output']>
  houseNumberExtension?: Maybe<Scalars['String']['output']>
  id: Scalars['String']['output']
  isMyAddress: Scalars['Boolean']['output']
  isTypeVerified?: Maybe<Scalars['Boolean']['output']>
  isVerified?: Maybe<Scalars['Boolean']['output']>
  lastName: Scalars['String']['output']
  postcode?: Maybe<Scalars['String']['output']>
  recipientId?: Maybe<Scalars['ID']['output']>
  state?: Maybe<Scalars['String']['output']>
  streetName?: Maybe<Scalars['String']['output']>
  /** @deprecated No longer in use */
  title?: Maybe<Scalars['String']['output']>
}

export type SignupSource = {
  __typename: 'SignupSource'
  key: Scalars['String']['output']
  name: Scalars['String']['output']
}

export type SimpleDeliveryStage = DeliveryStage & {
  __typename: 'SimpleDeliveryStage'
  label: Scalars['String']['output']
  progress: DeliveryPipelineProgressState
  stageNumber: Scalars['Int']['output']
  timestamp?: Maybe<Scalars['Date']['output']>
}

export type SizedImage = {
  __typename: 'SizedImage'
  jpgUrl: Scalars['String']['output']
}

export enum SortOrder {
  NEWNESS = 'NEWNESS',
  POPULARITY = 'POPULARITY',
  PRICE_ASCENDING = 'PRICE_ASCENDING',
  PRICE_DESCENDING = 'PRICE_DESCENDING',
}

export type SortOrderDescriptor = {
  __typename: 'SortOrderDescriptor'
  displayText: Scalars['String']['output']
  isDefault: Scalars['Boolean']['output']
  value: SortOrder
}

export enum Sorts {
  WEIGHTED_ADD_TO_BASKET_RANK = 'WEIGHTED_ADD_TO_BASKET_RANK',
  WEIGHTED_ADD_TO_BASKET_RANK_PLATFORM = 'WEIGHTED_ADD_TO_BASKET_RANK_PLATFORM',
  WEIGHTED_ADD_TO_BASKET_RANK_USER_AFFINITY = 'WEIGHTED_ADD_TO_BASKET_RANK_USER_AFFINITY',
  WEIGHTED_ADD_TO_BASKET_RANK_V2 = 'WEIGHTED_ADD_TO_BASKET_RANK_V2',
  WEIGHTED_CLICK_RANK = 'WEIGHTED_CLICK_RANK',
  WEIGHTED_PERSONALISED_RANK = 'WEIGHTED_PERSONALISED_RANK',
}

export enum Source {
  ANDROID_BACK_TO_ME = 'ANDROID_BACK_TO_ME',
  ANDROID_CREATE_ADDRESS = 'ANDROID_CREATE_ADDRESS',
  ANDROID_INFLOW_QUICK_ADD = 'ANDROID_INFLOW_QUICK_ADD',
  ANDROID_REMINDERS_TAB = 'ANDROID_REMINDERS_TAB',
  ANDROID_SEND_DIRECT = 'ANDROID_SEND_DIRECT',
  ANDROID_SOFT_OPT_IN_QUICK_ADD = 'ANDROID_SOFT_OPT_IN_QUICK_ADD',
  ANDROID_SOFT_OPT_IN_REMINDERS = 'ANDROID_SOFT_OPT_IN_REMINDERS',
  EMAIL_UNKNOWN = 'EMAIL_UNKNOWN',
  FACEBOOK_UNKNOWN = 'FACEBOOK_UNKNOWN',
  IOS_BACK_TO_ME_INFLOW_REMINDER = 'IOS_BACK_TO_ME_INFLOW_REMINDER',
  IOS_BULK_IMPORT = 'IOS_BULK_IMPORT',
  IOS_CREATE_ADDRESS = 'IOS_CREATE_ADDRESS',
  IOS_INCENTIVISED_REMINDER_MODAL = 'IOS_INCENTIVISED_REMINDER_MODAL',
  IOS_INFLOW_QUICK_ADD = 'IOS_INFLOW_QUICK_ADD',
  IOS_ORDER_CONFIRMATION = 'IOS_ORDER_CONFIRMATION',
  IOS_REMINDERS_TAB = 'IOS_REMINDERS_TAB',
  IOS_SEND_DIRECT = 'IOS_SEND_DIRECT',
  IOS_SOFT_OPT_IN_QUICK_ADD = 'IOS_SOFT_OPT_IN_QUICK_ADD',
  IOS_SOFT_OPT_IN_REMINDERS = 'IOS_SOFT_OPT_IN_REMINDERS',
  UNKNOWN = 'UNKNOWN',
  WEB_INCENTIVISED_REMINDER_MODAL = 'WEB_INCENTIVISED_REMINDER_MODAL',
  WEB_INCENTIVISED_REMINDER_MODAL_QUICK_ADD = 'WEB_INCENTIVISED_REMINDER_MODAL_QUICK_ADD',
  WEB_INFLOW_MODAL = 'WEB_INFLOW_MODAL',
  WEB_INFLOW_QUICK_ADD = 'WEB_INFLOW_QUICK_ADD',
  WEB_LOAD_TEST = 'WEB_LOAD_TEST',
  WEB_MIGRATED_REMINDER_FLOW = 'WEB_MIGRATED_REMINDER_FLOW',
  WEB_MULTI_INFLOW_MODAL = 'WEB_MULTI_INFLOW_MODAL',
  WEB_MY_ACCOUNT = 'WEB_MY_ACCOUNT',
  WEB_MY_ACCOUNT_QUICK_ADD = 'WEB_MY_ACCOUNT_QUICK_ADD',
  WEB_ORDER_CONFIRMATION = 'WEB_ORDER_CONFIRMATION',
  WEB_REMINDER_MODAL = 'WEB_REMINDER_MODAL',
  WEB_REMINDER_MODAL_QUICK_ADD = 'WEB_REMINDER_MODAL_QUICK_ADD',
  WEB_REMINDER_PAGE = 'WEB_REMINDER_PAGE',
  WEB_SHARED_REMINDER = 'WEB_SHARED_REMINDER',
  WEB_SOFT_OPT_IN_QUICK_ADD = 'WEB_SOFT_OPT_IN_QUICK_ADD',
  WEB_SOFT_OPT_IN_REMINDERS = 'WEB_SOFT_OPT_IN_REMINDERS',
  WEB_UNKNOWN = 'WEB_UNKNOWN',
}

export type SpellingCorrection = {
  __typename: 'SpellingCorrection'
  correctedSearchTerm: Scalars['String']['output']
  initialSearchTerm: Scalars['String']['output']
}

export type SplitLineItemQuantityInput = {
  lineItemId: Scalars['ID']['input']
}

export type SplitLineItemQuantityResult =
  | Basket
  | BasketNotFoundError
  | ConcurrentModificationError
  | LineItemNotFoundError
  | { __typename?: '%other' }

export type SplitMultiCardsInput = {
  id: Scalars['ID']['input']
}

export type SplitMultiCardsResult = Basket | { __typename?: '%other' }

export type SponsoredProduct = {
  __typename: 'SponsoredProduct'
  internallyPromoted: Scalars['Boolean']['output']
  productKey: Scalars['String']['output']
}

export type SponsoredProductInput = {
  internallyPromoted: Scalars['Boolean']['input']
  productKey: Scalars['String']['input']
}

export type StandardLineItemPrice = {
  __typename: 'StandardLineItemPrice'
  value: Money
}

export type Sticker = {
  __typename: 'Sticker'
  id: Scalars['ID']['output']
  urls: StickerUrls
}

export type StickerEdge = {
  __typename: 'StickerEdge'
  cursor: Scalars['ID']['output']
  node: Sticker
}

export type StickerEdges = {
  __typename: 'StickerEdges'
  edges: Array<StickerEdge>
  pageInfo: StickerPageInfo
  totalCount: Scalars['Int']['output']
}

export type StickerPageInfo = {
  __typename: 'StickerPageInfo'
  endCursor?: Maybe<Scalars['ID']['output']>
  hasNextPage: Scalars['Boolean']['output']
}

export type StickerUrls = {
  __typename: 'StickerUrls'
  editor: Scalars['String']['output']
  editorThumbnail: Scalars['String']['output']
  preview: Scalars['String']['output']
  print: Scalars['String']['output']
}

/** Input for filtering stickers by set IDs. */
export type StickersFilterInput = {
  /** List of sticker set IDs to filter by */
  stickerSetIds: Array<Scalars['ID']['input']>
}

export type StickersResult =
  | DesignInvalidCursorError
  | DesignServiceError
  | StickerEdges
  | { __typename?: '%other' }

export type StockValidation = BasketValidation & {
  __typename: 'StockValidation'
  isBlocking: Scalars['Boolean']['output']
  message: Scalars['String']['output']
  title: Scalars['String']['output']
}

export enum Store {
  AU = 'AU',
  IE = 'IE',
  UK = 'UK',
  US = 'US',
}

export enum StoresEnumType {
  AU = 'AU',
  IE = 'IE',
  UK = 'UK',
  US = 'US',
}

export type StrikethroughPrice = {
  __typename: 'StrikethroughPrice'
  member: Money
  original: Money
}

export type StructuredData = {
  __typename: 'StructuredData'
  json: Scalars['String']['output']
}

export type SuggestQuickAddsInput = {
  bypassFixedSuggestions?: InputMaybe<Scalars['Boolean']['input']>
}

export type SuggestedAddress = {
  __typename: 'SuggestedAddress'
  addressFirstLine: Scalars['String']['output']
  addressId: Scalars['String']['output']
  city?: Maybe<Scalars['String']['output']>
  country: Scalars['String']['output']
  extraAddressLine?: Maybe<Scalars['String']['output']>
  firstName: Scalars['String']['output']
  houseNumber?: Maybe<Scalars['String']['output']>
  houseNumberExtension?: Maybe<Scalars['String']['output']>
  isMyAddress: Scalars['Boolean']['output']
  lastName: Scalars['String']['output']
  postcode?: Maybe<Scalars['String']['output']>
  state?: Maybe<Scalars['String']['output']>
}

export type SuggestedCustomerAddressLine = {
  __typename: 'SuggestedCustomerAddressLine'
  hasChanges: Scalars['Boolean']['output']
  value: Scalars['String']['output']
}

export type SuggestedCustomerAddressResult = {
  __typename: 'SuggestedCustomerAddressResult'
  address: SuggestedAddress
  original: Array<SuggestedCustomerAddressLine>
  suggested: Array<SuggestedCustomerAddressLine>
}

export type SuggestedDeliveryMethod = {
  __typename: 'SuggestedDeliveryMethod'
  deliveryDate: Scalars['Date']['output']
  methodId: Scalars['String']['output']
}

export type SuggestedDeliveryOption = {
  __typename: 'SuggestedDeliveryOption'
  dateDisplay?: Maybe<Scalars['String']['output']>
  deliveryGuarantee?: Maybe<DeliveryGuarantee>
  description?: Maybe<Scalars['String']['output']>
  id: Scalars['String']['output']
  method: SuggestedDeliveryMethod
  price: Scalars['String']['output']
  title: Scalars['String']['output']
  trackingTag: Scalars['String']['output']
  type: SuggestedDeliveryOptionType
}

export enum SuggestedDeliveryOptionType {
  ASAP = 'ASAP',
  ECONOMY = 'ECONOMY',
  FLEXIBLE = 'FLEXIBLE',
}

export type SuggestedMessage = {
  __typename: 'SuggestedMessage'
  category: Scalars['String']['output']
  messages: Array<Scalars['String']['output']>
}

export enum SuggestedMessageLength {
  LONG = 'LONG',
  MEDIUM = 'MEDIUM',
  SHORT = 'SHORT',
}

export type SuggestedMessages = {
  __typename: 'SuggestedMessages'
  values: Array<Scalars['String']['output']>
}

export type SuggestedMessagesError = Error & {
  __typename: 'SuggestedMessagesError'
  message: Scalars['String']['output']
}

export type SuggestedMessagesInput = {
  details?: InputMaybe<Scalars['String']['input']>
  length?: InputMaybe<SuggestedMessageLength>
  occasion: Scalars['String']['input']
  relationship?: InputMaybe<Scalars['String']['input']>
  tone?: InputMaybe<Scalars['String']['input']>
}

export type SuggestedMessagesModeratedError = Error & {
  __typename: 'SuggestedMessagesModeratedError'
  message: Scalars['String']['output']
}

export type SuggestedMessagesOption = {
  __typename: 'SuggestedMessagesOption'
  key: Scalars['String']['output']
  value: Scalars['String']['output']
}

export type SuggestedMessagesOptions = {
  __typename: 'SuggestedMessagesOptions'
  occasions: Array<SuggestedMessagesOption>
  relationships: Array<SuggestedMessagesOption>
  tones: Array<SuggestedMessagesOption>
}

export type SuggestedMessagesOptionsResult =
  | SuggestedMessagesError
  | SuggestedMessagesOptions
  | { __typename?: '%other' }

export type SuggestedMessagesResult =
  | SuggestedMessages
  | SuggestedMessagesError
  | SuggestedMessagesModeratedError
  | { __typename?: '%other' }

export type SuggestedReminder = {
  __typename: 'SuggestedReminder'
  date: OccasionDate
  occasion: Occasion
  relationship?: Maybe<Relationship>
}

export enum SuggesterType {
  DYNAMIC = 'DYNAMIC',
  FACETS = 'FACETS',
  STATIC = 'STATIC',
}

export type Suggestions = {
  __typename: 'Suggestions'
  messages?: Maybe<SuggestedMessagesResult>
  messagesOptions: SuggestedMessagesOptionsResult
}

export type SuggestionsmessagesArgs = {
  input: SuggestedMessagesInput
}

export type SupportOptions = {
  __typename: 'SupportOptions'
  amend: Scalars['Boolean']['output']
  cancel: Scalars['Boolean']['output']
  resend: Scalars['Boolean']['output']
}

export type TermsAndConditions = {
  __typename: 'TermsAndConditions'
  copy: Scalars['String']['output']
  headingCopy: Scalars['String']['output']
  url: Scalars['String']['output']
}

export type Tile = {
  __typename: 'Tile'
  image: ContentImage
  label?: Maybe<TileLabel>
  title: Scalars['String']['output']
  url: Scalars['String']['output']
}

export type TileLabel = LabelPromo | LabelRoundel | { __typename?: '%other' }

export enum TileLabelVariant {
  Default = 'Default',
  Promo = 'Promo',
}

export type ToggleFilter = {
  __typename: 'ToggleFilter'
  facetKey: Scalars['String']['output']
  group: Scalars['String']['output']
  icon?: Maybe<Scalars['String']['output']>
  isAutoApplied?: Maybe<Scalars['Boolean']['output']>
  isQuickFilter?: Maybe<Scalars['Boolean']['output']>
  isSelected: Scalars['Boolean']['output']
  isUserSelected: Scalars['Boolean']['output']
  label: Scalars['String']['output']
  nbaScore?: Maybe<Scalars['Float']['output']>
  toggleType: ToggleType
}

export enum ToggleType {
  EDITABLE_NUMBER = 'EDITABLE_NUMBER',
  FACE_SWAP = 'FACE_SWAP',
  LETTERBOX = 'LETTERBOX',
  NOT_RUDE = 'NOT_RUDE',
  PERSONALISABLE = 'PERSONALISABLE',
  PHOTO_CARDS = 'PHOTO_CARDS',
  PLUS = 'PLUS',
}

export type TrackRecipientInput = {
  trackingId: Scalars['ID']['input']
}

export type TrackRecipientResult = {
  message: Scalars['String']['output']
}

export type TrackRecipientResultFailed = TrackRecipientResult & {
  __typename: 'TrackRecipientResultFailed'
  message: Scalars['String']['output']
}

export type TrackRecipientResultSuccess = TrackRecipientResult & {
  __typename: 'TrackRecipientResultSuccess'
  message: Scalars['String']['output']
}

export type TrackingInformation = {
  __typename: 'TrackingInformation'
  deliveryDate?: Maybe<Scalars['String']['output']>
  fullTrackingUrl?: Maybe<Scalars['String']['output']>
}

export type TrackingInformationInput = {
  trackingId: Scalars['ID']['input']
}

export type TrackingInformationInvalidTrackingId = Error & {
  __typename: 'TrackingInformationInvalidTrackingId'
  message: Scalars['String']['output']
}

export type TrackingInformationResult =
  | TrackingInformation
  | TrackingInformationInvalidTrackingId
  | { __typename?: '%other' }

export type Transaction = {
  __typename: 'Transaction'
  amount: Money
  id: Scalars['ID']['output']
  interactionId: Scalars['String']['output']
  state: TransactionState
  type: TransactionType
}

export enum TransactionState {
  Failure = 'Failure',
  Initial = 'Initial',
  Pending = 'Pending',
  Success = 'Success',
}

export enum TransactionType {
  Authorization = 'Authorization',
  CancelAuthorization = 'CancelAuthorization',
  Charge = 'Charge',
  Chargeback = 'Chargeback',
  Refund = 'Refund',
}

export type USP = {
  __typename: 'USP'
  description: Scalars['String']['output']
  icon?: Maybe<ContentImage>
  title: Scalars['String']['output']
}

export type UnlinkReminderFromOrderResult =
  | Reminder
  | ReminderNotFound
  | { __typename?: '%other' }

export type UnredeemableGift = {
  __typename: 'UnredeemableGift'
  customerFacingReference?: Maybe<Scalars['String']['output']>
  giftSku?: Maybe<Scalars['String']['output']>
  id: Scalars['String']['output']
}

export type UpdateAddressInput = {
  city?: InputMaybe<Scalars['String']['input']>
  country: Scalars['String']['input']
  extraAddressLine?: InputMaybe<Scalars['String']['input']>
  firstName: Scalars['String']['input']
  houseNumber?: InputMaybe<Scalars['String']['input']>
  houseNumberExtension?: InputMaybe<Scalars['String']['input']>
  id: Scalars['String']['input']
  isMyAddress?: InputMaybe<Scalars['Boolean']['input']>
  lastName: Scalars['String']['input']
  postalCode?: InputMaybe<Scalars['String']['input']>
  state?: InputMaybe<Scalars['String']['input']>
  streetName: Scalars['String']['input']
}

export type UpdateAddressPackagingInput = {
  addressId: Scalars['String']['input']
  id: Scalars['ID']['input']
  requiresPackaging: Scalars['Boolean']['input']
}

export type UpdateAddressPackagingResult =
  | AddressNotFoundError
  | Basket
  | BasketNotFoundError
  | ConcurrentModificationError
  | DeliveryAddressInvalidError
  | DeliveryRestrictedError
  | { __typename?: '%other' }

export type UpdateAddressResult =
  | AddressError
  | UpdateAddressSuccess
  | { __typename?: '%other' }

export type UpdateAddressSuccess = {
  __typename: 'UpdateAddressSuccess'
  address: ShippingAddress
  addressBook?: Maybe<AddressBook>
}

export type UpdateAddressTypeInput = {
  id: Scalars['ID']['input']
  isMyAddress: Scalars['Boolean']['input']
}

export type UpdateAddressTypeResult =
  | AddressError
  | UpdateAddressTypeSuccess
  | { __typename?: '%other' }

export type UpdateAddressTypeSuccess = {
  __typename: 'UpdateAddressTypeSuccess'
  address: ShippingAddress
  addressBook?: Maybe<AddressBook>
}

export type UpdateBasketAddressPackagingInput = {
  addressId: Scalars['ID']['input']
  basketId: Scalars['ID']['input']
  requiresPackaging: Scalars['Boolean']['input']
}

export type UpdateBasketAddressPackagingResult =
  | Basket
  | DeliveryAddressInvalidError
  | DeliveryRestrictedError
  | { __typename?: '%other' }

export type UpdateContactPreferencesInput = {
  preferences: Array<ContactPreferenceInput>
  source: ContactSource
}

export type UpdateCustomerAddressResult =
  | ConcurrentModificationError
  | Customer
  | CustomerAddressInvalidCountry
  | CustomerAddressInvalidError
  | UserInputError
  | { __typename?: '%other' }

export type UpdateCustomerDetailsInput = {
  firstName: Scalars['String']['input']
  lastName: Scalars['String']['input']
  title?: InputMaybe<Scalars['String']['input']>
  version: Scalars['Long']['input']
}

export type UpdateCustomerDetailsResult =
  | ConcurrentModificationError
  | Customer
  | UserInputError
  | { __typename?: '%other' }

export type UpdateCustomerMarketingConsentPositionInput = {
  position: ConsentPosition
  source: MarketingConsentSource
}

export type UpdateCustomerMarketingConsentPositionResult =
  | Customer
  | { __typename?: '%other' }

export type UpdateEmailExistingEmail = Error & {
  __typename: 'UpdateEmailExistingEmail'
  message: Scalars['String']['output']
}

export type UpdateEmailFailed = Error & {
  __typename: 'UpdateEmailFailed'
  message: Scalars['String']['output']
}

export type UpdateEmailInvalidEmail = Error & {
  __typename: 'UpdateEmailInvalidEmail'
  message: Scalars['String']['output']
}

export type UpdateEmailResult =
  | Customer
  | UpdateEmailExistingEmail
  | UpdateEmailFailed
  | UpdateEmailInvalidEmail
  | { __typename?: '%other' }

export type UpdateLineItemInput = {
  id: Scalars['ID']['input']
  lineItemId: Scalars['ID']['input']
  packagingSku?: InputMaybe<Scalars['String']['input']>
  quantity?: InputMaybe<Scalars['Int']['input']>
  variantSku?: InputMaybe<Scalars['String']['input']>
  /** @deprecated No longer required please remove */
  version?: InputMaybe<Scalars['Long']['input']>
}

export type UpdateLineItemQuantityInput = {
  id: Scalars['ID']['input']
  lineItemId: Scalars['ID']['input']
  quantity: Scalars['Int']['input']
  version: Scalars['Long']['input']
}

export type UpdateLineItemQuantityResult =
  | Basket
  | BasketNotFoundError
  | ConcurrentModificationError
  | { __typename?: '%other' }

export type UpdateLineItemResult =
  | Basket
  | BasketNotFoundError
  | ConcurrentModificationError
  | DeliveryRestrictedError
  | ProductNotFoundError
  | UserInputError
  | { __typename?: '%other' }

export type UpdateLineItemVariantInput = {
  id: Scalars['ID']['input']
  lineItemId: Scalars['ID']['input']
  /** @deprecated Non-functional, replaced by updateLineItem mutation */
  packagingSku?: InputMaybe<Scalars['String']['input']>
  sku: Scalars['String']['input']
  variantId?: InputMaybe<Scalars['Int']['input']>
  version: Scalars['Long']['input']
}

export type UpdateLineItemVariantResult =
  | Basket
  | BasketNotFoundError
  | ConcurrentModificationError
  | DeliveryRestrictedError
  | ProductNotFoundError
  | UserInputError
  | { __typename?: '%other' }

export enum UpdatePhoneNumberErrorCode {
  CONFLICT = 'CONFLICT',
  INVALID_INPUT = 'INVALID_INPUT',
}

export type UpdatePhoneNumberFailed = Error & {
  __typename: 'UpdatePhoneNumberFailed'
  code: UpdatePhoneNumberErrorCode
  message: Scalars['String']['output']
}

export type UpdatePhoneNumberResult =
  | Customer
  | UpdatePhoneNumberFailed
  | { __typename?: '%other' }

export type UpdateRecipientAddressInput = {
  addressId: Scalars['String']['input']
  fields: Array<AddressFieldInput>
}

export type UpdateRecipientAddressResult =
  | AddressError
  | RecipientAddressValidationError
  | UpdateRecipientAddressSuccess
  | { __typename?: '%other' }

export type UpdateRecipientAddressSuccess = {
  __typename: 'UpdateRecipientAddressSuccess'
  address: Address
}

export type UpdateRecipientInput = {
  allowDuplicate?: InputMaybe<Scalars['Boolean']['input']>
  firstName: Scalars['String']['input']
  id: Scalars['ID']['input']
  lastName: Scalars['String']['input']
  relationship?: InputMaybe<Scalars['String']['input']>
}

export type UpdateRecipientResult =
  | DuplicateRecipientError
  | RecipientValidationError
  | UpdateRecipientSuccessResult
  | { __typename?: '%other' }

export type UpdateRecipientSuccessResult = {
  __typename: 'UpdateRecipientSuccessResult'
  recipient: Recipient
}

export type UpdateReminderInput = {
  name?: InputMaybe<Scalars['String']['input']>
  occasion?: InputMaybe<Occasion>
  occasionDate?: InputMaybe<OccasionDateInput>
  relationship?: InputMaybe<Relationship>
  store?: InputMaybe<Store>
}

export type UpdateReminderResult =
  | BadRequest
  | ReminderNotFound
  | UpdatedReminder
  | { __typename?: '%other' }

export type UpdatedReminder = Node & {
  __typename: 'UpdatedReminder'
  id: Scalars['ID']['output']
  name?: Maybe<Scalars['String']['output']>
  occasion?: Maybe<Occasion>
  occasionDate?: Maybe<OccasionDate>
  relationship?: Maybe<Relationship>
  store?: Maybe<Store>
}

export type UpsellProductVariant = {
  __typename: 'UpsellProductVariant'
  price: ProductVariantPrice
  productVariant: ProductVariant
  sku?: Maybe<Scalars['String']['output']>
}

export type UserInputError = Error & {
  __typename: 'UserInputError'
  message: Scalars['String']['output']
}

export type UserNotFound = Error & {
  __typename: 'UserNotFound'
  email: Scalars['String']['output']
  message: Scalars['String']['output']
}

export type UspGroup = {
  __typename: 'UspGroup'
  id: Scalars['ID']['output']
  items: Array<UspItem>
}

export type UspItem = {
  __typename: 'UspItem'
  id: Scalars['ID']['output']
  title: Scalars['String']['output']
}

export type ValidCustomerAddressResult = {
  __typename: 'ValidCustomerAddressResult'
  address: ShippingAddress
}

export type ValidateBasketInput = {
  id: Scalars['ID']['input']
  /** @deprecated No longer required please remove */
  version?: InputMaybe<Scalars['Long']['input']>
}

export type ValidateBasketResult =
  | BasketNotFoundError
  | BasketOrderedError
  | BasketValidatedResult
  | ConcurrentModificationError
  | { __typename?: '%other' }

export type ValidateCustomerAddressInput = {
  id: Scalars['String']['input']
}

export type ValidateCustomerAddressResult =
  | ConcurrentModificationError
  | InvalidCustomerAddressResult
  | SuggestedCustomerAddressResult
  | ValidCustomerAddressResult
  | { __typename?: '%other' }

export type VariantAvailability = {
  __typename: 'VariantAvailability'
  isInStock: Scalars['Boolean']['output']
}

export type VariantPackaging = {
  __typename: 'VariantPackaging'
  image: Image
  inStock: Scalars['Boolean']['output']
  price: Money
  sku: Scalars['String']['output']
  title: Scalars['String']['output']
}

export type Versioned = {
  version: Scalars['Long']['output']
}

export type ViewDigitalGift = {
  __typename: 'ViewDigitalGift'
  url: Scalars['String']['output']
}

export type VoucherCode = {
  __typename: 'VoucherCode'
  code: Scalars['String']['output']
  isActive: Scalars['Boolean']['output']
  name?: Maybe<Scalars['String']['output']>
  stateErrorMessage?: Maybe<Scalars['String']['output']>
}

export type VoucherInlay = Inlay & {
  __typename: 'VoucherInlay'
  id: Scalars['ID']['output']
  scene: InlayScene
  sceneObjects: Array<InlaySceneObject>
}

export type VoucherOptions = {
  __typename: 'VoucherOptions'
  defaultCard: Product
}

export type VoucherValidation = BasketValidation & {
  __typename: 'VoucherValidation'
  isBlocking: Scalars['Boolean']['output']
  message: Scalars['String']['output']
  title: Scalars['String']['output']
}
